const townFromIreland = [
    {
        LOCATION_CODE: 'AA000200',
        LOCATION_NAME: 'Aasleagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.665977,
        LOCATION_LATITUDE_DEG: 53.6165376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000700',
        LOCATION_NAME: 'Abbeville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.582518,
        LOCATION_LATITUDE_DEG: 51.9663618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB001000',
        LOCATION_NAME: 'Abbey',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7472293,
        LOCATION_LATITUDE_DEG: 53.4358274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB000800',
        LOCATION_NAME: 'Abbey',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3998363,
        LOCATION_LATITUDE_DEG: 53.1065861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002000',
        LOCATION_NAME: 'Abbeydorney',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6826042,
        LOCATION_LATITUDE_DEG: 52.3497203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002100',
        LOCATION_NAME: 'Abbeyfeale',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3025665,
        LOCATION_LATITUDE_DEG: 52.3920173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB457735',
        LOCATION_NAME: 'Abbeyknockmoy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7477845,
        LOCATION_LATITUDE_DEG: 53.4382731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002300',
        LOCATION_NAME: 'Abbeylara',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4490765,
        LOCATION_LATITUDE_DEG: 53.766535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002400',
        LOCATION_NAME: 'Abbeyleix',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3463493,
        LOCATION_LATITUDE_DEG: 52.9202545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002600',
        LOCATION_NAME: 'Abbeyshrule',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6490933,
        LOCATION_LATITUDE_DEG: 53.583116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002700',
        LOCATION_NAME: 'Abbeyside',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6100455,
        LOCATION_LATITUDE_DEG: 52.1026762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB002900',
        LOCATION_NAME: 'Abbeytown',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.165926,
        LOCATION_LATITUDE_DEG: 54.1665934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB003000',
        LOCATION_NAME: 'Abbeyville',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824614,
        LOCATION_LATITUDE_DEG: 54.0498765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AB013200',
        LOCATION_NAME: 'Abington',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4158775,
        LOCATION_LATITUDE_DEG: 52.6330372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001500',
        LOCATION_NAME: 'Achill',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.901897,
        LOCATION_LATITUDE_DEG: 53.9396752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC001600',
        LOCATION_NAME: 'Achill Sound',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9384893,
        LOCATION_LATITUDE_DEG: 53.9276543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004400',
        LOCATION_NAME: 'Aclare',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.904487,
        LOCATION_LATITUDE_DEG: 54.0355142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC004500',
        LOCATION_NAME: 'Aclare',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.899201,
        LOCATION_LATITUDE_DEG: 54.0331794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AC005050',
        LOCATION_NAME: 'Acragar',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.302995,
        LOCATION_LATITUDE_DEG: 53.1014917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000350',
        LOCATION_NAME: 'Adamstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5165829,
        LOCATION_LATITUDE_DEG: 53.4480272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000300',
        LOCATION_NAME: 'Adamstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7157282,
        LOCATION_LATITUDE_DEG: 52.3829933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000400',
        LOCATION_NAME: 'Adare',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7883446,
        LOCATION_LATITUDE_DEG: 52.5668269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000925',
        LOCATION_NAME: 'Addergoole',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7947625,
        LOCATION_LATITUDE_DEG: 53.4981143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD000950',
        LOCATION_NAME: 'Addergoole More',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7123819,
        LOCATION_LATITUDE_DEG: 53.6003979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD990823',
        LOCATION_NAME: 'Addinstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AD003400',
        LOCATION_NAME: 'Adrigole',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7160205,
        LOCATION_LATITUDE_DEG: 51.6829516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000400',
        LOCATION_NAME: 'Aghaboe',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5157969,
        LOCATION_LATITUDE_DEG: 52.9164558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000500',
        LOCATION_NAME: 'Aghabog',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990292,
        LOCATION_LATITUDE_DEG: 54.1498688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000600',
        LOCATION_NAME: 'Aghabullogue',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992374,
        LOCATION_LATITUDE_DEG: 51.9329688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG990491',
        LOCATION_NAME: 'Aghacashel',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000700',
        LOCATION_NAME: 'Aghada',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158701,
        LOCATION_LATITUDE_DEG: 51.8329546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG000750',
        LOCATION_NAME: 'Aghadoe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5896666,
        LOCATION_LATITUDE_DEG: 52.0847704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001100',
        LOCATION_NAME: 'Aghagower',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4659645,
        LOCATION_LATITUDE_DEG: 53.7498475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001400',
        LOCATION_NAME: 'Aghamore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159021,
        LOCATION_LATITUDE_DEG: 53.8165493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001500',
        LOCATION_NAME: 'Aghamore',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491279,
        LOCATION_LATITUDE_DEG: 53.8998529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001600',
        LOCATION_NAME: 'Aghancon',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7824231,
        LOCATION_LATITUDE_DEG: 53.0330735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001800',
        LOCATION_NAME: 'Aghanvilla',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157673,
        LOCATION_LATITUDE_DEG: 53.1997775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG001900',
        LOCATION_NAME: 'Aghatubrid',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.199356,
        LOCATION_LATITUDE_DEG: 51.8829727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002000',
        LOCATION_NAME: 'Aghavannagh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156959,
        LOCATION_LATITUDE_DEG: 52.916443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002100',
        LOCATION_NAME: 'Aghavas',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7157946,
        LOCATION_LATITUDE_DEG: 53.9498559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002200',
        LOCATION_NAME: 'Aghaville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3325887,
        LOCATION_LATITUDE_DEG: 51.6496466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002300',
        LOCATION_NAME: 'Aghern',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491733,
        LOCATION_LATITUDE_DEG: 52.0829779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002400',
        LOCATION_NAME: 'Aghinagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8571471,
        LOCATION_LATITUDE_DEG: 51.9328007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002500',
        LOCATION_NAME: 'Aghleam',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.099328,
        LOCATION_LATITUDE_DEG: 54.1165885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002600',
        LOCATION_NAME: 'Aghlem Bridge',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.015813,
        LOCATION_LATITUDE_DEG: 54.6499346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG990624',
        LOCATION_NAME: 'Aghnacross',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002700',
        LOCATION_NAME: 'Aghnagar Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.249367,
        LOCATION_LATITUDE_DEG: 51.8996729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG002900',
        LOCATION_NAME: 'Aghyohil',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8909171,
        LOCATION_LATITUDE_DEG: 51.7063329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG003200',
        LOCATION_NAME: 'Aglish',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992414,
        LOCATION_LATITUDE_DEG: 52.983072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG003100',
        LOCATION_NAME: 'Aglish',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324355,
        LOCATION_LATITUDE_DEG: 52.0663696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AG003250',
        LOCATION_NAME: 'Aglish',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000100',
        LOCATION_NAME: 'Ahakista',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6318443,
        LOCATION_LATITUDE_DEG: 51.6031405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000150',
        LOCATION_NAME: 'Ahanagran',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5106601,
        LOCATION_LATITUDE_DEG: 52.5371343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000200',
        LOCATION_NAME: 'Ahascragh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324533,
        LOCATION_LATITUDE_DEG: 53.399806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000300',
        LOCATION_NAME: 'Ahenny',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3991066,
        LOCATION_LATITUDE_DEG: 52.4164059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000400',
        LOCATION_NAME: 'Aherla',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.73253,
        LOCATION_LATITUDE_DEG: 51.8496607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000500',
        LOCATION_NAME: 'Aherlow',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1608664,
        LOCATION_LATITUDE_DEG: 52.4212044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000550',
        LOCATION_NAME: 'Ahgloragh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7706406,
        LOCATION_LATITUDE_DEG: 53.5055068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AH000600',
        LOCATION_NAME: 'Ahimma',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6493061,
        LOCATION_LATITUDE_DEG: 52.4830265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AI000800',
        LOCATION_NAME: 'Aille',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992462,
        LOCATION_LATITUDE_DEG: 53.7665523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL010800',
        LOCATION_NAME: 'Allen',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8690209,
        LOCATION_LATITUDE_DEG: 53.2403445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011550',
        LOCATION_NAME: 'Allenstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8258328,
        LOCATION_LATITUDE_DEG: 53.6643756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL011800',
        LOCATION_NAME: 'Allenwood',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8736402,
        LOCATION_LATITUDE_DEG: 53.2878776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL990303',
        LOCATION_NAME: 'Allenwood North',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8932348,
        LOCATION_LATITUDE_DEG: 53.2892872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL990849',
        LOCATION_NAME: 'Allenwood South',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL013700',
        LOCATION_NAME: 'Allihies',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.051462,
        LOCATION_LATITUDE_DEG: 51.6417459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019100',
        LOCATION_NAME: 'Alt',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5823772,
        LOCATION_LATITUDE_DEG: 54.7666314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL019200',
        LOCATION_NAME: 'Altadush',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491041,
        LOCATION_LATITUDE_DEG: 54.9166498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AL020700',
        LOCATION_NAME: 'Altnapaste',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8990992,
        LOCATION_LATITUDE_DEG: 54.7999417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AM001350',
        LOCATION_NAME: 'America',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0508906,
        LOCATION_LATITUDE_DEG: 53.31383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000200',
        LOCATION_NAME: 'An Leim',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492693,
        LOCATION_LATITUDE_DEG: 51.5829315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000300',
        LOCATION_NAME: 'Anablaha',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825807,
        LOCATION_LATITUDE_DEG: 52.1163854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN900741',
        LOCATION_NAME: 'Anagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7632732,
        LOCATION_LATITUDE_DEG: 52.2455584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000400',
        LOCATION_NAME: 'Anaglog Cross Roads',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322707,
        LOCATION_LATITUDE_DEG: 53.8165294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000500',
        LOCATION_NAME: 'Anascaul',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.055356,
        LOCATION_LATITUDE_DEG: 52.1562933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN000550',
        LOCATION_NAME: 'Anbally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.883141,
        LOCATION_LATITUDE_DEG: 53.423226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN002900',
        LOCATION_NAME: 'Anglesborough',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.299164,
        LOCATION_LATITUDE_DEG: 52.3329959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN003050',
        LOCATION_NAME: 'Anglish',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7630677,
        LOCATION_LATITUDE_DEG: 51.8888378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004000',
        LOCATION_NAME: 'Annacarriga',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824912,
        LOCATION_LATITUDE_DEG: 52.8497582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004100',
        LOCATION_NAME: 'Annacarty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158548,
        LOCATION_LATITUDE_DEG: 52.5664221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004300',
        LOCATION_NAME: 'Annacotty',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5346425,
        LOCATION_LATITUDE_DEG: 52.6689748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004400',
        LOCATION_NAME: 'Annacurragh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489777,
        LOCATION_LATITUDE_DEG: 52.8330367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN990599',
        LOCATION_NAME: 'Annaduff',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004600',
        LOCATION_NAME: 'Annagassan',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3477432,
        LOCATION_LATITUDE_DEG: 53.8828327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004700',
        LOCATION_NAME: 'Annagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3253791,
        LOCATION_LATITUDE_DEG: 52.0085654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004825',
        LOCATION_NAME: 'Annagh',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8537288,
        LOCATION_LATITUDE_DEG: 53.4471187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN991044',
        LOCATION_NAME: 'Annagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156959,
        LOCATION_LATITUDE_DEG: 52.916443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004800',
        LOCATION_NAME: 'Annagh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3629311,
        LOCATION_LATITUDE_DEG: 52.7408116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004850',
        LOCATION_NAME: 'Annagh Hill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8231357,
        LOCATION_LATITUDE_DEG: 53.4038403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004900',
        LOCATION_NAME: 'Annaghdown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.065932,
        LOCATION_LATITUDE_DEG: 53.3998132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN004500',
        LOCATION_NAME: 'Annagry',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158175,
        LOCATION_LATITUDE_DEG: 55.0166661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005300',
        LOCATION_NAME: 'Annamoe',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489783,
        LOCATION_LATITUDE_DEG: 53.0330531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN990866',
        LOCATION_NAME: 'Annascaul',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN005900',
        LOCATION_NAME: 'Annesbrook',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323146,
        LOCATION_LATITUDE_DEG: 53.8165311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006200',
        LOCATION_NAME: 'Annestown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2741474,
        LOCATION_LATITUDE_DEG: 52.1451746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN991041',
        LOCATION_NAME: 'Anneville',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9975,
        LOCATION_LATITUDE_DEG: 53.4572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN990179',
        LOCATION_NAME: 'Annfield',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -1.7348177,
        LOCATION_LATITUDE_DEG: 54.8615878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AN006700',
        LOCATION_NAME: 'Anns Fort',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823196,
        LOCATION_LATITUDE_DEG: 54.0331602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000200',
        LOCATION_NAME: 'Araglen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.114199,
        LOCATION_LATITUDE_DEG: 52.2000948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR000300',
        LOCATION_NAME: 'Araglin',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.115857,
        LOCATION_LATITUDE_DEG: 52.1996844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990331',
        LOCATION_NAME: 'Aran Island',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6679722,
        LOCATION_LATITUDE_DEG: 53.8006473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001200',
        LOCATION_NAME: 'Archerstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1037464,
        LOCATION_LATITUDE_DEG: 53.6589894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990101',
        LOCATION_NAME: 'Arclough',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5732631,
        LOCATION_LATITUDE_DEG: 53.2966231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001500',
        LOCATION_NAME: 'Ard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8826108,
        LOCATION_LATITUDE_DEG: 53.3165136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001800',
        LOCATION_NAME: 'Ardagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0640539,
        LOCATION_LATITUDE_DEG: 52.4980167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001700',
        LOCATION_NAME: 'Ardagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991,
        LOCATION_LATITUDE_DEG: 53.6665221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR001900',
        LOCATION_NAME: 'Ardagh',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7322964,
        LOCATION_LATITUDE_DEG: 53.8831411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990580',
        LOCATION_NAME: 'Ardamine',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002100',
        LOCATION_NAME: 'Ardamore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.366084,
        LOCATION_LATITUDE_DEG: 52.1996973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002200',
        LOCATION_NAME: 'Ardara',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4157159,
        LOCATION_LATITUDE_DEG: 54.7672404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002300',
        LOCATION_NAME: 'Ardattin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7029115,
        LOCATION_LATITUDE_DEG: 52.7522405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990742',
        LOCATION_NAME: 'Ardbraccan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR002700',
        LOCATION_NAME: 'Ardcath',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.382266,
        LOCATION_LATITUDE_DEG: 53.5998063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990784',
        LOCATION_NAME: 'Ardcroney',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003100',
        LOCATION_NAME: 'Ardcrony',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491454,
        LOCATION_LATITUDE_DEG: 52.9330591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003300',
        LOCATION_NAME: 'Ardea',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7660343,
        LOCATION_LATITUDE_DEG: 51.7996633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR003400',
        LOCATION_NAME: 'Ardee',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5440325,
        LOCATION_LATITUDE_DEG: 53.8592359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR004900',
        LOCATION_NAME: 'Ardfert',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826282,
        LOCATION_LATITUDE_DEG: 52.3330137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005000',
        LOCATION_NAME: 'Ardfield',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992405,
        LOCATION_LATITUDE_DEG: 51.582935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005100',
        LOCATION_NAME: 'Ardfinnan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.865846,
        LOCATION_LATITUDE_DEG: 52.3163918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005300',
        LOCATION_NAME: 'Ardgehane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8289575,
        LOCATION_LATITUDE_DEG: 51.6029803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR005700',
        LOCATION_NAME: 'Ardgroom',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.884646,
        LOCATION_LATITUDE_DEG: 51.7432517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR006400',
        LOCATION_NAME: 'Ardinode',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6323017,
        LOCATION_LATITUDE_DEG: 53.1164629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007000',
        LOCATION_NAME: 'Ardloman',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2009094,
        LOCATION_LATITUDE_DEG: 52.4328894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007100',
        LOCATION_NAME: 'Ardlougher',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5823814,
        LOCATION_LATITUDE_DEG: 54.0665676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR007800',
        LOCATION_NAME: 'Ardmore',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7244047,
        LOCATION_LATITUDE_DEG: 51.948833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990749',
        LOCATION_NAME: 'Ardmulchan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR991150',
        LOCATION_NAME: 'Ardnacassa',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.78332,
        LOCATION_LATITUDE_DEG: 53.7281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008000',
        LOCATION_NAME: 'Ardnacrusha',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6159053,
        LOCATION_LATITUDE_DEG: 52.6830368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990928',
        LOCATION_NAME: 'Ardnacrusha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008400',
        LOCATION_NAME: 'Ardnaree',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492164,
        LOCATION_LATITUDE_DEG: 54.1165909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008300',
        LOCATION_NAME: 'Ardnaree',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.617203,
        LOCATION_LATITUDE_DEG: 55.0471624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008850',
        LOCATION_NAME: 'Ardour',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0174156,
        LOCATION_LATITUDE_DEG: 53.5747144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR008900',
        LOCATION_NAME: 'Ardpatrick',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.532494,
        LOCATION_LATITUDE_DEG: 52.3330066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009200',
        LOCATION_NAME: 'Ardrahan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7554404,
        LOCATION_LATITUDE_DEG: 52.3533241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009100',
        LOCATION_NAME: 'Ardrahan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8060776,
        LOCATION_LATITUDE_DEG: 53.1536909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009300',
        LOCATION_NAME: 'Ardranny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991559,
        LOCATION_LATITUDE_DEG: 53.2497965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009800',
        LOCATION_NAME: 'Ards',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324242,
        LOCATION_LATITUDE_DEG: 53.6331257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009900',
        LOCATION_NAME: 'Ards',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823916,
        LOCATION_LATITUDE_DEG: 55.0216303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990738',
        LOCATION_NAME: 'Ardsallagh',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR009950',
        LOCATION_NAME: 'Ardskea Moor',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8551257,
        LOCATION_LATITUDE_DEG: 53.4450959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR010200',
        LOCATION_NAME: 'Ardsollus',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825243,
        LOCATION_LATITUDE_DEG: 52.7830445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR011600',
        LOCATION_NAME: 'Ardy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5274392,
        LOCATION_LATITUDE_DEG: 55.1192638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR012600',
        LOCATION_NAME: 'Arigna',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158281,
        LOCATION_LATITUDE_DEG: 54.066569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR013800',
        LOCATION_NAME: 'Arklow',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1691179,
        LOCATION_LATITUDE_DEG: 52.7985288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR014500',
        LOCATION_NAME: 'Arless',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0345264,
        LOCATION_LATITUDE_DEG: 52.9058504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990386',
        LOCATION_NAME: 'Arran Island',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990330',
        LOCATION_NAME: 'Arran Island',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR990385',
        LOCATION_NAME: 'Arranmore Island',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019100',
        LOCATION_NAME: 'Artane',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2039194,
        LOCATION_LATITUDE_DEG: 53.3819858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR019600',
        LOCATION_NAME: 'Arthurstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9459257,
        LOCATION_LATITUDE_DEG: 52.2439844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020100',
        LOCATION_NAME: 'Arva',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5836487,
        LOCATION_LATITUDE_DEG: 53.923242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AR020200',
        LOCATION_NAME: 'Arvagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5810174,
        LOCATION_LATITUDE_DEG: 53.9227255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS019200',
        LOCATION_NAME: 'Asdee',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659974,
        LOCATION_LATITUDE_DEG: 52.5497298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS001900',
        LOCATION_NAME: 'Ash Field',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.865712,
        LOCATION_LATITUDE_DEG: 53.8498357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS002900',
        LOCATION_NAME: 'Ashakiltubbrid',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491126,
        LOCATION_LATITUDE_DEG: 53.9331541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS003400',
        LOCATION_NAME: 'Ashbourne',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.405478,
        LOCATION_LATITUDE_DEG: 53.5183103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS990092',
        LOCATION_NAME: 'ASHFIELD',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0725671,
        LOCATION_LATITUDE_DEG: 53.2873117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS007500',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.065939,
        LOCATION_LATITUDE_DEG: 52.3664101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS006900',
        LOCATION_NAME: 'Ashford',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1103389,
        LOCATION_LATITUDE_DEG: 53.0080911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS014300',
        LOCATION_NAME: 'Ashtown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3266755,
        LOCATION_LATITUDE_DEG: 53.3733904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS015800',
        LOCATION_NAME: 'Askamore',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822976,
        LOCATION_LATITUDE_DEG: 52.6664195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS016000',
        LOCATION_NAME: 'Askeaton',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9677886,
        LOCATION_LATITUDE_DEG: 52.6034312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017000',
        LOCATION_NAME: 'Askill',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1846674,
        LOCATION_LATITUDE_DEG: 54.428706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AS017100',
        LOCATION_NAME: 'Askintinny',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1489701,
        LOCATION_LATITUDE_DEG: 52.7497262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000300',
        LOCATION_NAME: 'Athabatteen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7825279,
        LOCATION_LATITUDE_DEG: 51.9663629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000400',
        LOCATION_NAME: 'Athboy',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9177191,
        LOCATION_LATITUDE_DEG: 53.6283127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT000500',
        LOCATION_NAME: 'Athea',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825616,
        LOCATION_LATITUDE_DEG: 52.4497236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001000',
        LOCATION_NAME: 'Athenry',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7546266,
        LOCATION_LATITUDE_DEG: 53.3084957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001700',
        LOCATION_NAME: 'Athgarvan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823245,
        LOCATION_LATITUDE_DEG: 53.1330689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001800',
        LOCATION_NAME: 'Athlacca',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492081,
        LOCATION_LATITUDE_DEG: 52.4497156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT001900',
        LOCATION_NAME: 'Athleague',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2507833,
        LOCATION_LATITUDE_DEG: 53.5751269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002100',
        LOCATION_NAME: 'Athlone',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9447209,
        LOCATION_LATITUDE_DEG: 53.4282038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002200',
        LOCATION_NAME: 'Athlunkard',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6089049,
        LOCATION_LATITUDE_DEG: 52.6808531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002300',
        LOCATION_NAME: 'Athnid',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658218,
        LOCATION_LATITUDE_DEG: 52.7164322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002400',
        LOCATION_NAME: 'Athy',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9765602,
        LOCATION_LATITUDE_DEG: 52.9981601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT002700',
        LOCATION_NAME: 'Attanagh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490847,
        LOCATION_LATITUDE_DEG: 52.8330453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003200',
        LOCATION_NAME: 'Attimachugh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325194,
        LOCATION_LATITUDE_DEG: 54.0165704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003700',
        LOCATION_NAME: 'Attymass',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0820074,
        LOCATION_LATITUDE_DEG: 54.0496015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AT003800',
        LOCATION_NAME: 'Attymon',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6158871,
        LOCATION_LATITUDE_DEG: 53.3165037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU004800',
        LOCATION_NAME: 'Aughacasla',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9841155,
        LOCATION_LATITUDE_DEG: 52.2349264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005000',
        LOCATION_NAME: 'Aughagault',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7323824,
        LOCATION_LATITUDE_DEG: 54.8666463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005100',
        LOCATION_NAME: 'Aughagault Little',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7157747,
        LOCATION_LATITUDE_DEG: 54.8666483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005200',
        LOCATION_NAME: 'Aughamore',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4512884,
        LOCATION_LATITUDE_DEG: 54.2373198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005300',
        LOCATION_NAME: 'Aughanacliffe',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6050439,
        LOCATION_LATITUDE_DEG: 53.8429427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU990494',
        LOCATION_NAME: 'Aughavas',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005400',
        LOCATION_NAME: 'Aughboy',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5324789,
        LOCATION_LATITUDE_DEG: 52.7330397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005500',
        LOCATION_NAME: 'Aughclare',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157579,
        LOCATION_LATITUDE_DEG: 52.3163899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005800',
        LOCATION_NAME: 'Aughils',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8660253,
        LOCATION_LATITUDE_DEG: 52.1663946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU005900',
        LOCATION_NAME: 'Aughinish',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0742352,
        LOCATION_LATITUDE_DEG: 53.1664935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006100',
        LOCATION_NAME: 'Aughnasheelan',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.865807,
        LOCATION_LATITUDE_DEG: 54.0665678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU990490',
        LOCATION_NAME: 'Aughnasheelin',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006400',
        LOCATION_NAME: 'Aughrim',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9629898,
        LOCATION_LATITUDE_DEG: 53.0086068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006200',
        LOCATION_NAME: 'Aughrim',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3095692,
        LOCATION_LATITUDE_DEG: 53.3096974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006300',
        LOCATION_NAME: 'Aughrim',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3233813,
        LOCATION_LATITUDE_DEG: 52.8587342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AU006500',
        LOCATION_NAME: 'Aughris',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7658738,
        LOCATION_LATITUDE_DEG: 54.2665946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001200',
        LOCATION_NAME: 'Avoca',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.229287,
        LOCATION_LATITUDE_DEG: 52.8607343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'AV001450',
        LOCATION_NAME: 'Avoley',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.365423,
        LOCATION_LATITUDE_DEG: 53.1260856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA006800',
        LOCATION_NAME: 'Bagenalstown',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9511778,
        LOCATION_LATITUDE_DEG: 52.7086261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA007000',
        LOCATION_NAME: 'Baggotstown',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.499203,
        LOCATION_LATITUDE_DEG: 52.4497138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA009100',
        LOCATION_NAME: 'Bailieborough',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9733357,
        LOCATION_LATITUDE_DEG: 53.9173529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA011300',
        LOCATION_NAME: 'Balbriggan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1934482,
        LOCATION_LATITUDE_DEG: 53.6102096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013100',
        LOCATION_NAME: 'Baldoyle',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1327297,
        LOCATION_LATITUDE_DEG: 53.398393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103500',
        LOCATION_NAME: 'Baldoyle',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.126258,
        LOCATION_LATITUDE_DEG: 53.4007313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013900',
        LOCATION_NAME: 'Baldwinstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823101,
        LOCATION_LATITUDE_DEG: 52.2329729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA013800',
        LOCATION_NAME: 'Baldwinstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3656674,
        LOCATION_LATITUDE_DEG: 53.5498056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103600',
        LOCATION_NAME: 'Balgriffin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1786897,
        LOCATION_LATITUDE_DEG: 53.4070288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA015800',
        LOCATION_NAME: 'Balgriffin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 17',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1649956,
        LOCATION_LATITUDE_DEG: 53.4067883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA016900',
        LOCATION_NAME: 'Balla',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1177985,
        LOCATION_LATITUDE_DEG: 53.8048561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017200',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1092316,
        LOCATION_LATITUDE_DEG: 53.2961937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990171',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1020697,
        LOCATION_LATITUDE_DEG: 52.4364926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017250',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8263194,
        LOCATION_LATITUDE_DEG: 53.7757641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017275',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3099083,
        LOCATION_LATITUDE_DEG: 53.5387772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991017',
        LOCATION_NAME: 'Ballagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0836,
        LOCATION_LATITUDE_DEG: 52.3667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017300',
        LOCATION_NAME: 'Ballaghaderreen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5793191,
        LOCATION_LATITUDE_DEG: 53.9040638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017400',
        LOCATION_NAME: 'Ballaghkeen',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156947,
        LOCATION_LATITUDE_DEG: 52.4664005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017500',
        LOCATION_NAME: 'Ballaghmore',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158196,
        LOCATION_LATITUDE_DEG: 52.9497608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA017950',
        LOCATION_NAME: 'Ballcarnan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018300',
        LOCATION_NAME: 'Ballickmoyler',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0115731,
        LOCATION_LATITUDE_DEG: 52.8829469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018600',
        LOCATION_NAME: 'Ballina',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1569197,
        LOCATION_LATITUDE_DEG: 54.1168786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018750',
        LOCATION_NAME: 'Ballina',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.779582,
        LOCATION_LATITUDE_DEG: 53.4424007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018500',
        LOCATION_NAME: 'Ballina',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324718,
        LOCATION_LATITUDE_DEG: 52.8164482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018700',
        LOCATION_NAME: 'Ballina',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4111943,
        LOCATION_LATITUDE_DEG: 53.5073551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018800',
        LOCATION_NAME: 'Ballinaboy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.016021,
        LOCATION_LATITUDE_DEG: 53.4665185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990558',
        LOCATION_NAME: 'Ballinabrackey',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA018900',
        LOCATION_NAME: 'Ballinaclash',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2656754,
        LOCATION_LATITUDE_DEG: 52.8997378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047000',
        LOCATION_NAME: 'Ballinacurra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1669171,
        LOCATION_LATITUDE_DEG: 51.9009586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991013',
        LOCATION_NAME: 'Ballinacurra',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6336,
        LOCATION_LATITUDE_DEG: 52.6544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019000',
        LOCATION_NAME: 'Ballinadee',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6325101,
        LOCATION_LATITUDE_DEG: 51.6996476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019100',
        LOCATION_NAME: 'Ballinafad',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324502,
        LOCATION_LATITUDE_DEG: 54.0165642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019200',
        LOCATION_NAME: 'Ballinagar',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3417987,
        LOCATION_LATITUDE_DEG: 53.2709871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022100',
        LOCATION_NAME: 'Ballinagare',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3872237,
        LOCATION_LATITUDE_DEG: 53.8405574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022101',
        LOCATION_NAME: 'Ballinagee',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019300',
        LOCATION_NAME: 'Ballinagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157177,
        LOCATION_LATITUDE_DEG: 53.9331874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019400',
        LOCATION_NAME: 'Ballinagleragh',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824098,
        LOCATION_LATITUDE_DEG: 54.1498815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019500',
        LOCATION_NAME: 'Ballinagore',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989757,
        LOCATION_LATITUDE_DEG: 52.7997357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019600',
        LOCATION_NAME: 'Ballinagree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9307733,
        LOCATION_LATITUDE_DEG: 51.9771827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019650',
        LOCATION_NAME: 'Ballinahinch',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3892273,
        LOCATION_LATITUDE_DEG: 52.7483599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048700',
        LOCATION_NAME: 'Ballinahown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8519425,
        LOCATION_LATITUDE_DEG: 53.3555982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019700',
        LOCATION_NAME: 'Ballinakill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3168035,
        LOCATION_LATITUDE_DEG: 52.884248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019800',
        LOCATION_NAME: 'Ballinalack',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4656411,
        LOCATION_LATITUDE_DEG: 53.6295234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA019900',
        LOCATION_NAME: 'Ballinalea',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1199689,
        LOCATION_LATITUDE_DEG: 53.0122556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020000',
        LOCATION_NAME: 'Ballinalee',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6493135,
        LOCATION_LATITUDE_DEG: 53.7782398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020200',
        LOCATION_NAME: 'Ballinameen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991322,
        LOCATION_LATITUDE_DEG: 53.8998523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020250',
        LOCATION_NAME: 'Ballinamona',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0964321,
        LOCATION_LATITUDE_DEG: 52.8287956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990878',
        LOCATION_NAME: 'Ballinamona',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020400',
        LOCATION_NAME: 'Ballinamore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658593,
        LOCATION_LATITUDE_DEG: 53.4831095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020300',
        LOCATION_NAME: 'Ballinamore',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8011487,
        LOCATION_LATITUDE_DEG: 54.0587662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020500',
        LOCATION_NAME: 'Ballinamuck',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158025,
        LOCATION_LATITUDE_DEG: 53.8665452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990879',
        LOCATION_NAME: 'Ballinamult',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020600',
        LOCATION_NAME: 'Ballinapark',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659711,
        LOCATION_LATITUDE_DEG: 54.316598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020625',
        LOCATION_NAME: 'Ballinapark',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2447332,
        LOCATION_LATITUDE_DEG: 52.8504023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020650',
        LOCATION_NAME: 'Ballinard',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5955006,
        LOCATION_LATITUDE_DEG: 52.4934696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA020700',
        LOCATION_NAME: 'Ballinascarthy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8573049,
        LOCATION_LATITUDE_DEG: 51.6843403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990249',
        LOCATION_NAME: 'Ballinascarty',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.849229,
        LOCATION_LATITUDE_DEG: 51.6663397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021000',
        LOCATION_NAME: 'Ballinasloe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2294535,
        LOCATION_LATITUDE_DEG: 53.3362031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990636',
        LOCATION_NAME: 'Ballincar',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021100',
        LOCATION_NAME: 'Ballinclashet',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324886,
        LOCATION_LATITUDE_DEG: 51.7163458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021200',
        LOCATION_NAME: 'Ballincloher Cross Roads',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6826149,
        LOCATION_LATITUDE_DEG: 52.3830193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021300',
        LOCATION_NAME: 'Ballincollig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.59142,
        LOCATION_LATITUDE_DEG: 51.8918661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021400',
        LOCATION_NAME: 'Ballincrea',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990657,
        LOCATION_LATITUDE_DEG: 52.3163852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021500',
        LOCATION_NAME: 'Ballincurrig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324806,
        LOCATION_LATITUDE_DEG: 51.9829643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021600',
        LOCATION_NAME: 'Ballincurry',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5991147,
        LOCATION_LATITUDE_DEG: 52.5830137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021700',
        LOCATION_NAME: 'Ballindaggan',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823305,
        LOCATION_LATITUDE_DEG: 52.5664144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA021900',
        LOCATION_NAME: 'Ballindangan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324764,
        LOCATION_LATITUDE_DEG: 52.2329965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022100',
        LOCATION_NAME: 'Ballinderreen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159214,
        LOCATION_LATITUDE_DEG: 53.183088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022275',
        LOCATION_NAME: 'Ballinderry',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8343442,
        LOCATION_LATITUDE_DEG: 53.4672456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022200',
        LOCATION_NAME: 'Ballinderry',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2211048,
        LOCATION_LATITUDE_DEG: 53.0203303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022250',
        LOCATION_NAME: 'Ballinderry',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1794043,
        LOCATION_LATITUDE_DEG: 53.6996145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022288',
        LOCATION_NAME: 'Ballinderry',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489885,
        LOCATION_LATITUDE_DEG: 52.9430732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022500',
        LOCATION_NAME: 'Ballindine',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9467132,
        LOCATION_LATITUDE_DEG: 53.6579429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022600',
        LOCATION_NAME: 'Ballindooly',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159269,
        LOCATION_LATITUDE_DEG: 53.3165034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022700',
        LOCATION_NAME: 'Ballindrait',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5157574,
        LOCATION_LATITUDE_DEG: 54.8332392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022800',
        LOCATION_NAME: 'Ballineen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9721801,
        LOCATION_LATITUDE_DEG: 51.7379522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA022900',
        LOCATION_NAME: 'Ballinfid',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3852488,
        LOCATION_LATITUDE_DEG: 53.5957511,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990649',
        LOCATION_NAME: 'Ballinfull',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023000',
        LOCATION_NAME: 'Ballingarrane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325346,
        LOCATION_LATITUDE_DEG: 52.5497305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023300',
        LOCATION_NAME: 'Ballingarry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659376,
        LOCATION_LATITUDE_DEG: 52.4664156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023100',
        LOCATION_NAME: 'Ballingarry',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0398179,
        LOCATION_LATITUDE_DEG: 53.0176709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023200',
        LOCATION_NAME: 'Ballingarry',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5345366,
        LOCATION_LATITUDE_DEG: 52.5897225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023400',
        LOCATION_NAME: 'Ballingeary',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2358335,
        LOCATION_LATITUDE_DEG: 51.8538629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023700',
        LOCATION_NAME: 'Ballinglen',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.411453,
        LOCATION_LATITUDE_DEG: 52.8241319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA023900',
        LOCATION_NAME: 'Ballinguile',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989973,
        LOCATION_LATITUDE_DEG: 52.9164429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024000',
        LOCATION_NAME: 'Ballingurteen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159579,
        LOCATION_LATITUDE_DEG: 51.6663504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024100',
        LOCATION_NAME: 'Ballinhassig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5312605,
        LOCATION_LATITUDE_DEG: 51.8165497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024200',
        LOCATION_NAME: 'Ballinilard',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.189532,
        LOCATION_LATITUDE_DEG: 52.4650131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024300',
        LOCATION_NAME: 'Ballinkillin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323415,
        LOCATION_LATITUDE_DEG: 52.649719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024400',
        LOCATION_NAME: 'Ballinleenty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2087543,
        LOCATION_LATITUDE_DEG: 52.4526739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024500',
        LOCATION_NAME: 'Ballinleeny',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325141,
        LOCATION_LATITUDE_DEG: 52.4497104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024600',
        LOCATION_NAME: 'Ballinlough',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6360006,
        LOCATION_LATITUDE_DEG: 53.7450389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024700',
        LOCATION_NAME: 'Ballinlough',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491698,
        LOCATION_LATITUDE_DEG: 53.0664741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA024800',
        LOCATION_NAME: 'Ballinlough',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0329018,
        LOCATION_LATITUDE_DEG: 53.7350992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990089',
        LOCATION_NAME: 'BALLINMOREBRIDGE',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3688358,
        LOCATION_LATITUDE_DEG: 53.5533672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025000',
        LOCATION_NAME: 'Ballinorig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6612577,
        LOCATION_LATITUDE_DEG: 52.2722153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025050',
        LOCATION_NAME: 'Ballinree',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1129286,
        LOCATION_LATITUDE_DEG: 52.8629353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025100',
        LOCATION_NAME: 'Ballinrobe',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2248729,
        LOCATION_LATITUDE_DEG: 53.6289355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025150',
        LOCATION_NAME: 'Ballinroddy',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6715613,
        LOCATION_LATITUDE_DEG: 53.680059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025200',
        LOCATION_NAME: 'Ballinrostig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824702,
        LOCATION_LATITUDE_DEG: 51.8163526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025300',
        LOCATION_NAME: 'Ballinruan',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325159,
        LOCATION_LATITUDE_DEG: 52.9497673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025500',
        LOCATION_NAME: 'Ballinskelligs',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.285072,
        LOCATION_LATITUDE_DEG: 51.8072705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025600',
        LOCATION_NAME: 'Ballinspittle',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5947076,
        LOCATION_LATITUDE_DEG: 51.671236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025650',
        LOCATION_NAME: 'Ballintaggart',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025700',
        LOCATION_NAME: 'Ballintaylor',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7324448,
        LOCATION_LATITUDE_DEG: 52.0663672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103900',
        LOCATION_NAME: 'Ballinteer',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2498489,
        LOCATION_LATITUDE_DEG: 53.2806089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025800',
        LOCATION_NAME: 'Ballintemple',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4310843,
        LOCATION_LATITUDE_DEG: 51.881161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025850',
        LOCATION_NAME: 'Ballinteskin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0732969,
        LOCATION_LATITUDE_DEG: 52.9474177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA025900',
        LOCATION_NAME: 'Ballintober',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992535,
        LOCATION_LATITUDE_DEG: 53.7331467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026000',
        LOCATION_NAME: 'Ballintober',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4158496,
        LOCATION_LATITUDE_DEG: 53.7165394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026100',
        LOCATION_NAME: 'Ballintogher',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658453,
        LOCATION_LATITUDE_DEG: 54.1998859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026200',
        LOCATION_NAME: 'Ballintonbay',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822788,
        LOCATION_LATITUDE_DEG: 52.916441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026400',
        LOCATION_NAME: 'Ballintra',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1322375,
        LOCATION_LATITUDE_DEG: 54.5782222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991047',
        LOCATION_NAME: 'Ballintrillick',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4042,
        LOCATION_LATITUDE_DEG: 54.4033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104700',
        LOCATION_NAME: 'Ballintubber',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2798359,
        LOCATION_LATITUDE_DEG: 53.7574929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104750',
        LOCATION_NAME: 'Ballintubber',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4107274,
        LOCATION_LATITUDE_DEG: 53.720282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026500',
        LOCATION_NAME: 'Ballintubbert',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823523,
        LOCATION_LATITUDE_DEG: 52.9830541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026700',
        LOCATION_NAME: 'Ballinunty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6658287,
        LOCATION_LATITUDE_DEG: 52.5830174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026800',
        LOCATION_NAME: 'Ballinure',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7927484,
        LOCATION_LATITUDE_DEG: 52.5589139,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA026900',
        LOCATION_NAME: 'Ballitore',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.806466,
        LOCATION_LATITUDE_DEG: 53.0225506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027000',
        LOCATION_NAME: 'Ballivor',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9985402,
        LOCATION_LATITUDE_DEG: 53.5400107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027400',
        LOCATION_NAME: 'Ballon',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7686803,
        LOCATION_LATITUDE_DEG: 52.7455323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027500',
        LOCATION_NAME: 'Balloor',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.649056,
        LOCATION_LATITUDE_DEG: 55.2666801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027600',
        LOCATION_NAME: 'Ballough',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1989508,
        LOCATION_LATITUDE_DEG: 53.5331053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA027700',
        LOCATION_NAME: 'Balloughter',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489927,
        LOCATION_LATITUDE_DEG: 52.616411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105400',
        LOCATION_NAME: 'Ballsbridge',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2319139,
        LOCATION_LATITUDE_DEG: 53.3317468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028050',
        LOCATION_NAME: 'Ballvary',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028200',
        LOCATION_NAME: 'Ballyadams',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.063379,
        LOCATION_LATITUDE_DEG: 52.9611319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028250',
        LOCATION_NAME: 'Ballyadding',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1120854,
        LOCATION_LATITUDE_DEG: 53.0937016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028300',
        LOCATION_NAME: 'Ballyagran',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7825175,
        LOCATION_LATITUDE_DEG: 52.3997134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028400',
        LOCATION_NAME: 'Ballyargus',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657134,
        LOCATION_LATITUDE_DEG: 55.1666687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028500',
        LOCATION_NAME: 'Ballybacon',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8709177,
        LOCATION_LATITUDE_DEG: 52.2729232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990442',
        LOCATION_NAME: 'Ballybane',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028700',
        LOCATION_NAME: 'Ballybay',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.999145,
        LOCATION_LATITUDE_DEG: 53.4665041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028600',
        LOCATION_NAME: 'Ballybay',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9072054,
        LOCATION_LATITUDE_DEG: 54.1337686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028800',
        LOCATION_NAME: 'Ballybeg',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1515523,
        LOCATION_LATITUDE_DEG: 52.2355816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028850',
        LOCATION_NAME: 'Ballybeg',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5079011,
        LOCATION_LATITUDE_DEG: 52.6356807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA028900',
        LOCATION_NAME: 'Ballybit',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7094498,
        LOCATION_LATITUDE_DEG: 52.8528741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103800',
        LOCATION_NAME: 'Ballyboden',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2852128,
        LOCATION_LATITUDE_DEG: 53.2849193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029000',
        LOCATION_NAME: 'Ballybofey',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7978765,
        LOCATION_LATITUDE_DEG: 54.7975348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029100',
        LOCATION_NAME: 'Ballyboghil',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.282654,
        LOCATION_LATITUDE_DEG: 53.5436987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029200',
        LOCATION_NAME: 'Ballyboghill',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2656567,
        LOCATION_LATITUDE_DEG: 53.5165073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105350',
        LOCATION_NAME: 'Ballybough',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7287861,
        LOCATION_LATITUDE_DEG: 52.4836048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105300',
        LOCATION_NAME: 'Ballybough',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2507133,
        LOCATION_LATITUDE_DEG: 53.3578249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990968',
        LOCATION_NAME: 'Ballyboughal',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029400',
        LOCATION_NAME: 'Ballyboy',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991121,
        LOCATION_LATITUDE_DEG: 53.1664743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029500',
        LOCATION_NAME: 'Ballybrack',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5826035,
        LOCATION_LATITUDE_DEG: 52.1329872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029600',
        LOCATION_NAME: 'Ballybrack',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1229111,
        LOCATION_LATITUDE_DEG: 53.2520735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029650',
        LOCATION_NAME: 'Ballybrew',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.20364,
        LOCATION_LATITUDE_DEG: 53.2089172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990444',
        LOCATION_NAME: 'Ballybrit',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029700',
        LOCATION_NAME: 'Ballybrittas',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323504,
        LOCATION_LATITUDE_DEG: 53.0997664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990964',
        LOCATION_NAME: 'Ballybroder',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029800',
        LOCATION_NAME: 'Ballybrood',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491791,
        LOCATION_LATITUDE_DEG: 52.566424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA029900',
        LOCATION_NAME: 'Ballybrophy',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.599106,
        LOCATION_LATITUDE_DEG: 52.8997549,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990803',
        LOCATION_NAME: 'Ballybunion',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030000',
        LOCATION_NAME: 'Ballybunnion',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6734723,
        LOCATION_LATITUDE_DEG: 52.513725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990930',
        LOCATION_NAME: 'Ballybur',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990929',
        LOCATION_NAME: 'Ballyburr',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030100',
        LOCATION_NAME: 'Ballycahill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991385,
        LOCATION_LATITUDE_DEG: 52.6830309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030200',
        LOCATION_NAME: 'Ballycallan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3621394,
        LOCATION_LATITUDE_DEG: 52.6219529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030300',
        LOCATION_NAME: 'Ballycanew',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3124341,
        LOCATION_LATITUDE_DEG: 52.6257128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030400',
        LOCATION_NAME: 'Ballycapple',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1322726,
        LOCATION_LATITUDE_DEG: 52.899738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030450',
        LOCATION_NAME: 'Ballycar',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8685829,
        LOCATION_LATITUDE_DEG: 52.7614081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030475',
        LOCATION_NAME: 'Ballycarnan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2857672,
        LOCATION_LATITUDE_DEG: 52.9937553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030500',
        LOCATION_NAME: 'Ballycarney',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5761249,
        LOCATION_LATITUDE_DEG: 52.5844149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030600',
        LOCATION_NAME: 'Ballycarra',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.215941,
        LOCATION_LATITUDE_DEG: 53.7998439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030650',
        LOCATION_NAME: 'Ballycarrol',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1414667,
        LOCATION_LATITUDE_DEG: 53.1328617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA030900',
        LOCATION_NAME: 'Ballycastle',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659184,
        LOCATION_LATITUDE_DEG: 54.2832284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031200',
        LOCATION_NAME: 'Ballyclerihan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7621175,
        LOCATION_LATITUDE_DEG: 52.4169083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031300',
        LOCATION_NAME: 'Ballyclery',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159227,
        LOCATION_LATITUDE_DEG: 53.1497831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031400',
        LOCATION_NAME: 'Ballyclogh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325238,
        LOCATION_LATITUDE_DEG: 52.1663906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031500',
        LOCATION_NAME: 'Ballyclogh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.622391,
        LOCATION_LATITUDE_DEG: 52.6205442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990668',
        LOCATION_NAME: 'Ballyclough',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031550',
        LOCATION_NAME: 'Ballycocksoost',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0900723,
        LOCATION_LATITUDE_DEG: 52.4692652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031600',
        LOCATION_NAME: 'Ballycolla',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4579426,
        LOCATION_LATITUDE_DEG: 52.8908437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031800',
        LOCATION_NAME: 'Ballycommon',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.234382,
        LOCATION_LATITUDE_DEG: 52.8865922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031700',
        LOCATION_NAME: 'Ballycommon',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490833,
        LOCATION_LATITUDE_DEG: 53.299787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA031900',
        LOCATION_NAME: 'Ballyconneely',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.066022,
        LOCATION_LATITUDE_DEG: 53.4331267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032100',
        LOCATION_NAME: 'Ballyconnell',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491726,
        LOCATION_LATITUDE_DEG: 54.3499071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032000',
        LOCATION_NAME: 'Ballyconnell',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5706731,
        LOCATION_LATITUDE_DEG: 54.1254715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032200',
        LOCATION_NAME: 'Ballyconnell',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6206518,
        LOCATION_LATITUDE_DEG: 52.8114414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032300',
        LOCATION_NAME: 'Ballyconra',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490846,
        LOCATION_LATITUDE_DEG: 52.7997412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032350',
        LOCATION_NAME: 'Ballyconway',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1630947,
        LOCATION_LATITUDE_DEG: 52.4908437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032375',
        LOCATION_NAME: 'Ballycoolan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.157608,
        LOCATION_LATITUDE_DEG: 52.9739816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103700',
        LOCATION_NAME: 'Ballycoolin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.364094,
        LOCATION_LATITUDE_DEG: 53.3973529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032400',
        LOCATION_NAME: 'Ballycorus',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1661712,
        LOCATION_LATITUDE_DEG: 53.2320071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032500',
        LOCATION_NAME: 'Ballycotton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9945282,
        LOCATION_LATITUDE_DEG: 51.8255782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991112',
        LOCATION_NAME: 'Ballycraheen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6561,
        LOCATION_LATITUDE_DEG: 51.9683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032600',
        LOCATION_NAME: 'Ballycrinnigan',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8710879,
        LOCATION_LATITUDE_DEG: 52.5041827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032700',
        LOCATION_NAME: 'Ballycroneen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1081282,
        LOCATION_LATITUDE_DEG: 51.811752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032800',
        LOCATION_NAME: 'Ballycrossaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824577,
        LOCATION_LATITUDE_DEG: 53.1497802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA032900',
        LOCATION_NAME: 'Ballycrovane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.94935,
        LOCATION_LATITUDE_DEG: 51.7163516,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033000',
        LOCATION_NAME: 'Ballycroy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8288654,
        LOCATION_LATITUDE_DEG: 54.0198799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033050',
        LOCATION_NAME: 'Ballycrystal',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7600137,
        LOCATION_LATITUDE_DEG: 52.6114817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033100',
        LOCATION_NAME: 'Ballycullane',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323518,
        LOCATION_LATITUDE_DEG: 52.266383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033150',
        LOCATION_NAME: 'Ballycullen',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1787593,
        LOCATION_LATITUDE_DEG: 53.0033273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033200',
        LOCATION_NAME: 'Ballycumber',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6658031,
        LOCATION_LATITUDE_DEG: 53.3164912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033300',
        LOCATION_NAME: 'Ballycummin',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6832662,
        LOCATION_LATITUDE_DEG: 52.6237665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033400',
        LOCATION_NAME: 'Ballydaly',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7757747,
        LOCATION_LATITUDE_DEG: 53.2772954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033500',
        LOCATION_NAME: 'Ballydane',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489823,
        LOCATION_LATITUDE_DEG: 52.64972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033600',
        LOCATION_NAME: 'Ballydangan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0817938,
        LOCATION_LATITUDE_DEG: 53.3599038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033700',
        LOCATION_NAME: 'Ballydavid',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.365171,
        LOCATION_LATITUDE_DEG: 52.2193087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033800',
        LOCATION_NAME: 'Ballydavid',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4796103,
        LOCATION_LATITUDE_DEG: 53.2093824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033850',
        LOCATION_NAME: 'Ballydavis',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2469749,
        LOCATION_LATITUDE_DEG: 53.0588428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA033900',
        LOCATION_NAME: 'Ballydehob',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.471059,
        LOCATION_LATITUDE_DEG: 51.5619418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034000',
        LOCATION_NAME: 'Ballydesmond',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2446015,
        LOCATION_LATITUDE_DEG: 52.1857949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034100',
        LOCATION_NAME: 'Ballydine Cross Roads',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4991021,
        LOCATION_LATITUDE_DEG: 52.3663968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034150',
        LOCATION_NAME: 'Ballydonagh',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8554032,
        LOCATION_LATITUDE_DEG: 53.3983645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034200',
        LOCATION_NAME: 'Ballydooley',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3442035,
        LOCATION_LATITUDE_DEG: 53.6748366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034300',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6660091,
        LOCATION_LATITUDE_DEG: 52.4497207,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990151',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6617057,
        LOCATION_LATITUDE_DEG: 52.4532906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034500',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0509436,
        LOCATION_LATITUDE_DEG: 52.1536832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990944',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034400',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2657838,
        LOCATION_LATITUDE_DEG: 52.2329845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034600',
        LOCATION_NAME: 'Ballyduff',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4717411,
        LOCATION_LATITUDE_DEG: 52.6348312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034650',
        LOCATION_NAME: 'Ballydunlea',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7124725,
        LOCATION_LATITUDE_DEG: 52.2490075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034700',
        LOCATION_NAME: 'Ballydurn',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3990963,
        LOCATION_LATITUDE_DEG: 52.2496824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA034800',
        LOCATION_NAME: 'Ballydwyer',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.57501,
        LOCATION_LATITUDE_DEG: 52.252238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035000',
        LOCATION_NAME: 'Ballyederlan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3844126,
        LOCATION_LATITUDE_DEG: 54.6049198,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035150',
        LOCATION_NAME: 'Ballyedmond',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1953767,
        LOCATION_LATITUDE_DEG: 51.9355394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035100',
        LOCATION_NAME: 'Ballyedmond',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3400573,
        LOCATION_LATITUDE_DEG: 52.5512637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA104000',
        LOCATION_NAME: 'Ballyedmonduff',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.227789,
        LOCATION_LATITUDE_DEG: 53.2419524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035200',
        LOCATION_NAME: 'Ballyfad',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.26568,
        LOCATION_LATITUDE_DEG: 52.7664259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035300',
        LOCATION_NAME: 'Ballyfanoher',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992501,
        LOCATION_LATITUDE_DEG: 54.2998956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035400',
        LOCATION_NAME: 'Ballyfarna',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0110776,
        LOCATION_LATITUDE_DEG: 53.7848655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035500',
        LOCATION_NAME: 'Ballyfarnan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2147536,
        LOCATION_LATITUDE_DEG: 54.0674679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035600',
        LOCATION_NAME: 'Ballyfermot',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3568945,
        LOCATION_LATITUDE_DEG: 53.3416899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035700',
        LOCATION_NAME: 'Ballyferriter',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.416094,
        LOCATION_LATITUDE_DEG: 52.1663986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035800',
        LOCATION_NAME: 'Ballyfin',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4173297,
        LOCATION_LATITUDE_DEG: 53.0580275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA035900',
        LOCATION_NAME: 'Ballyforan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2675742,
        LOCATION_LATITUDE_DEG: 53.4772124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036100',
        LOCATION_NAME: 'Ballyfoyle',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3408877,
        LOCATION_LATITUDE_DEG: 51.7396434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036000',
        LOCATION_NAME: 'Ballyfoyle',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323746,
        LOCATION_LATITUDE_DEG: 52.7164281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA105500',
        LOCATION_NAME: 'Ballygall',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2882107,
        LOCATION_LATITUDE_DEG: 53.3850914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036300',
        LOCATION_NAME: 'Ballygar',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3305596,
        LOCATION_LATITUDE_DEG: 53.5249142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990844',
        LOCATION_NAME: 'Ballygarran',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036400',
        LOCATION_NAME: 'Ballygarrett',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322743,
        LOCATION_LATITUDE_DEG: 52.5664104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036500',
        LOCATION_NAME: 'Ballygarries',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825446,
        LOCATION_LATITUDE_DEG: 53.6831445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036600',
        LOCATION_NAME: 'Ballygarvan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491907,
        LOCATION_LATITUDE_DEG: 51.8163521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA036900',
        LOCATION_NAME: 'Ballygawley',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.445554,
        LOCATION_LATITUDE_DEG: 54.1921177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037000',
        LOCATION_NAME: 'Ballygeale',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159103,
        LOCATION_LATITUDE_DEG: 52.5664277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990869',
        LOCATION_NAME: 'Ballygibbon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037050',
        LOCATION_NAME: 'Ballygireen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9329255,
        LOCATION_LATITUDE_DEG: 52.7686555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037100',
        LOCATION_NAME: 'Ballyglass',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659459,
        LOCATION_LATITUDE_DEG: 53.7331519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037300',
        LOCATION_NAME: 'Ballyglass',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5870378,
        LOCATION_LATITUDE_DEG: 52.7148237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037200',
        LOCATION_NAME: 'Ballyglass',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1643457,
        LOCATION_LATITUDE_DEG: 52.4465773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037350',
        LOCATION_NAME: 'Ballyglisheen',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8545089,
        LOCATION_LATITUDE_DEG: 52.5478195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037400',
        LOCATION_NAME: 'Ballyglunin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7965837,
        LOCATION_LATITUDE_DEG: 53.4252605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037500',
        LOCATION_NAME: 'Ballygorey',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323857,
        LOCATION_LATITUDE_DEG: 52.2663906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037600',
        LOCATION_NAME: 'Ballygorman',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.343491,
        LOCATION_LATITUDE_DEG: 55.3721924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA037800',
        LOCATION_NAME: 'Ballygowan',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9700275,
        LOCATION_LATITUDE_DEG: 52.7779431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038000',
        LOCATION_NAME: 'Ballygrady',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159325,
        LOCATION_LATITUDE_DEG: 52.2163979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038150',
        LOCATION_NAME: 'Ballygrennan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4658975,
        LOCATION_LATITUDE_DEG: 52.4308584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038200',
        LOCATION_NAME: 'Ballygriffin',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824382,
        LOCATION_LATITUDE_DEG: 52.516422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038250',
        LOCATION_NAME: 'Ballygub',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0203138,
        LOCATION_LATITUDE_DEG: 52.4783737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA913340',
        LOCATION_NAME: 'Ballygunner',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0597479,
        LOCATION_LATITUDE_DEG: 52.2366826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA914540',
        LOCATION_NAME: 'Ballygurteen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9593487,
        LOCATION_LATITUDE_DEG: 51.6354963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038300',
        LOCATION_NAME: 'Ballyhack',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657554,
        LOCATION_LATITUDE_DEG: 52.2496838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038400',
        LOCATION_NAME: 'Ballyhade',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8434917,
        LOCATION_LATITUDE_DEG: 52.876555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038500',
        LOCATION_NAME: 'Ballyhahill',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992496,
        LOCATION_LATITUDE_DEG: 52.5497313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038600',
        LOCATION_NAME: 'Ballyhaise',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157584,
        LOCATION_LATITUDE_DEG: 54.0498688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038800',
        LOCATION_NAME: 'Ballyhale',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157708,
        LOCATION_LATITUDE_DEG: 52.4664035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA038900',
        LOCATION_NAME: 'Ballyhar',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5660107,
        LOCATION_LATITUDE_DEG: 52.1163882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039000',
        LOCATION_NAME: 'Ballyhard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824733,
        LOCATION_LATITUDE_DEG: 53.5998254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039100',
        LOCATION_NAME: 'Ballyhaunis',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7651176,
        LOCATION_LATITUDE_DEG: 53.7637491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990439',
        LOCATION_NAME: 'Ballyhea',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039150',
        LOCATION_NAME: 'Ballyhealy',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0715843,
        LOCATION_LATITUDE_DEG: 53.5917721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039200',
        LOCATION_NAME: 'Ballyhean',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159488,
        LOCATION_LATITUDE_DEG: 53.7831459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039250',
        LOCATION_NAME: 'Ballyheedy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5663271,
        LOCATION_LATITUDE_DEG: 51.7912807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039300',
        LOCATION_NAME: 'Ballyheelan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490642,
        LOCATION_LATITUDE_DEG: 53.8331404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039400',
        LOCATION_NAME: 'Ballyheigue',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326255,
        LOCATION_LATITUDE_DEG: 52.3830187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039500',
        LOCATION_NAME: 'Ballyhenry',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159267,
        LOCATION_LATITUDE_DEG: 53.5498275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039600',
        LOCATION_NAME: 'Ballyhide',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9649926,
        LOCATION_LATITUDE_DEG: 52.8220007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990971',
        LOCATION_NAME: 'Ballyhogue',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039700',
        LOCATION_NAME: 'Ballyhoolahan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492438,
        LOCATION_LATITUDE_DEG: 52.1496912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039800',
        LOCATION_NAME: 'Ballyhooly',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991853,
        LOCATION_LATITUDE_DEG: 52.1496852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA039900',
        LOCATION_NAME: 'Ballyhoorisky',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7323804,
        LOCATION_LATITUDE_DEG: 55.2332818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040100',
        LOCATION_NAME: 'Ballyhugh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5323781,
        LOCATION_LATITUDE_DEG: 54.0831705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040150',
        LOCATION_NAME: 'Ballyhuppanane',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4604186,
        LOCATION_LATITUDE_DEG: 53.0846409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040200',
        LOCATION_NAME: 'Ballyjamesduff',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2095097,
        LOCATION_LATITUDE_DEG: 53.864742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040250',
        LOCATION_NAME: 'Ballyjohnboy',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9554547,
        LOCATION_LATITUDE_DEG: 52.5689791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040300',
        LOCATION_NAME: 'Ballykealey',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.772293,
        LOCATION_LATITUDE_DEG: 52.7412831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991004',
        LOCATION_NAME: 'Ballykeane',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040400',
        LOCATION_NAME: 'Ballykeeran',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824248,
        LOCATION_LATITUDE_DEG: 53.4498098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040600',
        LOCATION_NAME: 'Ballykelly',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9649853,
        LOCATION_LATITUDE_DEG: 52.3370867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040700',
        LOCATION_NAME: 'Ballykerin',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991229,
        LOCATION_LATITUDE_DEG: 52.1496779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA040900',
        LOCATION_NAME: 'Ballykisteen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2042911,
        LOCATION_LATITUDE_DEG: 52.4977076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041050',
        LOCATION_NAME: 'Ballyknockan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2720734,
        LOCATION_LATITUDE_DEG: 52.9897295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041000',
        LOCATION_NAME: 'Ballyknockan',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.498989,
        LOCATION_LATITUDE_DEG: 53.099766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041100',
        LOCATION_NAME: 'Ballylaan',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4659776,
        LOCATION_LATITUDE_DEG: 52.9330678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041200',
        LOCATION_NAME: 'Ballylanders',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3452466,
        LOCATION_LATITUDE_DEG: 52.3743039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041300',
        LOCATION_NAME: 'Ballylane',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9314442,
        LOCATION_LATITUDE_DEG: 52.3564672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041400',
        LOCATION_NAME: 'Ballylaneen',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.399094,
        LOCATION_LATITUDE_DEG: 52.1663832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041500',
        LOCATION_NAME: 'Ballylassa',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.165943,
        LOCATION_LATITUDE_DEG: 53.5831285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041600',
        LOCATION_NAME: 'Ballyleague',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1495268,
        LOCATION_LATITUDE_DEG: 53.6603121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041650',
        LOCATION_NAME: 'Ballyleague',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9917743,
        LOCATION_LATITUDE_DEG: 53.6737233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041700',
        LOCATION_NAME: 'Ballylehane Upper',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157521,
        LOCATION_LATITUDE_DEG: 52.8997434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990219',
        LOCATION_NAME: 'Ballylickey',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4376794,
        LOCATION_LATITUDE_DEG: 51.7225599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041800',
        LOCATION_NAME: 'Ballyliffin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3990342,
        LOCATION_LATITUDE_DEG: 55.2832826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041900',
        LOCATION_NAME: 'Ballylinchy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492939,
        LOCATION_LATITUDE_DEG: 51.4829301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA041950',
        LOCATION_NAME: 'Ballyline',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4777788,
        LOCATION_LATITUDE_DEG: 52.5287479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991151',
        LOCATION_NAME: 'Ballylongane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0114,
        LOCATION_LATITUDE_DEG: 51.86,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042000',
        LOCATION_NAME: 'Ballylongford',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4825929,
        LOCATION_LATITUDE_DEG: 52.5497353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990307',
        LOCATION_NAME: 'Ballylongford',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042100',
        LOCATION_NAME: 'Ballylooby',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9907566,
        LOCATION_LATITUDE_DEG: 52.3277933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042200',
        LOCATION_NAME: 'Ballylusk',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1581215,
        LOCATION_LATITUDE_DEG: 52.9953071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042300',
        LOCATION_NAME: 'Ballylynan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0465759,
        LOCATION_LATITUDE_DEG: 52.9438485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042400',
        LOCATION_NAME: 'Ballymacarbry',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158299,
        LOCATION_LATITUDE_DEG: 52.2496875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042500',
        LOCATION_NAME: 'Ballymacaw',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0443274,
        LOCATION_LATITUDE_DEG: 52.1384776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042600',
        LOCATION_NAME: 'Ballymacelligott',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5826066,
        LOCATION_LATITUDE_DEG: 52.2497019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042700',
        LOCATION_NAME: 'Ballymackesy',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6974206,
        LOCATION_LATITUDE_DEG: 52.4568037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042800',
        LOCATION_NAME: 'Ballymackey',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0824308,
        LOCATION_LATITUDE_DEG: 52.8664521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA042900',
        LOCATION_NAME: 'Ballymackney',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6656789,
        LOCATION_LATITUDE_DEG: 53.9498472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990962',
        LOCATION_NAME: 'Ballymaclode',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043000',
        LOCATION_NAME: 'Ballymacoda',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324518,
        LOCATION_LATITUDE_DEG: 51.882956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043100',
        LOCATION_NAME: 'Ballymacquin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8160267,
        LOCATION_LATITUDE_DEG: 52.3864225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043150',
        LOCATION_NAME: 'Ballymacsliney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.195477,
        LOCATION_LATITUDE_DEG: 51.9391089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043200',
        LOCATION_NAME: 'Ballymacurly',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2966178,
        LOCATION_LATITUDE_DEG: 53.6935319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043300',
        LOCATION_NAME: 'Ballymacward',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824647,
        LOCATION_LATITUDE_DEG: 53.3831125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043350',
        LOCATION_NAME: 'Ballymaddock',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1817253,
        LOCATION_LATITUDE_DEG: 53.0406491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043400',
        LOCATION_NAME: 'Ballymagan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323442,
        LOCATION_LATITUDE_DEG: 55.1499712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043500',
        LOCATION_NAME: 'Ballymagooly',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.599195,
        LOCATION_LATITUDE_DEG: 52.1329878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043700',
        LOCATION_NAME: 'Ballymahon',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7669033,
        LOCATION_LATITUDE_DEG: 53.5666194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043750',
        LOCATION_NAME: 'Ballymakeegan',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7715395,
        LOCATION_LATITUDE_DEG: 53.6923457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043800',
        LOCATION_NAME: 'Ballymakeery',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1325647,
        LOCATION_LATITUDE_DEG: 51.9329659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA043900',
        LOCATION_NAME: 'Ballymakenny',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322573,
        LOCATION_LATITUDE_DEG: 53.7498272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044000',
        LOCATION_NAME: 'Ballymaleel',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6710302,
        LOCATION_LATITUDE_DEG: 54.9820024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044050',
        LOCATION_NAME: 'Ballymaloe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0684505,
        LOCATION_LATITUDE_DEG: 51.8601846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044100',
        LOCATION_NAME: 'Ballymanagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6992791,
        LOCATION_LATITUDE_DEG: 53.1978483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044150',
        LOCATION_NAME: 'Ballymanus',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0850922,
        LOCATION_LATITUDE_DEG: 53.0334178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044500',
        LOCATION_NAME: 'Ballymitty',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7094714,
        LOCATION_LATITUDE_DEG: 52.2794313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044550',
        LOCATION_NAME: 'Ballymoat',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8117239,
        LOCATION_LATITUDE_DEG: 53.5088732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044600',
        LOCATION_NAME: 'Ballymoe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4722645,
        LOCATION_LATITUDE_DEG: 53.6942367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044800',
        LOCATION_NAME: 'Ballymoney',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2245193,
        LOCATION_LATITUDE_DEG: 52.6776598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044850',
        LOCATION_NAME: 'Ballymoney South',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7643357,
        LOCATION_LATITUDE_DEG: 53.6114034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA044900',
        LOCATION_NAME: 'Ballymoon',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157544,
        LOCATION_LATITUDE_DEG: 52.6997272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045000',
        LOCATION_NAME: 'Ballymore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.323169,
        LOCATION_LATITUDE_DEG: 52.1169984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045250',
        LOCATION_NAME: 'Ballymore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2565302,
        LOCATION_LATITUDE_DEG: 51.8640271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045100',
        LOCATION_NAME: 'Ballymore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9157877,
        LOCATION_LATITUDE_DEG: 55.1499747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045200',
        LOCATION_NAME: 'Ballymore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6671857,
        LOCATION_LATITUDE_DEG: 53.4959155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045300',
        LOCATION_NAME: 'Ballymore Eustace',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157025,
        LOCATION_LATITUDE_DEG: 53.1330628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045500',
        LOCATION_NAME: 'Ballymorris',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7752364,
        LOCATION_LATITUDE_DEG: 52.6948755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045400',
        LOCATION_NAME: 'Ballymorris',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323887,
        LOCATION_LATITUDE_DEG: 52.18298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045550',
        LOCATION_NAME: 'Ballymorris',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2162464,
        LOCATION_LATITUDE_DEG: 53.1388801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045600',
        LOCATION_NAME: 'Ballymote',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5174324,
        LOCATION_LATITUDE_DEG: 54.1038842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990702',
        LOCATION_NAME: 'Ballymount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045700',
        LOCATION_NAME: 'Ballymoyle',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1156548,
        LOCATION_LATITUDE_DEG: 52.8497273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045800',
        LOCATION_NAME: 'Ballymullen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6983235,
        LOCATION_LATITUDE_DEG: 52.25629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045850',
        LOCATION_NAME: 'Ballymullen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3342167,
        LOCATION_LATITUDE_DEG: 52.8991449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA045900',
        LOCATION_NAME: 'Ballymun',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.263639,
        LOCATION_LATITUDE_DEG: 53.3948889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046000',
        LOCATION_NAME: 'Ballymurn',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4823065,
        LOCATION_LATITUDE_DEG: 52.4329996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046100',
        LOCATION_NAME: 'Ballymurphy',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8630546,
        LOCATION_LATITUDE_DEG: 52.5776428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046200',
        LOCATION_NAME: 'Ballymurray',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.13111,
        LOCATION_LATITUDE_DEG: 53.6017212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990946',
        LOCATION_NAME: 'Ballymurray',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046300',
        LOCATION_NAME: 'Ballynabola',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7916493,
        LOCATION_LATITUDE_DEG: 52.3637975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046400',
        LOCATION_NAME: 'Ballynacallagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.164671,
        LOCATION_LATITUDE_DEG: 51.610946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046500',
        LOCATION_NAME: 'Ballynacally',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659552,
        LOCATION_LATITUDE_DEG: 52.716452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046600',
        LOCATION_NAME: 'Ballynacarriga',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325555,
        LOCATION_LATITUDE_DEG: 51.6996467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046700',
        LOCATION_NAME: 'Ballynacarrigy',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5323808,
        LOCATION_LATITUDE_DEG: 53.5831136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046800',
        LOCATION_NAME: 'Ballynacarrow',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491674,
        LOCATION_LATITUDE_DEG: 54.1331834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA046900',
        LOCATION_NAME: 'Ballynaclogh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.165844,
        LOCATION_LATITUDE_DEG: 52.8164445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990856',
        LOCATION_NAME: 'Ballynaclough',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047100',
        LOCATION_NAME: 'Ballynacourty',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5658205,
        LOCATION_LATITUDE_DEG: 52.0829758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047200',
        LOCATION_NAME: 'Ballynacree',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2251691,
        LOCATION_LATITUDE_DEG: 53.7679714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047300',
        LOCATION_NAME: 'Ballynadrumny',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9555171,
        LOCATION_LATITUDE_DEG: 53.4329945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047400',
        LOCATION_NAME: 'Ballynafid',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3850049,
        LOCATION_LATITUDE_DEG: 53.5956181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047500',
        LOCATION_NAME: 'Ballynagall',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.38368,
        LOCATION_LATITUDE_DEG: 52.1791996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047600',
        LOCATION_NAME: 'Ballynagarbry',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7324086,
        LOCATION_LATITUDE_DEG: 53.3998061,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047800',
        LOCATION_NAME: 'Ballynagaul',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.565815,
        LOCATION_LATITUDE_DEG: 52.0496683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA047900',
        LOCATION_NAME: 'Ballynaglogh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491702,
        LOCATION_LATITUDE_DEG: 54.0665669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048000',
        LOCATION_NAME: 'Ballynagore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4688009,
        LOCATION_LATITUDE_DEG: 53.410705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048100',
        LOCATION_NAME: 'Ballynagrallagh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990417,
        LOCATION_LATITUDE_DEG: 52.3829982,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048200',
        LOCATION_NAME: 'Ballynagree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325461,
        LOCATION_LATITUDE_DEG: 51.982969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048300',
        LOCATION_NAME: 'Ballynahattina',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158803,
        LOCATION_LATITUDE_DEG: 53.4498169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048500',
        LOCATION_NAME: 'Ballynaheglish',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2906264,
        LOCATION_LATITUDE_DEG: 53.7300321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990857',
        LOCATION_NAME: 'Ballynahown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048800',
        LOCATION_NAME: 'Ballynakill',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324233,
        LOCATION_LATITUDE_DEG: 53.3664941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA048900',
        LOCATION_NAME: 'Ballynakill',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8656714,
        LOCATION_LATITUDE_DEG: 52.6834124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049000',
        LOCATION_NAME: 'Ballynakilla',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493382,
        LOCATION_LATITUDE_DEG: 51.6329423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049050',
        LOCATION_NAME: 'Ballynakillew',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1208599,
        LOCATION_LATITUDE_DEG: 53.458414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049100',
        LOCATION_NAME: 'Ballynalty',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992367,
        LOCATION_LATITUDE_DEG: 53.4998263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049200',
        LOCATION_NAME: 'Ballynameelagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9323989,
        LOCATION_LATITUDE_DEG: 54.8499406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049300',
        LOCATION_NAME: 'Ballynameeltogue',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158165,
        LOCATION_LATITUDE_DEG: 54.1165744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049400',
        LOCATION_NAME: 'Ballynamona',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6395645,
        LOCATION_LATITUDE_DEG: 52.0947846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049500',
        LOCATION_NAME: 'Ballynamona',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.449187,
        LOCATION_LATITUDE_DEG: 52.499726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991148',
        LOCATION_NAME: 'Ballynamullagh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.73542,
        LOCATION_LATITUDE_DEG: 53.236889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049800',
        LOCATION_NAME: 'Ballynamult',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491361,
        LOCATION_LATITUDE_DEG: 52.2163931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA049900',
        LOCATION_NAME: 'Ballynanty',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658982,
        LOCATION_LATITUDE_DEG: 52.4830216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050000',
        LOCATION_NAME: 'Ballynare Cross Roads',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5656925,
        LOCATION_LATITUDE_DEG: 53.4330971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA991038',
        LOCATION_NAME: 'Ballynaroon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3419,
        LOCATION_LATITUDE_DEG: 51.9169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050100',
        LOCATION_NAME: 'Ballynasare',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7572321,
        LOCATION_LATITUDE_DEG: 52.296211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050300',
        LOCATION_NAME: 'Ballynascarty',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991588,
        LOCATION_LATITUDE_DEG: 51.9329651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050400',
        LOCATION_NAME: 'Ballynashee',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991311,
        LOCATION_LATITUDE_DEG: 54.0998761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050500',
        LOCATION_NAME: 'Ballynaskreena',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.76016,
        LOCATION_LATITUDE_DEG: 52.4394428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050600',
        LOCATION_NAME: 'Ballynastangford',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.032517,
        LOCATION_LATITUDE_DEG: 53.7498444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050700',
        LOCATION_NAME: 'Ballyneale',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990649,
        LOCATION_LATITUDE_DEG: 52.4163934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050800',
        LOCATION_NAME: 'Ballynee',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7656942,
        LOCATION_LATITUDE_DEG: 53.7998321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA050900',
        LOCATION_NAME: 'Ballyneety',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491976,
        LOCATION_LATITUDE_DEG: 52.5997282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051000',
        LOCATION_NAME: 'Ballyneill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4658103,
        LOCATION_LATITUDE_DEG: 52.3664065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051100',
        LOCATION_NAME: 'Ballynestragh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.282291,
        LOCATION_LATITUDE_DEG: 52.716431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051200',
        LOCATION_NAME: 'Ballynew',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4320768,
        LOCATION_LATITUDE_DEG: 53.2359896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051300',
        LOCATION_NAME: 'Ballynoe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8547985,
        LOCATION_LATITUDE_DEG: 52.2022012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051400',
        LOCATION_NAME: 'Ballynoran',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6992112,
        LOCATION_LATITUDE_DEG: 52.3164057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051600',
        LOCATION_NAME: 'Ballyorgan',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658907,
        LOCATION_LATITUDE_DEG: 52.3163957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051800',
        LOCATION_NAME: 'Ballypatrick',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9088535,
        LOCATION_LATITUDE_DEG: 52.7336311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051900',
        LOCATION_NAME: 'Ballypatrick',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5485034,
        LOCATION_LATITUDE_DEG: 52.392644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA051950',
        LOCATION_NAME: 'Ballypierce',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6906196,
        LOCATION_LATITUDE_DEG: 52.6731437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052000',
        LOCATION_NAME: 'Ballyporeen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991641,
        LOCATION_LATITUDE_DEG: 52.2663995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052050',
        LOCATION_NAME: 'Ballyprecas',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6547248,
        LOCATION_LATITUDE_DEG: 52.6369027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052200',
        LOCATION_NAME: 'Ballyquin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.166051,
        LOCATION_LATITUDE_DEG: 52.2497025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052100',
        LOCATION_NAME: 'Ballyquin',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323758,
        LOCATION_LATITUDE_DEG: 52.3663942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052300',
        LOCATION_NAME: 'Ballyragget',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3343126,
        LOCATION_LATITUDE_DEG: 52.7880405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052350',
        LOCATION_NAME: 'Ballyrahan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0506472,
        LOCATION_LATITUDE_DEG: 52.3133135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052500',
        LOCATION_NAME: 'Ballyroan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2990691,
        LOCATION_LATITUDE_DEG: 52.9330536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052600',
        LOCATION_NAME: 'Ballyroe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7477389,
        LOCATION_LATITUDE_DEG: 52.2924579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052650',
        LOCATION_NAME: 'Ballyroe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7346205,
        LOCATION_LATITUDE_DEG: 52.751668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA052700',
        LOCATION_NAME: 'Ballyroebuck',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5536297,
        LOCATION_LATITUDE_DEG: 52.6518531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053000',
        LOCATION_NAME: 'Ballyroon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7660265,
        LOCATION_LATITUDE_DEG: 51.5663333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053100',
        LOCATION_NAME: 'Ballysadare',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5131053,
        LOCATION_LATITUDE_DEG: 54.2113918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053200',
        LOCATION_NAME: 'Ballysakeery',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992285,
        LOCATION_LATITUDE_DEG: 54.1831867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053300',
        LOCATION_NAME: 'Ballysax',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8133201,
        LOCATION_LATITUDE_DEG: 53.1152321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053400',
        LOCATION_NAME: 'Ballyshannon',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1960491,
        LOCATION_LATITUDE_DEG: 54.5035122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053500',
        LOCATION_NAME: 'Ballysheedy',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6342019,
        LOCATION_LATITUDE_DEG: 52.6283469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053550',
        LOCATION_NAME: 'Ballysheen Beg',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.792358,
        LOCATION_LATITUDE_DEG: 52.7577737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053600',
        LOCATION_NAME: 'Ballyshoneen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6825131,
        LOCATION_LATITUDE_DEG: 51.9496714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053800',
        LOCATION_NAME: 'Ballysimon',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5655111,
        LOCATION_LATITUDE_DEG: 52.6490503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990182',
        LOCATION_NAME: 'Ballysloe',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6088869,
        LOCATION_LATITUDE_DEG: 52.6395698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA053900',
        LOCATION_NAME: 'Ballysteen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492184,
        LOCATION_LATITUDE_DEG: 52.6497407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054000',
        LOCATION_NAME: 'Ballytarsna',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324508,
        LOCATION_LATITUDE_DEG: 52.5664204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990733',
        LOCATION_NAME: 'Ballythomas',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054025',
        LOCATION_NAME: 'Ballythomas',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1625019,
        LOCATION_LATITUDE_DEG: 53.0522065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054050',
        LOCATION_NAME: 'Ballytrasna',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8495076,
        LOCATION_LATITUDE_DEG: 53.5527285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054200',
        LOCATION_NAME: 'Ballyvaldon',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3128399,
        LOCATION_LATITUDE_DEG: 52.4575965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990831',
        LOCATION_NAME: 'Ballyvary',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054100',
        LOCATION_NAME: 'Ballyvaughan',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1514023,
        LOCATION_LATITUDE_DEG: 53.1174881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054400',
        LOCATION_NAME: 'Ballyvisteen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.449189,
        LOCATION_LATITUDE_DEG: 52.2663937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990725',
        LOCATION_NAME: 'Ballyvolane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054500',
        LOCATION_NAME: 'Ballyvourcher',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658939,
        LOCATION_LATITUDE_DEG: 52.7330508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054600',
        LOCATION_NAME: 'Ballyvourney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1647287,
        LOCATION_LATITUDE_DEG: 51.9481647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA054750',
        LOCATION_NAME: 'Ballywairy',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0629181,
        LOCATION_LATITUDE_DEG: 52.3808821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055050',
        LOCATION_NAME: 'Ballywilliam',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3251403,
        LOCATION_LATITUDE_DEG: 52.8270848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055000',
        LOCATION_NAME: 'Ballywilliam',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657388,
        LOCATION_LATITUDE_DEG: 52.4497048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA055100',
        LOCATION_NAME: 'Ballywilliamroe',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8970021,
        LOCATION_LATITUDE_DEG: 52.7046358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA056800',
        LOCATION_NAME: 'Balnacart',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2990526,
        LOCATION_LATITUDE_DEG: 53.7498323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058200',
        LOCATION_NAME: 'Balrath',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.482266,
        LOCATION_LATITUDE_DEG: 53.6165104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058300',
        LOCATION_NAME: 'Balrothery',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2156454,
        LOCATION_LATITUDE_DEG: 53.5831046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA058500',
        LOCATION_NAME: 'Balscadden',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2376016,
        LOCATION_LATITUDE_DEG: 53.6166316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059000',
        LOCATION_NAME: 'Baltimore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3634985,
        LOCATION_LATITUDE_DEG: 51.4865299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059100',
        LOCATION_NAME: 'Baltinglass',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6997332,
        LOCATION_LATITUDE_DEG: 52.939251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059300',
        LOCATION_NAME: 'Baltovin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7329421,
        LOCATION_LATITUDE_DEG: 52.3633332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059400',
        LOCATION_NAME: 'Baltray',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.261711,
        LOCATION_LATITUDE_DEG: 53.733423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA059500',
        LOCATION_NAME: 'Baltyboys',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5215866,
        LOCATION_LATITUDE_DEG: 53.1352686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060800',
        LOCATION_NAME: 'Banada',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8158868,
        LOCATION_LATITUDE_DEG: 54.0331695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060950',
        LOCATION_NAME: 'Banagher',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9043635,
        LOCATION_LATITUDE_DEG: 53.6031258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA060900',
        LOCATION_NAME: 'Banagher',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824459,
        LOCATION_LATITUDE_DEG: 53.1830826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA062300',
        LOCATION_NAME: 'Bandon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7402349,
        LOCATION_LATITUDE_DEG: 51.7497546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA063000',
        LOCATION_NAME: 'Bangor Erris',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7492968,
        LOCATION_LATITUDE_DEG: 54.1498827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA064800',
        LOCATION_NAME: 'Banna',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8160299,
        LOCATION_LATITUDE_DEG: 52.349713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065300',
        LOCATION_NAME: 'Bannow',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823409,
        LOCATION_LATITUDE_DEG: 52.2163813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065400',
        LOCATION_NAME: 'Banoge',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159048,
        LOCATION_LATITUDE_DEG: 52.4830216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065500',
        LOCATION_NAME: 'Bansha',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0658363,
        LOCATION_LATITUDE_DEG: 52.4497087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA065700',
        LOCATION_NAME: 'Banteer',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9032464,
        LOCATION_LATITUDE_DEG: 52.1353806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA066000',
        LOCATION_NAME: 'Bantry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4623216,
        LOCATION_LATITUDE_DEG: 51.6797492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA070100',
        LOCATION_NAME: 'Barefield',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9500996,
        LOCATION_LATITUDE_DEG: 52.8848921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA072650',
        LOCATION_NAME: 'Barkmill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3881759,
        LOCATION_LATITUDE_DEG: 53.0895093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA074400',
        LOCATION_NAME: 'Barloge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3067651,
        LOCATION_LATITUDE_DEG: 51.49053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075100',
        LOCATION_NAME: 'Barmona',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990354,
        LOCATION_LATITUDE_DEG: 52.5830138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075600',
        LOCATION_NAME: 'Barna',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1440664,
        LOCATION_LATITUDE_DEG: 53.256494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075700',
        LOCATION_NAME: 'Barna',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324712,
        LOCATION_LATITUDE_DEG: 52.5330173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075750',
        LOCATION_NAME: 'Barnabrow',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0818952,
        LOCATION_LATITUDE_DEG: 51.8753889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA075800',
        LOCATION_NAME: 'Barnacahoge',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8658898,
        LOCATION_LATITUDE_DEG: 53.9165564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076200',
        LOCATION_NAME: 'Barnacurra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659596,
        LOCATION_LATITUDE_DEG: 52.199693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990787',
        LOCATION_NAME: 'Barnadearg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076300',
        LOCATION_NAME: 'Barnaderg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7200041,
        LOCATION_LATITUDE_DEG: 53.4874161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076350',
        LOCATION_NAME: 'Barnahask',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6880468,
        LOCATION_LATITUDE_DEG: 52.6397705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076650',
        LOCATION_NAME: 'Barnashrone',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3659895,
        LOCATION_LATITUDE_DEG: 53.0819725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA076700',
        LOCATION_NAME: 'Barnatra',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8429276,
        LOCATION_LATITUDE_DEG: 54.2207292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA077600',
        LOCATION_NAME: 'Barnesmore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991201,
        LOCATION_LATITUDE_DEG: 54.6832254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990582',
        LOCATION_NAME: 'Barnlands',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA080600',
        LOCATION_NAME: 'Barntown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5465588,
        LOCATION_LATITUDE_DEG: 52.3314785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990747',
        LOCATION_NAME: 'Barnwellstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081000',
        LOCATION_NAME: 'Barnycarroll',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492171,
        LOCATION_LATITUDE_DEG: 53.7498436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081400',
        LOCATION_NAME: 'Barrabehy',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490933,
        LOCATION_LATITUDE_DEG: 52.3496969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081600',
        LOCATION_NAME: 'Barrack Village',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.749143,
        LOCATION_LATITUDE_DEG: 52.3163957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081700',
        LOCATION_NAME: 'Barrack Village',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657428,
        LOCATION_LATITUDE_DEG: 52.4664076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA081800',
        LOCATION_NAME: 'Barraduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3325775,
        LOCATION_LATITUDE_DEG: 52.066382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082300',
        LOCATION_NAME: 'Barratogher',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8491867,
        LOCATION_LATITUDE_DEG: 54.0331693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990304',
        LOCATION_NAME: 'Barretstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6109359,
        LOCATION_LATITUDE_DEG: 53.1488777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082400',
        LOCATION_NAME: 'Barrettstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6973121,
        LOCATION_LATITUDE_DEG: 53.2566261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA082700',
        LOCATION_NAME: 'Barrigone',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492407,
        LOCATION_LATITUDE_DEG: 52.5997408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083000',
        LOCATION_NAME: 'Barringtonsbridge',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658499,
        LOCATION_LATITUDE_DEG: 52.6497352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083500',
        LOCATION_NAME: 'Barronstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2087467,
        LOCATION_LATITUDE_DEG: 52.4835156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083600',
        LOCATION_NAME: 'Barronstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323433,
        LOCATION_LATITUDE_DEG: 52.3997048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA083700',
        LOCATION_NAME: 'Barrow',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326311,
        LOCATION_LATITUDE_DEG: 52.299712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086000',
        LOCATION_NAME: 'Barry',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658093,
        LOCATION_LATITUDE_DEG: 53.5998209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086150',
        LOCATION_NAME: 'Barry More',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA086175',
        LOCATION_NAME: 'Barrymore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9947911,
        LOCATION_LATITUDE_DEG: 53.4565219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA087200',
        LOCATION_NAME: 'Bartlemy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658645,
        LOCATION_LATITUDE_DEG: 52.0496771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA095900',
        LOCATION_NAME: 'Batterstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.532279,
        LOCATION_LATITUDE_DEG: 53.4664942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA096500',
        LOCATION_NAME: 'Battle Bridge',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0839381,
        LOCATION_LATITUDE_DEG: 53.9998569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097650',
        LOCATION_NAME: 'Baunskeha',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1383375,
        LOCATION_LATITUDE_DEG: 52.5001776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097800',
        LOCATION_NAME: 'Bauraneag',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659521,
        LOCATION_LATITUDE_DEG: 52.5164268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA097900',
        LOCATION_NAME: 'Baurscoob',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157953,
        LOCATION_LATITUDE_DEG: 52.499707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098500',
        LOCATION_NAME: 'Bawn',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991453,
        LOCATION_LATITUDE_DEG: 52.833046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098600',
        LOCATION_NAME: 'Bawn Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992343,
        LOCATION_LATITUDE_DEG: 52.2330004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098700',
        LOCATION_NAME: 'Bawnboy',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6767148,
        LOCATION_LATITUDE_DEG: 54.121771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098800',
        LOCATION_NAME: 'Bawnmore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492368,
        LOCATION_LATITUDE_DEG: 51.9496691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA098900',
        LOCATION_NAME: 'Bawnmore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5936825,
        LOCATION_LATITUDE_DEG: 52.6434983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103100',
        LOCATION_NAME: 'Bawnogue',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 22',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4113822,
        LOCATION_LATITUDE_DEG: 53.3257473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA099600',
        LOCATION_NAME: 'Bay View',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4326004,
        LOCATION_LATITUDE_DEG: 51.6829506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002500',
        LOCATION_NAME: 'Baylin',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.849133,
        LOCATION_LATITUDE_DEG: 53.4165084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022900',
        LOCATION_NAME: 'Baylough',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.960102,
        LOCATION_LATITUDE_DEG: 53.4351058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA103400',
        LOCATION_NAME: 'Bayside',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1368551,
        LOCATION_LATITUDE_DEG: 53.3920514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BA990921',
        LOCATION_NAME: 'Baytown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE001950',
        LOCATION_NAME: 'Beagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.942688,
        LOCATION_LATITUDE_DEG: 53.5670147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002000',
        LOCATION_NAME: 'Beal',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6160062,
        LOCATION_LATITUDE_DEG: 52.5664298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002200',
        LOCATION_NAME: 'Bealaclugga',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659363,
        LOCATION_LATITUDE_DEG: 53.1164817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002300',
        LOCATION_NAME: 'Bealadangan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6159908,
        LOCATION_LATITUDE_DEG: 53.3165142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002400',
        LOCATION_NAME: 'Bealaha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5825881,
        LOCATION_LATITUDE_DEG: 52.7164446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002450',
        LOCATION_NAME: 'Bealin',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8192764,
        LOCATION_LATITUDE_DEG: 53.4268309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002600',
        LOCATION_NAME: 'Bealnablath',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492415,
        LOCATION_LATITUDE_DEG: 51.8163559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002650',
        LOCATION_NAME: 'Bealnamorive',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022300',
        LOCATION_NAME: 'Bealnamulla',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0158324,
        LOCATION_LATITUDE_DEG: 53.4164999,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE002700',
        LOCATION_NAME: 'Bealock',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159638,
        LOCATION_LATITUDE_DEG: 51.7996567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005400',
        LOCATION_NAME: 'Beaufort',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6326174,
        LOCATION_LATITUDE_DEG: 52.066382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE005550',
        LOCATION_NAME: 'Beaulieu',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2936333,
        LOCATION_LATITUDE_DEG: 53.7314718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE048800',
        LOCATION_NAME: 'Beaumont',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2258113,
        LOCATION_LATITUDE_DEG: 53.3877341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE006300',
        LOCATION_NAME: 'Beauparc',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.591344,
        LOCATION_LATITUDE_DEG: 53.680247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009300',
        LOCATION_NAME: 'Bective',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6989888,
        LOCATION_LATITUDE_DEG: 53.5998208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE009400',
        LOCATION_NAME: 'Bective Bridge',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990068,
        LOCATION_LATITUDE_DEG: 53.5665174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010550',
        LOCATION_NAME: 'Bedford',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5018128,
        LOCATION_LATITUDE_DEG: 52.4698889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE010800',
        LOCATION_NAME: 'Bedlam',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491061,
        LOCATION_LATITUDE_DEG: 55.1166746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE013800',
        LOCATION_NAME: 'Beennamweel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159249,
        LOCATION_LATITUDE_DEG: 52.0496745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016400',
        LOCATION_NAME: 'Behagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659325,
        LOCATION_LATITUDE_DEG: 53.1330863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016500',
        LOCATION_NAME: 'Behy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0694813,
        LOCATION_LATITUDE_DEG: 54.1101518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE016800',
        LOCATION_NAME: 'Bekan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492027,
        LOCATION_LATITUDE_DEG: 53.7498443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE017000',
        LOCATION_NAME: 'Belalt',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8793916,
        LOCATION_LATITUDE_DEG: 54.537315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018000',
        LOCATION_NAME: 'Belclare',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325243,
        LOCATION_LATITUDE_DEG: 53.483112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018300',
        LOCATION_NAME: 'Belderg',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5616052,
        LOCATION_LATITUDE_DEG: 54.2966018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018400',
        LOCATION_NAME: 'Belderg',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492684,
        LOCATION_LATITUDE_DEG: 54.2999028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE018500',
        LOCATION_NAME: 'Beleek',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0804229,
        LOCATION_LATITUDE_DEG: 54.4890084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020300',
        LOCATION_NAME: 'Belgooly',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4798417,
        LOCATION_LATITUDE_DEG: 51.7353468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE020450',
        LOCATION_NAME: 'Belgrove',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2094192,
        LOCATION_LATITUDE_DEG: 51.8752762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021100',
        LOCATION_NAME: 'Bellacorick',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5778458,
        LOCATION_LATITUDE_DEG: 54.1242822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021500',
        LOCATION_NAME: 'Bellaheady Bridge',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6157727,
        LOCATION_LATITUDE_DEG: 54.0831658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021600',
        LOCATION_NAME: 'Bellahy',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992036,
        LOCATION_LATITUDE_DEG: 53.9665638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021800',
        LOCATION_NAME: 'Bellanaboy',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0658344,
        LOCATION_LATITUDE_DEG: 54.01656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE021900',
        LOCATION_NAME: 'Bellanaboy Bridge',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7492922,
        LOCATION_LATITUDE_DEG: 54.2166011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022000',
        LOCATION_NAME: 'Bellanacargy',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2657345,
        LOCATION_LATITUDE_DEG: 54.0331654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022400',
        LOCATION_NAME: 'Bellananagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4100121,
        LOCATION_LATITUDE_DEG: 53.9336523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022600',
        LOCATION_NAME: 'Bellanode',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323134,
        LOCATION_LATITUDE_DEG: 54.2665791,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE022800',
        LOCATION_NAME: 'Bellatrain',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657116,
        LOCATION_LATITUDE_DEG: 54.0331592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023000',
        LOCATION_NAME: 'Bellavary',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1576906,
        LOCATION_LATITUDE_DEG: 53.8985671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023650',
        LOCATION_NAME: 'Bellegrove',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1320006,
        LOCATION_LATITUDE_DEG: 53.0826722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE023900',
        LOCATION_NAME: 'Belleville',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7750066,
        LOCATION_LATITUDE_DEG: 53.3527437,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024000',
        LOCATION_NAME: 'Bellewstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3504343,
        LOCATION_LATITUDE_DEG: 53.6408625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024150',
        LOCATION_NAME: 'Bellharbour',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0709268,
        LOCATION_LATITUDE_DEG: -7.9947867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024200',
        LOCATION_NAME: 'Bellia',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7326172,
        LOCATION_LATITUDE_DEG: 52.6164353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990743',
        LOCATION_NAME: 'Bellinter',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE024500',
        LOCATION_NAME: 'Bellmount',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824338,
        LOCATION_LATITUDE_DEG: 53.2497896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990992',
        LOCATION_NAME: 'Bellurgan',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE901979',
        LOCATION_NAME: 'Belmont',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9665577,
        LOCATION_LATITUDE_DEG: 53.6092697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE025900',
        LOCATION_NAME: 'Belmullet',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9900983,
        LOCATION_LATITUDE_DEG: 54.2256059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE026800',
        LOCATION_NAME: 'Beltany',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324131,
        LOCATION_LATITUDE_DEG: 55.0999683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027800',
        LOCATION_NAME: 'Beltra',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3886189,
        LOCATION_LATITUDE_DEG: 53.9505692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE027700',
        LOCATION_NAME: 'Beltra',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6223961,
        LOCATION_LATITUDE_DEG: 54.222487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028000',
        LOCATION_NAME: 'Belturbet',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4235129,
        LOCATION_LATITUDE_DEG: 54.0995644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028200',
        LOCATION_NAME: 'Belvelly',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991838,
        LOCATION_LATITUDE_DEG: 51.8829578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE028300',
        LOCATION_NAME: 'Belville',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492477,
        LOCATION_LATITUDE_DEG: 54.1665892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030700',
        LOCATION_NAME: 'Bennekerry',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8669711,
        LOCATION_LATITUDE_DEG: 52.8320724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE030800',
        LOCATION_NAME: 'Bennettsbridge',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1833458,
        LOCATION_LATITUDE_DEG: 52.591014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE990675',
        LOCATION_NAME: 'Berrings',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BE040400',
        LOCATION_NAME: 'Bettystown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489557,
        LOCATION_LATITUDE_DEG: 53.6998248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI006800',
        LOCATION_NAME: 'Bilboa',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0357824,
        LOCATION_LATITUDE_DEG: 52.7813375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI009600',
        LOCATION_NAME: 'Billis',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1494626,
        LOCATION_LATITUDE_DEG: 53.8852053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012200',
        LOCATION_NAME: 'Bingfield',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323754,
        LOCATION_LATITUDE_DEG: 53.9665568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI012500',
        LOCATION_NAME: 'Binghamstown',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032625,
        LOCATION_LATITUDE_DEG: 54.1998939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI013900',
        LOCATION_NAME: 'Biorra',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.899139,
        LOCATION_LATITUDE_DEG: 53.0997647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI016500',
        LOCATION_NAME: 'Birdhill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324787,
        LOCATION_LATITUDE_DEG: 52.766447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI019450',
        LOCATION_NAME: 'Birmingham',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.78252,
        LOCATION_LATITUDE_DEG: 53.5244589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI024200',
        LOCATION_NAME: 'Birr',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9117624,
        LOCATION_LATITUDE_DEG: 53.0938781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029400',
        LOCATION_NAME: 'Bishops Village',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.282588,
        LOCATION_LATITUDE_DEG: 51.6163413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029700',
        LOCATION_NAME: 'Bishopshall',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323759,
        LOCATION_LATITUDE_DEG: 52.3163969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI029750',
        LOCATION_NAME: 'Bishopsquarter',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.118428,
        LOCATION_LATITUDE_DEG: 53.1262496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BI030600',
        LOCATION_NAME: 'Bishopstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5220715,
        LOCATION_LATITUDE_DEG: 51.8808238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000300',
        LOCATION_NAME: 'Black Bull',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822795,
        LOCATION_LATITUDE_DEG: 53.449795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL000400',
        LOCATION_NAME: 'Black Bush, The',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989851,
        LOCATION_LATITUDE_DEG: 53.4664952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006500',
        LOCATION_NAME: 'Blacklion',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8922947,
        LOCATION_LATITUDE_DEG: 54.2814885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL006600',
        LOCATION_NAME: 'Blacklion',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6657134,
        LOCATION_LATITUDE_DEG: 52.7497262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008100',
        LOCATION_NAME: 'Blackpool',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5324857,
        LOCATION_LATITUDE_DEG: 52.3830095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008400',
        LOCATION_NAME: 'Blackpool',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658868,
        LOCATION_LATITUDE_DEG: 51.9163673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008800',
        LOCATION_NAME: 'Blackrock',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4091931,
        LOCATION_LATITUDE_DEG: 51.896607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL001800',
        LOCATION_NAME: 'Blackrock',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3785192,
        LOCATION_LATITUDE_DEG: 53.9443394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL008700',
        LOCATION_NAME: 'Blackrock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1841052,
        LOCATION_LATITUDE_DEG: 53.2993835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL009600',
        LOCATION_NAME: 'Blacksod',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.070524,
        LOCATION_LATITUDE_DEG: 54.1013859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010100',
        LOCATION_NAME: 'Blackwater',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5953763,
        LOCATION_LATITUDE_DEG: 52.7157271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010500',
        LOCATION_NAME: 'Blackwater',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3490009,
        LOCATION_LATITUDE_DEG: 52.4496927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL010600',
        LOCATION_NAME: 'Blackwater Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7493281,
        LOCATION_LATITUDE_DEG: 51.8496701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL011600',
        LOCATION_NAME: 'Blackwood',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.79902,
        LOCATION_LATITUDE_DEG: 53.2830815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL015050',
        LOCATION_NAME: 'Blainroe',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0461089,
        LOCATION_LATITUDE_DEG: 52.9422573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL016400',
        LOCATION_NAME: 'Blairs Cove',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5326053,
        LOCATION_LATITUDE_DEG: 51.5996399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL018400',
        LOCATION_NAME: 'Blanchardstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.392976,
        LOCATION_LATITUDE_DEG: 53.3851891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL019700',
        LOCATION_NAME: 'Blarney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5585983,
        LOCATION_LATITUDE_DEG: 51.9370634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL020800',
        LOCATION_NAME: 'Bleach Hill',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658385,
        LOCATION_LATITUDE_DEG: 53.2497811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL022900',
        LOCATION_NAME: 'Blennerville',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.734352,
        LOCATION_LATITUDE_DEG: 52.2558136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL023000',
        LOCATION_NAME: 'Blessington',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322989,
        LOCATION_LATITUDE_DEG: 53.1664701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL024350',
        LOCATION_NAME: 'Blindwell',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9924454,
        LOCATION_LATITUDE_DEG: 53.5878058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL026800',
        LOCATION_NAME: 'Blue Ball',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6158102,
        LOCATION_LATITUDE_DEG: 53.2164806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL027400',
        LOCATION_NAME: 'Bluebell',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491847,
        LOCATION_LATITUDE_DEG: 52.0496748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BL030400',
        LOCATION_NAME: 'Bluebell',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3512163,
        LOCATION_LATITUDE_DEG: -5.8881533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO001200',
        LOCATION_NAME: 'Bobsville',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657409,
        LOCATION_LATITUDE_DEG: 53.7165227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO002900',
        LOCATION_NAME: 'Bodenstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6706556,
        LOCATION_LATITUDE_DEG: 53.2672858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004700',
        LOCATION_NAME: 'Bodyke',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6001698,
        LOCATION_LATITUDE_DEG: 52.8868576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO004900',
        LOCATION_NAME: 'Bofeenaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3257111,
        LOCATION_LATITUDE_DEG: 53.9867587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005400',
        LOCATION_NAME: 'Boghadoon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4325485,
        LOCATION_LATITUDE_DEG: 53.9998727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO005650',
        LOCATION_NAME: 'Boghlone',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3402168,
        LOCATION_LATITUDE_DEG: 53.031001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006400',
        LOCATION_NAME: 'Boher',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658926,
        LOCATION_LATITUDE_DEG: 52.6164286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006500',
        LOCATION_NAME: 'Boher',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3653386,
        LOCATION_LATITUDE_DEG: 52.82128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006600',
        LOCATION_NAME: 'Boheraphuca',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491275,
        LOCATION_LATITUDE_DEG: 53.0164621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006700',
        LOCATION_NAME: 'Boherboy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659538,
        LOCATION_LATITUDE_DEG: 52.1496953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006800',
        LOCATION_NAME: 'Boherbue',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0707359,
        LOCATION_LATITUDE_DEG: 52.160506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO006900',
        LOCATION_NAME: 'Bohercrow',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1847462,
        LOCATION_LATITUDE_DEG: 52.481923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007000',
        LOCATION_NAME: 'Bohereen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5811131,
        LOCATION_LATITUDE_DEG: 52.6376163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007100',
        LOCATION_NAME: 'Boherlahan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8921508,
        LOCATION_LATITUDE_DEG: 52.5707652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007200',
        LOCATION_NAME: 'Bohermeen',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823024,
        LOCATION_LATITUDE_DEG: 53.6498205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007300',
        LOCATION_NAME: 'Bohermore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0485624,
        LOCATION_LATITUDE_DEG: 53.2705319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO991147',
        LOCATION_NAME: 'Boherquill',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4622,
        LOCATION_LATITUDE_DEG: 53.7044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007425',
        LOCATION_NAME: 'Bohilla',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1030494,
        LOCATION_LATITUDE_DEG: 52.445439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007600',
        LOCATION_NAME: 'Bohola',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492237,
        LOCATION_LATITUDE_DEG: 53.8998633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO007850',
        LOCATION_NAME: 'Boladurragh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7109537,
        LOCATION_LATITUDE_DEG: 52.592705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009300',
        LOCATION_NAME: 'Boleyvogue',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156992,
        LOCATION_LATITUDE_DEG: 52.5497119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009550',
        LOCATION_NAME: 'Bolinahaney',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5860106,
        LOCATION_LATITUDE_DEG: 52.666313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO009700',
        LOCATION_NAME: 'Bolinglanna',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993125,
        LOCATION_LATITUDE_DEG: 53.866569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015600',
        LOCATION_NAME: 'Boolakennedy',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.065848,
        LOCATION_LATITUDE_DEG: 52.3329967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015650',
        LOCATION_NAME: 'Boolavogue',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4208156,
        LOCATION_LATITUDE_DEG: 52.556107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015800',
        LOCATION_NAME: 'Boolteens',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.749323,
        LOCATION_LATITUDE_DEG: 52.1830341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO015900',
        LOCATION_NAME: 'Boolteens',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7493167,
        LOCATION_LATITUDE_DEG: 52.1829985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016000',
        LOCATION_NAME: 'Boolyglass',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823961,
        LOCATION_LATITUDE_DEG: 52.4164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO016300',
        LOCATION_NAME: 'Booterstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1953507,
        LOCATION_LATITUDE_DEG: 53.3086862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO019200',
        LOCATION_NAME: 'Borim',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.699099,
        LOCATION_LATITUDE_DEG: 54.1665778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO990600',
        LOCATION_NAME: 'Bornacoola',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020100',
        LOCATION_NAME: 'Borris',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9305967,
        LOCATION_LATITUDE_DEG: 52.6060178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO040900',
        LOCATION_NAME: 'Borris Idrone',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020200',
        LOCATION_NAME: 'Borris in Ossory',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6242572,
        LOCATION_LATITUDE_DEG: 52.9418548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020300',
        LOCATION_NAME: 'Borris-Idrone',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.915719,
        LOCATION_LATITUDE_DEG: 52.5830408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO991055',
        LOCATION_NAME: 'Borris-in-Ossory',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.631,
        LOCATION_LATITUDE_DEG: 52.939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020500',
        LOCATION_NAME: 'Borrisokane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.134075,
        LOCATION_LATITUDE_DEG: 53.001465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020800',
        LOCATION_NAME: 'Borrisoleigh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9623092,
        LOCATION_LATITUDE_DEG: 52.754635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO020700',
        LOCATION_NAME: 'Borrisoleigh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491156,
        LOCATION_LATITUDE_DEG: 52.7497445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024300',
        LOCATION_NAME: 'Boston',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325173,
        LOCATION_LATITUDE_DEG: 53.0330704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO024400',
        LOCATION_NAME: 'Boston',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658738,
        LOCATION_LATITUDE_DEG: 53.1997925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO027100',
        LOCATION_NAME: 'Bottlehill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658982,
        LOCATION_LATITUDE_DEG: 52.0496734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO029200',
        LOCATION_NAME: 'Bouladuff',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9043435,
        LOCATION_LATITUDE_DEG: 52.7140399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO030900',
        LOCATION_NAME: 'Bourney',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8158314,
        LOCATION_LATITUDE_DEG: 52.8997512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039450',
        LOCATION_NAME: 'Boycestown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3460451,
        LOCATION_LATITUDE_DEG: 51.8003107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO990745',
        LOCATION_NAME: 'Boyerstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BO039500',
        LOCATION_NAME: 'Boyle',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3064083,
        LOCATION_LATITUDE_DEG: 53.9747653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR001600',
        LOCATION_NAME: 'Brackhill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993108,
        LOCATION_LATITUDE_DEG: 52.1663937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002100',
        LOCATION_NAME: 'Bracklin',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1073989,
        LOCATION_LATITUDE_DEG: 53.567187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002150',
        LOCATION_NAME: 'Brackloon',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7112051,
        LOCATION_LATITUDE_DEG: 53.574648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR002300',
        LOCATION_NAME: 'Bracknagh',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990551,
        LOCATION_LATITUDE_DEG: 53.1997694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR003200',
        LOCATION_NAME: 'Braddocks',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990135,
        LOCATION_LATITUDE_DEG: 54.1998666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR019300',
        LOCATION_NAME: 'Brandon',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.166055,
        LOCATION_LATITUDE_DEG: 52.2664064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR020200',
        LOCATION_NAME: 'Brannockstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6887209,
        LOCATION_LATITUDE_DEG: 53.1211603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR024400',
        LOCATION_NAME: 'Bray',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1105027,
        LOCATION_LATITUDE_DEG: 53.2065668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026200',
        LOCATION_NAME: 'Breaghwy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2325435,
        LOCATION_LATITUDE_DEG: 53.8331613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026800',
        LOCATION_NAME: 'Breansha',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3111563,
        LOCATION_LATITUDE_DEG: 52.4691424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR026900',
        LOCATION_NAME: 'Breansha Beg',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1959016,
        LOCATION_LATITUDE_DEG: 52.4501628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR027000',
        LOCATION_NAME: 'Breansha More',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1852497,
        LOCATION_LATITUDE_DEG: 52.4510286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029400',
        LOCATION_NAME: 'Bree',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5990238,
        LOCATION_LATITUDE_DEG: 52.4329991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029500',
        LOCATION_NAME: 'Breedoge',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824553,
        LOCATION_LATITUDE_DEG: 53.899856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR029700',
        LOCATION_NAME: 'Breenagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8990855,
        LOCATION_LATITUDE_DEG: 54.93325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR094200',
        LOCATION_NAME: 'Brennanstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1672828,
        LOCATION_LATITUDE_DEG: 53.2585351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990736',
        LOCATION_NAME: 'Brews Hill',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR033900',
        LOCATION_NAME: 'Brickeens',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825081,
        LOCATION_LATITUDE_DEG: 53.7165408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034100',
        LOCATION_NAME: 'Brickens',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8834265,
        LOCATION_LATITUDE_DEG: 53.716677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034250',
        LOCATION_NAME: 'Brickhill West',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7657792,
        LOCATION_LATITUDE_DEG: 52.6953641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR034700',
        LOCATION_NAME: 'Bridebridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324736,
        LOCATION_LATITUDE_DEG: 52.0663846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR035200',
        LOCATION_NAME: 'Brideswell',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0985753,
        LOCATION_LATITUDE_DEG: 53.4554101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR991131',
        LOCATION_NAME: 'Brideswell',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5672,
        LOCATION_LATITUDE_DEG: 52.2506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR036500',
        LOCATION_NAME: 'Bridge End',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823496,
        LOCATION_LATITUDE_DEG: 55.0332581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR037300',
        LOCATION_NAME: 'Bridge Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991167,
        LOCATION_LATITUDE_DEG: 54.5832248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR039600',
        LOCATION_NAME: 'Bridgeland',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4990045,
        LOCATION_LATITUDE_DEG: 52.799739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR040300',
        LOCATION_NAME: 'Bridgend',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823544,
        LOCATION_LATITUDE_DEG: 55.0332938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041400',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5208964,
        LOCATION_LATITUDE_DEG: 52.7621759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041200',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158708,
        LOCATION_LATITUDE_DEG: 53.7498389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041100',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658374,
        LOCATION_LATITUDE_DEG: 54.4165969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR041300',
        LOCATION_NAME: 'Bridgetown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5490126,
        LOCATION_LATITUDE_DEG: 52.2329767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR042650',
        LOCATION_NAME: 'Brierfield',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6606403,
        LOCATION_LATITUDE_DEG: 53.4523194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049300',
        LOCATION_NAME: 'Brinlack',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.282406,
        LOCATION_LATITUDE_DEG: 55.1166746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR049400',
        LOCATION_NAME: 'Brinny',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6978223,
        LOCATION_LATITUDE_DEG: 51.7903874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050200',
        LOCATION_NAME: 'Briskil',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8158208,
        LOCATION_LATITUDE_DEG: 53.7831359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR050300',
        LOCATION_NAME: 'Briskil Upper',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991142,
        LOCATION_LATITUDE_DEG: 53.7998381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053200',
        LOCATION_NAME: 'Brittas',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991755,
        LOCATION_LATITUDE_DEG: 52.6164281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053350',
        LOCATION_NAME: 'Brittas',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8248576,
        LOCATION_LATITUDE_DEG: 53.4716817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053300',
        LOCATION_NAME: 'Brittas',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4611207,
        LOCATION_LATITUDE_DEG: 53.2380754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR053375',
        LOCATION_NAME: 'Brittas Bay',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0557767,
        LOCATION_LATITUDE_DEG: 52.8870935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057100',
        LOCATION_NAME: 'Broadford',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659481,
        LOCATION_LATITUDE_DEG: 52.3497016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR057000',
        LOCATION_NAME: 'Broadford',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6324941,
        LOCATION_LATITUDE_DEG: 52.7997535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR990996',
        LOCATION_NAME: 'Broadford',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR060200',
        LOCATION_NAME: 'Broadway',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.389111,
        LOCATION_LATITUDE_DEG: 52.2180142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR071200',
        LOCATION_NAME: 'Brooklodge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.349187,
        LOCATION_LATITUDE_DEG: 51.9329671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR072100',
        LOCATION_NAME: 'Brookville',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658464,
        LOCATION_LATITUDE_DEG: 52.4497134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073450',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.165625,
        LOCATION_LATITUDE_DEG: 51.932434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR073100',
        LOCATION_NAME: 'Broomfield',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6989888,
        LOCATION_LATITUDE_DEG: 54.0665559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075200',
        LOCATION_NAME: 'Brosna',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659811,
        LOCATION_LATITUDE_DEG: 52.3164118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR075100',
        LOCATION_NAME: 'Brosna',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824267,
        LOCATION_LATITUDE_DEG: 52.9830554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR076300',
        LOCATION_NAME: 'Broughal',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658089,
        LOCATION_LATITUDE_DEG: 53.1830782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080600',
        LOCATION_NAME: 'Browns Mills',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.499196,
        LOCATION_LATITUDE_DEG: 51.716352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR080800',
        LOCATION_NAME: 'Brownsbarn',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823595,
        LOCATION_LATITUDE_DEG: 52.4997123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081100',
        LOCATION_NAME: 'Brownsgrove',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7991166,
        LOCATION_LATITUDE_DEG: 53.5600492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081600',
        LOCATION_NAME: 'Brownstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8458017,
        LOCATION_LATITUDE_DEG: 53.1255382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081500',
        LOCATION_NAME: 'Brownstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5626181,
        LOCATION_LATITUDE_DEG: 53.6349817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR081700',
        LOCATION_NAME: 'Brownswood',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5490146,
        LOCATION_LATITUDE_DEG: 52.4664047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083000',
        LOCATION_NAME: 'Bruckless',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824376,
        LOCATION_LATITUDE_DEG: 54.6332321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083500',
        LOCATION_NAME: 'Bruff',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5498452,
        LOCATION_LATITUDE_DEG: 52.4817177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR083800',
        LOCATION_NAME: 'Bruis',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2390034,
        LOCATION_LATITUDE_DEG: 52.4498963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BR085400',
        LOCATION_NAME: 'Bruree',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6659023,
        LOCATION_LATITUDE_DEG: 52.41641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU990832',
        LOCATION_NAME: 'Buckree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU009600',
        LOCATION_NAME: 'Bulgaden',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.532493,
        LOCATION_LATITUDE_DEG: 52.4164132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU010500',
        LOCATION_NAME: 'Bullaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491862,
        LOCATION_LATITUDE_DEG: 53.2497945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU011400',
        LOCATION_NAME: 'Bullys Corner',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.565701,
        LOCATION_LATITUDE_DEG: 52.8330445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU012800',
        LOCATION_NAME: 'Bunacurry',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9743151,
        LOCATION_LATITUDE_DEG: 53.9748716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013100',
        LOCATION_NAME: 'Bunaw',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7993427,
        LOCATION_LATITUDE_DEG: 51.7829629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013200',
        LOCATION_NAME: 'Bunbeg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2986723,
        LOCATION_LATITUDE_DEG: 55.0622729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013300',
        LOCATION_NAME: 'Bunbrosna',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.432407,
        LOCATION_LATITUDE_DEG: 53.5998241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013400',
        LOCATION_NAME: 'Bunbrusna',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323757,
        LOCATION_LATITUDE_DEG: 53.5998165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013800',
        LOCATION_NAME: 'Bunclody',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6548885,
        LOCATION_LATITUDE_DEG: 52.6558203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU013900',
        LOCATION_NAME: 'Buncrana',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4568929,
        LOCATION_LATITUDE_DEG: 55.1407704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014100',
        LOCATION_NAME: 'Bundoran',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2901957,
        LOCATION_LATITUDE_DEG: 54.475118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014200',
        LOCATION_NAME: 'Bundorragha',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7492961,
        LOCATION_LATITUDE_DEG: 53.5975373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014500',
        LOCATION_NAME: 'Bunglass',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990215,
        LOCATION_LATITUDE_DEG: 53.4331032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014700',
        LOCATION_NAME: 'Bunlacken',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4490949,
        LOCATION_LATITUDE_DEG: 52.7997417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU014800',
        LOCATION_NAME: 'Bunlahy',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5823817,
        LOCATION_LATITUDE_DEG: 53.7998387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015000',
        LOCATION_NAME: 'Bunmahon',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.37152,
        LOCATION_LATITUDE_DEG: 52.1438731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015050',
        LOCATION_NAME: 'Bunnagurragh',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6882226,
        LOCATION_LATITUDE_DEG: 52.6658418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015200',
        LOCATION_NAME: 'Bunnahowen',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993115,
        LOCATION_LATITUDE_DEG: 54.1998932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015300',
        LOCATION_NAME: 'Bunnanaddan',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991733,
        LOCATION_LATITUDE_DEG: 54.0498698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015500',
        LOCATION_NAME: 'Bunnyconnellan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159216,
        LOCATION_LATITUDE_DEG: 54.1165811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015600',
        LOCATION_NAME: 'Bunowen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.099331,
        LOCATION_LATITUDE_DEG: 53.4198131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015700',
        LOCATION_NAME: 'Bunratty',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8072785,
        LOCATION_LATITUDE_DEG: 52.6865459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU015800',
        LOCATION_NAME: 'Bunratty East',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159241,
        LOCATION_LATITUDE_DEG: 52.6997386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU020300',
        LOCATION_NAME: 'Burkestown Cross Roads',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490441,
        LOCATION_LATITUDE_DEG: 52.2663811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU023300',
        LOCATION_NAME: 'Burncourt',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0755535,
        LOCATION_LATITUDE_DEG: 52.3102649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024100',
        LOCATION_NAME: 'Burnfoot',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4032671,
        LOCATION_LATITUDE_DEG: 55.0579634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU024200',
        LOCATION_NAME: 'Burnfort',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5992083,
        LOCATION_LATITUDE_DEG: 52.0663848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030100',
        LOCATION_NAME: 'Burrishoole Bridge',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659841,
        LOCATION_LATITUDE_DEG: 53.8998626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU030400',
        LOCATION_NAME: 'Burrow',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3989876,
        LOCATION_LATITUDE_DEG: 52.2829803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU031950',
        LOCATION_NAME: 'Burt',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4299462,
        LOCATION_LATITUDE_DEG: 55.0397519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035300',
        LOCATION_NAME: 'Burtonhill',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.748957,
        LOCATION_LATITUDE_DEG: 52.7001825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035400',
        LOCATION_NAME: 'Burtonport',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4308638,
        LOCATION_LATITUDE_DEG: 54.9846587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU035700',
        LOCATION_NAME: 'Burtown Cross Roads',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823234,
        LOCATION_LATITUDE_DEG: 52.9830607,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038700',
        LOCATION_NAME: 'Bushfield',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325219,
        LOCATION_LATITUDE_DEG: 53.8331481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU038600',
        LOCATION_NAME: 'Bushfield',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491647,
        LOCATION_LATITUDE_DEG: 52.799744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU039300',
        LOCATION_NAME: 'Bushville',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3989998,
        LOCATION_LATITUDE_DEG: 52.2496783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040400',
        LOCATION_NAME: 'Butlersbridge',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823579,
        LOCATION_LATITUDE_DEG: 54.0498686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040700',
        LOCATION_NAME: 'Butlerstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.715918,
        LOCATION_LATITUDE_DEG: 51.5996334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU040750',
        LOCATION_NAME: 'Butlerstown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1953577,
        LOCATION_LATITUDE_DEG: -2.5954306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BU042500',
        LOCATION_NAME: 'Buttevant',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6734867,
        LOCATION_LATITUDE_DEG: 52.2282954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000100',
        LOCATION_NAME: 'Bweeneg',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7321793,
        LOCATION_LATITUDE_DEG: 52.0468333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BW000200',
        LOCATION_NAME: 'Bweeng',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7280198,
        LOCATION_LATITUDE_DEG: 52.0415326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'BY001200',
        LOCATION_NAME: 'Byrnesgrove',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823739,
        LOCATION_LATITUDE_DEG: 52.7997404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089400',
        LOCATION_NAME: 'Cabinteely',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1509688,
        LOCATION_LATITUDE_DEG: 53.2717813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990180',
        LOCATION_NAME: 'Cabra',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8323019,
        LOCATION_LATITUDE_DEG: 52.6592591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000500',
        LOCATION_NAME: 'Cabry',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990109,
        LOCATION_LATITUDE_DEG: 55.133273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA000700',
        LOCATION_NAME: 'Cadamstown',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6617355,
        LOCATION_LATITUDE_DEG: 53.1462786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006000',
        LOCATION_NAME: 'Caher',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7993288,
        LOCATION_LATITUDE_DEG: 51.466326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006100',
        LOCATION_NAME: 'Caher',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492629,
        LOCATION_LATITUDE_DEG: 53.2498032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006200',
        LOCATION_NAME: 'Caher',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491908,
        LOCATION_LATITUDE_DEG: 52.9664629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006300',
        LOCATION_NAME: 'Caheracruttera',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.917455,
        LOCATION_LATITUDE_DEG: 52.1548925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990222',
        LOCATION_NAME: 'Caheragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.294427,
        LOCATION_LATITUDE_DEG: 52.0524905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006400',
        LOCATION_NAME: 'Caherbarnagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992604,
        LOCATION_LATITUDE_DEG: 52.0496798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007600',
        LOCATION_NAME: 'Caherciveen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.233673,
        LOCATION_LATITUDE_DEG: 51.9455728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006500',
        LOCATION_NAME: 'Caherconlish',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4778628,
        LOCATION_LATITUDE_DEG: 52.6132322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006600',
        LOCATION_NAME: 'Caherdaniel',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.099371,
        LOCATION_LATITUDE_DEG: 51.7663575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006700',
        LOCATION_NAME: 'Caherdavin',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6645175,
        LOCATION_LATITUDE_DEG: 52.6711144,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990956',
        LOCATION_NAME: 'Cahergal',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006800',
        LOCATION_NAME: 'Caherkeen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032661,
        LOCATION_LATITUDE_DEG: 51.6663497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006900',
        LOCATION_NAME: 'Caherleaheen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6842168,
        LOCATION_LATITUDE_DEG: 52.2330084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007000',
        LOCATION_NAME: 'Caherline',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4497395,
        LOCATION_LATITUDE_DEG: 52.5682216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007100',
        LOCATION_NAME: 'Caherlistrane',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0158913,
        LOCATION_LATITUDE_DEG: 53.4998276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007300',
        LOCATION_NAME: 'Cahermacun',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.199256,
        LOCATION_LATITUDE_DEG: 53.0830894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007400',
        LOCATION_NAME: 'Cahermore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.057464,
        LOCATION_LATITUDE_DEG: 51.6103444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007500',
        LOCATION_NAME: 'Cahernarry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5520468,
        LOCATION_LATITUDE_DEG: 52.6102515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007700',
        LOCATION_NAME: 'Cahir',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9382391,
        LOCATION_LATITUDE_DEG: 52.3815044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007800',
        LOCATION_NAME: 'Cahir Guillamore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5825029,
        LOCATION_LATITUDE_DEG: 52.5164277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA007850',
        LOCATION_NAME: 'Cahore',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.20681,
        LOCATION_LATITUDE_DEG: 52.5603106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA008000',
        LOCATION_NAME: 'Caim',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6802648,
        LOCATION_LATITUDE_DEG: 52.5077164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA009000',
        LOCATION_NAME: 'Caislean an Bharraigh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.299248,
        LOCATION_LATITUDE_DEG: 53.8498621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA006182',
        LOCATION_NAME: 'Calary Upper',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1691767,
        LOCATION_LATITUDE_DEG: 53.1310942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013700',
        LOCATION_NAME: 'Callaghane Bridge',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323638,
        LOCATION_LATITUDE_DEG: 52.2163819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA013900',
        LOCATION_NAME: 'Callan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.394503,
        LOCATION_LATITUDE_DEG: 52.5491167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA014900',
        LOCATION_NAME: 'Callow',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0359196,
        LOCATION_LATITUDE_DEG: 53.9826644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990637',
        LOCATION_NAME: 'Calry',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016600',
        LOCATION_NAME: 'Caltra',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324972,
        LOCATION_LATITUDE_DEG: 53.4331449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016800',
        LOCATION_NAME: 'Caltragh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324387,
        LOCATION_LATITUDE_DEG: 53.4831155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA016900',
        LOCATION_NAME: 'Caltragh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324269,
        LOCATION_LATITUDE_DEG: 53.5998238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA017500',
        LOCATION_NAME: 'Calverstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990215,
        LOCATION_LATITUDE_DEG: 53.0830637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018375',
        LOCATION_NAME: 'Cam',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1459113,
        LOCATION_LATITUDE_DEG: 53.4592247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA018400',
        LOCATION_NAME: 'Camaross',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990348,
        LOCATION_LATITUDE_DEG: 52.3663906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021550',
        LOCATION_NAME: 'Camira',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3708286,
        LOCATION_LATITUDE_DEG: 53.1365256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA021900',
        LOCATION_NAME: 'Camolin',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4251277,
        LOCATION_LATITUDE_DEG: 52.6230159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022100',
        LOCATION_NAME: 'Camp',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9160435,
        LOCATION_LATITUDE_DEG: 52.2164035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA022800',
        LOCATION_NAME: 'Campile',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323601,
        LOCATION_LATITUDE_DEG: 52.2829822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023100',
        LOCATION_NAME: 'Camport',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.016019,
        LOCATION_LATITUDE_DEG: 53.9165657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA023800',
        LOCATION_NAME: 'Camross',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5823972,
        LOCATION_LATITUDE_DEG: 52.9997645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA025700',
        LOCATION_NAME: 'Cangort',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491432,
        LOCATION_LATITUDE_DEG: 52.9830644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA026500',
        LOCATION_NAME: 'Canningstown',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490304,
        LOCATION_LATITUDE_DEG: 53.98315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990752',
        LOCATION_NAME: 'Cannistown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA029050',
        LOCATION_NAME: 'Capard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.460877,
        LOCATION_LATITUDE_DEG: 53.1020288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032300',
        LOCATION_NAME: 'Cappach',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992276,
        LOCATION_LATITUDE_DEG: 52.5664319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032500',
        LOCATION_NAME: 'Cappagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8990277,
        LOCATION_LATITUDE_DEG: 52.5706954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091350',
        LOCATION_NAME: 'Cappagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.761354,
        LOCATION_LATITUDE_DEG: 53.6471815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091300',
        LOCATION_NAME: 'Cappagh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3118163,
        LOCATION_LATITUDE_DEG: 53.3854812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA091375',
        LOCATION_NAME: 'Cappagh North',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3614999,
        LOCATION_LATITUDE_DEG: 53.0647762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032600',
        LOCATION_NAME: 'Cappagh White',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658491,
        LOCATION_LATITUDE_DEG: 52.5830262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032650',
        LOCATION_NAME: 'Cappaghduff',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3743533,
        LOCATION_LATITUDE_DEG: 53.6470308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032675',
        LOCATION_NAME: 'Cappakeel',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1592055,
        LOCATION_LATITUDE_DEG: 53.0836709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032700',
        LOCATION_NAME: 'Cappalusk',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658841,
        LOCATION_LATITUDE_DEG: 53.366501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032900',
        LOCATION_NAME: 'Cappamore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6160075,
        LOCATION_LATITUDE_DEG: 51.8996639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA032800',
        LOCATION_NAME: 'Cappamore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324751,
        LOCATION_LATITUDE_DEG: 52.6164248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033000',
        LOCATION_NAME: 'Cappanawalla',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1742484,
        LOCATION_LATITUDE_DEG: 53.124783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033100',
        LOCATION_NAME: 'Cappanoloha',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4825939,
        LOCATION_LATITUDE_DEG: 51.6663425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033200',
        LOCATION_NAME: 'Capparoe',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2541582,
        LOCATION_LATITUDE_DEG: 52.8200365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033300',
        LOCATION_NAME: 'Cappataggle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991675,
        LOCATION_LATITUDE_DEG: 53.266495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033400',
        LOCATION_NAME: 'Cappateemore',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6754911,
        LOCATION_LATITUDE_DEG: 52.7192583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033500',
        LOCATION_NAME: 'Cappeen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825472,
        LOCATION_LATITUDE_DEG: 51.7829499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033550',
        LOCATION_NAME: 'Cappoley',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2763711,
        LOCATION_LATITUDE_DEG: 53.008782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA033600',
        LOCATION_NAME: 'Cappoquin',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8529086,
        LOCATION_LATITUDE_DEG: 52.1517819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034200',
        LOCATION_NAME: 'Caragh Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8826227,
        LOCATION_LATITUDE_DEG: 52.0663814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA034250',
        LOCATION_NAME: 'Caragh Lake',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8511291,
        LOCATION_LATITUDE_DEG: 52.0562215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA035400',
        LOCATION_NAME: 'Carbury',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9639095,
        LOCATION_LATITUDE_DEG: 53.3610909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA038100',
        LOCATION_NAME: 'Cargagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823252,
        LOCATION_LATITUDE_DEG: 53.8998456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039000',
        LOCATION_NAME: 'Carha',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325077,
        LOCATION_LATITUDE_DEG: 54.1498824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA039400',
        LOCATION_NAME: 'Carheenlea',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8329523,
        LOCATION_LATITUDE_DEG: 53.3682701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA040100',
        LOCATION_NAME: 'Carlanstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323185,
        LOCATION_LATITUDE_DEG: 53.7498267,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA041500',
        LOCATION_NAME: 'Carlingford',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1955348,
        LOCATION_LATITUDE_DEG: 54.0454492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA042000',
        LOCATION_NAME: 'Carlow',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9273092,
        LOCATION_LATITUDE_DEG: 52.8397468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045700',
        LOCATION_NAME: 'Carna',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326178,
        LOCATION_LATITUDE_DEG: 53.3165097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA045900',
        LOCATION_NAME: 'Carnagh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8616701,
        LOCATION_LATITUDE_DEG: 52.345641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046200',
        LOCATION_NAME: 'Carnaross',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9490158,
        LOCATION_LATITUDE_DEG: 53.7498323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046300',
        LOCATION_NAME: 'Carnaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7856744,
        LOCATION_LATITUDE_DEG: 53.328732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA046700',
        LOCATION_NAME: 'Carndonagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2706495,
        LOCATION_LATITUDE_DEG: 55.25368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA991037',
        LOCATION_NAME: 'Carne',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489,
        LOCATION_LATITUDE_DEG: 52.1974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047100',
        LOCATION_NAME: 'Carnew',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5104756,
        LOCATION_LATITUDE_DEG: 52.7114276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047200',
        LOCATION_NAME: 'Carnew',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4934473,
        LOCATION_LATITUDE_DEG: 52.7077834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047300',
        LOCATION_NAME: 'Carney',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5304574,
        LOCATION_LATITUDE_DEG: 54.3376012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047400',
        LOCATION_NAME: 'Carney',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1777898,
        LOCATION_LATITUDE_DEG: 52.9694416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA047800',
        LOCATION_NAME: 'Carnhill',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7992911,
        LOCATION_LATITUDE_DEG: 54.2665991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048300',
        LOCATION_NAME: 'Carnmalin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.332326,
        LOCATION_LATITUDE_DEG: 55.3499909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA048500',
        LOCATION_NAME: 'Carnmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9283903,
        LOCATION_LATITUDE_DEG: 53.3048067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049300',
        LOCATION_NAME: 'Carnowen',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323747,
        LOCATION_LATITUDE_DEG: 54.8332428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA049650',
        LOCATION_NAME: 'Carownlasson',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2389574,
        LOCATION_LATITUDE_DEG: 53.7155979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089300',
        LOCATION_NAME: 'Carpenterstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3826282,
        LOCATION_LATITUDE_DEG: 53.3766179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050300',
        LOCATION_NAME: 'Carrabaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159247,
        LOCATION_LATITUDE_DEG: 53.549828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050400',
        LOCATION_NAME: 'Carracastle',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7241778,
        LOCATION_LATITUDE_DEG: 53.9584642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050700',
        LOCATION_NAME: 'Carragh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323118,
        LOCATION_LATITUDE_DEG: 53.2330755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050750',
        LOCATION_NAME: 'Carraghs East',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5938355,
        LOCATION_LATITUDE_DEG: 53.7303617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050800',
        LOCATION_NAME: 'Carran',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490772,
        LOCATION_LATITUDE_DEG: 52.5997221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA050900',
        LOCATION_NAME: 'Carraroe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5825763,
        LOCATION_LATITUDE_DEG: 53.2665082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051000',
        LOCATION_NAME: 'Carraroe',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4857967,
        LOCATION_LATITUDE_DEG: 54.2458448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051500',
        LOCATION_NAME: 'Carrick',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6505169,
        LOCATION_LATITUDE_DEG: 54.6616316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051600',
        LOCATION_NAME: 'Carrick',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323317,
        LOCATION_LATITUDE_DEG: 52.2329801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051800',
        LOCATION_NAME: 'Carrick on Shannon',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0954252,
        LOCATION_LATITUDE_DEG: 53.9493515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA051900',
        LOCATION_NAME: 'Carrick on Suir',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157647,
        LOCATION_LATITUDE_DEG: 52.3497062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052100',
        LOCATION_NAME: 'Carrickaboy',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3291301,
        LOCATION_LATITUDE_DEG: 53.9292947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052300',
        LOCATION_NAME: 'Carrickbeg',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4012395,
        LOCATION_LATITUDE_DEG: 52.3350165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052400',
        LOCATION_NAME: 'Carrickboy',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6776889,
        LOCATION_LATITUDE_DEG: 53.6434248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052550',
        LOCATION_NAME: 'Carrickglass',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7353284,
        LOCATION_LATITUDE_DEG: 53.7499166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052600',
        LOCATION_NAME: 'Carrickmacross',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7193263,
        LOCATION_LATITUDE_DEG: 53.9735449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089500',
        LOCATION_NAME: 'Carrickmines',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1952605,
        LOCATION_LATITUDE_DEG: 53.2448759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052800',
        LOCATION_NAME: 'Carrickmore Lower',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4490372,
        LOCATION_LATITUDE_DEG: 54.8832474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052900',
        LOCATION_NAME: 'Carrickmore Upper',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4657436,
        LOCATION_LATITUDE_DEG: 54.8832508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052950',
        LOCATION_NAME: 'Carrickynaghtan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9312525,
        LOCATION_LATITUDE_DEG: 53.3968587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053200',
        LOCATION_NAME: 'Carrig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6326113,
        LOCATION_LATITUDE_DEG: 51.9329689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053300',
        LOCATION_NAME: 'Carrig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992871,
        LOCATION_LATITUDE_DEG: 51.5996406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053400',
        LOCATION_NAME: 'Carrig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5659058,
        LOCATION_LATITUDE_DEG: 52.1496783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053450',
        LOCATION_NAME: 'Carrig',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2463531,
        LOCATION_LATITUDE_DEG: 52.8931018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053100',
        LOCATION_NAME: 'Carrig',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.965842,
        LOCATION_LATITUDE_DEG: 53.0664639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053500',
        LOCATION_NAME: 'Carrigadrohid',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.822439,
        LOCATION_LATITUDE_DEG: 51.9144432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053600',
        LOCATION_NAME: 'Carrigaholt',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7160551,
        LOCATION_LATITUDE_DEG: 52.604841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053700',
        LOCATION_NAME: 'Carrigahorig',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1531701,
        LOCATION_LATITUDE_DEG: 53.063066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053800',
        LOCATION_NAME: 'Carrigaline',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4043482,
        LOCATION_LATITUDE_DEG: 51.8119506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA053900',
        LOCATION_NAME: 'Carrigallen',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6398785,
        LOCATION_LATITUDE_DEG: 53.9801562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054000',
        LOCATION_NAME: 'Carrigaloe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3179782,
        LOCATION_LATITUDE_DEG: 51.8675111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054100',
        LOCATION_NAME: 'Carrigan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3990669,
        LOCATION_LATITUDE_DEG: 53.8831458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054200',
        LOCATION_NAME: 'Carrigane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158679,
        LOCATION_LATITUDE_DEG: 52.2829911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054300',
        LOCATION_NAME: 'Carrigane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158279,
        LOCATION_LATITUDE_DEG: 52.2830202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054400',
        LOCATION_NAME: 'Carriganimmy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325912,
        LOCATION_LATITUDE_DEG: 51.9663423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054600',
        LOCATION_NAME: 'Carrigans',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323587,
        LOCATION_LATITUDE_DEG: 54.9499568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA052200',
        LOCATION_NAME: 'Carrigart',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8001873,
        LOCATION_LATITUDE_DEG: 55.1757786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054800',
        LOCATION_NAME: 'Carrigatogher',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824577,
        LOCATION_LATITUDE_DEG: 52.8330525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990850',
        LOCATION_NAME: 'Carrigatoher',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA054900',
        LOCATION_NAME: 'Carrigbeg',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.432884,
        LOCATION_LATITUDE_DEG: 52.6674898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055000',
        LOCATION_NAME: 'Carrigcastle',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3991008,
        LOCATION_LATITUDE_DEG: 52.1496763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055100',
        LOCATION_NAME: 'Carrigeen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7659043,
        LOCATION_LATITUDE_DEG: 53.216487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055150',
        LOCATION_NAME: 'Carrigeen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1932709,
        LOCATION_LATITUDE_DEG: 53.0450045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055200',
        LOCATION_NAME: 'Carrigillihy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1259049,
        LOCATION_LATITUDE_DEG: 51.5337322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055300',
        LOCATION_NAME: 'Carrigkerry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492503,
        LOCATION_LATITUDE_DEG: 52.4830264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055400',
        LOCATION_NAME: 'Carrignavar',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4659023,
        LOCATION_LATITUDE_DEG: 51.9829728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055450',
        LOCATION_NAME: 'Carrigoran',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9076275,
        LOCATION_LATITUDE_DEG: 52.7469599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055600',
        LOCATION_NAME: 'Carrigshane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491696,
        LOCATION_LATITUDE_DEG: 51.8996577,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055800',
        LOCATION_NAME: 'Carrigtohill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2625176,
        LOCATION_LATITUDE_DEG: 51.9080021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055700',
        LOCATION_NAME: 'Carrigtohill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491832,
        LOCATION_LATITUDE_DEG: 51.8996548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA055900',
        LOCATION_NAME: 'Carrigtwohill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2610163,
        LOCATION_LATITUDE_DEG: 51.9121615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA056700',
        LOCATION_NAME: 'Carron',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1890993,
        LOCATION_LATITUDE_DEG: 52.4939769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057200',
        LOCATION_NAME: 'Carrowen',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4990477,
        LOCATION_LATITUDE_DEG: 55.0166574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057500',
        LOCATION_NAME: 'Carrowkeel',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6697749,
        LOCATION_LATITUDE_DEG: 55.1347413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057300',
        LOCATION_NAME: 'Carrowkeel',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2032775,
        LOCATION_LATITUDE_DEG: 55.1175656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057600',
        LOCATION_NAME: 'Carrowkennedy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492665,
        LOCATION_LATITUDE_DEG: 53.699842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057650',
        LOCATION_NAME: 'Carrowmeer',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8430143,
        LOCATION_LATITUDE_DEG: 52.7732068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057700',
        LOCATION_NAME: 'Carrowmenagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.065694,
        LOCATION_LATITUDE_DEG: 55.249979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057750',
        LOCATION_NAME: 'Carrowmoneen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8079058,
        LOCATION_LATITUDE_DEG: 53.494075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057900',
        LOCATION_NAME: 'Carrowmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8325876,
        LOCATION_LATITUDE_DEG: 54.2166007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058000',
        LOCATION_NAME: 'Carrowmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825358,
        LOCATION_LATITUDE_DEG: 54.2498939,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA057800',
        LOCATION_NAME: 'Carrowmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492461,
        LOCATION_LATITUDE_DEG: 53.6165335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058200',
        LOCATION_NAME: 'Carrowmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9679527,
        LOCATION_LATITUDE_DEG: 53.2067888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058100',
        LOCATION_NAME: 'Carrowmore',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6991868,
        LOCATION_LATITUDE_DEG: 54.1165865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058250',
        LOCATION_NAME: 'Carrowntryla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7331658,
        LOCATION_LATITUDE_DEG: 53.5822361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058400',
        LOCATION_NAME: 'Carrowreagh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6542282,
        LOCATION_LATITUDE_DEG: 54.2668996,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058300',
        LOCATION_NAME: 'Carrowreagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991383,
        LOCATION_LATITUDE_DEG: 53.3831099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058500',
        LOCATION_NAME: 'Carrowreagh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7064312,
        LOCATION_LATITUDE_DEG: 52.3559179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058550',
        LOCATION_NAME: 'Carrowrevagh Beg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7727831,
        LOCATION_LATITUDE_DEG: 53.5700897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058600',
        LOCATION_NAME: 'Carrowteige',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7972925,
        LOCATION_LATITUDE_DEG: 54.3131574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA058700',
        LOCATION_NAME: 'Carrowwilkin',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7658928,
        LOCATION_LATITUDE_DEG: 54.0165661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061300',
        LOCATION_NAME: 'Carton',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5489982,
        LOCATION_LATITUDE_DEG: 53.3830956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA061500',
        LOCATION_NAME: 'Cartymore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7924779,
        LOCATION_LATITUDE_DEG: 53.3393059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062600',
        LOCATION_NAME: 'Cashel',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9660158,
        LOCATION_LATITUDE_DEG: 53.9581691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062500',
        LOCATION_NAME: 'Cashel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0825525,
        LOCATION_LATITUDE_DEG: 51.616337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062700',
        LOCATION_NAME: 'Cashel',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.615876,
        LOCATION_LATITUDE_DEG: 53.6165238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062300',
        LOCATION_NAME: 'Cashel',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8848092,
        LOCATION_LATITUDE_DEG: 52.5169763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062400',
        LOCATION_NAME: 'Cashel',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990082,
        LOCATION_LATITUDE_DEG: 55.2499837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990641',
        LOCATION_NAME: 'Cashelgarran',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990640',
        LOCATION_NAME: 'Cashelgarren',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA062900',
        LOCATION_NAME: 'Cashelmore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.915792,
        LOCATION_LATITUDE_DEG: 55.1332725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063000',
        LOCATION_NAME: 'Casheltown',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991143,
        LOCATION_LATITUDE_DEG: 54.666629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063200',
        LOCATION_NAME: 'Cashla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.850882,
        LOCATION_LATITUDE_DEG: 53.3192409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA063300',
        LOCATION_NAME: 'Cashleen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032628,
        LOCATION_LATITUDE_DEG: 53.5998304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990172',
        LOCATION_NAME: 'Cassestown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7065618,
        LOCATION_LATITUDE_DEG: 52.3567282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA907837',
        LOCATION_NAME: 'Castelgrove East',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.927531,
        LOCATION_LATITUDE_DEG: 53.5707445,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065100',
        LOCATION_NAME: 'Castle Cary',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0977751,
        LOCATION_LATITUDE_DEG: 55.1722713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA065600',
        LOCATION_NAME: 'Castle E Len',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.768358,
        LOCATION_LATITUDE_DEG: 53.3339538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067300',
        LOCATION_NAME: 'Castle Roche Cross Roads',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822667,
        LOCATION_LATITUDE_DEG: 54.0498581,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067700',
        LOCATION_NAME: 'Castlebaldwin',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3752616,
        LOCATION_LATITUDE_DEG: 54.0790462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067800',
        LOCATION_NAME: 'Castlebank',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6145457,
        LOCATION_LATITUDE_DEG: 52.7061072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA067900',
        LOCATION_NAME: 'Castlebar',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2994101,
        LOCATION_LATITUDE_DEG: 53.8604587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068100',
        LOCATION_NAME: 'Castlebellingham',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3960221,
        LOCATION_LATITUDE_DEG: 53.9040404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068200',
        LOCATION_NAME: 'Castlebin New Inn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4860357,
        LOCATION_LATITUDE_DEG: 53.3004641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068300',
        LOCATION_NAME: 'Castleblagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4158847,
        LOCATION_LATITUDE_DEG: 52.1163811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068400',
        LOCATION_NAME: 'Castleblakeney',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824574,
        LOCATION_LATITUDE_DEG: 53.4331166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068500',
        LOCATION_NAME: 'Castleblayney',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7423958,
        LOCATION_LATITUDE_DEG: 54.1252718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA068600',
        LOCATION_NAME: 'Castlebridge',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4514091,
        LOCATION_LATITUDE_DEG: 52.3886927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069000',
        LOCATION_NAME: 'Castlecomer',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.210697,
        LOCATION_LATITUDE_DEG: 52.8057441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069100',
        LOCATION_NAME: 'Castleconnell',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4986315,
        LOCATION_LATITUDE_DEG: 52.7136345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069200',
        LOCATION_NAME: 'Castleconor',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.127834,
        LOCATION_LATITUDE_DEG: 54.1661894,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069300',
        LOCATION_NAME: 'Castlecoote',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824417,
        LOCATION_LATITUDE_DEG: 53.616526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069400',
        LOCATION_NAME: 'Castlecor',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992332,
        LOCATION_LATITUDE_DEG: 52.1996932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069500',
        LOCATION_NAME: 'Castlecor',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1823479,
        LOCATION_LATITUDE_DEG: 53.766532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990812',
        LOCATION_NAME: 'Castledaly',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA069900',
        LOCATION_NAME: 'Castledermot',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323316,
        LOCATION_LATITUDE_DEG: 52.8997424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070000',
        LOCATION_NAME: 'Castledockrell',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5990096,
        LOCATION_LATITUDE_DEG: 52.5830136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070300',
        LOCATION_NAME: 'Castlefinn',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.606363,
        LOCATION_LATITUDE_DEG: 54.8055359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070500',
        LOCATION_NAME: 'Castlefore',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.899109,
        LOCATION_LATITUDE_DEG: 54.0331601,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070600',
        LOCATION_NAME: 'Castleforward',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823493,
        LOCATION_LATITUDE_DEG: 54.9999504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070650',
        LOCATION_NAME: 'Castlefreke',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.960054,
        LOCATION_LATITUDE_DEG: 51.5746521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070700',
        LOCATION_NAME: 'Castlegar',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0184034,
        LOCATION_LATITUDE_DEG: 53.2973023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA070800',
        LOCATION_NAME: 'Castlegregory',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.020199,
        LOCATION_LATITUDE_DEG: 52.2549808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071200',
        LOCATION_NAME: 'Castlehill',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8229252,
        LOCATION_LATITUDE_DEG: 53.9937648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071300',
        LOCATION_NAME: 'Castleisland',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4688771,
        LOCATION_LATITUDE_DEG: 52.2375028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071400',
        LOCATION_NAME: 'Castlejordan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0975765,
        LOCATION_LATITUDE_DEG: 53.3876985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA089200',
        LOCATION_NAME: 'Castleknock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -5.6019297,
        LOCATION_LATITUDE_DEG: -4.2300508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071600',
        LOCATION_NAME: 'Castlelampert',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8058951,
        LOCATION_LATITUDE_DEG: 53.3098921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071750',
        LOCATION_NAME: 'Castlelough',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3896034,
        LOCATION_LATITUDE_DEG: 52.8829481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071800',
        LOCATION_NAME: 'Castlelyons',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324702,
        LOCATION_LATITUDE_DEG: 52.0829806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071850',
        LOCATION_NAME: 'Castlemacadam',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2212148,
        LOCATION_LATITUDE_DEG: 52.8500276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA071900',
        LOCATION_NAME: 'Castlemagner',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8461754,
        LOCATION_LATITUDE_DEG: 52.165809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990618',
        LOCATION_NAME: 'Castlemahon',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072000',
        LOCATION_NAME: 'Castlemaine',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7062885,
        LOCATION_LATITUDE_DEG: 52.1739921,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072100',
        LOCATION_NAME: 'Castlemaine',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993207,
        LOCATION_LATITUDE_DEG: 52.166366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072300',
        LOCATION_NAME: 'Castlemartyr',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0531346,
        LOCATION_LATITUDE_DEG: 51.9160628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072500',
        LOCATION_NAME: 'Castlemitchell',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0590833,
        LOCATION_LATITUDE_DEG: 52.999304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072700',
        LOCATION_NAME: 'Castlemoyle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7491979,
        LOCATION_LATITUDE_DEG: 53.4998158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072800',
        LOCATION_NAME: 'Castlemungret',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6889288,
        LOCATION_LATITUDE_DEG: 52.6426667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA072900',
        LOCATION_NAME: 'Castleore',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824505,
        LOCATION_LATITUDE_DEG: 54.1998864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073100',
        LOCATION_NAME: 'Castleplunket',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324487,
        LOCATION_LATITUDE_DEG: 53.7498396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073300',
        LOCATION_NAME: 'Castlepollard',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3001594,
        LOCATION_LATITUDE_DEG: 53.6803697,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073350',
        LOCATION_NAME: 'Castlequarter',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7648625,
        LOCATION_LATITUDE_DEG: 52.7176202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA990836',
        LOCATION_NAME: 'Castlequarter',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073400',
        LOCATION_NAME: 'Castlequin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.231562,
        LOCATION_LATITUDE_DEG: 51.9486782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073500',
        LOCATION_NAME: 'Castlerahan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.180798,
        LOCATION_LATITUDE_DEG: 53.8200423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA073600',
        LOCATION_NAME: 'Castlerea',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4985074,
        LOCATION_LATITUDE_DEG: 53.7710505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074000',
        LOCATION_NAME: 'Castleshane',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.879175,
        LOCATION_LATITUDE_DEG: 54.240466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074100',
        LOCATION_NAME: 'Castleshannon',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826177,
        LOCATION_LATITUDE_DEG: 52.433019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA074300',
        LOCATION_NAME: 'Castlestrange Bridge',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658604,
        LOCATION_LATITUDE_DEG: 53.5831243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075400',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659393,
        LOCATION_LATITUDE_DEG: 53.0164776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075700',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492398,
        LOCATION_LATITUDE_DEG: 51.7663589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075100',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159111,
        LOCATION_LATITUDE_DEG: 52.4164205,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075300',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4995236,
        LOCATION_LATITUDE_DEG: 52.9791623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075600',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823872,
        LOCATION_LATITUDE_DEG: 53.4498042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076288',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7030715,
        LOCATION_LATITUDE_DEG: 53.7587673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076275',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6710941,
        LOCATION_LATITUDE_DEG: 53.6925345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075500',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322868,
        LOCATION_LATITUDE_DEG: 53.3497928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA075200',
        LOCATION_NAME: 'Castletown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1822802,
        LOCATION_LATITUDE_DEG: 52.716417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076300',
        LOCATION_NAME: 'Castletown Bearhaven',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9076122,
        LOCATION_LATITUDE_DEG: 51.6587484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076400',
        LOCATION_NAME: 'Castletown Geoghegan',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.456874,
        LOCATION_LATITUDE_DEG: 53.471625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA991043',
        LOCATION_NAME: 'Castletownbere',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9089,
        LOCATION_LATITUDE_DEG: 51.6519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076500',
        LOCATION_NAME: 'Castletownroche',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4645113,
        LOCATION_LATITUDE_DEG: 52.1785919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076600',
        LOCATION_NAME: 'Castletownshend',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1834573,
        LOCATION_LATITUDE_DEG: 51.527835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076700',
        LOCATION_NAME: 'Castletroy',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5609086,
        LOCATION_LATITUDE_DEG: 52.6626629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA991104',
        LOCATION_NAME: 'Castleturvin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7656,
        LOCATION_LATITUDE_DEG: 53.2736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA076900',
        LOCATION_NAME: 'Castlewarren',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.115754,
        LOCATION_LATITUDE_DEG: 52.6830272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA078800',
        LOCATION_NAME: 'Cathair na Mart',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5159694,
        LOCATION_LATITUDE_DEG: 53.7998525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079250',
        LOCATION_NAME: 'Catherinestown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3030507,
        LOCATION_LATITUDE_DEG: 53.4928453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA079450',
        LOCATION_NAME: 'Cathole',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4432645,
        LOCATION_LATITUDE_DEG: 53.0909739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA083600',
        LOCATION_NAME: 'Causeway',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7312691,
        LOCATION_LATITUDE_DEG: 52.4130565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084400',
        LOCATION_NAME: 'Cavan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3627809,
        LOCATION_LATITUDE_DEG: 53.9958579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA084500',
        LOCATION_NAME: 'Cavanagarvan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823082,
        LOCATION_LATITUDE_DEG: 54.1831687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CA085200',
        LOCATION_NAME: 'Cavetown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2473344,
        LOCATION_LATITUDE_DEG: 53.9331515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE000100',
        LOCATION_NAME: 'Cecilstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7825317,
        LOCATION_LATITUDE_DEG: 52.1663951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CE002600',
        LOCATION_NAME: 'Celbridge',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5324908,
        LOCATION_LATITUDE_DEG: 53.3471847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH991015',
        LOCATION_NAME: 'Chambersland',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.93506,
        LOCATION_LATITUDE_DEG: 52.3884,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH006200',
        LOCATION_NAME: 'Chapel',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990356,
        LOCATION_LATITUDE_DEG: 52.4330004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008750',
        LOCATION_NAME: 'Chapelhill',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.134234,
        LOCATION_LATITUDE_DEG: 52.4688279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990701',
        LOCATION_NAME: 'Chapelizod',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH008900',
        LOCATION_NAME: 'Chapelmidway',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3156717,
        LOCATION_LATITUDE_DEG: 53.4497961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH012500',
        LOCATION_NAME: 'Charlestown',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8025375,
        LOCATION_LATITUDE_DEG: 53.9604196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH013100',
        LOCATION_NAME: 'Charleville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6831105,
        LOCATION_LATITUDE_DEG: 52.3614106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH021900',
        LOCATION_NAME: 'Cheekpoint',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990613,
        LOCATION_LATITUDE_DEG: 52.2663826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH026700',
        LOCATION_NAME: 'Cherryville',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657321,
        LOCATION_LATITUDE_DEG: 53.1497702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049400',
        LOCATION_NAME: 'Church Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.465752,
        LOCATION_LATITUDE_DEG: 54.9666475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH049500',
        LOCATION_NAME: 'Church Village',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659197,
        LOCATION_LATITUDE_DEG: 53.9998707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050350',
        LOCATION_NAME: 'Churchfield',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3931478,
        LOCATION_LATITUDE_DEG: 53.6307435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990729',
        LOCATION_NAME: 'Churchfield Business Park',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051000',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.825319,
        LOCATION_LATITUDE_DEG: 52.2889878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH050900',
        LOCATION_NAME: 'Churchill',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8947065,
        LOCATION_LATITUDE_DEG: 54.9874578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990381',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH990848',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH055000',
        LOCATION_NAME: 'Churchtown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2603214,
        LOCATION_LATITUDE_DEG: 53.2968248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CH051900',
        LOCATION_NAME: 'Churchtown South',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0716971,
        LOCATION_LATITUDE_DEG: 51.8280251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CI990230',
        LOCATION_NAME: 'Circular Road',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001600',
        LOCATION_NAME: 'Claddagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659437,
        LOCATION_LATITUDE_DEG: 53.2664978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001650',
        LOCATION_NAME: 'Claddagh West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7066244,
        LOCATION_LATITUDE_DEG: 53.543352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL001700',
        LOCATION_NAME: 'Claddaghduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.141041,
        LOCATION_LATITUDE_DEG: 53.5442343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002350',
        LOCATION_NAME: 'Claggan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.826827,
        LOCATION_LATITUDE_DEG: 53.9756053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002100',
        LOCATION_NAME: 'Claggan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4992741,
        LOCATION_LATITUDE_DEG: 53.499824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002200',
        LOCATION_NAME: 'Claggan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991019,
        LOCATION_LATITUDE_DEG: 55.1999769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002300',
        LOCATION_NAME: 'Claggan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9822957,
        LOCATION_LATITUDE_DEG: 55.2332718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002400',
        LOCATION_NAME: 'Clahane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993202,
        LOCATION_LATITUDE_DEG: 52.2330097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL002600',
        LOCATION_NAME: 'Clamper Cross',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825647,
        LOCATION_LATITUDE_DEG: 52.199698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL003000',
        LOCATION_NAME: 'Clane',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6878437,
        LOCATION_LATITUDE_DEG: 53.2957827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004600',
        LOCATION_NAME: 'Clara',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6136544,
        LOCATION_LATITUDE_DEG: 53.3477892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004650',
        LOCATION_NAME: 'Clara',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5146425,
        LOCATION_LATITUDE_DEG: 53.3603863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004500',
        LOCATION_NAME: 'Clara',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489746,
        LOCATION_LATITUDE_DEG: 52.9664481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL004700',
        LOCATION_NAME: 'Clara Bridge',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489736,
        LOCATION_LATITUDE_DEG: 52.9497495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990387',
        LOCATION_NAME: 'Clare',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005600',
        LOCATION_NAME: 'Clarecastle',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9577973,
        LOCATION_LATITUDE_DEG: 52.8158836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005800',
        LOCATION_NAME: 'Clareen',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8005053,
        LOCATION_LATITUDE_DEG: 53.0750716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL005900',
        LOCATION_NAME: 'Claregalway',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9488223,
        LOCATION_LATITUDE_DEG: 53.3454047,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006200',
        LOCATION_NAME: 'Claremorris',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9970901,
        LOCATION_LATITUDE_DEG: 53.7238454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006550',
        LOCATION_NAME: 'Claretuam',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9010804,
        LOCATION_LATITUDE_DEG: 53.4970123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006700',
        LOCATION_NAME: 'Clareville',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1325464,
        LOCATION_LATITUDE_DEG: 53.1164897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006800',
        LOCATION_NAME: 'Clarina',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325027,
        LOCATION_LATITUDE_DEG: 52.6330359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL006900',
        LOCATION_NAME: 'Clarinbridge',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8785056,
        LOCATION_LATITUDE_DEG: 53.2340992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991140',
        LOCATION_NAME: 'Clarkstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6733,
        LOCATION_LATITUDE_DEG: 53.4614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007150',
        LOCATION_NAME: 'Clashaganny',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2256558,
        LOCATION_LATITUDE_DEG: 53.7416871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007200',
        LOCATION_NAME: 'Clashganna',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990526,
        LOCATION_LATITUDE_DEG: 52.549715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007300',
        LOCATION_NAME: 'Clashmore',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8222958,
        LOCATION_LATITUDE_DEG: 52.012269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL007500',
        LOCATION_NAME: 'Clashnabrock',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5825101,
        LOCATION_LATITUDE_DEG: 52.1663922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013400',
        LOCATION_NAME: 'Cleady',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5421848,
        LOCATION_LATITUDE_DEG: 51.8957682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL013500',
        LOCATION_NAME: 'Cleanagh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990746,
        LOCATION_LATITUDE_DEG: 52.8997435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991016',
        LOCATION_NAME: 'Cleariestown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5858,
        LOCATION_LATITUDE_DEG: 52.2731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL015600',
        LOCATION_NAME: 'Cleggan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.116036,
        LOCATION_LATITUDE_DEG: 53.5498313,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL016200',
        LOCATION_NAME: 'Clenagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9487504,
        LOCATION_LATITUDE_DEG: 52.7288625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL017100',
        LOCATION_NAME: 'Cleraun',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.949128,
        LOCATION_LATITUDE_DEG: 53.5498223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018500',
        LOCATION_NAME: 'Clifden',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.022618,
        LOCATION_LATITUDE_DEG: 53.4917223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL018550',
        LOCATION_NAME: 'Clifden',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2454803,
        LOCATION_LATITUDE_DEG: 52.7296366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991031',
        LOCATION_NAME: 'Cliffoney',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.455,
        LOCATION_LATITUDE_DEG: 54.43,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019400',
        LOCATION_NAME: 'Cliffony',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.461165,
        LOCATION_LATITUDE_DEG: 54.434305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL019900',
        LOCATION_NAME: 'Cliffort',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492097,
        LOCATION_LATITUDE_DEG: 51.7496578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024300',
        LOCATION_NAME: 'Clogh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5135,
        LOCATION_LATITUDE_DEG: 52.8866138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024400',
        LOCATION_NAME: 'Clogh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1660103,
        LOCATION_LATITUDE_DEG: 52.8597431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024200',
        LOCATION_NAME: 'Clogh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1640996,
        LOCATION_LATITUDE_DEG: 52.8595564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024500',
        LOCATION_NAME: 'Clogh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3403673,
        LOCATION_LATITUDE_DEG: 52.6411024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024800',
        LOCATION_NAME: 'Cloghan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9323898,
        LOCATION_LATITUDE_DEG: 54.833239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024700',
        LOCATION_NAME: 'Cloghan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8897265,
        LOCATION_LATITUDE_DEG: 53.2292876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024600',
        LOCATION_NAME: 'Cloghan',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2368124,
        LOCATION_LATITUDE_DEG: 53.5576162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL024900',
        LOCATION_NAME: 'Cloghane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.182669,
        LOCATION_LATITUDE_DEG: 52.2330026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025000',
        LOCATION_NAME: 'Cloghane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8035224,
        LOCATION_LATITUDE_DEG: 51.4540238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025050',
        LOCATION_NAME: 'Cloghanower',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0905198,
        LOCATION_LATITUDE_DEG: 53.4437396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025100',
        LOCATION_NAME: 'Cloghans',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2128429,
        LOCATION_LATITUDE_DEG: 54.0587715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025200',
        LOCATION_NAME: 'Cloghans Hill',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0261411,
        LOCATION_LATITUDE_DEG: 53.5852904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025300',
        LOCATION_NAME: 'Cloghanulk',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3325612,
        LOCATION_LATITUDE_DEG: 53.08308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025400',
        LOCATION_NAME: 'Cloghaun',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159601,
        LOCATION_LATITUDE_DEG: 53.0497762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025500',
        LOCATION_NAME: 'Cloghbrack',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.447981,
        LOCATION_LATITUDE_DEG: 53.5539579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025600',
        LOCATION_NAME: 'Cloghdonnell',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.365994,
        LOCATION_LATITUDE_DEG: 51.5996404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025900',
        LOCATION_NAME: 'Clogheen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.526647,
        LOCATION_LATITUDE_DEG: 51.903075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL025700',
        LOCATION_NAME: 'Clogheen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991429,
        LOCATION_LATITUDE_DEG: 52.2663563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026000',
        LOCATION_NAME: 'Clogher',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5722585,
        LOCATION_LATITUDE_DEG: 52.2584621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026200',
        LOCATION_NAME: 'Clogher',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4659311,
        LOCATION_LATITUDE_DEG: 53.8331873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026300',
        LOCATION_NAME: 'Cloghera',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5980235,
        LOCATION_LATITUDE_DEG: 52.7442475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026325',
        LOCATION_NAME: 'Clogherboy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7561507,
        LOCATION_LATITUDE_DEG: 53.4676683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026350',
        LOCATION_NAME: 'Clogherbrien',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7369664,
        LOCATION_LATITUDE_DEG: 52.2864272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026400',
        LOCATION_NAME: 'Cloghereen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4826059,
        LOCATION_LATITUDE_DEG: 52.0329765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990638',
        LOCATION_NAME: 'Clogherevagh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026500',
        LOCATION_NAME: 'Clogherhead',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.255363,
        LOCATION_LATITUDE_DEG: 53.7957252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026700',
        LOCATION_NAME: 'Clogherstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3656581,
        LOCATION_LATITUDE_DEG: 53.5831131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL026800',
        LOCATION_NAME: 'Cloghjordan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0345197,
        LOCATION_LATITUDE_DEG: 52.9405597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027100',
        LOCATION_NAME: 'Cloghmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493278,
        LOCATION_LATITUDE_DEG: 53.8665634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027200',
        LOCATION_NAME: 'Cloghore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1033799,
        LOCATION_LATITUDE_DEG: 54.485308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027300',
        LOCATION_NAME: 'Cloghran',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.238565,
        LOCATION_LATITUDE_DEG: 53.4305915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027400',
        LOCATION_NAME: 'Cloghran',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322775,
        LOCATION_LATITUDE_DEG: 53.4164561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027500',
        LOCATION_NAME: 'Cloghroe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.640748,
        LOCATION_LATITUDE_DEG: 51.920153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027600',
        LOCATION_NAME: 'Clogrenan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9853992,
        LOCATION_LATITUDE_DEG: 52.8105506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027700',
        LOCATION_NAME: 'Clohamon',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157093,
        LOCATION_LATITUDE_DEG: 52.6330151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027850',
        LOCATION_NAME: 'Clonacody',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7368717,
        LOCATION_LATITUDE_DEG: 52.4377569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL027900',
        LOCATION_NAME: 'Clonakenny',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324285,
        LOCATION_LATITUDE_DEG: 52.8664513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028000',
        LOCATION_NAME: 'Clonakilty',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8758834,
        LOCATION_LATITUDE_DEG: 51.6326366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028100',
        LOCATION_NAME: 'Clonamery',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323582,
        LOCATION_LATITUDE_DEG: 52.4664037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028150',
        LOCATION_NAME: 'Clonanny',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1044992,
        LOCATION_LATITUDE_DEG: 53.1491985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028200',
        LOCATION_NAME: 'Clonard',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0226852,
        LOCATION_LATITUDE_DEG: 53.4548051,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028300',
        LOCATION_NAME: 'Clonaslee',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5157953,
        LOCATION_LATITUDE_DEG: 53.1497819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028400',
        LOCATION_NAME: 'Clonavoe',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490574,
        LOCATION_LATITUDE_DEG: 53.2497788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028500',
        LOCATION_NAME: 'Clonbern',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6324727,
        LOCATION_LATITUDE_DEG: 53.5665293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028550',
        LOCATION_NAME: 'Clonboyne',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3286633,
        LOCATION_LATITUDE_DEG: 53.016651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990234',
        LOCATION_NAME: 'Clonbrock',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2622014,
        LOCATION_LATITUDE_DEG: 53.6446358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990855',
        LOCATION_NAME: 'Clonbrusk',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028600',
        LOCATION_NAME: 'Clonbulloge',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823408,
        LOCATION_LATITUDE_DEG: 53.2497781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028700',
        LOCATION_NAME: 'Clonbur',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3665838,
        LOCATION_LATITUDE_DEG: 53.5473298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990945',
        LOCATION_NAME: 'Clonbur',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028800',
        LOCATION_NAME: 'Cloncagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325354,
        LOCATION_LATITUDE_DEG: 52.449721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028850',
        LOCATION_NAME: 'Cloncanon',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3624006,
        LOCATION_LATITUDE_DEG: 53.1012711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028875',
        LOCATION_NAME: 'Cloncosney',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2962911,
        LOCATION_LATITUDE_DEG: 53.1031591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL028900',
        LOCATION_NAME: 'Cloncourse Bridge',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823791,
        LOCATION_LATITUDE_DEG: 52.9997602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029000',
        LOCATION_NAME: 'Cloncurry',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7917612,
        LOCATION_LATITUDE_DEG: 53.4178965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL043600',
        LOCATION_NAME: 'Clondalkin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 22',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3943912,
        LOCATION_LATITUDE_DEG: 53.3221558,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033900',
        LOCATION_NAME: 'Clondra',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158216,
        LOCATION_LATITUDE_DEG: 53.7331368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029100',
        LOCATION_NAME: 'Clondrohid',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0023293,
        LOCATION_LATITUDE_DEG: 51.9226543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029300',
        LOCATION_NAME: 'Clondulane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158557,
        LOCATION_LATITUDE_DEG: 52.1329819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029400',
        LOCATION_NAME: 'Clonea',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4324111,
        LOCATION_LATITUDE_DEG: 52.2663867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029500',
        LOCATION_NAME: 'Clonee',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4485286,
        LOCATION_LATITUDE_DEG: 53.415492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029600',
        LOCATION_NAME: 'Cloneen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5991179,
        LOCATION_LATITUDE_DEG: 52.4664085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990813',
        LOCATION_NAME: 'Clonegal',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029700',
        LOCATION_NAME: 'Clonegall',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490204,
        LOCATION_LATITUDE_DEG: 52.6830199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029750',
        LOCATION_NAME: 'Clonemore',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1746988,
        LOCATION_LATITUDE_DEG: 53.1042373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029800',
        LOCATION_NAME: 'Clones',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2298129,
        LOCATION_LATITUDE_DEG: 54.1822796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL029900',
        LOCATION_NAME: 'Clonevan',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322736,
        LOCATION_LATITUDE_DEG: 52.5497115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030000',
        LOCATION_NAME: 'Cloneygowan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2832484,
        LOCATION_LATITUDE_DEG: 53.1862325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990824',
        LOCATION_NAME: 'Clonfanlough',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030100',
        LOCATION_NAME: 'Clonfert',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.055812,
        LOCATION_LATITUDE_DEG: 53.2386822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030200',
        LOCATION_NAME: 'Clonfert',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.049122,
        LOCATION_LATITUDE_DEG: 53.2330893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030300',
        LOCATION_NAME: 'Clongarret',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323496,
        LOCATION_LATITUDE_DEG: 53.2664854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030400',
        LOCATION_NAME: 'Clongeen',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657304,
        LOCATION_LATITUDE_DEG: 52.2996851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990912',
        LOCATION_NAME: 'Clonkeen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030600',
        LOCATION_NAME: 'Clonkeen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3504158,
        LOCATION_LATITUDE_DEG: 53.0181379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030500',
        LOCATION_NAME: 'Clonkeen',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823265,
        LOCATION_LATITUDE_DEG: 53.3497922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030700',
        LOCATION_NAME: 'Clonlara',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5522713,
        LOCATION_LATITUDE_DEG: 52.7239724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044900',
        LOCATION_NAME: 'Clonliffe',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2543032,
        LOCATION_LATITUDE_DEG: 53.3635087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030800',
        LOCATION_NAME: 'Clonlost',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.184392,
        LOCATION_LATITUDE_DEG: 53.5419685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030900',
        LOCATION_NAME: 'Clonlyon',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.882439,
        LOCATION_LATITUDE_DEG: 53.2830839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL030950',
        LOCATION_NAME: 'Clonmacnoise',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9815138,
        LOCATION_LATITUDE_DEG: 53.3220503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031000',
        LOCATION_NAME: 'Clonmanstown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6172282,
        LOCATION_LATITUDE_DEG: 53.3938361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031100',
        LOCATION_NAME: 'Clonmany',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4156885,
        LOCATION_LATITUDE_DEG: 55.2666563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031300',
        LOCATION_NAME: 'Clonmel',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7095947,
        LOCATION_LATITUDE_DEG: 52.3578956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031400',
        LOCATION_NAME: 'Clonmellon',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0289966,
        LOCATION_LATITUDE_DEG: 53.6669209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031500',
        LOCATION_NAME: 'Clonmines',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7886909,
        LOCATION_LATITUDE_DEG: 52.2563859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031550',
        LOCATION_NAME: 'Clonmoney',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8305739,
        LOCATION_LATITUDE_DEG: 52.7055032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031600',
        LOCATION_NAME: 'Clonmore',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658137,
        LOCATION_LATITUDE_DEG: 52.8330466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031700',
        LOCATION_NAME: 'Clonmore',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.382373,
        LOCATION_LATITUDE_DEG: 53.266484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031800',
        LOCATION_NAME: 'Clonmore',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.565709,
        LOCATION_LATITUDE_DEG: 52.8164335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL031900',
        LOCATION_NAME: 'Clonmult',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0901662,
        LOCATION_LATITUDE_DEG: 51.9986043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032000',
        LOCATION_NAME: 'Clonony',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158345,
        LOCATION_LATITUDE_DEG: 53.2330861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032200',
        LOCATION_NAME: 'Clonoulty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658297,
        LOCATION_LATITUDE_DEG: 52.5997284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032100',
        LOCATION_NAME: 'Clonown',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.924121,
        LOCATION_LATITUDE_DEG: 53.2350591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032300',
        LOCATION_NAME: 'Clonpet',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.186922,
        LOCATION_LATITUDE_DEG: 52.4591441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032350',
        LOCATION_NAME: 'Clonreher',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3421121,
        LOCATION_LATITUDE_DEG: 53.0588189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032400',
        LOCATION_NAME: 'Clonroche',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.716167,
        LOCATION_LATITUDE_DEG: 52.4555071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032500',
        LOCATION_NAME: 'Clonsast',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990634,
        LOCATION_LATITUDE_DEG: 53.2164793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL042400',
        LOCATION_NAME: 'Clonshag Br',
        COUNTY_NAME: 'Carlow',
        POSTCODE: 'Dublin 17',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2788512,
        LOCATION_LATITUDE_DEG: 53.3518334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032600',
        LOCATION_NAME: 'Clonshag Br.',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 17',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.21344,
        LOCATION_LATITUDE_DEG: 53.4030886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990501',
        LOCATION_NAME: 'Clonshaugh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2094244,
        LOCATION_LATITUDE_DEG: 53.4143953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032700',
        LOCATION_NAME: 'Clonsilla',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156776,
        LOCATION_LATITUDE_DEG: 53.3830814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044200',
        LOCATION_NAME: 'Clonskeagh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2317421,
        LOCATION_LATITUDE_DEG: 53.3165213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044800',
        LOCATION_NAME: 'Clontarf',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1966315,
        LOCATION_LATITUDE_DEG: 53.3613075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL044850',
        LOCATION_NAME: 'Clonterry',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2789344,
        LOCATION_LATITUDE_DEG: 53.1292784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032800',
        LOCATION_NAME: 'Clontibret',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490093,
        LOCATION_LATITUDE_DEG: 54.1998696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032900',
        LOCATION_NAME: 'Clontuskert',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.224038,
        LOCATION_LATITUDE_DEG: 53.2749372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL032950',
        LOCATION_NAME: 'Clontyglass',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.361036,
        LOCATION_LATITUDE_DEG: 53.0701709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038350',
        LOCATION_NAME: 'Clonygowan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3836901,
        LOCATION_LATITUDE_DEG: 53.0780383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033000',
        LOCATION_NAME: 'Clonygowan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.282381,
        LOCATION_LATITUDE_DEG: 53.1830848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038375',
        LOCATION_NAME: 'Clonyguin',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2826837,
        LOCATION_LATITUDE_DEG: 53.1697322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033100',
        LOCATION_NAME: 'Cloonacool',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7658973,
        LOCATION_LATITUDE_DEG: 54.0998748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991146',
        LOCATION_NAME: 'Cloonahard',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9247,
        LOCATION_LATITUDE_DEG: 53.7194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033200',
        LOCATION_NAME: 'Cloonakilleg',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824475,
        LOCATION_LATITUDE_DEG: 53.5165204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990639',
        LOCATION_NAME: 'Cloonamahon',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033250',
        LOCATION_NAME: 'Cloonark',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0518008,
        LOCATION_LATITUDE_DEG: 53.367881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991014',
        LOCATION_NAME: 'Cloonart North',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8833,
        LOCATION_LATITUDE_DEG: 53.8056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033300',
        LOCATION_NAME: 'Cloonart South',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824268,
        LOCATION_LATITUDE_DEG: 53.7998452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033350',
        LOCATION_NAME: 'Cloonbalt',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7898941,
        LOCATION_LATITUDE_DEG: 53.7542438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033400',
        LOCATION_NAME: 'Cloonbannin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159543,
        LOCATION_LATITUDE_DEG: 52.1329846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033500',
        LOCATION_NAME: 'Cloonboo',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159259,
        LOCATION_LATITUDE_DEG: 53.366505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033600',
        LOCATION_NAME: 'Clooncah',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991179,
        LOCATION_LATITUDE_DEG: 53.6998365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033700',
        LOCATION_NAME: 'Clooncan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.665873,
        LOCATION_LATITUDE_DEG: 53.7831513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033800',
        LOCATION_NAME: 'Clooncoorha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.44928,
        LOCATION_LATITUDE_DEG: 52.6664418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL033850',
        LOCATION_NAME: 'Clooncoose',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7743204,
        LOCATION_LATITUDE_DEG: 53.7373338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034000',
        LOCATION_NAME: 'Cloondergan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8158957,
        LOCATION_LATITUDE_DEG: 53.6498398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL991145',
        LOCATION_NAME: 'Cloondroon',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8661,
        LOCATION_LATITUDE_DEG: 53.4842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034100',
        LOCATION_NAME: 'Cloone',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7824153,
        LOCATION_LATITUDE_DEG: 53.9498531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034150',
        LOCATION_NAME: 'Cloonee',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3225029,
        LOCATION_LATITUDE_DEG: 53.7148603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034200',
        LOCATION_NAME: 'Clooneen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.082542,
        LOCATION_LATITUDE_DEG: 53.4498193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034300',
        LOCATION_NAME: 'Clooneen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324311,
        LOCATION_LATITUDE_DEG: 53.5665246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034400',
        LOCATION_NAME: 'Cloonfad',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7535847,
        LOCATION_LATITUDE_DEG: 53.6996343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034450',
        LOCATION_NAME: 'Cloonfad',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0990819,
        LOCATION_LATITUDE_DEG: 53.3045955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034500',
        LOCATION_NAME: 'Cloonfower',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991815,
        LOCATION_LATITUDE_DEG: 53.799854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034600',
        LOCATION_NAME: 'Cloongowla',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.199244,
        LOCATION_LATITUDE_DEG: 53.6331279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034625',
        LOCATION_NAME: 'Cloongowna',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0056608,
        LOCATION_LATITUDE_DEG: 53.4349496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034650',
        LOCATION_NAME: 'Cloonkeely',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1937828,
        LOCATION_LATITUDE_DEG: 53.4529327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034800',
        LOCATION_NAME: 'Cloonkeen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6533675,
        LOCATION_LATITUDE_DEG: 53.3231291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL034700',
        LOCATION_NAME: 'Cloonkeen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991481,
        LOCATION_LATITUDE_DEG: 53.3998046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035000',
        LOCATION_NAME: 'Cloonlavis',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659075,
        LOCATION_LATITUDE_DEG: 53.7998448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035100',
        LOCATION_NAME: 'Cloonloogh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3953726,
        LOCATION_LATITUDE_DEG: 53.9664598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035300',
        LOCATION_NAME: 'Cloonmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7158925,
        LOCATION_LATITUDE_DEG: 53.9665595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035200',
        LOCATION_NAME: 'Cloonmore',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.051163,
        LOCATION_LATITUDE_DEG: 53.615125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990859',
        LOCATION_NAME: 'Cloonnavaddoge',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035350',
        LOCATION_NAME: 'Cloonrallagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7907674,
        LOCATION_LATITUDE_DEG: 53.7642038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035400',
        LOCATION_NAME: 'Cloonslaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159194,
        LOCATION_LATITUDE_DEG: 54.083181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035500',
        LOCATION_NAME: 'Cloonteen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824676,
        LOCATION_LATITUDE_DEG: 52.6164325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035600',
        LOCATION_NAME: 'Cloontuskert',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991374,
        LOCATION_LATITUDE_DEG: 53.6998341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL035700',
        LOCATION_NAME: 'Cloonusker',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658773,
        LOCATION_LATITUDE_DEG: 52.9330611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL036250',
        LOCATION_NAME: 'Closeland',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1314091,
        LOCATION_LATITUDE_DEG: 53.1196975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990796',
        LOCATION_NAME: 'Cloughbrack',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990905',
        LOCATION_NAME: 'Cloughduv',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL990995',
        LOCATION_NAME: 'Cloughjordan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037850',
        LOCATION_NAME: 'Cloverhill',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2438817,
        LOCATION_LATITUDE_DEG: 53.6519973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL037800',
        LOCATION_NAME: 'Cloverhill',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3657668,
        LOCATION_LATITUDE_DEG: 54.0831685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL038400',
        LOCATION_NAME: 'Cloyne',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1275336,
        LOCATION_LATITUDE_DEG: 51.866349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL040600',
        LOCATION_NAME: 'Clydagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6658804,
        LOCATION_LATITUDE_DEG: 53.7498498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CL041000',
        LOCATION_NAME: 'Clynacartan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.39938,
        LOCATION_LATITUDE_DEG: 51.8996701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CN000100',
        LOCATION_NAME: 'Cnoc Mhuire',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.915894,
        LOCATION_LATITUDE_DEG: 53.7831497,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000200',
        LOCATION_NAME: 'Coachford',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7796094,
        LOCATION_LATITUDE_DEG: 51.9121737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO000700',
        LOCATION_NAME: 'Coalbrook',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.582401,
        LOCATION_LATITUDE_DEG: 52.5997209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002600',
        LOCATION_NAME: 'Coan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157642,
        LOCATION_LATITUDE_DEG: 52.7830373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO002800',
        LOCATION_NAME: 'Coars',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.116065,
        LOCATION_LATITUDE_DEG: 51.9496837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO004200',
        LOCATION_NAME: 'Cobh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2959963,
        LOCATION_LATITUDE_DEG: 51.8582574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO008250',
        LOCATION_NAME: 'Codrum',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9897209,
        LOCATION_LATITUDE_DEG: 51.9094539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO010800',
        LOCATION_NAME: 'Coill Dubh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8081837,
        LOCATION_LATITUDE_DEG: 53.2864551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO011400',
        LOCATION_NAME: 'Colbinstown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7466765,
        LOCATION_LATITUDE_DEG: 53.0348737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990088',
        LOCATION_NAME: 'COLEMANSTOWN',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6182626,
        LOCATION_LATITUDE_DEG: 53.394382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO018800',
        LOCATION_NAME: 'Colgagh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.382445,
        LOCATION_LATITUDE_DEG: 54.283194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079700',
        LOCATION_NAME: 'College Green',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 2',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2610439,
        LOCATION_LATITUDE_DEG: 53.3450222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO019900',
        LOCATION_NAME: 'Collegeland',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823111,
        LOCATION_LATITUDE_DEG: 53.4831027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO020600',
        LOCATION_NAME: 'Collierstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489648,
        LOCATION_LATITUDE_DEG: 53.649814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021900',
        LOCATION_NAME: 'Collinstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157604,
        LOCATION_LATITUDE_DEG: 53.6331158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021800',
        LOCATION_NAME: 'Collinstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490297,
        LOCATION_LATITUDE_DEG: 53.0330608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO021700',
        LOCATION_NAME: 'Collinstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2489417,
        LOCATION_LATITUDE_DEG: 53.4331282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022100',
        LOCATION_NAME: 'Collon',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4873388,
        LOCATION_LATITUDE_DEG: 53.7831233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022300',
        LOCATION_NAME: 'Collooney',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4979568,
        LOCATION_LATITUDE_DEG: 54.1890835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022400',
        LOCATION_NAME: 'Collorus',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493477,
        LOCATION_LATITUDE_DEG: 51.7663573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO022600',
        LOCATION_NAME: 'Colmanstown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6158878,
        LOCATION_LATITUDE_DEG: 53.3831022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990961',
        LOCATION_NAME: 'Comertagh',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO029500',
        LOCATION_NAME: 'Commons',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5491095,
        LOCATION_LATITUDE_DEG: 52.6164224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO033300',
        LOCATION_NAME: 'Cong',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2868038,
        LOCATION_LATITUDE_DEG: 53.5461252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO034200',
        LOCATION_NAME: 'Conigar',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6895474,
        LOCATION_LATITUDE_DEG: 52.6516297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO035500',
        LOCATION_NAME: 'Conna',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991598,
        LOCATION_LATITUDE_DEG: 52.0829838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990978',
        LOCATION_NAME: 'Connemara',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036000',
        LOCATION_NAME: 'Connolly',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825491,
        LOCATION_LATITUDE_DEG: 52.8164556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO036100',
        LOCATION_NAME: 'Connonagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1045616,
        LOCATION_LATITUDE_DEG: 51.5972449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO037300',
        LOCATION_NAME: 'Convoy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6669462,
        LOCATION_LATITUDE_DEG: 54.874048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO038900',
        LOCATION_NAME: 'Coola Cross Roads',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658571,
        LOCATION_LATITUDE_DEG: 54.1498835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039000',
        LOCATION_NAME: 'Coolacurn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491291,
        LOCATION_LATITUDE_DEG: 53.2164852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039050',
        LOCATION_NAME: 'Cooladoyle',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1365992,
        LOCATION_LATITUDE_DEG: 53.0969026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039100',
        LOCATION_NAME: 'Coolagarybeg',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990544,
        LOCATION_LATITUDE_DEG: 53.2330764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039200',
        LOCATION_NAME: 'Coolagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.049239,
        LOCATION_LATITUDE_DEG: 53.2997994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039250',
        LOCATION_NAME: 'Coolagowan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5947502,
        LOCATION_LATITUDE_DEG: 52.4382861,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039275',
        LOCATION_NAME: 'Coolakay',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1818012,
        LOCATION_LATITUDE_DEG: 53.1687609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039300',
        LOCATION_NAME: 'Coolamoney',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5989885,
        LOCATION_LATITUDE_DEG: 53.8831416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039400',
        LOCATION_NAME: 'Coolaney',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991639,
        LOCATION_LATITUDE_DEG: 54.1665789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039450',
        LOCATION_NAME: 'Coolanure',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7300883,
        LOCATION_LATITUDE_DEG: 52.5329394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039500',
        LOCATION_NAME: 'Coolard',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5233381,
        LOCATION_LATITUDE_DEG: 52.4709021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039600',
        LOCATION_NAME: 'Coolatogher',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157497,
        LOCATION_LATITUDE_DEG: 52.5664161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039700',
        LOCATION_NAME: 'Coolattin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4990011,
        LOCATION_LATITUDE_DEG: 52.7497282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039800',
        LOCATION_NAME: 'Coolavokig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0850921,
        LOCATION_LATITUDE_DEG: 51.9185598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO991142',
        LOCATION_NAME: 'Coolbally',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.53361,
        LOCATION_LATITUDE_DEG: 52.90056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039850',
        LOCATION_NAME: 'Coolbanagher',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2381896,
        LOCATION_LATITUDE_DEG: 53.0904001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039900',
        LOCATION_NAME: 'Coolbaun',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491511,
        LOCATION_LATITUDE_DEG: 52.9830589,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990828',
        LOCATION_NAME: 'Coolbawn',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO039950',
        LOCATION_NAME: 'Coolbeg',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1127165,
        LOCATION_LATITUDE_DEG: 52.9497015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040000',
        LOCATION_NAME: 'Coolboy',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4656955,
        LOCATION_LATITUDE_DEG: 52.7497295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040100',
        LOCATION_NAME: 'Coolcarrigan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8433148,
        LOCATION_LATITUDE_DEG: 53.3234649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990906',
        LOCATION_NAME: 'Coolcraheen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040200',
        LOCATION_NAME: 'Coolcullen',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1212855,
        LOCATION_LATITUDE_DEG: 52.7566709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040300',
        LOCATION_NAME: 'Coolcullen',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157524,
        LOCATION_LATITUDE_DEG: 52.749728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990977',
        LOCATION_NAME: 'Cooldrisla',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040400',
        LOCATION_NAME: 'Coole',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823658,
        LOCATION_LATITUDE_DEG: 53.6998349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040500',
        LOCATION_NAME: 'Coole East',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491997,
        LOCATION_LATITUDE_DEG: 51.9663674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040700',
        LOCATION_NAME: 'Coole West',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4659089,
        LOCATION_LATITUDE_DEG: 51.9663749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040800',
        LOCATION_NAME: 'Coolea',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159626,
        LOCATION_LATITUDE_DEG: 51.9163702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO040900',
        LOCATION_NAME: 'Coolearagh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8440193,
        LOCATION_LATITUDE_DEG: 53.29895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041000',
        LOCATION_NAME: 'Cooleeny',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6824158,
        LOCATION_LATITUDE_DEG: 52.7330391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO991049',
        LOCATION_NAME: 'Cooleran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.78198,
        LOCATION_LATITUDE_DEG: 53.2789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041100',
        LOCATION_NAME: 'Coolgreany',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322705,
        LOCATION_LATITUDE_DEG: 52.7497292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041400',
        LOCATION_NAME: 'Coolkenno',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5990099,
        LOCATION_LATITUDE_DEG: 52.7830301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041450',
        LOCATION_NAME: 'Coolkeragh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.499086,
        LOCATION_LATITUDE_DEG: 52.49761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041500',
        LOCATION_NAME: 'Coollegreane',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324264,
        LOCATION_LATITUDE_DEG: 54.1998808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041600',
        LOCATION_NAME: 'Coollick',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4825928,
        LOCATION_LATITUDE_DEG: 52.1163893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041650',
        LOCATION_NAME: 'Coolmain',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6615483,
        LOCATION_LATITUDE_DEG: 51.6422835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041700',
        LOCATION_NAME: 'Coolmeen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159575,
        LOCATION_LATITUDE_DEG: 52.6497355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041800',
        LOCATION_NAME: 'Coolmela',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823155,
        LOCATION_LATITUDE_DEG: 52.6830222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078800',
        LOCATION_NAME: 'Coolmine',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3953234,
        LOCATION_LATITUDE_DEG: 53.3940818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041900',
        LOCATION_NAME: 'Coolmore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324335,
        LOCATION_LATITUDE_DEG: 54.533217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041925',
        LOCATION_NAME: 'Coolmore',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.684937,
        LOCATION_LATITUDE_DEG: 52.525824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041938',
        LOCATION_NAME: 'Coolnabacky',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1824992,
        LOCATION_LATITUDE_DEG: 52.9808706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO041950',
        LOCATION_NAME: 'Coolnaleen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5029276,
        LOCATION_LATITUDE_DEG: 52.4238517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990829',
        LOCATION_NAME: 'Coolock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990684',
        LOCATION_NAME: 'Coolowen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042000',
        LOCATION_NAME: 'Coolrain',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5657917,
        LOCATION_LATITUDE_DEG: 52.9664637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042200',
        LOCATION_NAME: 'Coolreagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5515958,
        LOCATION_LATITUDE_DEG: 52.6124741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990682',
        LOCATION_NAME: 'Coolroe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042300',
        LOCATION_NAME: 'Coolvalley',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490313,
        LOCATION_LATITUDE_DEG: 52.5497137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO042350',
        LOCATION_NAME: 'Coolyhune',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9339131,
        LOCATION_LATITUDE_DEG: 52.5368793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079800',
        LOCATION_NAME: 'Coombe',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.290444,
        LOCATION_LATITUDE_DEG: 53.3353838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990223',
        LOCATION_NAME: 'Coomhola Village',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3748213,
        LOCATION_LATITUDE_DEG: 53.4185349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043500',
        LOCATION_NAME: 'Coomnahincha',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.216065,
        LOCATION_LATITUDE_DEG: 51.9829776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO043600',
        LOCATION_NAME: 'Coonagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6825149,
        LOCATION_LATITUDE_DEG: 52.6664396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044000',
        LOCATION_NAME: 'Cooraclare',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4159694,
        LOCATION_LATITUDE_DEG: 52.6997474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO902795',
        LOCATION_NAME: 'Coosan',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9342876,
        LOCATION_LATITUDE_DEG: 53.4480373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044100',
        LOCATION_NAME: 'Coosavuddig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.316076,
        LOCATION_LATITUDE_DEG: 52.2329993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044300',
        LOCATION_NAME: 'Cootehall',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658305,
        LOCATION_LATITUDE_DEG: 53.9831604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO044400',
        LOCATION_NAME: 'Cootehill',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0880765,
        LOCATION_LATITUDE_DEG: 54.0779578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO045950',
        LOCATION_NAME: 'Coppanagh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0166235,
        LOCATION_LATITUDE_DEG: 52.5510701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO046100',
        LOCATION_NAME: 'Copperalley',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990396,
        LOCATION_LATITUDE_DEG: 53.5831153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047400',
        LOCATION_NAME: 'Coralstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657411,
        LOCATION_LATITUDE_DEG: 53.46651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047500',
        LOCATION_NAME: 'Coras Point',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3978118,
        LOCATION_LATITUDE_DEG: 53.9911619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047600',
        LOCATION_NAME: 'Coratober',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3124595,
        LOCATION_LATITUDE_DEG: 54.0157043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048000',
        LOCATION_NAME: 'Corbally',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0825111,
        LOCATION_LATITUDE_DEG: 54.1665883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048050',
        LOCATION_NAME: 'Corbally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9139382,
        LOCATION_LATITUDE_DEG: 53.3744579,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047700',
        LOCATION_NAME: 'Corbally',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.71148,
        LOCATION_LATITUDE_DEG: 52.6394852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047900',
        LOCATION_NAME: 'Corbally',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657724,
        LOCATION_LATITUDE_DEG: 52.1496794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO047800',
        LOCATION_NAME: 'Corbally',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323175,
        LOCATION_LATITUDE_DEG: 53.1497661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048150',
        LOCATION_NAME: 'Corboy',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6988264,
        LOCATION_LATITUDE_DEG: 53.718795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO991063',
        LOCATION_NAME: 'Corcaghan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9986,
        LOCATION_LATITUDE_DEG: 54.1906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048700',
        LOCATION_NAME: 'Corcaigh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658946,
        LOCATION_LATITUDE_DEG: 51.8996612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048800',
        LOCATION_NAME: 'Corcamore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7579882,
        LOCATION_LATITUDE_DEG: 52.6377664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO048900',
        LOCATION_NAME: 'Corclogh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.03265,
        LOCATION_LATITUDE_DEG: 54.2665624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049000',
        LOCATION_NAME: 'Corclogh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032626,
        LOCATION_LATITUDE_DEG: 54.2555004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049100',
        LOCATION_NAME: 'Corcreaghy',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6156909,
        LOCATION_LATITUDE_DEG: 53.9498478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049200',
        LOCATION_NAME: 'Cordal',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825793,
        LOCATION_LATITUDE_DEG: 52.2163993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049300',
        LOCATION_NAME: 'Cordangan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1697398,
        LOCATION_LATITUDE_DEG: 52.4688515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990779',
        LOCATION_NAME: 'Corduff',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078900',
        LOCATION_NAME: 'Corduff',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO049400',
        LOCATION_NAME: 'Corduff',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3827156,
        LOCATION_LATITUDE_DEG: 53.3999895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050300',
        LOCATION_NAME: 'Corgarve',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991538,
        LOCATION_LATITUDE_DEG: 52.1663775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050400',
        LOCATION_NAME: 'Corglass',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0824284,
        LOCATION_LATITUDE_DEG: 54.116569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050600',
        LOCATION_NAME: 'Cork',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4710748,
        LOCATION_LATITUDE_DEG: 51.9016628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050700',
        LOCATION_NAME: 'Cork Airport',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4899027,
        LOCATION_LATITUDE_DEG: 51.8444254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO050900',
        LOCATION_NAME: 'Corlea',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658177,
        LOCATION_LATITUDE_DEG: 53.6165249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051200',
        LOCATION_NAME: 'Corlismore',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4815166,
        LOCATION_LATITUDE_DEG: 53.9210661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051300',
        LOCATION_NAME: 'Corlough',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7823964,
        LOCATION_LATITUDE_DEG: 54.1165709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990174',
        LOCATION_NAME: 'Cormackstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8614091,
        LOCATION_LATITUDE_DEG: 52.6715932,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051350',
        LOCATION_NAME: 'Cormeen',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8882388,
        LOCATION_LATITUDE_DEG: 53.8511587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051500',
        LOCATION_NAME: 'Cornacullew',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7157898,
        LOCATION_LATITUDE_DEG: 53.8831556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051600',
        LOCATION_NAME: 'Cornafean',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4810695,
        LOCATION_LATITUDE_DEG: 53.9570026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051700',
        LOCATION_NAME: 'Cornafulla',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991408,
        LOCATION_LATITUDE_DEG: 53.3664971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051800',
        LOCATION_NAME: 'Cornageeha',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658003,
        LOCATION_LATITUDE_DEG: 53.8831508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO051850',
        LOCATION_NAME: 'Cornagower West',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0606072,
        LOCATION_LATITUDE_DEG: 52.8776798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052050',
        LOCATION_NAME: 'Cornamaddy',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9005782,
        LOCATION_LATITUDE_DEG: 53.4379452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO052100',
        LOCATION_NAME: 'Cornamona',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4492703,
        LOCATION_LATITUDE_DEG: 53.5165223,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO078400',
        LOCATION_NAME: 'Cornelscourt',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1658548,
        LOCATION_LATITUDE_DEG: 53.2685264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055700',
        LOCATION_NAME: 'Corofin',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659351,
        LOCATION_LATITUDE_DEG: 52.9330608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054100',
        LOCATION_NAME: 'Corradrishy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0992249,
        LOCATION_LATITUDE_DEG: 54.0165676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990963',
        LOCATION_NAME: 'Corrafaireen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054150',
        LOCATION_NAME: 'Corramore',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0305574,
        LOCATION_LATITUDE_DEG: 53.4534278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990058',
        LOCATION_NAME: 'Corrandrum',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990854',
        LOCATION_NAME: 'Corrandulla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054400',
        LOCATION_NAME: 'Corraun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7658874,
        LOCATION_LATITUDE_DEG: 53.7165388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054600',
        LOCATION_NAME: 'Corrawalleen',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158084,
        LOCATION_LATITUDE_DEG: 54.0165648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO054900',
        LOCATION_NAME: 'Corries Cross',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9052753,
        LOCATION_LATITUDE_DEG: 52.6589357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055000',
        LOCATION_NAME: 'Corrigeenroe',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2780394,
        LOCATION_LATITUDE_DEG: 54.0284888,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055100',
        LOCATION_NAME: 'Corrigo',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823972,
        LOCATION_LATITUDE_DEG: 53.9331524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055600',
        LOCATION_NAME: 'Corrofin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492057,
        LOCATION_LATITUDE_DEG: 53.4331135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055500',
        LOCATION_NAME: 'Corrofin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8418886,
        LOCATION_LATITUDE_DEG: 53.4339492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO055800',
        LOCATION_NAME: 'Corroy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659305,
        LOCATION_LATITUDE_DEG: 54.0665731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO991040',
        LOCATION_NAME: 'Corrybracken',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7717,
        LOCATION_LATITUDE_DEG: 53.9608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO057500',
        LOCATION_NAME: 'Cortown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657256,
        LOCATION_LATITUDE_DEG: 53.6831221,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO059500',
        LOCATION_NAME: 'Costelloe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5481802,
        LOCATION_LATITUDE_DEG: 53.2928023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO065300',
        LOCATION_NAME: 'Coulagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9660359,
        LOCATION_LATITUDE_DEG: 51.6829487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO066400',
        LOCATION_NAME: 'Coumduffmore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.066047,
        LOCATION_LATITUDE_DEG: 52.1664017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO991051',
        LOCATION_NAME: 'Courtbrack',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.645,
        LOCATION_LATITUDE_DEG: 51.968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068100',
        LOCATION_NAME: 'Courtmacsherry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159229,
        LOCATION_LATITUDE_DEG: 51.6329397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068200',
        LOCATION_NAME: 'Courtmatrix',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492339,
        LOCATION_LATITUDE_DEG: 52.4997233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068300',
        LOCATION_NAME: 'Courtnacuddy',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6982422,
        LOCATION_LATITUDE_DEG: 52.4836955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068400',
        LOCATION_NAME: 'Courtown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322765,
        LOCATION_LATITUDE_DEG: 52.6330082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO990838',
        LOCATION_NAME: 'Courtstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068650',
        LOCATION_NAME: 'Courtwood',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0688747,
        LOCATION_LATITUDE_DEG: 53.0756645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO068700',
        LOCATION_NAME: 'Cousane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992891,
        LOCATION_LATITUDE_DEG: 51.7496463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CO079500',
        LOCATION_NAME: 'Cove',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6290895,
        LOCATION_LATITUDE_DEG: 51.5114641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000200',
        LOCATION_NAME: 'Craanford',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4065352,
        LOCATION_LATITUDE_DEG: 52.6852191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR000100',
        LOCATION_NAME: 'Craanford',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.390633,
        LOCATION_LATITUDE_DEG: 52.678882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR001200',
        LOCATION_NAME: 'Craddanstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657322,
        LOCATION_LATITUDE_DEG: 53.5331082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR007500',
        LOCATION_NAME: 'Cranford',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6990582,
        LOCATION_LATITUDE_DEG: 55.1499718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008600',
        LOCATION_NAME: 'Crannagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824338,
        LOCATION_LATITUDE_DEG: 53.3998066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR008900',
        LOCATION_NAME: 'Cranroe',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323607,
        LOCATION_LATITUDE_DEG: 52.6997278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010700',
        LOCATION_NAME: 'Cratloe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7642783,
        LOCATION_LATITUDE_DEG: 52.7036469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990625',
        LOCATION_NAME: 'Cratloe East',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990626',
        LOCATION_NAME: 'Cratloe West',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR010800',
        LOCATION_NAME: 'Craughwell',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7304956,
        LOCATION_LATITUDE_DEG: 53.2316883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR013400',
        LOCATION_NAME: 'Creaghanroe',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7322838,
        LOCATION_LATITUDE_DEG: 54.1665672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014000',
        LOCATION_NAME: 'Crecora',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6779083,
        LOCATION_LATITUDE_DEG: 52.5811605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014100',
        LOCATION_NAME: 'Crecrin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157118,
        LOCATION_LATITUDE_DEG: 52.7997381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR014400',
        LOCATION_NAME: 'Creduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3325555,
        LOCATION_LATITUDE_DEG: 53.2498013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990338',
        LOCATION_NAME: 'Cree',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4921916,
        LOCATION_LATITUDE_DEG: 53.357112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015300',
        LOCATION_NAME: 'Creegh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4325772,
        LOCATION_LATITUDE_DEG: 52.7330519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015400',
        LOCATION_NAME: 'Creeharmore',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658504,
        LOCATION_LATITUDE_DEG: 53.4831115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR015600',
        LOCATION_NAME: 'Creeslough',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8990821,
        LOCATION_LATITUDE_DEG: 55.1166722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016100',
        LOCATION_NAME: 'Creevagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659211,
        LOCATION_LATITUDE_DEG: 54.2998978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016200',
        LOCATION_NAME: 'Creevagh',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991489,
        LOCATION_LATITUDE_DEG: 53.2997953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016300',
        LOCATION_NAME: 'Creeves',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325473,
        LOCATION_LATITUDE_DEG: 52.5664325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR991054',
        LOCATION_NAME: 'Creeves Cross',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0164,
        LOCATION_LATITUDE_DEG: 52.5639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016400',
        LOCATION_NAME: 'Creevy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825552,
        LOCATION_LATITUDE_DEG: 54.0498787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016500',
        LOCATION_NAME: 'Cregg',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992499,
        LOCATION_LATITUDE_DEG: 53.1330871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016600',
        LOCATION_NAME: 'Cregg',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0825542,
        LOCATION_LATITUDE_DEG: 51.5496306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016800',
        LOCATION_NAME: 'Cregg',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5147009,
        LOCATION_LATITUDE_DEG: 54.3011676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016700',
        LOCATION_NAME: 'Cregg',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3967696,
        LOCATION_LATITUDE_DEG: 52.3664022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016963',
        LOCATION_NAME: 'Creggan Lower',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8841466,
        LOCATION_LATITUDE_DEG: 53.4144763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR016975',
        LOCATION_NAME: 'Creggan Upper',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8828542,
        LOCATION_LATITUDE_DEG: 53.4048165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017000',
        LOCATION_NAME: 'Cregganbaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8032501,
        LOCATION_LATITUDE_DEG: 53.7135409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017100',
        LOCATION_NAME: 'Creggaun',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7492146,
        LOCATION_LATITUDE_DEG: 52.666435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR017200',
        LOCATION_NAME: 'Creggs',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3737634,
        LOCATION_LATITUDE_DEG: 53.5913247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990980',
        LOCATION_NAME: 'Cremartin',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052200',
        LOCATION_NAME: 'Cremore',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2744761,
        LOCATION_LATITUDE_DEG: 53.3794399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019100',
        LOCATION_NAME: 'Crettyard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1233816,
        LOCATION_LATITUDE_DEG: 52.8405163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR019200',
        LOCATION_NAME: 'Crettyard',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1233806,
        LOCATION_LATITUDE_DEG: 52.8405074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022400',
        LOCATION_NAME: 'Crinkill',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991317,
        LOCATION_LATITUDE_DEG: 53.0664702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022500',
        LOCATION_NAME: 'Crinkill',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8963447,
        LOCATION_LATITUDE_DEG: 53.0769988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR022900',
        LOCATION_NAME: 'Crissard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323482,
        LOCATION_LATITUDE_DEG: 52.8997457,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023100',
        LOCATION_NAME: 'Croagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659279,
        LOCATION_LATITUDE_DEG: 52.5330206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023200',
        LOCATION_NAME: 'Croaghan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5490816,
        LOCATION_LATITUDE_DEG: 54.0165597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990834',
        LOCATION_NAME: 'Croaghrimbeg',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023300',
        LOCATION_NAME: 'Crockan, The',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4322825,
        LOCATION_LATITUDE_DEG: 53.5165079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR023400',
        LOCATION_NAME: 'Crockaun',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657392,
        LOCATION_LATITUDE_DEG: 52.8164436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024000',
        LOCATION_NAME: 'Crockets Town',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159225,
        LOCATION_LATITUDE_DEG: 54.13318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR024300',
        LOCATION_NAME: 'Crockfadda',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.382435,
        LOCATION_LATITUDE_DEG: 54.6999333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027800',
        LOCATION_NAME: 'Croghan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158291,
        LOCATION_LATITUDE_DEG: 53.8998523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027700',
        LOCATION_NAME: 'Croghan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823628,
        LOCATION_LATITUDE_DEG: 53.3330922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR027600',
        LOCATION_NAME: 'Croghan',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3156825,
        LOCATION_LATITUDE_DEG: 52.7830319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR028100',
        LOCATION_NAME: 'Crolly',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2695188,
        LOCATION_LATITUDE_DEG: 55.0256709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR030600',
        LOCATION_NAME: 'Crookedwood',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823556,
        LOCATION_LATITUDE_DEG: 53.5998194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031200',
        LOCATION_NAME: 'Crookhaven',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7278259,
        LOCATION_LATITUDE_DEG: 51.4725217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031500',
        LOCATION_NAME: 'Crookstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8233758,
        LOCATION_LATITUDE_DEG: 51.8440507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031400',
        LOCATION_NAME: 'Crookstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8095844,
        LOCATION_LATITUDE_DEG: 53.0150451,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR031700',
        LOCATION_NAME: 'Croom',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7194139,
        LOCATION_LATITUDE_DEG: 52.5275241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033700',
        LOCATION_NAME: 'Cross',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826541,
        LOCATION_LATITUDE_DEG: 52.5830713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR033600',
        LOCATION_NAME: 'Cross',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2060567,
        LOCATION_LATITUDE_DEG: 53.5386722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034100',
        LOCATION_NAME: 'Cross Barry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492293,
        LOCATION_LATITUDE_DEG: 51.7996515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034600',
        LOCATION_NAME: 'Cross Guns',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7322991,
        LOCATION_LATITUDE_DEG: 53.7831248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR034700',
        LOCATION_NAME: 'Cross Guns, The',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.682293,
        LOCATION_LATITUDE_DEG: 53.899845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035900',
        LOCATION_NAME: 'Cross Keys',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6156995,
        LOCATION_LATITUDE_DEG: 53.4997993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036300',
        LOCATION_NAME: 'Crossabeg',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4990084,
        LOCATION_LATITUDE_DEG: 52.3829908,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036400',
        LOCATION_NAME: 'Crossagalla',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5914669,
        LOCATION_LATITUDE_DEG: 52.6463782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036600',
        LOCATION_NAME: 'Crossakeel',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0279419,
        LOCATION_LATITUDE_DEG: 53.7299262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR036900',
        LOCATION_NAME: 'Crossboyne',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992162,
        LOCATION_LATITUDE_DEG: 53.683142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037400',
        LOCATION_NAME: 'Crossdoney',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4404443,
        LOCATION_LATITUDE_DEG: 53.9578554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037500',
        LOCATION_NAME: 'Crossea',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323879,
        LOCATION_LATITUDE_DEG: 53.6665287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR037700',
        LOCATION_NAME: 'Crosserlough',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823524,
        LOCATION_LATITUDE_DEG: 53.8831417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR038700',
        LOCATION_NAME: 'Crosshaven',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.304653,
        LOCATION_LATITUDE_DEG: 51.7951442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR035800',
        LOCATION_NAME: 'Crosskeys',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2657527,
        LOCATION_LATITUDE_DEG: 53.916545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039100',
        LOCATION_NAME: 'Crosskeys',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157465,
        LOCATION_LATITUDE_DEG: 53.0997726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039500',
        LOCATION_NAME: 'Crossmolina',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3192356,
        LOCATION_LATITUDE_DEG: 54.1026857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039700',
        LOCATION_NAME: 'Crossmount',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.449293,
        LOCATION_LATITUDE_DEG: 51.9329753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR039800',
        LOCATION_NAME: 'Crossna',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824249,
        LOCATION_LATITUDE_DEG: 54.0165687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040100',
        LOCATION_NAME: 'Crosspatrick',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5991072,
        LOCATION_LATITUDE_DEG: 52.766442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040000',
        LOCATION_NAME: 'Crosspatrick',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4489982,
        LOCATION_LATITUDE_DEG: 52.7497284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR040900',
        LOCATION_NAME: 'Crosswell',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824525,
        LOCATION_LATITUDE_DEG: 53.5998295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR042300',
        LOCATION_NAME: 'Crowbane',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4991482,
        LOCATION_LATITUDE_DEG: 54.6999291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990557',
        LOCATION_NAME: 'Crowenstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR043450',
        LOCATION_NAME: 'Crowinstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0257252,
        LOCATION_LATITUDE_DEG: 53.6258945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR047200',
        LOCATION_NAME: 'Crubany',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3175712,
        LOCATION_LATITUDE_DEG: 53.9613652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR990054',
        LOCATION_NAME: 'Crumlin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7777372,
        LOCATION_LATITUDE_DEG: 53.4047172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR052300',
        LOCATION_NAME: 'Crumlin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3115858,
        LOCATION_LATITUDE_DEG: 53.3018352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048400',
        LOCATION_NAME: 'Crumpaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5687345,
        LOCATION_LATITUDE_DEG: 53.2848049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048800',
        LOCATION_NAME: 'Crusheen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8966615,
        LOCATION_LATITUDE_DEG: 52.9425675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CR048900',
        LOCATION_NAME: 'Crutt',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990689,
        LOCATION_LATITUDE_DEG: 52.8664509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002300',
        LOCATION_NAME: 'Cuffes Grange',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2990874,
        LOCATION_LATITUDE_DEG: 52.5997213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002500',
        LOCATION_NAME: 'Cuilmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825041,
        LOCATION_LATITUDE_DEG: 53.9498618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU002600',
        LOCATION_NAME: 'Cuilmullagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992559,
        LOCATION_LATITUDE_DEG: 53.9665692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU003100',
        LOCATION_NAME: 'Culdaff',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1671798,
        LOCATION_LATITUDE_DEG: 55.2902805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004200',
        LOCATION_NAME: 'Cullahill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.732424,
        LOCATION_LATITUDE_DEG: 52.8664485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004100',
        LOCATION_NAME: 'Cullahill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4657949,
        LOCATION_LATITUDE_DEG: 52.8164435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004250',
        LOCATION_NAME: 'Culleen More',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3556772,
        LOCATION_LATITUDE_DEG: 53.560385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004300',
        LOCATION_NAME: 'Culleens',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992019,
        LOCATION_LATITUDE_DEG: 54.2165862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004500',
        LOCATION_NAME: 'Cullen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159599,
        LOCATION_LATITUDE_DEG: 52.1163858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004600',
        LOCATION_NAME: 'Cullen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658689,
        LOCATION_LATITUDE_DEG: 52.4997181,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004800',
        LOCATION_NAME: 'Cullenagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2492573,
        LOCATION_LATITUDE_DEG: 52.9164646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU990958',
        LOCATION_NAME: 'Cullenogue',
        COUNTY_NAME: 'Wexford',
        POSTCODE: 'Y25k7p2',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU004900',
        LOCATION_NAME: 'Cullentra',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989733,
        LOCATION_LATITUDE_DEG: 52.5497062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU006700',
        LOCATION_NAME: 'Culmullin',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157079,
        LOCATION_LATITUDE_DEG: 53.4830986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU007200',
        LOCATION_NAME: 'Culray',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5657899,
        LOCATION_LATITUDE_DEG: 53.8165366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU009000',
        LOCATION_NAME: 'Cummer',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9175182,
        LOCATION_LATITUDE_DEG: 53.4513647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU010500',
        LOCATION_NAME: 'Cur',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5992918,
        LOCATION_LATITUDE_DEG: 53.5165257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU990853',
        LOCATION_NAME: 'Curnaseer',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011200',
        LOCATION_NAME: 'Curracloe',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3829223,
        LOCATION_LATITUDE_DEG: 52.3922736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011500',
        LOCATION_NAME: 'Curragh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491671,
        LOCATION_LATITUDE_DEG: 53.1164762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011300',
        LOCATION_NAME: 'Curragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991756,
        LOCATION_LATITUDE_DEG: 52.1329899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011400',
        LOCATION_NAME: 'Curragh',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158338,
        LOCATION_LATITUDE_DEG: 51.9621606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011600',
        LOCATION_NAME: 'Curragh Camp',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8332173,
        LOCATION_LATITUDE_DEG: 53.1436079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011700',
        LOCATION_NAME: 'Curragh West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491755,
        LOCATION_LATITUDE_DEG: 53.6498352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011800',
        LOCATION_NAME: 'Curragha',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4489853,
        LOCATION_LATITUDE_DEG: 53.5331073,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU011900',
        LOCATION_NAME: 'Curraghaleen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491267,
        LOCATION_LATITUDE_DEG: 53.4165048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012000',
        LOCATION_NAME: 'Curraghbinny',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3188573,
        LOCATION_LATITUDE_DEG: 51.8099484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012100',
        LOCATION_NAME: 'Curraghboy',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1196708,
        LOCATION_LATITUDE_DEG: 53.4817824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012200',
        LOCATION_NAME: 'Curraghgorm',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658895,
        LOCATION_LATITUDE_DEG: 52.266394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012250',
        LOCATION_NAME: 'Curraghlane',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.029422,
        LOCATION_LATITUDE_DEG: 52.5796407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012300',
        LOCATION_NAME: 'Curraghroe',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0157912,
        LOCATION_LATITUDE_DEG: 53.7331756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012350',
        LOCATION_NAME: 'Curraghtown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7314276,
        LOCATION_LATITUDE_DEG: 53.6105346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012400',
        LOCATION_NAME: 'Curraglass',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491457,
        LOCATION_LATITUDE_DEG: 52.0829773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012550',
        LOCATION_NAME: 'Curraheen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7460218,
        LOCATION_LATITUDE_DEG: 52.2473204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012500',
        LOCATION_NAME: 'Curraheen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658956,
        LOCATION_LATITUDE_DEG: 51.8663529,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012600',
        LOCATION_NAME: 'Currans',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5493039,
        LOCATION_LATITUDE_DEG: 52.1997007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012700',
        LOCATION_NAME: 'Currantiarmuid',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6900577,
        LOCATION_LATITUDE_DEG: 53.3675289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012800',
        LOCATION_NAME: 'Curratubbin Cross Roads',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.310648,
        LOCATION_LATITUDE_DEG: 52.5752568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU012900',
        LOCATION_NAME: 'Curreeny',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491455,
        LOCATION_LATITUDE_DEG: 52.7330492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013300',
        LOCATION_NAME: 'Curry',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7824996,
        LOCATION_LATITUDE_DEG: 53.9998703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013350',
        LOCATION_NAME: 'Curry',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8214174,
        LOCATION_LATITUDE_DEG: 53.6634277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU013600',
        LOCATION_NAME: 'Curryglass',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8102337,
        LOCATION_LATITUDE_DEG: 51.6699463,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014050',
        LOCATION_NAME: 'Curtlestown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2124114,
        LOCATION_LATITUDE_DEG: 53.1866907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014600',
        LOCATION_NAME: 'Cushenstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8583213,
        LOCATION_LATITUDE_DEG: 52.3675847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014700',
        LOCATION_NAME: 'Cushina',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1654476,
        LOCATION_LATITUDE_DEG: 53.2020774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU014800',
        LOCATION_NAME: 'Cushleeka',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8068728,
        LOCATION_LATITUDE_DEG: 53.8886654,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'CU015300',
        LOCATION_NAME: 'Cut Bush',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8326234,
        LOCATION_LATITUDE_DEG: 53.1232943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA001600',
        LOCATION_NAME: 'Daingean',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2903599,
        LOCATION_LATITUDE_DEG: 53.2999831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004000',
        LOCATION_NAME: 'Dalgin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659052,
        LOCATION_LATITUDE_DEG: 53.6331316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA004700',
        LOCATION_NAME: 'Dalkey',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1064583,
        LOCATION_LATITUDE_DEG: 53.278372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA008700',
        LOCATION_NAME: 'Dalystown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3657255,
        LOCATION_LATITUDE_DEG: 53.4331355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA010450',
        LOCATION_NAME: 'Danesfort',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1957045,
        LOCATION_LATITUDE_DEG: 52.590669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011000',
        LOCATION_NAME: 'Dangan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324566,
        LOCATION_LATITUDE_DEG: 51.9663616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA011700',
        LOCATION_NAME: 'Dardistown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3156648,
        LOCATION_LATITUDE_DEG: 53.6498156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA990502',
        LOCATION_NAME: 'Darndale',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 17',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA014200',
        LOCATION_NAME: 'Darragh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0465478,
        LOCATION_LATITUDE_DEG: 52.7985587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA019200',
        LOCATION_NAME: 'Dartry',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2628052,
        LOCATION_LATITUDE_DEG: 53.3134432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA016600',
        LOCATION_NAME: 'Davidstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6301177,
        LOCATION_LATITUDE_DEG: 52.4762994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017600',
        LOCATION_NAME: 'Dawros Beg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9756792,
        LOCATION_LATITUDE_DEG: 53.5673409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017700',
        LOCATION_NAME: 'Dawros Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6493189,
        LOCATION_LATITUDE_DEG: 51.8496676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DA017800',
        LOCATION_NAME: 'Dawros More',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9660164,
        LOCATION_LATITUDE_DEG: 53.5665375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE001000',
        LOCATION_NAME: 'Deans Grange',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.175572,
        LOCATION_LATITUDE_DEG: 53.2776773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE002400',
        LOCATION_NAME: 'Deelis',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493395,
        LOCATION_LATITUDE_DEG: 52.2164046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE019150',
        LOCATION_NAME: 'Deerpark',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0783636,
        LOCATION_LATITUDE_DEG: 53.4650964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE019100',
        LOCATION_NAME: 'Deerpark',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.066514,
        LOCATION_LATITUDE_DEG: 53.3960191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005300',
        LOCATION_NAME: 'Delgany',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0822635,
        LOCATION_LATITUDE_DEG: 53.133094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005400',
        LOCATION_NAME: 'Delgany',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.082246,
        LOCATION_LATITUDE_DEG: 53.1330676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE005700',
        LOCATION_NAME: 'Delvin',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0961696,
        LOCATION_LATITUDE_DEG: 53.6126126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE019000',
        LOCATION_NAME: 'Delwood',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5492283,
        LOCATION_LATITUDE_DEG: 53.5264308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011700',
        LOCATION_NAME: 'Dernagree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325474,
        LOCATION_LATITUDE_DEG: 52.1163797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011800',
        LOCATION_NAME: 'Dernahelty Beg',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.849108,
        LOCATION_LATITUDE_DEG: 54.0831755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE011900',
        LOCATION_NAME: 'Dernahelty More',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658188,
        LOCATION_LATITUDE_DEG: 54.0998707,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE990800',
        LOCATION_NAME: 'Derradda',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012100',
        LOCATION_NAME: 'Derrane',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1788666,
        LOCATION_LATITUDE_DEG: 53.6697369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012300',
        LOCATION_NAME: 'Derreen',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493233,
        LOCATION_LATITUDE_DEG: 53.8998678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012200',
        LOCATION_NAME: 'Derreen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159646,
        LOCATION_LATITUDE_DEG: 53.0830797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012400',
        LOCATION_NAME: 'Derreen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159502,
        LOCATION_LATITUDE_DEG: 52.0663874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012450',
        LOCATION_NAME: 'Derreen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7095739,
        LOCATION_LATITUDE_DEG: 53.4476233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE012600',
        LOCATION_NAME: 'Derrew',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991547,
        LOCATION_LATITUDE_DEG: 53.1997805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE991045',
        LOCATION_NAME: 'Derrinagree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.033457,
        LOCATION_LATITUDE_DEG: 52.120738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013000',
        LOCATION_NAME: 'Derrinkee',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5159734,
        LOCATION_LATITUDE_DEG: 53.6831381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013100',
        LOCATION_NAME: 'Derrinturn',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323259,
        LOCATION_LATITUDE_DEG: 53.3330926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013200',
        LOCATION_NAME: 'Derrinvoney',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0819986,
        LOCATION_LATITUDE_DEG: 54.1681777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013350',
        LOCATION_NAME: 'Derry',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.41114,
        LOCATION_LATITUDE_DEG: 52.4821059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013375',
        LOCATION_NAME: 'Derry',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2390608,
        LOCATION_LATITUDE_DEG: 53.0207958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013600',
        LOCATION_NAME: 'Derryad',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658115,
        LOCATION_LATITUDE_DEG: 53.599824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013800',
        LOCATION_NAME: 'Derrybeg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991273,
        LOCATION_LATITUDE_DEG: 55.0832693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013900',
        LOCATION_NAME: 'Derrybrien',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5856342,
        LOCATION_LATITUDE_DEG: 53.0732703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE013950',
        LOCATION_NAME: 'Derrycloney',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3411666,
        LOCATION_LATITUDE_DEG: 53.1024985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014000',
        LOCATION_NAME: 'Derryclure',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4657832,
        LOCATION_LATITUDE_DEG: 53.2330815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014100',
        LOCATION_NAME: 'Derrycoffey',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323735,
        LOCATION_LATITUDE_DEG: 53.3497904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014200',
        LOCATION_NAME: 'Derrycramph',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3832083,
        LOCATION_LATITUDE_DEG: 53.9799374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014250',
        LOCATION_NAME: 'Derrydavy',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2908665,
        LOCATION_LATITUDE_DEG: 53.0860564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014300',
        LOCATION_NAME: 'Derrydonnell',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7716718,
        LOCATION_LATITUDE_DEG: 53.2866716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014400',
        LOCATION_NAME: 'Derryfrench',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824651,
        LOCATION_LATITUDE_DEG: 53.1664835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014425',
        LOCATION_NAME: 'Derrygarran',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2599076,
        LOCATION_LATITUDE_DEG: 53.0715193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014438',
        LOCATION_NAME: 'Derrygile',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3226806,
        LOCATION_LATITUDE_DEG: 53.0847329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014450',
        LOCATION_NAME: 'Derryglad',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0878331,
        LOCATION_LATITUDE_DEG: 53.4710604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014582',
        LOCATION_NAME: 'Derrykearn',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3974275,
        LOCATION_LATITUDE_DEG: 52.9553209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014588',
        LOCATION_NAME: 'Derrylahan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0465681,
        LOCATION_LATITUDE_DEG: 53.3513993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014600',
        LOCATION_NAME: 'Derrylehan',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491431,
        LOCATION_LATITUDE_DEG: 54.3999052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014625',
        LOCATION_NAME: 'Derrylemoge',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3925005,
        LOCATION_LATITUDE_DEG: 53.1093317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014800',
        LOCATION_NAME: 'Derrymore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8418356,
        LOCATION_LATITUDE_DEG: 52.2399821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE014900',
        LOCATION_NAME: 'Derrymore',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658884,
        LOCATION_LATITUDE_DEG: 52.9164613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE990902',
        LOCATION_NAME: 'Derrymore East',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015000',
        LOCATION_NAME: 'Derrymullin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491431,
        LOCATION_LATITUDE_DEG: 53.3330984,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015100',
        LOCATION_NAME: 'Derrynacaheragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659729,
        LOCATION_LATITUDE_DEG: 51.74965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015250',
        LOCATION_NAME: 'Derrypark',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4600027,
        LOCATION_LATITUDE_DEG: 53.6026542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015300',
        LOCATION_NAME: 'Derryrush',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6478925,
        LOCATION_LATITUDE_DEG: 53.395615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DE015550',
        LOCATION_NAME: 'Derryvohy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI000200',
        LOCATION_NAME: 'Diamond',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8322952,
        LOCATION_LATITUDE_DEG: 53.9331402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI004400',
        LOCATION_NAME: 'Dingle',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.265376,
        LOCATION_LATITUDE_DEG: 52.1399967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DI006350',
        LOCATION_NAME: 'Disduff',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO000200',
        LOCATION_NAME: 'Doagh Beg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323549,
        LOCATION_LATITUDE_DEG: 55.249981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004500',
        LOCATION_NAME: 'Dolla',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1894733,
        LOCATION_LATITUDE_DEG: 52.7970383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025500',
        LOCATION_NAME: 'Dollymount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1845363,
        LOCATION_LATITUDE_DEG: 53.3661772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO004900',
        LOCATION_NAME: 'Dollys Grove',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322966,
        LOCATION_LATITUDE_DEG: 53.416493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025700',
        LOCATION_NAME: 'Dolphins Barn',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2905386,
        LOCATION_LATITUDE_DEG: 53.3351285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006000',
        LOCATION_NAME: 'Donabate',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1489494,
        LOCATION_LATITUDE_DEG: 53.4830886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006200',
        LOCATION_NAME: 'Donacarney',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822793,
        LOCATION_LATITUDE_DEG: 53.6998236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006100',
        LOCATION_NAME: 'Donacarney',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822633,
        LOCATION_LATITUDE_DEG: 53.6998152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO006300',
        LOCATION_NAME: 'Donadea',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323045,
        LOCATION_LATITUDE_DEG: 53.3330858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025000',
        LOCATION_NAME: 'Donaghies',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1734654,
        LOCATION_LATITUDE_DEG: 53.39889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO024900',
        LOCATION_NAME: 'Donaghmede',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1732893,
        LOCATION_LATITUDE_DEG: 53.4021619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007100',
        LOCATION_NAME: 'Donaghmore',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5990977,
        LOCATION_LATITUDE_DEG: 52.8664113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007000',
        LOCATION_NAME: 'Donaghmore',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3720018,
        LOCATION_LATITUDE_DEG: 53.4797381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007200',
        LOCATION_NAME: 'Donaghmore Bridge',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6656946,
        LOCATION_LATITUDE_DEG: 53.6498153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007300',
        LOCATION_NAME: 'Donaghmoyne',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990015,
        LOCATION_LATITUDE_DEG: 53.9998527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007400',
        LOCATION_NAME: 'Donaghpatrick',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7572872,
        LOCATION_LATITUDE_DEG: 53.700068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007600',
        LOCATION_NAME: 'Donamon',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3177185,
        LOCATION_LATITUDE_DEG: 53.631088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007700',
        LOCATION_NAME: 'Donard',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157117,
        LOCATION_LATITUDE_DEG: 53.0164541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO007800',
        LOCATION_NAME: 'Donaskeagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0824483,
        LOCATION_LATITUDE_DEG: 52.51642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008000',
        LOCATION_NAME: 'Donegal',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.114919,
        LOCATION_LATITUDE_DEG: 54.6591273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO008100',
        LOCATION_NAME: 'Doneraile',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5824968,
        LOCATION_LATITUDE_DEG: 52.2163873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO025600',
        LOCATION_NAME: 'Donnybrook',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2405802,
        LOCATION_LATITUDE_DEG: -7.3001599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO990189',
        LOCATION_NAME: 'Donnycarney',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2233499,
        LOCATION_LATITUDE_DEG: 53.3744433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO009900',
        LOCATION_NAME: 'Donohill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491587,
        LOCATION_LATITUDE_DEG: 52.5330217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010100',
        LOCATION_NAME: 'Donore',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4186859,
        LOCATION_LATITUDE_DEG: 53.6928812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010000',
        LOCATION_NAME: 'Donore',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156618,
        LOCATION_LATITUDE_DEG: 53.683123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010200',
        LOCATION_NAME: 'Donoughmore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.749221,
        LOCATION_LATITUDE_DEG: 51.9829669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010400',
        LOCATION_NAME: 'Dooagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.127124,
        LOCATION_LATITUDE_DEG: 53.9779744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010500',
        LOCATION_NAME: 'Doocastle',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6324841,
        LOCATION_LATITUDE_DEG: 54.016575,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010600',
        LOCATION_NAME: 'Doocharry',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158287,
        LOCATION_LATITUDE_DEG: 54.8999547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010700',
        LOCATION_NAME: 'Dooega',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.038211,
        LOCATION_LATITUDE_DEG: 53.9195717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO010800',
        LOCATION_NAME: 'Dooey',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658305,
        LOCATION_LATITUDE_DEG: 54.8666519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO990842',
        LOCATION_NAME: 'Doogarry',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011000',
        LOCATION_NAME: 'Doogega',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.024734,
        LOCATION_LATITUDE_DEG: 53.9231838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011100',
        LOCATION_NAME: 'Dooghbeg',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8160006,
        LOCATION_LATITUDE_DEG: 53.8817664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011200',
        LOCATION_NAME: 'Doogort',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9993191,
        LOCATION_LATITUDE_DEG: 54.016576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011300',
        LOCATION_NAME: 'Doohamlet',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8157009,
        LOCATION_LATITUDE_DEG: 54.1165688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011400',
        LOCATION_NAME: 'Doohooma',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9418112,
        LOCATION_LATITUDE_DEG: 54.0698834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011600',
        LOCATION_NAME: 'Dooleeg More',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4992623,
        LOCATION_LATITUDE_DEG: 54.1165776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011700',
        LOCATION_NAME: 'Doolin',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659805,
        LOCATION_LATITUDE_DEG: 52.9997795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011750',
        LOCATION_NAME: 'Doolough',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1853767,
        LOCATION_LATITUDE_DEG: 53.1354798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012100',
        LOCATION_NAME: 'Doon',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7166018,
        LOCATION_LATITUDE_DEG: 52.2977983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011900',
        LOCATION_NAME: 'Doon',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6659984,
        LOCATION_LATITUDE_DEG: 52.5164292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO011800',
        LOCATION_NAME: 'Doon',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491586,
        LOCATION_LATITUDE_DEG: 52.599732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012000',
        LOCATION_NAME: 'Doon',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8180117,
        LOCATION_LATITUDE_DEG: 53.3300733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012200',
        LOCATION_NAME: 'Doonaha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6488459,
        LOCATION_LATITUDE_DEG: 52.6194369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012400',
        LOCATION_NAME: 'Doonane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324725,
        LOCATION_LATITUDE_DEG: 52.7330448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012300',
        LOCATION_NAME: 'Doonane',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323499,
        LOCATION_LATITUDE_DEG: 52.8497403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012500',
        LOCATION_NAME: 'Doonbeg',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5224898,
        LOCATION_LATITUDE_DEG: 52.7304506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012550',
        LOCATION_NAME: 'Doonbeg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.819693,
        LOCATION_LATITUDE_DEG: 53.4486377,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO990839',
        LOCATION_NAME: 'Dooneen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012700',
        LOCATION_NAME: 'Doonloughan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.132633,
        LOCATION_LATITUDE_DEG: 53.4415273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012750',
        LOCATION_NAME: 'Doora',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.929132,
        LOCATION_LATITUDE_DEG: 52.8357117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012800',
        LOCATION_NAME: 'Dooradoyle',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6788826,
        LOCATION_LATITUDE_DEG: 52.6440736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012900',
        LOCATION_NAME: 'Dooroge',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.248947,
        LOCATION_LATITUDE_DEG: 53.4997937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO012950',
        LOCATION_NAME: 'Doorty',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1806514,
        LOCATION_LATITUDE_DEG: 53.7144891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO013000',
        LOCATION_NAME: 'Dooyork',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9242966,
        LOCATION_LATITUDE_DEG: 54.1067845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016300',
        LOCATION_NAME: 'Doughiska',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9731156,
        LOCATION_LATITUDE_DEG: 53.278413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO016700',
        LOCATION_NAME: 'Douglas',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324991,
        LOCATION_LATITUDE_DEG: 51.8663592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO018300',
        LOCATION_NAME: 'Dovea',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8491433,
        LOCATION_LATITUDE_DEG: 52.716434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO021600',
        LOCATION_NAME: 'Downings',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8513083,
        LOCATION_LATITUDE_DEG: 55.1969258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO022300',
        LOCATION_NAME: 'Downs, The',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2326155,
        LOCATION_LATITUDE_DEG: 53.5062097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023200',
        LOCATION_NAME: 'Dowra',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0056804,
        LOCATION_LATITUDE_DEG: 54.1894805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DO023400',
        LOCATION_NAME: 'Dowth',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4542062,
        LOCATION_LATITUDE_DEG: 53.7055089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR001100',
        LOCATION_NAME: 'Drangan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5824135,
        LOCATION_LATITUDE_DEG: 52.5164149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR004300',
        LOCATION_NAME: 'Dreenagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9160301,
        LOCATION_LATITUDE_DEG: 52.4164285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR005800',
        LOCATION_NAME: 'Drimmeen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.082641,
        LOCATION_LATITUDE_DEG: 53.4831257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023500',
        LOCATION_NAME: 'Drimnagh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3187737,
        LOCATION_LATITUDE_DEG: 53.334306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006000',
        LOCATION_NAME: 'Drimoleague',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.267586,
        LOCATION_LATITUDE_DEG: 51.6620515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006200',
        LOCATION_NAME: 'Drin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4992799,
        LOCATION_LATITUDE_DEG: 53.549833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006300',
        LOCATION_NAME: 'Drinagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492704,
        LOCATION_LATITUDE_DEG: 51.6496401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006400',
        LOCATION_NAME: 'Drinagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824238,
        LOCATION_LATITUDE_DEG: 53.7331412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006500',
        LOCATION_NAME: 'Drinagh',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6824126,
        LOCATION_LATITUDE_DEG: 53.1497738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006550',
        LOCATION_NAME: 'Drinagh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3639474,
        LOCATION_LATITUDE_DEG: 53.1121106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR006700',
        LOCATION_NAME: 'Dring',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5490836,
        LOCATION_LATITUDE_DEG: 53.8165119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007500',
        LOCATION_NAME: 'Dripsey',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.74922,
        LOCATION_LATITUDE_DEG: 51.9163692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007550',
        LOCATION_NAME: 'Dripsey Model Village',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7108421,
        LOCATION_LATITUDE_DEG: 51.9150158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007600',
        LOCATION_NAME: 'Drishaghaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5159722,
        LOCATION_LATITUDE_DEG: 53.5498337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007700',
        LOCATION_NAME: 'Drishane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659781,
        LOCATION_LATITUDE_DEG: 51.5163299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007800',
        LOCATION_NAME: 'Drisoge',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.744681,
        LOCATION_LATITUDE_DEG: 52.7477927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990991',
        LOCATION_NAME: 'Drogheda',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR007900',
        LOCATION_NAME: 'Drogheda',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3624489,
        LOCATION_LATITUDE_DEG: 53.71662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023100',
        LOCATION_NAME: 'Droichead Nuadh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7960676,
        LOCATION_LATITUDE_DEG: 53.1825846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008200',
        LOCATION_NAME: 'Drom',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9826433,
        LOCATION_LATITUDE_DEG: 52.0329899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008300',
        LOCATION_NAME: 'Drom',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991351,
        LOCATION_LATITUDE_DEG: 52.7664479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008400',
        LOCATION_NAME: 'Dromagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825469,
        LOCATION_LATITUDE_DEG: 52.1163842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008600',
        LOCATION_NAME: 'Dromahair',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3047964,
        LOCATION_LATITUDE_DEG: 54.2307926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008500',
        LOCATION_NAME: 'Dromahair',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991258,
        LOCATION_LATITUDE_DEG: 54.2332157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990903',
        LOCATION_NAME: 'Dromahair',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008650',
        LOCATION_NAME: 'Dromahane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6864343,
        LOCATION_LATITUDE_DEG: 52.1040487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008800',
        LOCATION_NAME: 'Dromard',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6893752,
        LOCATION_LATITUDE_DEG: 54.2347153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR008900',
        LOCATION_NAME: 'Drombane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3977187,
        LOCATION_LATITUDE_DEG: 52.5872656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009000',
        LOCATION_NAME: 'Drombanna',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5789676,
        LOCATION_LATITUDE_DEG: 52.6196418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009100',
        LOCATION_NAME: 'Dromcolliher',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159336,
        LOCATION_LATITUDE_DEG: 52.3330071,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009200',
        LOCATION_NAME: 'Dromdowney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7244984,
        LOCATION_LATITUDE_DEG: 52.1741371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009450',
        LOCATION_NAME: 'Dromin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4848303,
        LOCATION_LATITUDE_DEG: 52.4653117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009300',
        LOCATION_NAME: 'Dromin',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5825036,
        LOCATION_LATITUDE_DEG: 52.4497165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009400',
        LOCATION_NAME: 'Dromin',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4322632,
        LOCATION_LATITUDE_DEG: 53.8331397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009500',
        LOCATION_NAME: 'Dromina',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992293,
        LOCATION_LATITUDE_DEG: 52.2997027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009600',
        LOCATION_NAME: 'Dromineer',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658609,
        LOCATION_LATITUDE_DEG: 52.9164563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990208',
        LOCATION_NAME: 'Dromiskin',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009700',
        LOCATION_NAME: 'Dromiskin',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3989527,
        LOCATION_LATITUDE_DEG: 53.9165376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR009900',
        LOCATION_NAME: 'Dromline',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0790882,
        LOCATION_LATITUDE_DEG: 52.4661518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010000',
        LOCATION_NAME: 'Drommartin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993078,
        LOCATION_LATITUDE_DEG: 52.433026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010050',
        LOCATION_NAME: 'Drommurrin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.571959,
        LOCATION_LATITUDE_DEG: 52.4461001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010088',
        LOCATION_NAME: 'Dromod',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010125',
        LOCATION_NAME: 'Dromoland',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9072457,
        LOCATION_LATITUDE_DEG: 52.775007,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010400',
        LOCATION_NAME: 'Dromore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6824874,
        LOCATION_LATITUDE_DEG: 52.1112717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR010600',
        LOCATION_NAME: 'Dromore West',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.879925,
        LOCATION_LATITUDE_DEG: 54.2533985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990621',
        LOCATION_NAME: 'Dromtrasna',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012175',
        LOCATION_NAME: 'Drum',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9221606,
        LOCATION_LATITUDE_DEG: 53.6280114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012150',
        LOCATION_NAME: 'Drum',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0435679,
        LOCATION_LATITUDE_DEG: 53.3957624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012000',
        LOCATION_NAME: 'Drum',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1421773,
        LOCATION_LATITUDE_DEG: 54.1069624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012300',
        LOCATION_NAME: 'Drumahaire',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991369,
        LOCATION_LATITUDE_DEG: 54.2331881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012500',
        LOCATION_NAME: 'Drumalee',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.35288,
        LOCATION_LATITUDE_DEG: 53.9988117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012700',
        LOCATION_NAME: 'Drumalure',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157713,
        LOCATION_LATITUDE_DEG: 54.0665647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR012800',
        LOCATION_NAME: 'Drumandoora',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325065,
        LOCATION_LATITUDE_DEG: 52.9997728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013100',
        LOCATION_NAME: 'Drumbane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491335,
        LOCATION_LATITUDE_DEG: 52.6497311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013300',
        LOCATION_NAME: 'Drumbilla',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822636,
        LOCATION_LATITUDE_DEG: 54.066557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013600',
        LOCATION_NAME: 'Drumbo',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3368587,
        LOCATION_LATITUDE_DEG: 54.0176628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013700',
        LOCATION_NAME: 'Drumboe',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7823816,
        LOCATION_LATITUDE_DEG: 54.8166427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR013800',
        LOCATION_NAME: 'Drumbologe',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8657961,
        LOCATION_LATITUDE_DEG: 54.9499562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014200',
        LOCATION_NAME: 'Drumcar',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3822647,
        LOCATION_LATITUDE_DEG: 53.8498338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014300',
        LOCATION_NAME: 'Drumcarban',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323704,
        LOCATION_LATITUDE_DEG: 53.9331532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR014700',
        LOCATION_NAME: 'Drumcliff',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5011988,
        LOCATION_LATITUDE_DEG: 54.3335944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015000',
        LOCATION_NAME: 'Drumcoggy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3471963,
        LOCATION_LATITUDE_DEG: 53.6695442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015100',
        LOCATION_NAME: 'Drumcollop',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824017,
        LOCATION_LATITUDE_DEG: 53.9998582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015200',
        LOCATION_NAME: 'Drumcondra',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490033,
        LOCATION_LATITUDE_DEG: 53.8331348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR023400',
        LOCATION_NAME: 'Drumcondra',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2685537,
        LOCATION_LATITUDE_DEG: 53.368685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015300',
        LOCATION_NAME: 'Drumcondrath',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.648987,
        LOCATION_LATITUDE_DEG: 53.8498447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990489',
        LOCATION_NAME: 'Drumcong',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015400',
        LOCATION_NAME: 'Drumcre',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657438,
        LOCATION_LATITUDE_DEG: 53.6331214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015500',
        LOCATION_NAME: 'Drumcree',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657019,
        LOCATION_LATITUDE_DEG: 53.6331502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015600',
        LOCATION_NAME: 'Drumderg',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6490941,
        LOCATION_LATITUDE_DEG: 53.8165371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015650',
        LOCATION_NAME: 'Drumderry',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6574314,
        LOCATION_LATITUDE_DEG: 52.6720527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015800',
        LOCATION_NAME: 'Drumelis',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3839353,
        LOCATION_LATITUDE_DEG: 54.0046846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR015900',
        LOCATION_NAME: 'Drumellihy',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4492814,
        LOCATION_LATITUDE_DEG: 52.7164446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016100',
        LOCATION_NAME: 'Drumfin',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324516,
        LOCATION_LATITUDE_DEG: 54.1331803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016200',
        LOCATION_NAME: 'Drumfree',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823345,
        LOCATION_LATITUDE_DEG: 55.1832758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016600',
        LOCATION_NAME: 'Drumgriffin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825202,
        LOCATION_LATITUDE_DEG: 53.3831133,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016800',
        LOCATION_NAME: 'Drumhallagh Lower',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5657528,
        LOCATION_LATITUDE_DEG: 55.1332676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR016900',
        LOCATION_NAME: 'Drumhillagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657235,
        LOCATION_LATITUDE_DEG: 53.9831559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017000',
        LOCATION_NAME: 'Druming',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6990995,
        LOCATION_LATITUDE_DEG: 53.6498314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990642',
        LOCATION_NAME: 'Drumiskabole',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017100',
        LOCATION_NAME: 'Drumkeen',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7654245,
        LOCATION_LATITUDE_DEG: 54.8654284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017200',
        LOCATION_NAME: 'Drumkeeran',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491163,
        LOCATION_LATITUDE_DEG: 54.1665756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017300',
        LOCATION_NAME: 'Drumlave',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993207,
        LOCATION_LATITUDE_DEG: 51.6829546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017550',
        LOCATION_NAME: 'Drumline',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8513906,
        LOCATION_LATITUDE_DEG: 52.7348695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017600',
        LOCATION_NAME: 'Drumlion',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4014236,
        LOCATION_LATITUDE_DEG: 53.9863905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017700',
        LOCATION_NAME: 'Drumlish',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7658126,
        LOCATION_LATITUDE_DEG: 53.816547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR017900',
        LOCATION_NAME: 'Drumman',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157412,
        LOCATION_LATITUDE_DEG: 53.5331043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018000',
        LOCATION_NAME: 'Drummin',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6043011,
        LOCATION_LATITUDE_DEG: 53.6957731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018400',
        LOCATION_NAME: 'Drumnafinnila',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.999128,
        LOCATION_LATITUDE_DEG: 54.1498751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018600',
        LOCATION_NAME: 'Drumnee',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824208,
        LOCATION_LATITUDE_DEG: 53.5665214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018800',
        LOCATION_NAME: 'Drumod',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9176579,
        LOCATION_LATITUDE_DEG: 53.8589705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR018900',
        LOCATION_NAME: 'Drumone',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490383,
        LOCATION_LATITUDE_DEG: 53.7165268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019500',
        LOCATION_NAME: 'Drumraney',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7430076,
        LOCATION_LATITUDE_DEG: 53.4815624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019600',
        LOCATION_NAME: 'Drumree',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5819503,
        LOCATION_LATITUDE_DEG: 53.5093875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990864',
        LOCATION_NAME: 'Drumrusk',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019700',
        LOCATION_NAME: 'Drumscor',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823155,
        LOCATION_LATITUDE_DEG: 54.2998899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR019800',
        LOCATION_NAME: 'Drumshambo',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0521723,
        LOCATION_LATITUDE_DEG: 54.0476677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR990493',
        LOCATION_NAME: 'Drumshanbo',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020100',
        LOCATION_NAME: 'Drumsna',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0093607,
        LOCATION_LATITUDE_DEG: 53.9294553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020800',
        LOCATION_NAME: 'Drung',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2510857,
        LOCATION_LATITUDE_DEG: 54.0366609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR020900',
        LOCATION_NAME: 'Drunganagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.149228,
        LOCATION_LATITUDE_DEG: 53.8498585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DR021400',
        LOCATION_NAME: 'Dry Mills',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.882509,
        LOCATION_LATITUDE_DEG: 53.666533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000100',
        LOCATION_NAME: 'Duagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825825,
        LOCATION_LATITUDE_DEG: 52.4164122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000200',
        LOCATION_NAME: 'Dualla',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8169907,
        LOCATION_LATITUDE_DEG: 52.5353216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000300',
        LOCATION_NAME: 'Dublin 1',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2476229,
        LOCATION_LATITUDE_DEG: 53.3532208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001200',
        LOCATION_NAME: 'Dublin 10',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3585068,
        LOCATION_LATITUDE_DEG: 53.3448159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001300',
        LOCATION_NAME: 'Dublin 11',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2904946,
        LOCATION_LATITUDE_DEG: 53.3790802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001400',
        LOCATION_NAME: 'Dublin 12',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3296715,
        LOCATION_LATITUDE_DEG: 53.3224571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001500',
        LOCATION_NAME: 'Dublin 13',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1048306,
        LOCATION_LATITUDE_DEG: 53.3897309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001600',
        LOCATION_NAME: 'Dublin 14',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2471852,
        LOCATION_LATITUDE_DEG: 53.2924808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001700',
        LOCATION_NAME: 'Dublin 15',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3648039,
        LOCATION_LATITUDE_DEG: 53.3721168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001800',
        LOCATION_NAME: 'Dublin 16',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2636988,
        LOCATION_LATITUDE_DEG: 53.2679048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001900',
        LOCATION_NAME: 'Dublin 17',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2053944,
        LOCATION_LATITUDE_DEG: 53.4085098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002000',
        LOCATION_NAME: 'Dublin 18',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1745115,
        LOCATION_LATITUDE_DEG: 53.2714259,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000400',
        LOCATION_NAME: 'Dublin 2',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2640268,
        LOCATION_LATITUDE_DEG: 53.3374121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002100',
        LOCATION_NAME: 'Dublin 20',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3715473,
        LOCATION_LATITUDE_DEG: 53.3579238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002200',
        LOCATION_NAME: 'Dublin 22',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3925569,
        LOCATION_LATITUDE_DEG: 53.3193713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002300',
        LOCATION_NAME: 'Dublin 24',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3353401,
        LOCATION_LATITUDE_DEG: 53.2890424,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000500',
        LOCATION_NAME: 'Dublin 3',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2356819,
        LOCATION_LATITUDE_DEG: 53.3619859,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000600',
        LOCATION_NAME: 'Dublin 4',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2311247,
        LOCATION_LATITUDE_DEG: 53.3278792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000700',
        LOCATION_NAME: 'Dublin 5',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1897728,
        LOCATION_LATITUDE_DEG: 53.3857857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000800',
        LOCATION_NAME: 'Dublin 6',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2847361,
        LOCATION_LATITUDE_DEG: 53.3080227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU991120',
        LOCATION_NAME: 'Dublin 6W',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2836,
        LOCATION_LATITUDE_DEG: 53.3097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU000900',
        LOCATION_NAME: 'Dublin 7',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1890759,
        LOCATION_LATITUDE_DEG: 53.3855853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001000',
        LOCATION_NAME: 'Dublin 8',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2949582,
        LOCATION_LATITUDE_DEG: 53.344542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU001100',
        LOCATION_NAME: 'Dublin 9',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2514031,
        LOCATION_LATITUDE_DEG: 53.3746963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002400',
        LOCATION_NAME: 'Dublin Airport',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.243762,
        LOCATION_LATITUDE_DEG: 53.4280225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU002600',
        LOCATION_NAME: 'Ducalla',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.337273,
        LOCATION_LATITUDE_DEG: 51.7891582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU005500',
        LOCATION_NAME: 'Dugort',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9046354,
        LOCATION_LATITUDE_DEG: 52.572981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006400',
        LOCATION_NAME: 'Duleek',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4211538,
        LOCATION_LATITUDE_DEG: 53.6528423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU006500',
        LOCATION_NAME: 'Duleek',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156725,
        LOCATION_LATITUDE_DEG: 53.649815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008100',
        LOCATION_NAME: 'Dun Laoghaire',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1420145,
        LOCATION_LATITUDE_DEG: 53.2885748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008400',
        LOCATION_NAME: 'Dunaff',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4990517,
        LOCATION_LATITUDE_DEG: 55.2666814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU008900',
        LOCATION_NAME: 'Dunbeacon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.566014,
        LOCATION_LATITUDE_DEG: 51.5829359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009400',
        LOCATION_NAME: 'Dunboyne',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4759207,
        LOCATION_LATITUDE_DEG: 53.4187584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009650',
        LOCATION_NAME: 'Dunbur',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0163992,
        LOCATION_LATITUDE_DEG: 52.9607286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU009700',
        LOCATION_NAME: 'Duncannon',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9292161,
        LOCATION_LATITUDE_DEG: 52.2215827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010200',
        LOCATION_NAME: 'Duncormick',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490246,
        LOCATION_LATITUDE_DEG: 52.2329772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010700',
        LOCATION_NAME: 'Dundalk',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4117554,
        LOCATION_LATITUDE_DEG: 54.0134505,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU010900',
        LOCATION_NAME: 'Dunderrow',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5825046,
        LOCATION_LATITUDE_DEG: 51.7163417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011000',
        LOCATION_NAME: 'Dunderry',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657018,
        LOCATION_LATITUDE_DEG: 53.5998132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011400',
        LOCATION_NAME: 'Dundonnell',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.165837,
        LOCATION_LATITUDE_DEG: 53.3831031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012000',
        LOCATION_NAME: 'Dundrum',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491366,
        LOCATION_LATITUDE_DEG: 52.5497199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU011900',
        LOCATION_NAME: 'Dundrum',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0442218,
        LOCATION_LATITUDE_DEG: 52.5621724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU029900',
        LOCATION_NAME: 'Dundrum',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2468367,
        LOCATION_LATITUDE_DEG: 53.290334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU012400',
        LOCATION_NAME: 'Dunfanaghy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9742002,
        LOCATION_LATITUDE_DEG: 55.1843838,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013100',
        LOCATION_NAME: 'Dunganstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823612,
        LOCATION_LATITUDE_DEG: 52.3329965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013300',
        LOCATION_NAME: 'Dungarvan',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6286454,
        LOCATION_LATITUDE_DEG: 52.0921814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013200',
        LOCATION_NAME: 'Dungarvan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823662,
        LOCATION_LATITUDE_DEG: 52.5830176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013500',
        LOCATION_NAME: 'Dungeagan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.256776,
        LOCATION_LATITUDE_DEG: 51.8348667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013800',
        LOCATION_NAME: 'Dungloe',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3626717,
        LOCATION_LATITUDE_DEG: 54.9556563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU990809',
        LOCATION_NAME: 'Dungooley',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU013900',
        LOCATION_NAME: 'Dungourney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0975061,
        LOCATION_LATITUDE_DEG: 51.9688786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014800',
        LOCATION_NAME: 'Dunheeda',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490048,
        LOCATION_LATITUDE_DEG: 53.8831456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU014900',
        LOCATION_NAME: 'Dunhill',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490993,
        LOCATION_LATITUDE_DEG: 52.1663851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015400',
        LOCATION_NAME: 'Duniry',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991768,
        LOCATION_LATITUDE_DEG: 53.133081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU015600',
        LOCATION_NAME: 'Dunkerrin',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8977612,
        LOCATION_LATITUDE_DEG: 52.9215647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016000',
        LOCATION_NAME: 'Dunkineely',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3724254,
        LOCATION_LATITUDE_DEG: 54.634428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016500',
        LOCATION_NAME: 'Dunkitt',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323789,
        LOCATION_LATITUDE_DEG: 52.2829872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU990816',
        LOCATION_NAME: 'Dunlavin',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016700',
        LOCATION_NAME: 'Dunlavin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990057,
        LOCATION_LATITUDE_DEG: 53.0497645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016800',
        LOCATION_NAME: 'Dunleary',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1327476,
        LOCATION_LATITUDE_DEG: 53.2942857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU016900',
        LOCATION_NAME: 'Dunleer',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.393932,
        LOCATION_LATITUDE_DEG: 53.8151368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017000',
        LOCATION_NAME: 'Dunlewy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991142,
        LOCATION_LATITUDE_DEG: 55.016659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017600',
        LOCATION_NAME: 'Dunmain',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8834676,
        LOCATION_LATITUDE_DEG: 52.3134846,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017700',
        LOCATION_NAME: 'Dunmanus',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6660171,
        LOCATION_LATITUDE_DEG: 51.5329394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU017800',
        LOCATION_NAME: 'Dunmanway',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1155053,
        LOCATION_LATITUDE_DEG: 51.7255531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU990741',
        LOCATION_NAME: 'Dunmoe',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018300',
        LOCATION_NAME: 'Dunmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7658554,
        LOCATION_LATITUDE_DEG: 53.5998318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018000',
        LOCATION_NAME: 'Dunmore',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2607632,
        LOCATION_LATITUDE_DEG: 52.6799665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018400',
        LOCATION_NAME: 'Dunmore East',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.000811,
        LOCATION_LATITUDE_DEG: 52.1509734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU018800',
        LOCATION_NAME: 'Dunnamaggan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.282375,
        LOCATION_LATITUDE_DEG: 52.4997136,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020100',
        LOCATION_NAME: 'Dunowen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159509,
        LOCATION_LATITUDE_DEG: 51.5496369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020300',
        LOCATION_NAME: 'Dunquin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.466086,
        LOCATION_LATITUDE_DEG: 52.1329966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU020900',
        LOCATION_NAME: 'Dunsany',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6262929,
        LOCATION_LATITUDE_DEG: 53.5368568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU021900',
        LOCATION_NAME: 'Dunshaughlin',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5482388,
        LOCATION_LATITUDE_DEG: 53.5189014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU022000',
        LOCATION_NAME: 'Dunsink',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322657,
        LOCATION_LATITUDE_DEG: 53.3830931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028000',
        LOCATION_NAME: 'Durrow',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5006637,
        LOCATION_LATITUDE_DEG: 53.3414006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU027900',
        LOCATION_NAME: 'Durrow',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3955907,
        LOCATION_LATITUDE_DEG: 52.8495493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028100',
        LOCATION_NAME: 'Durrow Cross Roads',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4991042,
        LOCATION_LATITUDE_DEG: 52.13298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DU028200',
        LOCATION_NAME: 'Durrus',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5268836,
        LOCATION_LATITUDE_DEG: 51.6247426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001800',
        LOCATION_NAME: 'Dysart',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1809266,
        LOCATION_LATITUDE_DEG: 52.8747667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001600',
        LOCATION_NAME: 'Dysart',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2250368,
        LOCATION_LATITUDE_DEG: 53.4636584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001700',
        LOCATION_NAME: 'Dysart',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4490805,
        LOCATION_LATITUDE_DEG: 53.4665089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'DY001850',
        LOCATION_NAME: 'Dysart',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2223027,
        LOCATION_LATITUDE_DEG: 53.024901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA006900',
        LOCATION_NAME: 'Easky',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9621487,
        LOCATION_LATITUDE_DEG: 54.2891986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA043200',
        LOCATION_NAME: 'East Wall',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2329076,
        LOCATION_LATITUDE_DEG: 53.3546442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EA990503',
        LOCATION_NAME: 'Eastwall',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2329076,
        LOCATION_LATITUDE_DEG: 53.3546442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED000900',
        LOCATION_NAME: 'Edenacarnan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.765783,
        LOCATION_LATITUDE_DEG: 54.9999595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001100',
        LOCATION_NAME: 'Edenderry',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0524889,
        LOCATION_LATITUDE_DEG: 53.3540889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED001500',
        LOCATION_NAME: 'Edenmore',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1800742,
        LOCATION_LATITUDE_DEG: 53.3870889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED002150',
        LOCATION_NAME: 'Edermine',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5559529,
        LOCATION_LATITUDE_DEG: 52.4528645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ED004000',
        LOCATION_NAME: 'Edgeworthstown',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6044571,
        LOCATION_LATITUDE_DEG: 53.6952637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EG001850',
        LOCATION_NAME: 'Eglish',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0981867,
        LOCATION_LATITUDE_DEG: 53.0567048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EI000200',
        LOCATION_NAME: 'Eighter',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323498,
        LOCATION_LATITUDE_DEG: 53.8165414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL002700',
        LOCATION_NAME: 'Ellaghmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325088,
        LOCATION_LATITUDE_DEG: 54.0831814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL003300',
        LOCATION_NAME: 'Ellendale',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822799,
        LOCATION_LATITUDE_DEG: 52.5497095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL013600',
        LOCATION_NAME: 'Elm Mount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2283891,
        LOCATION_LATITUDE_DEG: 53.3838371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL008700',
        LOCATION_NAME: 'Elphin',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991297,
        LOCATION_LATITUDE_DEG: 53.8498494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EL012000',
        LOCATION_NAME: 'Elton',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658863,
        LOCATION_LATITUDE_DEG: 52.4164065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001100',
        LOCATION_NAME: 'Emlagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8826144,
        LOCATION_LATITUDE_DEG: 53.7498456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001200',
        LOCATION_NAME: 'Emlaghyroyin',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491471,
        LOCATION_LATITUDE_DEG: 53.6331288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM001500',
        LOCATION_NAME: 'Emly',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3452432,
        LOCATION_LATITUDE_DEG: 52.4699232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002100',
        LOCATION_NAME: 'Emo',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2007881,
        LOCATION_LATITUDE_DEG: 53.097247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EM002600',
        LOCATION_NAME: 'Emyvale',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9617873,
        LOCATION_LATITUDE_DEG: 54.3531914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN001100',
        LOCATION_NAME: 'Enfield',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.831651,
        LOCATION_LATITUDE_DEG: 53.4202992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002250',
        LOCATION_NAME: 'Enneybegs',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7508597,
        LOCATION_LATITUDE_DEG: 53.8428081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002300',
        LOCATION_NAME: 'Ennis',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9852875,
        LOCATION_LATITUDE_DEG: 52.8528635,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002500',
        LOCATION_NAME: 'Enniscorthy',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5673686,
        LOCATION_LATITUDE_DEG: 52.5013027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002550',
        LOCATION_NAME: 'Enniscrone',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002600',
        LOCATION_NAME: 'Enniskean',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9371523,
        LOCATION_LATITUDE_DEG: 51.7425483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN990590',
        LOCATION_NAME: 'Enniskeane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002700',
        LOCATION_NAME: 'Enniskerry',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1669088,
        LOCATION_LATITUDE_DEG: 53.1919462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002850',
        LOCATION_NAME: 'Ennismore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5848373,
        LOCATION_LATITUDE_DEG: 52.4385204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EN002900',
        LOCATION_NAME: 'Ennistymon',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2959839,
        LOCATION_LATITUDE_DEG: 52.9444772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EO000100',
        LOCATION_NAME: 'Eochaill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8491385,
        LOCATION_LATITUDE_DEG: 51.9496592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001300',
        LOCATION_NAME: 'Erra',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658351,
        LOCATION_LATITUDE_DEG: 53.7165306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ER001400',
        LOCATION_NAME: 'Errill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6824215,
        LOCATION_LATITUDE_DEG: 52.8497472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001500',
        LOCATION_NAME: 'Esker',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.683919,
        LOCATION_LATITUDE_DEG: 53.2775747,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001650',
        LOCATION_NAME: 'Esker',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.103652,
        LOCATION_LATITUDE_DEG: 53.4003126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001600',
        LOCATION_NAME: 'Esker',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490455,
        LOCATION_LATITUDE_DEG: 53.28308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001700',
        LOCATION_NAME: 'Esker South',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158088,
        LOCATION_LATITUDE_DEG: 53.7831355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES001800',
        LOCATION_NAME: 'Eskerboy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158536,
        LOCATION_LATITUDE_DEG: 53.2164897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES990601',
        LOCATION_NAME: 'Eslinbridge',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ES002900',
        LOCATION_NAME: 'Essexford',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6322821,
        LOCATION_LATITUDE_DEG: 53.9665556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY000900',
        LOCATION_NAME: 'Eyeries',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493338,
        LOCATION_LATITUDE_DEG: 51.6829518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001150',
        LOCATION_NAME: 'Eyne',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2776858,
        LOCATION_LATITUDE_DEG: 53.083538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY001900',
        LOCATION_NAME: 'Eyrecourt',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324398,
        LOCATION_LATITUDE_DEG: 53.1997942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'EY002000',
        LOCATION_NAME: 'Eyries',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9595082,
        LOCATION_LATITUDE_DEG: 51.6896668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001100',
        LOCATION_NAME: 'Faha',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6325993,
        LOCATION_LATITUDE_DEG: 52.0996896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001200',
        LOCATION_NAME: 'Fahamore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032654,
        LOCATION_LATITUDE_DEG: 52.2997121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001300',
        LOCATION_NAME: 'Fahan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.417391,
        LOCATION_LATITUDE_DEG: 52.1029953,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA001400',
        LOCATION_NAME: 'Fahan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4623775,
        LOCATION_LATITUDE_DEG: 55.0854633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990728',
        LOCATION_NAME: 'Fairhill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA019000',
        LOCATION_NAME: 'Fairview',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2402267,
        LOCATION_LATITUDE_DEG: 53.3674562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004800',
        LOCATION_NAME: 'Fairyhouse',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4361167,
        LOCATION_LATITUDE_DEG: 53.500638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA004900',
        LOCATION_NAME: 'Fairymount',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158223,
        LOCATION_LATITUDE_DEG: 53.6831335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA900453',
        LOCATION_NAME: 'Faithlegg',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0202679,
        LOCATION_LATITUDE_DEG: 52.2715196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA005400',
        LOCATION_NAME: 'Falcarragh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1077384,
        LOCATION_LATITUDE_DEG: 55.1369798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA006400',
        LOCATION_NAME: 'Fallmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.098523,
        LOCATION_LATITUDE_DEG: 54.0984826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990607',
        LOCATION_NAME: 'Fanad',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007300',
        LOCATION_NAME: 'Fanore',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2895309,
        LOCATION_LATITUDE_DEG: 53.1178426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA007400',
        LOCATION_NAME: 'Fanore Bridge',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659654,
        LOCATION_LATITUDE_DEG: 53.1164796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008000',
        LOCATION_NAME: 'Farahy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491975,
        LOCATION_LATITUDE_DEG: 52.2329998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA008300',
        LOCATION_NAME: 'Fardrum',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8637953,
        LOCATION_LATITUDE_DEG: 53.4008864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990737',
        LOCATION_NAME: 'Farganstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA018200',
        LOCATION_NAME: 'Farmers Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011100',
        LOCATION_NAME: "Farmer's Bridge",
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6562505,
        LOCATION_LATITUDE_DEG: 52.2413701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011250',
        LOCATION_NAME: 'Farmhill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7397219,
        LOCATION_LATITUDE_DEG: 53.4275066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011200',
        LOCATION_NAME: 'Farmhill',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657385,
        LOCATION_LATITUDE_DEG: 52.9664492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011500',
        LOCATION_NAME: 'Farnaght',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8158173,
        LOCATION_LATITUDE_DEG: 53.8665499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011600',
        LOCATION_NAME: 'Farnanes',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992265,
        LOCATION_LATITUDE_DEG: 51.9829686,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA011650',
        LOCATION_NAME: 'Farnans',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0810667,
        LOCATION_LATITUDE_DEG: 52.8962679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA012700',
        LOCATION_NAME: 'Farney Castle',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991457,
        LOCATION_LATITUDE_DEG: 52.6664282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA013200',
        LOCATION_NAME: 'Farnham',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4008925,
        LOCATION_LATITUDE_DEG: 54.0081882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990904',
        LOCATION_NAME: 'Farnivane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014350',
        LOCATION_NAME: 'Farran',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8310094,
        LOCATION_LATITUDE_DEG: 51.8489199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014400',
        LOCATION_NAME: 'Farranfore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5542231,
        LOCATION_LATITUDE_DEG: 52.176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA014500',
        LOCATION_NAME: 'Farrangalway',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5325092,
        LOCATION_LATITUDE_DEG: 51.7329499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA990722',
        LOCATION_NAME: 'Farranree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015000',
        LOCATION_NAME: 'Farsid',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1904576,
        LOCATION_LATITUDE_DEG: 51.8437818,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA015150',
        LOCATION_NAME: 'Fartamore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.910873,
        LOCATION_LATITUDE_DEG: 53.5834332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA016200',
        LOCATION_NAME: 'Faughalstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323665,
        LOCATION_LATITUDE_DEG: 53.6331216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017600',
        LOCATION_NAME: 'Fawnaboy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324231,
        LOCATION_LATITUDE_DEG: 55.0832725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FA017700',
        LOCATION_NAME: 'Fawnagown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1386974,
        LOCATION_LATITUDE_DEG: 52.4582535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000100',
        LOCATION_NAME: 'Feagarrid',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824425,
        LOCATION_LATITUDE_DEG: 52.1829857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000150',
        LOCATION_NAME: 'Feagh East',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7377539,
        LOCATION_LATITUDE_DEG: 53.4605867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000175',
        LOCATION_NAME: 'Feagh West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7504206,
        LOCATION_LATITUDE_DEG: 53.4554907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000200',
        LOCATION_NAME: 'Feakle',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491996,
        LOCATION_LATITUDE_DEG: 52.9164642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE000300',
        LOCATION_NAME: 'Fearagha',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992129,
        LOCATION_LATITUDE_DEG: 53.4665208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001200',
        LOCATION_NAME: 'Fedamore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991934,
        LOCATION_LATITUDE_DEG: 52.5497283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001300',
        LOCATION_NAME: 'Feenagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825183,
        LOCATION_LATITUDE_DEG: 52.3830068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001600',
        LOCATION_NAME: 'Feevagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324511,
        LOCATION_LATITUDE_DEG: 53.4331032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE001650',
        LOCATION_NAME: 'Feighcullen',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9117669,
        LOCATION_LATITUDE_DEG: 53.234006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE005100',
        LOCATION_NAME: 'Fenagh',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8390292,
        LOCATION_LATITUDE_DEG: 54.0223636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006000',
        LOCATION_NAME: 'Fenit',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8660397,
        LOCATION_LATITUDE_DEG: 52.283012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006150',
        LOCATION_NAME: 'Fenloe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8236382,
        LOCATION_LATITUDE_DEG: 52.7683378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006400',
        LOCATION_NAME: 'Fennagh',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490355,
        LOCATION_LATITUDE_DEG: 52.7164301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006450',
        LOCATION_NAME: 'Fennells Bay',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.291487,
        LOCATION_LATITUDE_DEG: 51.786352,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE006600',
        LOCATION_NAME: 'Fennor',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157872,
        LOCATION_LATITUDE_DEG: 52.1496761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008600',
        LOCATION_NAME: 'Feohanagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659309,
        LOCATION_LATITUDE_DEG: 52.3830153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008750',
        LOCATION_NAME: 'Feraghfad',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7606399,
        LOCATION_LATITUDE_DEG: 53.7001464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008800',
        LOCATION_NAME: 'Ferbane',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8309462,
        LOCATION_LATITUDE_DEG: 53.2727918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE008850',
        LOCATION_NAME: 'Fergus',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7608106,
        LOCATION_LATITUDE_DEG: 51.9011906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE009000',
        LOCATION_NAME: 'Fermoy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2806812,
        LOCATION_LATITUDE_DEG: 52.1412853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE010600',
        LOCATION_NAME: 'Ferns',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5126734,
        LOCATION_LATITUDE_DEG: 52.5897161,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011000',
        LOCATION_NAME: 'Ferry Bridge',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7659051,
        LOCATION_LATITUDE_DEG: 52.6164332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011400',
        LOCATION_NAME: 'Ferrybank',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157806,
        LOCATION_LATITUDE_DEG: 52.2496789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011300',
        LOCATION_NAME: 'Ferrybank',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1418192,
        LOCATION_LATITUDE_DEG: 52.8080333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE011100',
        LOCATION_NAME: 'Ferrycarrig',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989993,
        LOCATION_LATITUDE_DEG: 52.3496886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012300',
        LOCATION_NAME: 'Fethard',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7019271,
        LOCATION_LATITUDE_DEG: 52.4732121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE012400',
        LOCATION_NAME: 'Fethard',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490519,
        LOCATION_LATITUDE_DEG: 52.1829737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FE013000',
        LOCATION_NAME: 'Fews',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4491086,
        LOCATION_LATITUDE_DEG: 52.2163852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000051',
        LOCATION_NAME: 'Fiddaun',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0322957,
        LOCATION_LATITUDE_DEG: 52.5110824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI000500',
        LOCATION_NAME: 'Fiddown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2990939,
        LOCATION_LATITUDE_DEG: 52.3329944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI001200',
        LOCATION_NAME: 'Fieries',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5993062,
        LOCATION_LATITUDE_DEG: 52.1664014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI003500',
        LOCATION_NAME: 'Finavarra',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.099231,
        LOCATION_LATITUDE_DEG: 53.1497905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI990559',
        LOCATION_NAME: 'Finea',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI014800',
        LOCATION_NAME: 'Finglas',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2884664,
        LOCATION_LATITUDE_DEG: 53.3931614,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006000',
        LOCATION_NAME: 'Finnea',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3851379,
        LOCATION_LATITUDE_DEG: 53.7829341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI990899',
        LOCATION_NAME: 'Finnis',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI006400',
        LOCATION_NAME: 'Finny',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4829954,
        LOCATION_LATITUDE_DEG: 53.5672251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007100',
        LOCATION_NAME: 'Fintown',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1787627,
        LOCATION_LATITUDE_DEG: 54.8574477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007400',
        LOCATION_NAME: 'Finuge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492973,
        LOCATION_LATITUDE_DEG: 52.4330127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013900',
        LOCATION_NAME: 'Firhouse',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3397997,
        LOCATION_LATITUDE_DEG: 53.2906704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI990830',
        LOCATION_NAME: 'Firies',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008400',
        LOCATION_NAME: 'Firkeel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.112868,
        LOCATION_LATITUDE_DEG: 51.606242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI008600',
        LOCATION_NAME: 'Firmount',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6992177,
        LOCATION_LATITUDE_DEG: 51.9829706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI007988',
        LOCATION_NAME: 'Firpark',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6782327,
        LOCATION_LATITUDE_DEG: 53.4459825,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI009950',
        LOCATION_NAME: 'Fisherstown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0678059,
        LOCATION_LATITUDE_DEG: 53.0881661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010000',
        LOCATION_NAME: 'Fisherstreet',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825739,
        LOCATION_LATITUDE_DEG: 52.9997721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI010750',
        LOCATION_NAME: 'Fishmoyne',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9121855,
        LOCATION_LATITUDE_DEG: 52.7474649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013000',
        LOCATION_NAME: 'Fivealley',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324212,
        LOCATION_LATITUDE_DEG: 53.1497721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013200',
        LOCATION_NAME: 'Fivemilebourne',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3439449,
        LOCATION_LATITUDE_DEG: 54.2728864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FI013300',
        LOCATION_NAME: 'Fivemilebridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4992054,
        LOCATION_LATITUDE_DEG: 51.8163518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FL000500',
        LOCATION_NAME: 'Flagmount',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492,
        LOCATION_LATITUDE_DEG: 52.9830714,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO000900',
        LOCATION_NAME: 'Foghill',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.249239,
        LOCATION_LATITUDE_DEG: 54.2665912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO990095',
        LOCATION_NAME: 'fohenagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3847967,
        LOCATION_LATITUDE_DEG: 53.3883436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO001000',
        LOCATION_NAME: 'Foilakill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6493134,
        LOCATION_LATITUDE_DEG: 51.6163423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO990735',
        LOCATION_NAME: 'Follistown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO002800',
        LOCATION_NAME: 'Fontstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8904382,
        LOCATION_LATITUDE_DEG: 53.0557645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO991022',
        LOCATION_NAME: 'Footstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6236,
        LOCATION_LATITUDE_DEG: 53.8026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO006900',
        LOCATION_NAME: 'Fordstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990039,
        LOCATION_LATITUDE_DEG: 53.666482,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007400',
        LOCATION_NAME: 'Fore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2153867,
        LOCATION_LATITUDE_DEG: 53.6690256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO007600',
        LOCATION_NAME: 'Forenaghts',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5990036,
        LOCATION_LATITUDE_DEG: 53.2164751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO990870',
        LOCATION_NAME: 'Forgney',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO010300',
        LOCATION_NAME: 'Formoyle',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324143,
        LOCATION_LATITUDE_DEG: 53.6165243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023650',
        LOCATION_NAME: 'Fort William',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.749868,
        LOCATION_LATITUDE_DEG: 52.7468971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO012100',
        LOCATION_NAME: 'Forth Mountain',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5637127,
        LOCATION_LATITUDE_DEG: 52.3167871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023100',
        LOCATION_NAME: 'Fortlawn',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4054641,
        LOCATION_LATITUDE_DEG: 53.3969464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013150',
        LOCATION_NAME: 'Fortyacres',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8202636,
        LOCATION_LATITUDE_DEG: 53.5245269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO013750',
        LOCATION_NAME: 'Fossa',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6062736,
        LOCATION_LATITUDE_DEG: 52.0688881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO991132',
        LOCATION_NAME: 'Foulkesmill',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.753,
        LOCATION_LATITUDE_DEG: 52.3142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO991133',
        LOCATION_NAME: 'Foulkesmills',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.753,
        LOCATION_LATITUDE_DEG: 52.3142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO015500',
        LOCATION_NAME: 'Foulksmill',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490269,
        LOCATION_LATITUDE_DEG: 52.3163958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO990825',
        LOCATION_NAME: 'Foulksmills',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016000',
        LOCATION_NAME: 'Fountain Cross',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0239427,
        LOCATION_LATITUDE_DEG: 52.8662925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO016300',
        LOCATION_NAME: 'Fountainstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3166179,
        LOCATION_LATITUDE_DEG: 51.7801184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017400',
        LOCATION_NAME: 'Four Mile House',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158272,
        LOCATION_LATITUDE_DEG: 53.6998391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO017800',
        LOCATION_NAME: 'Four Roads',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2253241,
        LOCATION_LATITUDE_DEG: 53.5175841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018100',
        LOCATION_NAME: 'Fourcourts',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2747641,
        LOCATION_LATITUDE_DEG: 53.3485613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO018200',
        LOCATION_NAME: 'Fourcuil',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.899247,
        LOCATION_LATITUDE_DEG: 51.6496439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020500',
        LOCATION_NAME: 'Foxford',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1146611,
        LOCATION_LATITUDE_DEG: 53.9832761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO020600',
        LOCATION_NAME: 'Foxhall',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0255779,
        LOCATION_LATITUDE_DEG: 53.5926304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO023200',
        LOCATION_NAME: 'Foxrock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1839224,
        LOCATION_LATITUDE_DEG: 53.2666782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022200',
        LOCATION_NAME: 'Foygh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324214,
        LOCATION_LATITUDE_DEG: 53.599823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FO022300',
        LOCATION_NAME: 'Foynes',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1056352,
        LOCATION_LATITUDE_DEG: 52.6113362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR002500',
        LOCATION_NAME: 'Frankford',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7324147,
        LOCATION_LATITUDE_DEG: 53.1664735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR004400',
        LOCATION_NAME: 'Freemount',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825383,
        LOCATION_LATITUDE_DEG: 52.2664079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005300',
        LOCATION_NAME: 'Frenchfort',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992171,
        LOCATION_LATITUDE_DEG: 53.2831013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005400',
        LOCATION_NAME: 'Frenchpark',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4050652,
        LOCATION_LATITUDE_DEG: 53.8665489,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR005500',
        LOCATION_NAME: 'Freneystown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157647,
        LOCATION_LATITUDE_DEG: 52.6664303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR006000',
        LOCATION_NAME: 'Freshford',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4054356,
        LOCATION_LATITUDE_DEG: 52.7369344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007300',
        LOCATION_NAME: 'Friarstown',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6192457,
        LOCATION_LATITUDE_DEG: 52.5948985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007200',
        LOCATION_NAME: 'Friarstown',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158325,
        LOCATION_LATITUDE_DEG: 54.2331934,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR007400',
        LOCATION_NAME: 'Friarstown Bridge',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8045755,
        LOCATION_LATITUDE_DEG: 52.8386336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FR014200',
        LOCATION_NAME: 'Frosses',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324152,
        LOCATION_LATITUDE_DEG: 54.6666338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000200',
        LOCATION_NAME: 'Fuerty',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658572,
        LOCATION_LATITUDE_DEG: 53.6165253,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU000400',
        LOCATION_NAME: 'Fuhiry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2492724,
        LOCATION_LATITUDE_DEG: 51.8996634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU002800',
        LOCATION_NAME: 'Furbogh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2117571,
        LOCATION_LATITUDE_DEG: 53.2573081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU003100',
        LOCATION_NAME: 'Furmina',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5182649,
        LOCATION_LATITUDE_DEG: 53.0549814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'FU004100',
        LOCATION_NAME: 'Furraleigh',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4991105,
        LOCATION_LATITUDE_DEG: 52.1996831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA000300',
        LOCATION_NAME: 'Gabys',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3990028,
        LOCATION_LATITUDE_DEG: 52.4664027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA001300',
        LOCATION_NAME: 'Gaillimh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492286,
        LOCATION_LATITUDE_DEG: 53.2831055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990751',
        LOCATION_NAME: 'Gainstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002000',
        LOCATION_NAME: 'Gainstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.326948,
        LOCATION_LATITUDE_DEG: 53.4837509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003000',
        LOCATION_NAME: 'Galbally',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2981561,
        LOCATION_LATITUDE_DEG: 52.4010386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA002900',
        LOCATION_NAME: 'Galbally',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6410828,
        LOCATION_LATITUDE_DEG: 52.3989752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA003600',
        LOCATION_NAME: 'Gallarus',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.366081,
        LOCATION_LATITUDE_DEG: 52.1663933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004200',
        LOCATION_NAME: 'Gallows Hill',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.738659,
        LOCATION_LATITUDE_DEG: 52.7202539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA004700',
        LOCATION_NAME: 'Galmoy',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5491014,
        LOCATION_LATITUDE_DEG: 52.7830399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA005500',
        LOCATION_NAME: 'Galway',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0581295,
        LOCATION_LATITUDE_DEG: 53.2753958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007000',
        LOCATION_NAME: 'Ganty',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6802566,
        LOCATION_LATITUDE_DEG: 53.2530375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007300',
        LOCATION_NAME: 'Garadice',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990045,
        LOCATION_LATITUDE_DEG: 53.4498001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA007750',
        LOCATION_NAME: 'Gardenfield',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.870025,
        LOCATION_LATITUDE_DEG: 53.5437356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA008700',
        LOCATION_NAME: 'Garinish',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.132656,
        LOCATION_LATITUDE_DEG: 51.5996448,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990739',
        LOCATION_NAME: 'Garlow Cross',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA009800',
        LOCATION_NAME: 'Garnavilla',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824234,
        LOCATION_LATITUDE_DEG: 52.3329951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA010900',
        LOCATION_NAME: 'Garrafrauns',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8324996,
        LOCATION_LATITUDE_DEG: 53.6331332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011000',
        LOCATION_NAME: 'Garranard',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492437,
        LOCATION_LATITUDE_DEG: 54.1831987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011100',
        LOCATION_NAME: 'Garrane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325494,
        LOCATION_LATITUDE_DEG: 51.9163666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011300',
        LOCATION_NAME: 'Garranlahan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6669363,
        LOCATION_LATITUDE_DEG: 53.7114726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011200',
        LOCATION_NAME: 'Garranlahan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6658885,
        LOCATION_LATITUDE_DEG: 53.7165394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011400',
        LOCATION_NAME: 'Garranty',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.094428,
        LOCATION_LATITUDE_DEG: 53.7018514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011600',
        LOCATION_NAME: 'Garraun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8660176,
        LOCATION_LATITUDE_DEG: 53.5831401,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990987',
        LOCATION_NAME: 'Garrauncreen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA011700',
        LOCATION_NAME: 'Garraunnatooha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992719,
        LOCATION_LATITUDE_DEG: 52.666447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990890',
        LOCATION_NAME: 'Garrettstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012300',
        LOCATION_NAME: 'Garristown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3822775,
        LOCATION_LATITUDE_DEG: 53.5665075,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012500',
        LOCATION_NAME: 'Garrydoolis',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3379733,
        LOCATION_LATITUDE_DEG: 52.5107035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012600',
        LOCATION_NAME: 'Garryduff',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158139,
        LOCATION_LATITUDE_DEG: 52.0163235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012700',
        LOCATION_NAME: 'Garryfine',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325165,
        LOCATION_LATITUDE_DEG: 52.4164196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012900',
        LOCATION_NAME: 'Garryhill',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8456803,
        LOCATION_LATITUDE_DEG: 52.6763409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA012950',
        LOCATION_NAME: 'Garryhinch',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2975382,
        LOCATION_LATITUDE_DEG: 53.1538052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013000',
        LOCATION_NAME: 'Garrykennedy',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324699,
        LOCATION_LATITUDE_DEG: 52.8997627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013100',
        LOCATION_NAME: 'Garrylucas',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5574914,
        LOCATION_LATITUDE_DEG: 51.6318381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013250',
        LOCATION_NAME: 'Garrynafela',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9141234,
        LOCATION_LATITUDE_DEG: 53.4475011,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013275',
        LOCATION_NAME: 'Garrynagawna',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9559674,
        LOCATION_LATITUDE_DEG: 53.3895106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013400',
        LOCATION_NAME: 'Garryspillane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824782,
        LOCATION_LATITUDE_DEG: 52.4164092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA013500',
        LOCATION_NAME: 'Garryvoe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991537,
        LOCATION_LATITUDE_DEG: 51.8663626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA990492',
        LOCATION_NAME: 'Garvagh',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA019600',
        LOCATION_NAME: 'Gathabawn',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4514065,
        LOCATION_LATITUDE_DEG: 52.7673647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA020000',
        LOCATION_NAME: 'Gattabaun',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.465635,
        LOCATION_LATITUDE_DEG: 52.7706418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA021800',
        LOCATION_NAME: 'Gaybrook',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157121,
        LOCATION_LATITUDE_DEG: 53.4664669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GA023200',
        LOCATION_NAME: 'Gazebo',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657609,
        LOCATION_LATITUDE_DEG: 52.8330408,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000100',
        LOCATION_NAME: 'Gearagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659418,
        LOCATION_LATITUDE_DEG: 51.649642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE000300',
        LOCATION_NAME: 'Geashill',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157781,
        LOCATION_LATITUDE_DEG: 53.2330803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE991134',
        LOCATION_NAME: 'Geesala',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8992,
        LOCATION_LATITUDE_DEG: 54.1125,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE001600',
        LOCATION_NAME: 'Geevagh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491422,
        LOCATION_LATITUDE_DEG: 54.0998729,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GE004700',
        LOCATION_NAME: 'Gerahies',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5826039,
        LOCATION_LATITUDE_DEG: 51.6329406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI990740',
        LOCATION_NAME: 'Gibbstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GI001150',
        LOCATION_NAME: 'Gigginstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2234561,
        LOCATION_LATITUDE_DEG: 53.6020789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000100',
        LOCATION_NAME: 'Glackaunadarragh',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658265,
        LOCATION_LATITUDE_DEG: 54.1165779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL000300',
        LOCATION_NAME: 'Gladree',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.061766,
        LOCATION_LATITUDE_DEG: 54.2554361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL001800',
        LOCATION_NAME: 'Glandore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1263925,
        LOCATION_LATITUDE_DEG: 51.5714298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002200',
        LOCATION_NAME: 'Glangevlin',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991113,
        LOCATION_LATITUDE_DEG: 54.1998788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002500',
        LOCATION_NAME: 'Glanleam',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.316082,
        LOCATION_LATITUDE_DEG: 51.9163734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002600',
        LOCATION_NAME: 'Glanlough',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.599314,
        LOCATION_LATITUDE_DEG: 51.6329443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL002700',
        LOCATION_NAME: 'Glanmire',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3878734,
        LOCATION_LATITUDE_DEG: 51.9092167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003100',
        LOCATION_NAME: 'Glantane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.749224,
        LOCATION_LATITUDE_DEG: 52.0996891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL003500',
        LOCATION_NAME: 'Glanworth',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491922,
        LOCATION_LATITUDE_DEG: 52.1829889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007750',
        LOCATION_NAME: 'Glasheen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.589233,
        LOCATION_LATITUDE_DEG: 52.3859032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL007900',
        LOCATION_NAME: 'Glaslough',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823069,
        LOCATION_LATITUDE_DEG: 54.2998834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL028600',
        LOCATION_NAME: 'Glasnevin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2783382,
        LOCATION_LATITUDE_DEG: 53.3837368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009000',
        LOCATION_NAME: 'Glasson',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658345,
        LOCATION_LATITUDE_DEG: 53.4665013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL009300',
        LOCATION_NAME: 'Glasthule',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1247252,
        LOCATION_LATITUDE_DEG: 53.2783703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010500',
        LOCATION_NAME: 'Glen',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8157814,
        LOCATION_LATITUDE_DEG: 55.1166748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL010600',
        LOCATION_NAME: 'Glen',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323769,
        LOCATION_LATITUDE_DEG: 53.8331396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011450',
        LOCATION_NAME: 'Glen of the Downs',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1054594,
        LOCATION_LATITUDE_DEG: 53.1283368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011600',
        LOCATION_NAME: 'Glenade',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3021031,
        LOCATION_LATITUDE_DEG: 54.3874002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL011700',
        LOCATION_NAME: 'Glenageary',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1251258,
        LOCATION_LATITUDE_DEG: 53.2772318,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020600',
        LOCATION_NAME: 'Glenamaddy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491727,
        LOCATION_LATITUDE_DEG: 53.5998257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012000',
        LOCATION_NAME: 'Glenamoy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.70336,
        LOCATION_LATITUDE_DEG: 54.2477972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012200',
        LOCATION_NAME: 'Glenard',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6178971,
        LOCATION_LATITUDE_DEG: 51.9840652,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012600',
        LOCATION_NAME: 'Glenbane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991659,
        LOCATION_LATITUDE_DEG: 52.4830126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012750',
        LOCATION_NAME: 'Glenbarrow',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4674633,
        LOCATION_LATITUDE_DEG: 53.1068924,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012800',
        LOCATION_NAME: 'Glenbaun',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.199256,
        LOCATION_LATITUDE_DEG: 52.5164312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL012900',
        LOCATION_NAME: 'Glenbeigh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9404322,
        LOCATION_LATITUDE_DEG: 52.0613856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013300',
        LOCATION_NAME: 'Glenbreedy',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324375,
        LOCATION_LATITUDE_DEG: 52.7830499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013400',
        LOCATION_NAME: 'Glenbrien',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989981,
        LOCATION_LATITUDE_DEG: 52.4497041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL013500',
        LOCATION_NAME: 'Glenbrook',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3382789,
        LOCATION_LATITUDE_DEG: 51.8501515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990815',
        LOCATION_NAME: 'Glencar',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014200',
        LOCATION_NAME: 'Glencolumbkille',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7240878,
        LOCATION_LATITUDE_DEG: 54.7079364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014400',
        LOCATION_NAME: 'Glencorrib',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1663747,
        LOCATION_LATITUDE_DEG: 53.5083347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014700',
        LOCATION_NAME: 'Glencree',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3050888,
        LOCATION_LATITUDE_DEG: 53.1945013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL014900',
        LOCATION_NAME: 'Glencullen',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2219163,
        LOCATION_LATITUDE_DEG: 53.2199568,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015100',
        LOCATION_NAME: 'Glendalough',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3300658,
        LOCATION_LATITUDE_DEG: 53.0117692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015400',
        LOCATION_NAME: 'Glenderry',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993302,
        LOCATION_LATITUDE_DEG: 52.399715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015600',
        LOCATION_NAME: 'Glendine',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8991308,
        LOCATION_LATITUDE_DEG: 51.999673,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL015900',
        LOCATION_NAME: 'Glendowan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658028,
        LOCATION_LATITUDE_DEG: 54.7999379,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016000',
        LOCATION_NAME: 'Glendree',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325139,
        LOCATION_LATITUDE_DEG: 52.916462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016100',
        LOCATION_NAME: 'Glenduff',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.165861,
        LOCATION_LATITUDE_DEG: 52.2496947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016300',
        LOCATION_NAME: 'Glenealy',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1395736,
        LOCATION_LATITUDE_DEG: 52.975245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016400',
        LOCATION_NAME: 'Gleneely',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823647,
        LOCATION_LATITUDE_DEG: 54.7666374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL016500',
        LOCATION_NAME: 'Gleneely',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1464935,
        LOCATION_LATITUDE_DEG: 55.2455733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017100',
        LOCATION_NAME: 'Glenfarn',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824192,
        LOCATION_LATITUDE_DEG: 54.2831853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017200',
        LOCATION_NAME: 'Glenfarne',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9699303,
        LOCATION_LATITUDE_DEG: 54.2860933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017450',
        LOCATION_NAME: 'Glenflesk',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.356432,
        LOCATION_LATITUDE_DEG: 52.0100615,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990220',
        LOCATION_NAME: 'Glengariff',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5505498,
        LOCATION_LATITUDE_DEG: 51.7519037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017700',
        LOCATION_NAME: 'Glengarrif',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.555278,
        LOCATION_LATITUDE_DEG: 51.7485885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL017800',
        LOCATION_NAME: 'Glengarriff',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5596852,
        LOCATION_LATITUDE_DEG: 51.7510608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990183',
        LOCATION_NAME: 'Glengoole',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8442339,
        LOCATION_LATITUDE_DEG: 52.9751049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990184',
        LOCATION_NAME: 'Glengoole North',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6512943,
        LOCATION_LATITUDE_DEG: -7.8442421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL990185',
        LOCATION_NAME: 'Glengoole South',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6284622,
        LOCATION_LATITUDE_DEG: 52.6102364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018000',
        LOCATION_NAME: 'Glengort',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992653,
        LOCATION_LATITUDE_DEG: 52.3664124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018200',
        LOCATION_NAME: 'Glenieraragh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8157805,
        LOCATION_LATITUDE_DEG: 55.0999649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL018400',
        LOCATION_NAME: 'Glenisland',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992599,
        LOCATION_LATITUDE_DEG: 53.8998664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019500',
        LOCATION_NAME: 'Glenmaquin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6717615,
        LOCATION_LATITUDE_DEG: 54.8921604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019900',
        LOCATION_NAME: 'Glenmore',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659696,
        LOCATION_LATITUDE_DEG: 52.7664443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL019700',
        LOCATION_NAME: 'Glenmore',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0240552,
        LOCATION_LATITUDE_DEG: 52.3513595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020000',
        LOCATION_NAME: 'Glenmore Bridge',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8957464,
        LOCATION_LATITUDE_DEG: 54.5571434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020400',
        LOCATION_NAME: 'Glenmullynaha',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7491828,
        LOCATION_LATITUDE_DEG: 53.916564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020500',
        LOCATION_NAME: 'Glennagoul',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491973,
        LOCATION_LATITUDE_DEG: 52.2663952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL020700',
        LOCATION_NAME: 'Glennan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157039,
        LOCATION_LATITUDE_DEG: 54.3165845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021200',
        LOCATION_NAME: 'Glenosheen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4991925,
        LOCATION_LATITUDE_DEG: 52.3164066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021300',
        LOCATION_NAME: 'Glenpatrick',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5824279,
        LOCATION_LATITUDE_DEG: 52.3163963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL021400',
        LOCATION_NAME: 'Glenpipe',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990702,
        LOCATION_LATITUDE_DEG: 52.4164052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022000',
        LOCATION_NAME: 'Glenroe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159323,
        LOCATION_LATITUDE_DEG: 52.9997681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL022800',
        LOCATION_NAME: 'Glentavraun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7991996,
        LOCATION_LATITUDE_DEG: 53.8831548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023000',
        LOCATION_NAME: 'Glenties',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2923519,
        LOCATION_LATITUDE_DEG: 54.8036454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023600',
        LOCATION_NAME: 'Glenvar',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5990517,
        LOCATION_LATITUDE_DEG: 55.1499757,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL023700',
        LOCATION_NAME: 'Glenville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4158911,
        LOCATION_LATITUDE_DEG: 52.0329713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024400',
        LOCATION_NAME: 'Glin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.28267,
        LOCATION_LATITUDE_DEG: 52.1829946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024300',
        LOCATION_NAME: 'Glin',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3014701,
        LOCATION_LATITUDE_DEG: 52.5713331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024800',
        LOCATION_NAME: 'Glinsk',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8263562,
        LOCATION_LATITUDE_DEG: 53.3720179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024600',
        LOCATION_NAME: 'Glinsk',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4158628,
        LOCATION_LATITUDE_DEG: 53.6498299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL024700',
        LOCATION_NAME: 'Glinsk',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7751393,
        LOCATION_LATITUDE_DEG: 55.2005771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025600',
        LOCATION_NAME: 'Glounthaune',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3377257,
        LOCATION_LATITUDE_DEG: 51.9165134,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL025700',
        LOCATION_NAME: 'Gloves',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6868193,
        LOCATION_LATITUDE_DEG: 53.2754657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027600',
        LOCATION_NAME: 'Glynn',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9032155,
        LOCATION_LATITUDE_DEG: 52.5030507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GL027500',
        LOCATION_NAME: 'Glynn',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5762304,
        LOCATION_LATITUDE_DEG: 52.3705359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GN000300',
        LOCATION_NAME: 'Gneeves',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992822,
        LOCATION_LATITUDE_DEG: 52.2997066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GN000200',
        LOCATION_NAME: 'Gneeves',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992218,
        LOCATION_LATITUDE_DEG: 52.149694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GN000400',
        LOCATION_NAME: 'Gneevgullia',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659789,
        LOCATION_LATITUDE_DEG: 52.1163875,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000900',
        LOCATION_NAME: 'Goatstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158481,
        LOCATION_LATITUDE_DEG: 52.9997691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO000800',
        LOCATION_NAME: 'Goatstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2315315,
        LOCATION_LATITUDE_DEG: 53.2910409,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO021100',
        LOCATION_NAME: 'Goatstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2249593,
        LOCATION_LATITUDE_DEG: 53.2897179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003100',
        LOCATION_NAME: 'Golan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490104,
        LOCATION_LATITUDE_DEG: 54.3331862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO003800',
        LOCATION_NAME: 'Golden',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9798702,
        LOCATION_LATITUDE_DEG: 52.4973562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO004000',
        LOCATION_NAME: 'Golden Ball',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1991713,
        LOCATION_LATITUDE_DEG: 53.2362721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO005700',
        LOCATION_NAME: 'Goleen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7172429,
        LOCATION_LATITUDE_DEG: 51.4971295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO991056',
        LOCATION_NAME: 'Gooig',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4775,
        LOCATION_LATITUDE_DEG: 52.7231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO008400',
        LOCATION_NAME: 'Goolds Cross',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491264,
        LOCATION_LATITUDE_DEG: 52.5830234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011100',
        LOCATION_NAME: 'Goresbridge',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9836306,
        LOCATION_LATITUDE_DEG: 52.6162216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011200',
        LOCATION_NAME: 'Gorey',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3037024,
        LOCATION_LATITUDE_DEG: 52.67872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO011900',
        LOCATION_NAME: 'Gormanston',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322478,
        LOCATION_LATITUDE_DEG: 53.6331141,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013500',
        LOCATION_NAME: 'Gort',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8165714,
        LOCATION_LATITUDE_DEG: 53.0678809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013550',
        LOCATION_NAME: 'Gort Beg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.792901,
        LOCATION_LATITUDE_DEG: 53.4557473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013700',
        LOCATION_NAME: 'Gortacullin',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158364,
        LOCATION_LATITUDE_DEG: 52.2663879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013800',
        LOCATION_NAME: 'Gortaglanna',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.382578,
        LOCATION_LATITUDE_DEG: 52.4497244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO013900',
        LOCATION_NAME: 'Gortahile',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490442,
        LOCATION_LATITUDE_DEG: 52.8164394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014000',
        LOCATION_NAME: 'Gortahill',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658147,
        LOCATION_LATITUDE_DEG: 54.2831824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014100',
        LOCATION_NAME: 'Gortahork',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324206,
        LOCATION_LATITUDE_DEG: 55.1166722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014200',
        LOCATION_NAME: 'Gortaroo',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.915845,
        LOCATION_LATITUDE_DEG: 51.9163604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014400',
        LOCATION_NAME: 'Gortatlea',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5777489,
        LOCATION_LATITUDE_DEG: 52.2236663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014500',
        LOCATION_NAME: 'Gortbaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825524,
        LOCATION_LATITUDE_DEG: 53.7831506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014675',
        LOCATION_NAME: 'Gorteen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7027774,
        LOCATION_LATITUDE_DEG: 53.5858057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014600',
        LOCATION_NAME: 'Gorteen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5824952,
        LOCATION_LATITUDE_DEG: 53.3665099,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014688',
        LOCATION_NAME: 'Gorteen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3181318,
        LOCATION_LATITUDE_DEG: 53.0542166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014650',
        LOCATION_NAME: 'Gorteen',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6292808,
        LOCATION_LATITUDE_DEG: 52.6621796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014800',
        LOCATION_NAME: 'Gorteeny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658602,
        LOCATION_LATITUDE_DEG: 53.0164672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014900',
        LOCATION_NAME: 'Gortfree',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4027356,
        LOCATION_LATITUDE_DEG: 53.658508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015100',
        LOCATION_NAME: 'Gortlee',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7323673,
        LOCATION_LATITUDE_DEG: 54.9499491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015200',
        LOCATION_NAME: 'Gortmellia',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8576029,
        LOCATION_LATITUDE_DEG: 54.2332004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015300',
        LOCATION_NAME: 'Gortmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6159861,
        LOCATION_LATITUDE_DEG: 53.3831106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015450',
        LOCATION_NAME: 'Gortmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4141039,
        LOCATION_LATITUDE_DEG: 53.616481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015400',
        LOCATION_NAME: 'Gortmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492437,
        LOCATION_LATITUDE_DEG: 53.3831065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO991025',
        LOCATION_NAME: 'Gortnadrung',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.41771,
        LOCATION_LATITUDE_DEG: 54.3943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015550',
        LOCATION_NAME: 'Gortnagoyne',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7940573,
        LOCATION_LATITUDE_DEG: 53.6210804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990630',
        LOCATION_NAME: 'Gortnagross',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015600',
        LOCATION_NAME: 'Gortnahoo',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.599113,
        LOCATION_LATITUDE_DEG: 52.6664278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015700',
        LOCATION_NAME: 'Gortnakistin',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491747,
        LOCATION_LATITUDE_DEG: 52.5497265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015850',
        LOCATION_NAME: 'Gortnaminsha',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5597352,
        LOCATION_LATITUDE_DEG: 52.4406327,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015900',
        LOCATION_NAME: 'Gortnasate',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991315,
        LOCATION_LATITUDE_DEG: 55.0332722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO015950',
        LOCATION_NAME: 'Gortnesk',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5630312,
        LOCATION_LATITUDE_DEG: 54.85737,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016100',
        LOCATION_NAME: 'Gortrelig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493399,
        LOCATION_LATITUDE_DEG: 52.0163887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016200',
        LOCATION_NAME: 'Gortroche',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991792,
        LOCATION_LATITUDE_DEG: 52.1163831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO016300',
        LOCATION_NAME: 'Gortroe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7815053,
        LOCATION_LATITUDE_DEG: 53.1796456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO017800',
        LOCATION_NAME: 'Gotinstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.229241,
        LOCATION_LATITUDE_DEG: 52.4940684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018050',
        LOCATION_NAME: 'Gougane Barra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3206223,
        LOCATION_LATITUDE_DEG: 51.8352998,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018100',
        LOCATION_NAME: 'Gouladane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6326209,
        LOCATION_LATITUDE_DEG: 51.6246438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO018300',
        LOCATION_NAME: 'Gouldavoher',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491994,
        LOCATION_LATITUDE_DEG: 52.6330326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019600',
        LOCATION_NAME: 'Gowla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7825998,
        LOCATION_LATITUDE_DEG: 53.383108,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019700',
        LOCATION_NAME: 'Gowlane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659983,
        LOCATION_LATITUDE_DEG: 51.9163706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019900',
        LOCATION_NAME: 'Gowlaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9160149,
        LOCATION_LATITUDE_DEG: 53.5998351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO019800',
        LOCATION_NAME: 'Gowlaun',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6491288,
        LOCATION_LATITUDE_DEG: 51.9996711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020000',
        LOCATION_NAME: 'Gowlin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.84905,
        LOCATION_LATITUDE_DEG: 52.5330148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020100',
        LOCATION_NAME: 'Gowlin New',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657405,
        LOCATION_LATITUDE_DEG: 52.5330123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO990588',
        LOCATION_NAME: 'Gowly',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO020200',
        LOCATION_NAME: 'Gowran',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657635,
        LOCATION_LATITUDE_DEG: 52.6164191,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000200',
        LOCATION_NAME: 'Gracedieu',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1639,
        LOCATION_LATITUDE_DEG: 52.274535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000700',
        LOCATION_NAME: 'Graffy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492203,
        LOCATION_LATITUDE_DEG: 54.0665842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR000600',
        LOCATION_NAME: 'Graffy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992102,
        LOCATION_LATITUDE_DEG: 53.9831699,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR991152',
        LOCATION_NAME: 'Gragarnagh',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.78428,
        LOCATION_LATITUDE_DEG: 54.0478,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002300',
        LOCATION_NAME: 'Graignagower',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991231,
        LOCATION_LATITUDE_DEG: 52.2496876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002400',
        LOCATION_NAME: 'Graigue',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991422,
        LOCATION_LATITUDE_DEG: 53.1164752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002500',
        LOCATION_NAME: 'Graigue',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991501,
        LOCATION_LATITUDE_DEG: 52.0496696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002700',
        LOCATION_NAME: 'Graigue',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4158009,
        LOCATION_LATITUDE_DEG: 52.5997287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002600',
        LOCATION_NAME: 'Graigue',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9546654,
        LOCATION_LATITUDE_DEG: 52.8450403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002800',
        LOCATION_NAME: 'Graigue Little',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823526,
        LOCATION_LATITUDE_DEG: 52.1663698,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002850',
        LOCATION_NAME: 'Graigue More',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.606834,
        LOCATION_LATITUDE_DEG: 52.6630651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR002900',
        LOCATION_NAME: 'Graiguealug',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490335,
        LOCATION_LATITUDE_DEG: 52.7497364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003000',
        LOCATION_NAME: 'Graiguenamanagh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9538834,
        LOCATION_LATITUDE_DEG: 52.541335,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003800',
        LOCATION_NAME: 'Granabeg',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989906,
        LOCATION_LATITUDE_DEG: 53.066456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR003900',
        LOCATION_NAME: 'Granard',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4897753,
        LOCATION_LATITUDE_DEG: 53.7818296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR004600',
        LOCATION_NAME: 'Graney',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823279,
        LOCATION_LATITUDE_DEG: 52.8997458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005000',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0370602,
        LOCATION_LATITUDE_DEG: 53.4144283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005300',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.544561,
        LOCATION_LATITUDE_DEG: 52.536905,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005100',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158331,
        LOCATION_LATITUDE_DEG: 54.399913,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006000',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3060249,
        LOCATION_LATITUDE_DEG: 52.151256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005400',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0446745,
        LOCATION_LATITUDE_DEG: 53.81434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005200',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8377256,
        LOCATION_LATITUDE_DEG: 52.3402975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005500',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7370212,
        LOCATION_LATITUDE_DEG: 51.9985422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055950',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3715474,
        LOCATION_LATITUDE_DEG: 53.5188154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR005900',
        LOCATION_NAME: 'Grange',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8122106,
        LOCATION_LATITUDE_DEG: 52.8198215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR006100',
        LOCATION_NAME: 'Grange Con',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7501213,
        LOCATION_LATITUDE_DEG: 52.9983719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007100',
        LOCATION_NAME: 'Grangebellew',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322594,
        LOCATION_LATITUDE_DEG: 53.8165296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990811',
        LOCATION_NAME: 'Grangecon',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007200',
        LOCATION_NAME: 'Grangegeeth',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322846,
        LOCATION_LATITUDE_DEG: 53.74983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007300',
        LOCATION_NAME: 'Grangegeeth Cross Roads',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5489829,
        LOCATION_LATITUDE_DEG: 53.749826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR007400',
        LOCATION_NAME: 'Grangemockler',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4824099,
        LOCATION_LATITUDE_DEG: 52.4497114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008200',
        LOCATION_NAME: 'Granny',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991393,
        LOCATION_LATITUDE_DEG: 53.9165574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008100',
        LOCATION_NAME: 'Granny',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657822,
        LOCATION_LATITUDE_DEG: 52.266388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008900',
        LOCATION_NAME: 'Grantstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0475765,
        LOCATION_LATITUDE_DEG: 52.5074628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990998',
        LOCATION_NAME: 'Grantstown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR008950',
        LOCATION_NAME: 'Grantstown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0779416,
        LOCATION_LATITUDE_DEG: 52.2410475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR011600',
        LOCATION_NAME: 'Greaghnageeragh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824185,
        LOCATION_LATITUDE_DEG: 54.0831703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR033000',
        LOCATION_NAME: 'Greatconnell',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657254,
        LOCATION_LATITUDE_DEG: 53.1664734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035000',
        LOCATION_NAME: 'Greenan',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989657,
        LOCATION_LATITUDE_DEG: 52.9164491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035300',
        LOCATION_NAME: 'Greenane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.668685,
        LOCATION_LATITUDE_DEG: 51.8707655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035200',
        LOCATION_NAME: 'Greenane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1297552,
        LOCATION_LATITUDE_DEG: 52.5007876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR035400',
        LOCATION_NAME: 'Greenanstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3186584,
        LOCATION_LATITUDE_DEG: 53.6145567,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR036000',
        LOCATION_NAME: 'Greencastle',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9822958,
        LOCATION_LATITUDE_DEG: 55.1999672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055600',
        LOCATION_NAME: 'Greenhills',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3314667,
        LOCATION_LATITUDE_DEG: 53.3106775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039400',
        LOCATION_NAME: 'Greenore',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1484278,
        LOCATION_LATITUDE_DEG: 54.0309473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR039500',
        LOCATION_NAME: 'Greenrath',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1657286,
        LOCATION_LATITUDE_DEG: 52.4906003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR990096',
        LOCATION_NAME: 'greenville',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4467651,
        LOCATION_LATITUDE_DEG: 53.4527987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041800',
        LOCATION_NAME: 'Grenagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5992151,
        LOCATION_LATITUDE_DEG: 52.0163721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR041850',
        LOCATION_NAME: 'Grenanstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0809891,
        LOCATION_LATITUDE_DEG: 52.8342279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR044100',
        LOCATION_NAME: 'Greystones',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0706495,
        LOCATION_LATITUDE_DEG: 53.1434603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR055500',
        LOCATION_NAME: 'Griffith Ave',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2464183,
        LOCATION_LATITUDE_DEG: 53.3758547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR050300',
        LOCATION_NAME: 'Grogan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991027,
        LOCATION_LATITUDE_DEG: 53.3164935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GR051600',
        LOCATION_NAME: 'Grousehall',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157296,
        LOCATION_LATITUDE_DEG: 53.9498484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000500',
        LOCATION_NAME: 'Gubaveeny',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658194,
        LOCATION_LATITUDE_DEG: 54.2498856,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU000700',
        LOCATION_NAME: 'Gubnaveagh',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.899108,
        LOCATION_LATITUDE_DEG: 54.0998764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU004700',
        LOCATION_NAME: 'Gunsborough',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5325915,
        LOCATION_LATITUDE_DEG: 52.4830249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU990730',
        LOCATION_NAME: 'Gurranebraher',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU005950',
        LOCATION_NAME: 'Gurtagarry',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9878601,
        LOCATION_LATITUDE_DEG: 52.8598858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GO014700',
        LOCATION_NAME: 'Gurteen',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158716,
        LOCATION_LATITUDE_DEG: 53.9998676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006000',
        LOCATION_NAME: 'Gurteenulla',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4325951,
        LOCATION_LATITUDE_DEG: 51.5829403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU990794',
        LOCATION_NAME: 'Gurtymadden',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GU006400',
        LOCATION_NAME: 'Gusserane',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.855293,
        LOCATION_LATITUDE_DEG: 52.3078992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW000800',
        LOCATION_NAME: 'Gweedore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2328416,
        LOCATION_LATITUDE_DEG: 55.0525706,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GW001000',
        LOCATION_NAME: 'Gweesalia',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993154,
        LOCATION_LATITUDE_DEG: 54.1165513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'GY000300',
        LOCATION_NAME: 'Gyleen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1744723,
        LOCATION_LATITUDE_DEG: 51.7884464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000900',
        LOCATION_NAME: 'Hackballs Cross',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5156806,
        LOCATION_LATITUDE_DEG: 54.0331572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990876',
        LOCATION_NAME: 'Hackballscross',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA001200',
        LOCATION_NAME: 'Hacketstown',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5547928,
        LOCATION_LATITUDE_DEG: 52.869439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA991019',
        LOCATION_NAME: 'Hacketts Cross',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.525,
        LOCATION_LATITUDE_DEG: 54.0317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA009100',
        LOCATION_NAME: 'Halfway',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5772303,
        LOCATION_LATITUDE_DEG: 51.8016922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990804',
        LOCATION_NAME: 'Halverstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA000200',
        LOCATION_NAME: 'Hand Crossroads',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659635,
        LOCATION_LATITUDE_DEG: 52.8164515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990734',
        LOCATION_NAME: 'Hanlonstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA034600',
        LOCATION_NAME: 'Haremount',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992811,
        LOCATION_LATITUDE_DEG: 52.1496981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA037800',
        LOCATION_NAME: 'Harlinstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5822719,
        LOCATION_LATITUDE_DEG: 53.7165233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990188',
        LOCATION_NAME: 'Harmonstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1917426,
        LOCATION_LATITUDE_DEG: 53.3827116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA068700',
        LOCATION_NAME: 'Harolds Cross',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.27405,
        LOCATION_LATITUDE_DEG: 53.3268774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA039300',
        LOCATION_NAME: "Harold's Cross",
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2881398,
        LOCATION_LATITUDE_DEG: 53.3167891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042000',
        LOCATION_NAME: 'Harristown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6158115,
        LOCATION_LATITUDE_DEG: 52.8330496,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA041900',
        LOCATION_NAME: 'Harristown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6157695,
        LOCATION_LATITUDE_DEG: 52.8330696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA072000',
        LOCATION_NAME: 'Harristown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2841778,
        LOCATION_LATITUDE_DEG: 53.4191997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047700',
        LOCATION_NAME: 'Hartstown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.73232,
        LOCATION_LATITUDE_DEG: 52.9664539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA047600',
        LOCATION_NAME: 'Hartstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4259175,
        LOCATION_LATITUDE_DEG: 53.3928506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA057000',
        LOCATION_NAME: 'Haulbowline',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3000242,
        LOCATION_LATITUDE_DEG: 51.8403101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA065600',
        LOCATION_NAME: 'Hayes Bridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7492423,
        LOCATION_LATITUDE_DEG: 51.6663363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990754',
        LOCATION_NAME: 'Hayestown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA066500',
        LOCATION_NAME: 'Hays',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6156814,
        LOCATION_LATITUDE_DEG: 53.6665235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA990643',
        LOCATION_NAME: 'Hazelwood',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000400',
        LOCATION_NAME: 'Headford',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1073136,
        LOCATION_LATITUDE_DEG: 53.4723251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE000450',
        LOCATION_NAME: 'Headfort',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2552669,
        LOCATION_LATITUDE_DEG: 52.0290096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE009900',
        LOCATION_NAME: 'Heirhill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.816026,
        LOCATION_LATITUDE_DEG: 52.4164174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE016350',
        LOCATION_NAME: 'Hempstown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5000893,
        LOCATION_LATITUDE_DEG: 53.2020023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE023200',
        LOCATION_NAME: 'Herbertstown',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.472177,
        LOCATION_LATITUDE_DEG: 52.5209264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HE024000',
        LOCATION_NAME: 'Hermitage',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4490069,
        LOCATION_LATITUDE_DEG: 52.299684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI010400',
        LOCATION_NAME: 'High Street',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0658318,
        LOCATION_LATITUDE_DEG: 53.0330719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI026700',
        LOCATION_NAME: 'Hill Street',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.082433,
        LOCATION_LATITUDE_DEG: 53.8831542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HI027000',
        LOCATION_NAME: 'Hill Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.332425,
        LOCATION_LATITUDE_DEG: 54.6832309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO002450',
        LOCATION_NAME: 'Hodsons Bay',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9756214,
        LOCATION_LATITUDE_DEG: 53.4772131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO009400',
        LOCATION_NAME: 'Hollow, The',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157225,
        LOCATION_LATITUDE_DEG: 53.8665466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010100',
        LOCATION_NAME: 'Hollyford',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158496,
        LOCATION_LATITUDE_DEG: 52.6330277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010200',
        LOCATION_NAME: 'Hollyfort',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489944,
        LOCATION_LATITUDE_DEG: 52.7164192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010300',
        LOCATION_NAME: 'Hollyfort',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.348977,
        LOCATION_LATITUDE_DEG: 52.7163929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO990726',
        LOCATION_NAME: 'Hollyhill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010700',
        LOCATION_NAME: 'Hollymount',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159306,
        LOCATION_LATITUDE_DEG: 53.6498302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010600',
        LOCATION_NAME: 'Hollymount',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9611008,
        LOCATION_LATITUDE_DEG: 52.8761165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO010800',
        LOCATION_NAME: 'Hollywood',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6049223,
        LOCATION_LATITUDE_DEG: 53.1036611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO012200',
        LOCATION_NAME: 'Holme',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7157683,
        LOCATION_LATITUDE_DEG: 55.1499701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018100',
        LOCATION_NAME: 'Holycross',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5324911,
        LOCATION_LATITUDE_DEG: 52.4997212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO018200',
        LOCATION_NAME: 'Holycross',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658398,
        LOCATION_LATITUDE_DEG: 52.6330282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO027250',
        LOCATION_NAME: 'Hopestown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4048886,
        LOCATION_LATITUDE_DEG: 53.5185237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO033300',
        LOCATION_NAME: 'Horse and Jockey',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.782435,
        LOCATION_LATITUDE_DEG: 52.6164262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034400',
        LOCATION_NAME: 'Horseleap',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5758755,
        LOCATION_LATITUDE_DEG: 53.3942968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO034500',
        LOCATION_NAME: 'Horseleap Cross Roads',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6658755,
        LOCATION_LATITUDE_DEG: 53.4665101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO039000',
        LOCATION_NAME: 'Hospital',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4349459,
        LOCATION_LATITUDE_DEG: 52.4843211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO044200',
        LOCATION_NAME: 'Howes Strand',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6244391,
        LOCATION_LATITUDE_DEG: 51.6406454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HO045800',
        LOCATION_NAME: 'Howth',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0639227,
        LOCATION_LATITUDE_DEG: 53.385582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU001600',
        LOCATION_NAME: 'Hugginstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490751,
        LOCATION_LATITUDE_DEG: 52.4497059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU017200',
        LOCATION_NAME: 'Huntstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3434081,
        LOCATION_LATITUDE_DEG: 53.4169484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HU011300',
        LOCATION_NAME: 'Hurlers Cross',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8392647,
        LOCATION_LATITUDE_DEG: 52.7155121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000100',
        LOCATION_NAME: 'Inagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1756423,
        LOCATION_LATITUDE_DEG: 52.8836651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000700',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9660371,
        LOCATION_LATITUDE_DEG: 52.1496987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN678838',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5345325,
        LOCATION_LATITUDE_DEG: 52.4684643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000800',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824712,
        LOCATION_LATITUDE_DEG: 51.7996492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001000',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991518,
        LOCATION_LATITUDE_DEG: 52.6830282,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000600',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658543,
        LOCATION_LATITUDE_DEG: 51.9829662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN457025',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9210523,
        LOCATION_LATITUDE_DEG: 52.7270242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN000900',
        LOCATION_NAME: 'Inch',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322649,
        LOCATION_LATITUDE_DEG: 52.7330217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001100',
        LOCATION_NAME: 'Inchamay',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825318,
        LOCATION_LATITUDE_DEG: 52.0496817,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001200',
        LOCATION_NAME: 'Inchaquire',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.799027,
        LOCATION_LATITUDE_DEG: 53.0164534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001600',
        LOCATION_NAME: 'Inchibeg Bridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825648,
        LOCATION_LATITUDE_DEG: 52.0829837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN013300',
        LOCATION_NAME: 'Inchicore',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3150751,
        LOCATION_LATITUDE_DEG: 53.3414308,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001700',
        LOCATION_NAME: 'Inchigeelagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1768388,
        LOCATION_LATITUDE_DEG: 51.8410274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN002150',
        LOCATION_NAME: 'Inchydoney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.860511,
        LOCATION_LATITUDE_DEG: 51.6011138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN900651',
        LOCATION_NAME: 'Ing',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9712174,
        LOCATION_LATITUDE_DEG: 52.7570046,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006100',
        LOCATION_NAME: 'Inishcarra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6325205,
        LOCATION_LATITUDE_DEG: 51.882963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006300',
        LOCATION_NAME: 'Inistioge',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0597125,
        LOCATION_LATITUDE_DEG: 52.4895072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN001501',
        LOCATION_NAME: 'Inniscarra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN006200',
        LOCATION_NAME: 'Inniscrone',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0898351,
        LOCATION_LATITUDE_DEG: 54.2150906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007400',
        LOCATION_NAME: 'Inniscrone',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0821702,
        LOCATION_LATITUDE_DEG: 54.2174538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007500',
        LOCATION_NAME: 'Innishannon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6483168,
        LOCATION_LATITUDE_DEG: 51.7707566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN007600',
        LOCATION_NAME: 'Inniskeen',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5822731,
        LOCATION_LATITUDE_DEG: 53.999852,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN991039',
        LOCATION_NAME: 'Inniskeen',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5758,
        LOCATION_LATITUDE_DEG: 54.0069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009100',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8659997,
        LOCATION_LATITUDE_DEG: 54.2498961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009200',
        LOCATION_NAME: 'Inver',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.302098,
        LOCATION_LATITUDE_DEG: 54.6529374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN009500',
        LOCATION_NAME: 'Inveran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4642057,
        LOCATION_LATITUDE_DEG: 53.2438027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IN990865',
        LOCATION_NAME: 'Inverin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001000',
        LOCATION_NAME: 'Irishford',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6656957,
        LOCATION_LATITUDE_DEG: 53.7498293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001100',
        LOCATION_NAME: 'Irishtown',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.891939,
        LOCATION_LATITUDE_DEG: 53.6672403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR002700',
        LOCATION_NAME: 'Irishtown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2234166,
        LOCATION_LATITUDE_DEG: 53.3394347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IR001650',
        LOCATION_NAME: 'Ironpool',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9724279,
        LOCATION_LATITUDE_DEG: 53.553105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS004300',
        LOCATION_NAME: 'Islandbridge',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3058934,
        LOCATION_LATITUDE_DEG: 53.3441472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000700',
        LOCATION_NAME: 'Islandeady',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992681,
        LOCATION_LATITUDE_DEG: 53.8165585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'IS000900',
        LOCATION_NAME: 'Islandmore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7120052,
        LOCATION_LATITUDE_DEG: 52.5100041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA002000',
        LOCATION_NAME: 'Jack Whites Cross Roads',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA000100',
        LOCATION_NAME: "Jack White's Cross Roads",
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0961718,
        LOCATION_LATITUDE_DEG: 52.8802981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA900158',
        LOCATION_NAME: 'Jamesbrook',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.186681,
        LOCATION_LATITUDE_DEG: 51.8608107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001400',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.034249,
        LOCATION_LATITUDE_DEG: 53.9329572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001000',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1027803,
        LOCATION_LATITUDE_DEG: 53.1189871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA001300',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.015768,
        LOCATION_LATITUDE_DEG: 52.3664004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JA002200',
        LOCATION_NAME: 'Jamestown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3279502,
        LOCATION_LATITUDE_DEG: 53.3364561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000400',
        LOCATION_NAME: 'Jenkinstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823708,
        LOCATION_LATITUDE_DEG: 52.7164375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000500',
        LOCATION_NAME: 'Jenkinstown Cross',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3058776,
        LOCATION_LATITUDE_DEG: 54.0206701,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000600',
        LOCATION_NAME: 'Jerpoint',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1644403,
        LOCATION_LATITUDE_DEG: 52.5053116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JE000800',
        LOCATION_NAME: 'Jerusalem',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9351011,
        LOCATION_LATITUDE_DEG: 52.8876328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JI990847',
        LOCATION_NAME: 'Jigginstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO002700',
        LOCATION_NAME: 'Jobstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4074262,
        LOCATION_LATITUDE_DEG: 53.2799981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001000',
        LOCATION_NAME: 'Johnstons Bridge',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658145,
        LOCATION_LATITUDE_DEG: 53.8331459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001500',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.088721,
        LOCATION_LATITUDE_DEG: 51.818832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001775',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0274498,
        LOCATION_LATITUDE_DEG: 53.3595372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001400',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5607953,
        LOCATION_LATITUDE_DEG: 52.7494354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001200',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.872594,
        LOCATION_LATITUDE_DEG: 53.4027936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001750',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6516568,
        LOCATION_LATITUDE_DEG: 53.6413196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001100',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6156934,
        LOCATION_LATITUDE_DEG: 53.233078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001300',
        LOCATION_NAME: 'Johnstown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322713,
        LOCATION_LATITUDE_DEG: 52.7830277,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001800',
        LOCATION_NAME: 'Johnstown South',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2356549,
        LOCATION_LATITUDE_DEG: 52.7825738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO001900',
        LOCATION_NAME: 'Johnswell',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657588,
        LOCATION_LATITUDE_DEG: 52.6997268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JO990744',
        LOCATION_NAME: 'Jordanstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'JU000100',
        LOCATION_NAME: 'Julianstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2900104,
        LOCATION_LATITUDE_DEG: 53.673618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KA000500',
        LOCATION_NAME: 'Kanturk',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9207308,
        LOCATION_LATITUDE_DEG: 52.1903893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000150',
        LOCATION_NAME: 'Kead',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6433076,
        LOCATION_LATITUDE_DEG: 53.5293285,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000300',
        LOCATION_NAME: 'Keadew',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491291,
        LOCATION_LATITUDE_DEG: 54.0498719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE990488',
        LOCATION_NAME: 'Keadue',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000600',
        LOCATION_NAME: 'Kealduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7050455,
        LOCATION_LATITUDE_DEG: 52.2731972,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE000700',
        LOCATION_NAME: 'Kealkill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3791784,
        LOCATION_LATITUDE_DEG: 51.7602536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001400',
        LOCATION_NAME: 'Keeas',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493289,
        LOCATION_LATITUDE_DEG: 51.9663789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001500',
        LOCATION_NAME: 'Keekill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0992237,
        LOCATION_LATITUDE_DEG: 53.4165149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001600',
        LOCATION_NAME: 'Keel',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.082437,
        LOCATION_LATITUDE_DEG: 53.9789705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE001650',
        LOCATION_NAME: 'Keel',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7787595,
        LOCATION_LATITUDE_DEG: 52.1606271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002000',
        LOCATION_NAME: 'Keenagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4992549,
        LOCATION_LATITUDE_DEG: 54.0331725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE002100',
        LOCATION_NAME: 'Keenagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.799118,
        LOCATION_LATITUDE_DEG: 53.6165271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006000',
        LOCATION_NAME: 'Kells',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2721162,
        LOCATION_LATITUDE_DEG: 52.5408204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006100',
        LOCATION_NAME: 'Kells',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.876037,
        LOCATION_LATITUDE_DEG: 53.7264726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006500',
        LOCATION_NAME: 'Kellys Grove',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491469,
        LOCATION_LATITUDE_DEG: 53.299797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006600',
        LOCATION_NAME: 'Kellys Quarter',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.732333,
        LOCATION_LATITUDE_DEG: 52.6497227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006700',
        LOCATION_NAME: 'Kellystown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1163834,
        LOCATION_LATITUDE_DEG: 52.9074833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE006900',
        LOCATION_NAME: 'Kellyville',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0801505,
        LOCATION_LATITUDE_DEG: 52.9910865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE011900',
        LOCATION_NAME: 'Kenmare',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5881313,
        LOCATION_LATITUDE_DEG: 51.8820653,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015100',
        LOCATION_NAME: 'Kentstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5323091,
        LOCATION_LATITUDE_DEG: 53.6331481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE015550',
        LOCATION_NAME: 'Keoltown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4186929,
        LOCATION_LATITUDE_DEG: 53.4992823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017100',
        LOCATION_NAME: 'Kerry Pike',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5659777,
        LOCATION_LATITUDE_DEG: 51.9075874,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017200',
        LOCATION_NAME: 'Kerryhead',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9439195,
        LOCATION_LATITUDE_DEG: 52.4185391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE017250',
        LOCATION_NAME: 'Kerrykeel',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6490599,
        LOCATION_LATITUDE_DEG: 55.1332666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018400',
        LOCATION_NAME: 'Kesh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4419566,
        LOCATION_LATITUDE_DEG: 54.0471804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KE018500',
        LOCATION_NAME: 'Keshcarrigan',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9491156,
        LOCATION_LATITUDE_DEG: 54.0165608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990235',
        LOCATION_NAME: 'Kidlawn',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990911',
        LOCATION_NAME: 'Kilanerin',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001400',
        LOCATION_NAME: 'Kilbaha',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8865606,
        LOCATION_LATITUDE_DEG: 52.5696373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001600',
        LOCATION_NAME: 'Kilbane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5632737,
        LOCATION_LATITUDE_DEG: 52.8027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001800',
        LOCATION_NAME: 'Kilbarrack',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1447773,
        LOCATION_LATITUDE_DEG: 53.3911824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI001950',
        LOCATION_NAME: 'Kilbarron',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2289709,
        LOCATION_LATITUDE_DEG: 52.9890028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002000',
        LOCATION_NAME: 'Kilbarry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492573,
        LOCATION_LATITUDE_DEG: 51.8663657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002100',
        LOCATION_NAME: 'Kilbeacanty',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.765907,
        LOCATION_LATITUDE_DEG: 53.0664801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002250',
        LOCATION_NAME: 'Kilbeg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1470731,
        LOCATION_LATITUDE_DEG: 53.4325044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002200',
        LOCATION_NAME: 'Kilbeg',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658406,
        LOCATION_LATITUDE_DEG: 52.0663677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002300',
        LOCATION_NAME: 'Kilbeg Monivea',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6509882,
        LOCATION_LATITUDE_DEG: 53.3951226,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002400',
        LOCATION_NAME: 'Kilbeggan',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4939971,
        LOCATION_LATITUDE_DEG: 53.3737995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002500',
        LOCATION_NAME: 'Kilbeheny',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2095742,
        LOCATION_LATITUDE_DEG: 52.3030078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002600',
        LOCATION_NAME: 'Kilbennan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8824976,
        LOCATION_LATITUDE_DEG: 53.5331235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002700',
        LOCATION_NAME: 'Kilberry',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157457,
        LOCATION_LATITUDE_DEG: 53.0330576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI002800',
        LOCATION_NAME: 'Kilberry',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823043,
        LOCATION_LATITUDE_DEG: 53.6998163,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003050',
        LOCATION_NAME: 'Kilbrannish',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7494794,
        LOCATION_LATITUDE_DEG: 52.6626416,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003100',
        LOCATION_NAME: 'Kilbrickan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6325908,
        LOCATION_LATITUDE_DEG: 53.35231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003200',
        LOCATION_NAME: 'Kilbricken',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4598099,
        LOCATION_LATITUDE_DEG: 52.9580623,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003400',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159096,
        LOCATION_LATITUDE_DEG: 53.9331591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003750',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2104029,
        LOCATION_LATITUDE_DEG: 53.1329083,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003600',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7157363,
        LOCATION_LATITUDE_DEG: 52.716428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003700',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4656758,
        LOCATION_LATITUDE_DEG: 53.1997725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003300',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.398974,
        LOCATION_LATITUDE_DEG: 53.4497933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003500',
        LOCATION_NAME: 'Kilbride',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0989471,
        LOCATION_LATITUDE_DEG: 52.9164407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003800',
        LOCATION_NAME: 'Kilbrien',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.649131,
        LOCATION_LATITUDE_DEG: 52.1829777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI003900',
        LOCATION_NAME: 'Kilbrin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325236,
        LOCATION_LATITUDE_DEG: 52.1996889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004000',
        LOCATION_NAME: 'Kilbrittain',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6825302,
        LOCATION_LATITUDE_DEG: 51.6663403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004500',
        LOCATION_NAME: 'Kilcaimin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.940917,
        LOCATION_LATITUDE_DEG: 53.239797,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004600',
        LOCATION_NAME: 'Kilcar',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.599154,
        LOCATION_LATITUDE_DEG: 54.6332321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004700',
        LOCATION_NAME: 'Kilcarn',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6657063,
        LOCATION_LATITUDE_DEG: 53.6165127,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004800',
        LOCATION_NAME: 'Kilcash',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5324082,
        LOCATION_LATITUDE_DEG: 52.399702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI004900',
        LOCATION_NAME: 'Kilcavan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3616638,
        LOCATION_LATITUDE_DEG: 53.1943668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005300',
        LOCATION_NAME: 'Kilchreest',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491802,
        LOCATION_LATITUDE_DEG: 53.1830851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005500',
        LOCATION_NAME: 'Kilclare',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0143717,
        LOCATION_LATITUDE_DEG: 54.0030555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005700',
        LOCATION_NAME: 'Kilcloher',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8158152,
        LOCATION_LATITUDE_DEG: 52.5689405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005800',
        LOCATION_NAME: 'Kilclonfert',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490658,
        LOCATION_LATITUDE_DEG: 53.3330915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990277',
        LOCATION_NAME: 'Kilcloon',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5725718,
        LOCATION_LATITUDE_DEG: -0.2042799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI005900',
        LOCATION_NAME: 'Kilclooney',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324504,
        LOCATION_LATITUDE_DEG: 54.8166439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006000',
        LOCATION_NAME: 'Kilcock',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6666373,
        LOCATION_LATITUDE_DEG: 53.3995295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006100',
        LOCATION_NAME: 'Kilcoe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4098025,
        LOCATION_LATITUDE_DEG: 51.5638381,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006200',
        LOCATION_NAME: 'Kilcogy',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157756,
        LOCATION_LATITUDE_DEG: 53.8331453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006300',
        LOCATION_NAME: 'Kilcolgan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8679987,
        LOCATION_LATITUDE_DEG: 53.2147904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006400',
        LOCATION_NAME: 'Kilcolman',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0825529,
        LOCATION_LATITUDE_DEG: 52.5330314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006550',
        LOCATION_NAME: 'Kilcolman',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8974495,
        LOCATION_LATITUDE_DEG: 51.7207111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006500',
        LOCATION_NAME: 'Kilcolman',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1476149,
        LOCATION_LATITUDE_DEG: 52.6920501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006600',
        LOCATION_NAME: 'Kilcolumb',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823353,
        LOCATION_LATITUDE_DEG: 53.5165081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006700',
        LOCATION_NAME: 'Kilcomin',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658245,
        LOCATION_LATITUDE_DEG: 52.9664599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990175',
        LOCATION_NAME: 'Kilcommon',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9370199,
        LOCATION_LATITUDE_DEG: 52.3509087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990622',
        LOCATION_NAME: 'Kilconlea Lower',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990623',
        LOCATION_NAME: 'Kilconlea Upper',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006750',
        LOCATION_NAME: 'Kilconly',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9819652,
        LOCATION_LATITUDE_DEG: 53.572069,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006800',
        LOCATION_NAME: 'Kilconnell',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4250451,
        LOCATION_LATITUDE_DEG: 53.3303016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI006900',
        LOCATION_NAME: 'Kilconny',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4657624,
        LOCATION_LATITUDE_DEG: 54.0998705,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007200',
        LOCATION_NAME: 'Kilcoole',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0656489,
        LOCATION_LATITUDE_DEG: 53.099756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007300',
        LOCATION_NAME: 'Kilcooly',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7326154,
        LOCATION_LATITUDE_DEG: 52.3830107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007400',
        LOCATION_NAME: 'Kilcormac',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7343708,
        LOCATION_LATITUDE_DEG: 53.1790819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007500',
        LOCATION_NAME: 'Kilcornan',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825266,
        LOCATION_LATITUDE_DEG: 52.6164393,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007600',
        LOCATION_NAME: 'Kilcorney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492429,
        LOCATION_LATITUDE_DEG: 52.0496841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007800',
        LOCATION_NAME: 'Kilcotty',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.465702,
        LOCATION_LATITUDE_DEG: 52.4830016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI007900',
        LOCATION_NAME: 'Kilcrea',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159214,
        LOCATION_LATITUDE_DEG: 51.8496596,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008000',
        LOCATION_NAME: 'Kilcredan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824574,
        LOCATION_LATITUDE_DEG: 51.8829633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008050',
        LOCATION_NAME: 'Kilcreen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5157747,
        LOCATION_LATITUDE_DEG: 52.4425135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008075',
        LOCATION_NAME: 'Kilcreevanty',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8919863,
        LOCATION_LATITUDE_DEG: 53.5626366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008200',
        LOCATION_NAME: 'Kilcroghery',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8157871,
        LOCATION_LATITUDE_DEG: 54.7666314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008300',
        LOCATION_NAME: 'Kilcrohane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7043127,
        LOCATION_LATITUDE_DEG: 51.5770399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008325',
        LOCATION_NAME: 'Kilcroney',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1404122,
        LOCATION_LATITUDE_DEG: 53.1880943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008350',
        LOCATION_NAME: 'Kilcross',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0447177,
        LOCATION_LATITUDE_DEG: 52.4979881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008400',
        LOCATION_NAME: 'Kilcullen',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7560692,
        LOCATION_LATITUDE_DEG: 53.1252681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008500',
        LOCATION_NAME: 'Kilcully',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658929,
        LOCATION_LATITUDE_DEG: 51.9329645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008800',
        LOCATION_NAME: 'Kilcummin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.099364,
        LOCATION_LATITUDE_DEG: 52.2329994,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008600',
        LOCATION_NAME: 'Kilcummin',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.232537,
        LOCATION_LATITUDE_DEG: 54.2665992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI008900',
        LOCATION_NAME: 'Kilcurly',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4581303,
        LOCATION_LATITUDE_DEG: 54.0111336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009000',
        LOCATION_NAME: 'Kilcurry',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4243719,
        LOCATION_LATITUDE_DEG: 54.0460499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009200',
        LOCATION_NAME: 'Kildalkey',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990103,
        LOCATION_LATITUDE_DEG: 53.5665111,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009300',
        LOCATION_NAME: 'Kildangan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9984307,
        LOCATION_LATITUDE_DEG: 53.1091605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009400',
        LOCATION_NAME: 'Kildare',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9387271,
        LOCATION_LATITUDE_DEG: 53.1609662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009600',
        LOCATION_NAME: 'Kildavin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6898946,
        LOCATION_LATITUDE_DEG: 52.6865266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI009800',
        LOCATION_NAME: 'Kildimo',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325562,
        LOCATION_LATITUDE_DEG: 52.6164001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991122',
        LOCATION_NAME: 'Kildinan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3633,
        LOCATION_LATITUDE_DEG: 52.0672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010100',
        LOCATION_NAME: 'Kildoney',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2582356,
        LOCATION_LATITUDE_DEG: 54.5185153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010200',
        LOCATION_NAME: 'Kildoon',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990395,
        LOCATION_LATITUDE_DEG: 53.0830646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010300',
        LOCATION_NAME: 'Kildorough',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157515,
        LOCATION_LATITUDE_DEG: 53.8498356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010400',
        LOCATION_NAME: 'Kildorrery',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4448189,
        LOCATION_LATITUDE_DEG: 52.2505941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010600',
        LOCATION_NAME: 'Kildrum',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157353,
        LOCATION_LATITUDE_DEG: 54.9666594,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010750',
        LOCATION_NAME: 'Kilduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5058069,
        LOCATION_LATITUDE_DEG: 52.3054781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI010850',
        LOCATION_NAME: 'Kildysart',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1095501,
        LOCATION_LATITUDE_DEG: 52.6750839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015600',
        LOCATION_NAME: 'Kildysart',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1028793,
        LOCATION_LATITUDE_DEG: 52.6664406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011000',
        LOCATION_NAME: 'Kilfane',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.115759,
        LOCATION_LATITUDE_DEG: 52.549715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011050',
        LOCATION_NAME: 'Kilfaul',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2859134,
        LOCATION_LATITUDE_DEG: 53.7216265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011100',
        LOCATION_NAME: 'Kilfeakle',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0613783,
        LOCATION_LATITUDE_DEG: 52.4886828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011200',
        LOCATION_NAME: 'Kilfearagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6492895,
        LOCATION_LATITUDE_DEG: 52.6497433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011400',
        LOCATION_NAME: 'Kilfenora',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326359,
        LOCATION_LATITUDE_DEG: 52.2830109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011300',
        LOCATION_NAME: 'Kilfenora',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159564,
        LOCATION_LATITUDE_DEG: 52.9830689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011700',
        LOCATION_NAME: 'Kilfinnane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658794,
        LOCATION_LATITUDE_DEG: 52.366406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011600',
        LOCATION_NAME: 'Kilfinnane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658592,
        LOCATION_LATITUDE_DEG: 52.3497102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011800',
        LOCATION_NAME: 'Kilfinny',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992158,
        LOCATION_LATITUDE_DEG: 52.5164242,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI011900',
        LOCATION_NAME: 'Kilflynn',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6325972,
        LOCATION_LATITUDE_DEG: 52.3497179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012000',
        LOCATION_NAME: 'Kilgarriff',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.615875,
        LOCATION_LATITUDE_DEG: 53.9665663,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012250',
        LOCATION_NAME: 'Kilgarvan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5194077,
        LOCATION_LATITUDE_DEG: 52.5079647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012200',
        LOCATION_NAME: 'Kilgarvan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.430594,
        LOCATION_LATITUDE_DEG: 51.9101693,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012100',
        LOCATION_NAME: 'Kilgarvan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159087,
        LOCATION_LATITUDE_DEG: 54.0998776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990233',
        LOCATION_NAME: 'Kilgass',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3477183,
        LOCATION_LATITUDE_DEG: -9.1095537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012500',
        LOCATION_NAME: 'Kilglass',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659152,
        LOCATION_LATITUDE_DEG: 54.2331987,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012600',
        LOCATION_NAME: 'Kilglass',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491589,
        LOCATION_LATITUDE_DEG: 53.4165035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012700',
        LOCATION_NAME: 'Kilglass',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0294877,
        LOCATION_LATITUDE_DEG: 53.7963694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990266',
        LOCATION_NAME: 'Kilglass',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012800',
        LOCATION_NAME: 'Kilgobnet',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7160227,
        LOCATION_LATITUDE_DEG: 52.0663889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI012900',
        LOCATION_NAME: 'Kilgolagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3990553,
        LOCATION_LATITUDE_DEG: 53.7831346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013000',
        LOCATION_NAME: 'Kilgowan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7665229,
        LOCATION_LATITUDE_DEG: 53.0603189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013100',
        LOCATION_NAME: 'Kilgraney',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7036908,
        LOCATION_LATITUDE_DEG: 52.7139739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013150',
        LOCATION_NAME: 'Kilgriffith',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1948976,
        LOCATION_LATITUDE_DEG: 52.8147547,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013400',
        LOCATION_NAME: 'Kilkea',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8947841,
        LOCATION_LATITUDE_DEG: 52.9476027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990788',
        LOCATION_NAME: 'Kilkeary',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013500',
        LOCATION_NAME: 'Kilkeasy',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157781,
        LOCATION_LATITUDE_DEG: 52.4330106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013600',
        LOCATION_NAME: 'Kilkee',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6504824,
        LOCATION_LATITUDE_DEG: 52.6813439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013650',
        LOCATION_NAME: 'Kilkeedy',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9590448,
        LOCATION_LATITUDE_DEG: 52.9857675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013700',
        LOCATION_NAME: 'Kilkeehagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.01605,
        LOCATION_LATITUDE_DEG: 52.0329876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013850',
        LOCATION_NAME: 'Kilkeeran',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2664793,
        LOCATION_LATITUDE_DEG: 53.7018892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI013900',
        LOCATION_NAME: 'Kilkelly',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492017,
        LOCATION_LATITUDE_DEG: 53.8665606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014100',
        LOCATION_NAME: 'Kilkenny',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2511747,
        LOCATION_LATITUDE_DEG: 52.6571258,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014150',
        LOCATION_NAME: 'Kilkenny West',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8212094,
        LOCATION_LATITUDE_DEG: 53.488849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014300',
        LOCATION_NAME: 'Kilkerin',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992622,
        LOCATION_LATITUDE_DEG: 52.5997351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990973',
        LOCATION_NAME: 'Kilkerley',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014450',
        LOCATION_NAME: 'Kilkerrin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5671034,
        LOCATION_LATITUDE_DEG: 53.5544345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014600',
        LOCATION_NAME: 'Kilkieran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7339822,
        LOCATION_LATITUDE_DEG: 53.3339085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014700',
        LOCATION_NAME: 'Kilkinlea',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3339217,
        LOCATION_LATITUDE_DEG: 52.3593138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014800',
        LOCATION_NAME: 'Kilkinnikin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032662,
        LOCATION_LATITUDE_DEG: 51.5996444,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI014900',
        LOCATION_NAME: 'Kilkishen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7522398,
        LOCATION_LATITUDE_DEG: 52.8116515,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015000',
        LOCATION_NAME: 'Kilkotton',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.549097,
        LOCATION_LATITUDE_DEG: 52.9164578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015300',
        LOCATION_NAME: 'Kill',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323871,
        LOCATION_LATITUDE_DEG: 52.1829819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015200',
        LOCATION_NAME: 'Kill',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157355,
        LOCATION_LATITUDE_DEG: 54.0331597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015100',
        LOCATION_NAME: 'Kill',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6112205,
        LOCATION_LATITUDE_DEG: 53.2462718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015400',
        LOCATION_NAME: 'Kill Of The Grange',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1531204,
        LOCATION_LATITUDE_DEG: 53.2789485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015500',
        LOCATION_NAME: 'Killadoon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993084,
        LOCATION_LATITUDE_DEG: 53.6998414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015550',
        LOCATION_NAME: 'Killag',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5864092,
        LOCATION_LATITUDE_DEG: 52.2061054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015700',
        LOCATION_NAME: 'Killagoola',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825443,
        LOCATION_LATITUDE_DEG: 53.3165118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015800',
        LOCATION_NAME: 'Killahy',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.215782,
        LOCATION_LATITUDE_DEG: 52.3996988,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI015900',
        LOCATION_NAME: 'Killakee',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3267893,
        LOCATION_LATITUDE_DEG: 53.2423795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016000',
        LOCATION_NAME: 'Killala',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2196763,
        LOCATION_LATITUDE_DEG: 54.2137931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016100',
        LOCATION_NAME: 'Killaloe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4484508,
        LOCATION_LATITUDE_DEG: 52.8106423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016400',
        LOCATION_NAME: 'Killamery',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4491022,
        LOCATION_LATITUDE_DEG: 52.4664048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016500',
        LOCATION_NAME: 'Killan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.065742,
        LOCATION_LATITUDE_DEG: 53.333087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016550',
        LOCATION_NAME: 'Killanena',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7104321,
        LOCATION_LATITUDE_DEG: 52.994649,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016600',
        LOCATION_NAME: 'Killann',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323319,
        LOCATION_LATITUDE_DEG: 52.5164039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990985',
        LOCATION_NAME: 'Killanny',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016650',
        LOCATION_NAME: 'Killanure',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7246112,
        LOCATION_LATITUDE_DEG: 52.6376851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016800',
        LOCATION_NAME: 'Killare',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5716589,
        LOCATION_LATITUDE_DEG: 53.4862064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI016900',
        LOCATION_NAME: 'Killarga',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.215835,
        LOCATION_LATITUDE_DEG: 54.2331893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990487',
        LOCATION_NAME: 'killargue',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017000',
        LOCATION_NAME: 'Killarney',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5137389,
        LOCATION_LATITUDE_DEG: 52.0633869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017200',
        LOCATION_NAME: 'Killashee',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8876027,
        LOCATION_LATITUDE_DEG: 53.6827254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017300',
        LOCATION_NAME: 'Killasona',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823764,
        LOCATION_LATITUDE_DEG: 53.7331288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017400',
        LOCATION_NAME: 'Killasser',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659162,
        LOCATION_LATITUDE_DEG: 53.9831677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017450',
        LOCATION_NAME: 'Killateeaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4412883,
        LOCATION_LATITUDE_DEG: 53.6117295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017500',
        LOCATION_NAME: 'Killavackan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491408,
        LOCATION_LATITUDE_DEG: 53.7165346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017600',
        LOCATION_NAME: 'Killavally',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659448,
        LOCATION_LATITUDE_DEG: 53.7498429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017700',
        LOCATION_NAME: 'Killavullen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158954,
        LOCATION_LATITUDE_DEG: 52.1496897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018000',
        LOCATION_NAME: 'Killea',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8725861,
        LOCATION_LATITUDE_DEG: 52.8260572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018025',
        LOCATION_NAME: 'Killea',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4081483,
        LOCATION_LATITUDE_DEG: 54.9794374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017900',
        LOCATION_NAME: 'Killea',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.999073,
        LOCATION_LATITUDE_DEG: 52.1663743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018050',
        LOCATION_NAME: 'Killeady',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.623507,
        LOCATION_LATITUDE_DEG: 51.8046131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018100',
        LOCATION_NAME: 'Killeagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0017222,
        LOCATION_LATITUDE_DEG: 51.9396659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018200',
        LOCATION_NAME: 'Killeany',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6660051,
        LOCATION_LATITUDE_DEG: 53.0997828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018250',
        LOCATION_NAME: 'Killeard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018500',
        LOCATION_NAME: 'Killedmond',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323384,
        LOCATION_LATITUDE_DEG: 52.5997184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018600',
        LOCATION_NAME: 'Killeedy',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659526,
        LOCATION_LATITUDE_DEG: 52.3830126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018700',
        LOCATION_NAME: 'Killeelaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825021,
        LOCATION_LATITUDE_DEG: 53.4998273,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018850',
        LOCATION_NAME: 'Killeen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2590306,
        LOCATION_LATITUDE_DEG: 53.0944289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI018900',
        LOCATION_NAME: 'Killeenaran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325307,
        LOCATION_LATITUDE_DEG: 53.1997931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019000',
        LOCATION_NAME: 'Killeenleagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992886,
        LOCATION_LATITUDE_DEG: 51.6329388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019100',
        LOCATION_NAME: 'Killeevan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657374,
        LOCATION_LATITUDE_DEG: 54.1665749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019200',
        LOCATION_NAME: 'Killeglan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824281,
        LOCATION_LATITUDE_DEG: 53.4165054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019300',
        LOCATION_NAME: 'Killeigh',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4467601,
        LOCATION_LATITUDE_DEG: 53.216582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019400',
        LOCATION_NAME: 'Killelton',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8660232,
        LOCATION_LATITUDE_DEG: 52.2330091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019450',
        LOCATION_NAME: 'Killelton',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5139368,
        LOCATION_LATITUDE_DEG: 52.5702402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019700',
        LOCATION_NAME: 'Killena',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.265637,
        LOCATION_LATITUDE_DEG: 52.5830439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019800',
        LOCATION_NAME: 'Killenagh',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822808,
        LOCATION_LATITUDE_DEG: 52.583009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019850',
        LOCATION_NAME: 'Killenard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1462605,
        LOCATION_LATITUDE_DEG: 53.1376492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI019900',
        LOCATION_NAME: 'Killenaule',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6658098,
        LOCATION_LATITUDE_DEG: 52.5664178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020000',
        LOCATION_NAME: 'Killenny',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.632272,
        LOCATION_LATITUDE_DEG: 53.949847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991103',
        LOCATION_NAME: 'Killermogh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.46,
        LOCATION_LATITUDE_DEG: 52.872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020200',
        LOCATION_NAME: 'Killeroran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.315855,
        LOCATION_LATITUDE_DEG: 53.5165183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020300',
        LOCATION_NAME: 'Killerrig',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7968886,
        LOCATION_LATITUDE_DEG: 52.8376583,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI017100',
        LOCATION_NAME: 'Killeshandra',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5295545,
        LOCATION_LATITUDE_DEG: 54.0161569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI020600',
        LOCATION_NAME: 'Killeshin',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990513,
        LOCATION_LATITUDE_DEG: 52.8330413,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990500',
        LOCATION_NAME: 'Killester',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5738645,
        LOCATION_LATITUDE_DEG: 53.4859254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021300',
        LOCATION_NAME: 'Killimer',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3915653,
        LOCATION_LATITUDE_DEG: 52.6166414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021400',
        LOCATION_NAME: 'Killimor',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2906777,
        LOCATION_LATITUDE_DEG: 53.166388,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021450',
        LOCATION_NAME: 'Killimy',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.219542,
        LOCATION_LATITUDE_DEG: 53.0964058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990176',
        LOCATION_NAME: 'Killinan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8717105,
        LOCATION_LATITUDE_DEG: 52.7595661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021700',
        LOCATION_NAME: 'Killinardrish',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492522,
        LOCATION_LATITUDE_DEG: 51.8996647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021900',
        LOCATION_NAME: 'Killinerin',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2905462,
        LOCATION_LATITUDE_DEG: 52.7309237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022100',
        LOCATION_NAME: 'Killiney',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.03265,
        LOCATION_LATITUDE_DEG: 52.249703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022000',
        LOCATION_NAME: 'Killiney',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1134474,
        LOCATION_LATITUDE_DEG: 53.2695751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022600',
        LOCATION_NAME: 'Killinick',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4546846,
        LOCATION_LATITUDE_DEG: 52.2603816,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022700',
        LOCATION_NAME: 'Killinkere',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490367,
        LOCATION_LATITUDE_DEG: 53.8831464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022800',
        LOCATION_NAME: 'Killinny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159298,
        LOCATION_LATITUDE_DEG: 53.099785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022813',
        LOCATION_NAME: 'Killinure',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.100595,
        LOCATION_LATITUDE_DEG: 53.1324641,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022825',
        LOCATION_NAME: 'Killinure North',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9031443,
        LOCATION_LATITUDE_DEG: 53.4799095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI022850',
        LOCATION_NAME: 'Killinure South',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8947769,
        LOCATION_LATITUDE_DEG: 53.4748768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023000',
        LOCATION_NAME: 'Killiskey',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1156561,
        LOCATION_LATITUDE_DEG: 53.0330524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023200',
        LOCATION_NAME: 'Killmacomma',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158402,
        LOCATION_LATITUDE_DEG: 52.3163966,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023300',
        LOCATION_NAME: 'Killmainham',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3103712,
        LOCATION_LATITUDE_DEG: 53.338767,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023400',
        LOCATION_NAME: 'Killnaleck',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.325609,
        LOCATION_LATITUDE_DEG: 53.8607122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023500',
        LOCATION_NAME: 'Killoe',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6958848,
        LOCATION_LATITUDE_DEG: 53.7510563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023600',
        LOCATION_NAME: 'Killonan',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5243137,
        LOCATION_LATITUDE_DEG: 52.6404288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023700',
        LOCATION_NAME: 'Killoran',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3587463,
        LOCATION_LATITUDE_DEG: 53.2476469,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023800',
        LOCATION_NAME: 'Killorglin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7916352,
        LOCATION_LATITUDE_DEG: 52.1097893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI023900',
        LOCATION_NAME: 'Killoscobe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658818,
        LOCATION_LATITUDE_DEG: 53.4498146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024000',
        LOCATION_NAME: 'Killoscully',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324672,
        LOCATION_LATITUDE_DEG: 52.7664462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024150',
        LOCATION_NAME: 'Killoughter',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.083983,
        LOCATION_LATITUDE_DEG: 53.0282801,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024300',
        LOCATION_NAME: 'Killower',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492183,
        LOCATION_LATITUDE_DEG: 53.5165162,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024400',
        LOCATION_NAME: 'Killsheelan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5979733,
        LOCATION_LATITUDE_DEG: 52.359355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039900',
        LOCATION_NAME: 'Killtoom',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323661,
        LOCATION_LATITUDE_DEG: 53.6665238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024500',
        LOCATION_NAME: 'Killucan',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1213368,
        LOCATION_LATITUDE_DEG: 53.5201045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024600',
        LOCATION_NAME: 'Killumney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492118,
        LOCATION_LATITUDE_DEG: 51.8663545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024700',
        LOCATION_NAME: 'Killurin',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823154,
        LOCATION_LATITUDE_DEG: 52.3829965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024800',
        LOCATION_NAME: 'Killurney',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5991218,
        LOCATION_LATITUDE_DEG: 52.3997112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024850',
        LOCATION_NAME: 'Killurriga',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0972187,
        LOCATION_LATITUDE_DEG: 51.8971754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI024900',
        LOCATION_NAME: 'Killusty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6327749,
        LOCATION_LATITUDE_DEG: 52.4504559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990936',
        LOCATION_NAME: 'Killvallig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025000',
        LOCATION_NAME: 'Killybegs',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4491566,
        LOCATION_LATITUDE_DEG: 54.6332677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990966',
        LOCATION_NAME: 'Killydonoghoe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025400',
        LOCATION_NAME: 'Killygar',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6142524,
        LOCATION_LATITUDE_DEG: 54.0127683,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025500',
        LOCATION_NAME: 'Killygordon',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823755,
        LOCATION_LATITUDE_DEG: 54.799937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025550',
        LOCATION_NAME: 'Killygowan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5537922,
        LOCATION_LATITUDE_DEG: 54.0320227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI025900',
        LOCATION_NAME: 'Killyon',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991279,
        LOCATION_LATITUDE_DEG: 53.0997802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026000',
        LOCATION_NAME: 'Kilmacanogue',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.137134,
        LOCATION_LATITUDE_DEG: 53.1676063,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026100',
        LOCATION_NAME: 'Kilmacar',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2657774,
        LOCATION_LATITUDE_DEG: 52.766439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026400',
        LOCATION_NAME: 'Kilmacoo',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1974311,
        LOCATION_LATITUDE_DEG: 52.8936439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026500',
        LOCATION_NAME: 'Kilmacow',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657618,
        LOCATION_LATITUDE_DEG: 52.2996909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026600',
        LOCATION_NAME: 'Kilmacrenan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7898346,
        LOCATION_LATITUDE_DEG: 55.0391561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026700',
        LOCATION_NAME: 'Kilmacthomas',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4141879,
        LOCATION_LATITUDE_DEG: 52.2132803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026750',
        LOCATION_NAME: 'Kilmacud',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2185381,
        LOCATION_LATITUDE_DEG: 53.288704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI026800',
        LOCATION_NAME: 'Kilmaganny',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157818,
        LOCATION_LATITUDE_DEG: 52.4497067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027000',
        LOCATION_NAME: 'Kilmaine',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1220014,
        LOCATION_LATITUDE_DEG: 53.5848287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027100',
        LOCATION_NAME: 'Kilmainham',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3066263,
        LOCATION_LATITUDE_DEG: 53.340387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027200',
        LOCATION_NAME: 'Kilmainhamwood',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990104,
        LOCATION_LATITUDE_DEG: 53.8331361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027300',
        LOCATION_NAME: 'Kilmaley',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159576,
        LOCATION_LATITUDE_DEG: 52.81646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027400',
        LOCATION_NAME: 'Kilmalkedar',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.332684,
        LOCATION_LATITUDE_DEG: 52.1830003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027500',
        LOCATION_NAME: 'Kilmallock',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5782837,
        LOCATION_LATITUDE_DEG: 52.4011103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027700',
        LOCATION_NAME: 'Kilmanagh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157969,
        LOCATION_LATITUDE_DEG: 52.6164265,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI027800',
        LOCATION_NAME: 'Kilmanahan',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.779109,
        LOCATION_LATITUDE_DEG: 52.3222209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028000',
        LOCATION_NAME: 'Kilmaran',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0822543,
        LOCATION_LATITUDE_DEG: 53.0497602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082100',
        LOCATION_NAME: 'Kilmashogue',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2803964,
        LOCATION_LATITUDE_DEG: 53.2704005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028300',
        LOCATION_NAME: 'Kilmastulla',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991754,
        LOCATION_LATITUDE_DEG: 52.7664453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990782',
        LOCATION_NAME: 'Kilmead',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990797',
        LOCATION_NAME: 'Kilmead',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028500',
        LOCATION_NAME: 'Kilmead',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9106765,
        LOCATION_LATITUDE_DEG: 53.0364893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028600',
        LOCATION_NAME: 'Kilmeadan',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490982,
        LOCATION_LATITUDE_DEG: 52.2496882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028700',
        LOCATION_NAME: 'Kilmeage',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323287,
        LOCATION_LATITUDE_DEG: 53.2497781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028800',
        LOCATION_NAME: 'Kilmeague',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8416521,
        LOCATION_LATITUDE_DEG: 53.2507578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI028900',
        LOCATION_NAME: 'Kilmeedy',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9159264,
        LOCATION_LATITUDE_DEG: 52.4164132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029000',
        LOCATION_NAME: 'Kilmeena',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659848,
        LOCATION_LATITUDE_DEG: 53.8331563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029300',
        LOCATION_NAME: 'Kilmessan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.648998,
        LOCATION_LATITUDE_DEG: 53.5498135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029500',
        LOCATION_NAME: 'Kilmichael',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0438686,
        LOCATION_LATITUDE_DEG: 51.8324045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI029700',
        LOCATION_NAME: 'Kilmihil',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159566,
        LOCATION_LATITUDE_DEG: 52.7164472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030100',
        LOCATION_NAME: 'Kilmoon',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4624957,
        LOCATION_LATITUDE_DEG: 53.5668741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030700',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5917654,
        LOCATION_LATITUDE_DEG: 52.7563237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030400',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0143401,
        LOCATION_LATITUDE_DEG: 53.8862375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030800',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5367984,
        LOCATION_LATITUDE_DEG: 52.2010622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI030300',
        LOCATION_NAME: 'Kilmore',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2270111,
        LOCATION_LATITUDE_DEG: 53.3961845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031000',
        LOCATION_NAME: 'Kilmore Quay',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5861344,
        LOCATION_LATITUDE_DEG: 52.1788773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031100',
        LOCATION_NAME: 'Kilmorna',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659875,
        LOCATION_LATITUDE_DEG: 52.4330229,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031200',
        LOCATION_NAME: 'Kilmorony',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823424,
        LOCATION_LATITUDE_DEG: 52.9497513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031500',
        LOCATION_NAME: 'Kilmovee',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6824835,
        LOCATION_LATITUDE_DEG: 53.883154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031600',
        LOCATION_NAME: 'Kilmoyly',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7758461,
        LOCATION_LATITUDE_DEG: 52.3630243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031700',
        LOCATION_NAME: 'Kilmuckridge',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822757,
        LOCATION_LATITUDE_DEG: 52.4997017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI031950',
        LOCATION_NAME: 'Kilmullen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1245195,
        LOCATION_LATITUDE_DEG: 53.1434674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032300',
        LOCATION_NAME: 'Kilmurry',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.120963,
        LOCATION_LATITUDE_DEG: 52.119692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032500',
        LOCATION_NAME: 'Kilmurry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825363,
        LOCATION_LATITUDE_DEG: 51.8329584,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032400',
        LOCATION_NAME: 'Kilmurry',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7775085,
        LOCATION_LATITUDE_DEG: 52.7830826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032100',
        LOCATION_NAME: 'Kilmurry',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3870398,
        LOCATION_LATITUDE_DEG: 53.768969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032200',
        LOCATION_NAME: 'Kilmurry Machmahon',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4492731,
        LOCATION_LATITUDE_DEG: 52.799763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032600',
        LOCATION_NAME: 'Kilmurry McMahon',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825644,
        LOCATION_LATITUDE_DEG: 52.6497387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032700',
        LOCATION_NAME: 'Kilmurvy',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7660107,
        LOCATION_LATITUDE_DEG: 53.1330915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI032800',
        LOCATION_NAME: 'Kilmyshall',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6568156,
        LOCATION_LATITUDE_DEG: 52.6240243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI021600',
        LOCATION_NAME: 'Kilnaboy',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0825421,
        LOCATION_LATITUDE_DEG: 52.9664739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990801',
        LOCATION_NAME: 'Kilnadeema',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990922',
        LOCATION_NAME: 'Kilnagnady',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033200',
        LOCATION_NAME: 'Kilnalag',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991828,
        LOCATION_LATITUDE_DEG: 53.6831296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033300',
        LOCATION_NAME: 'Kilnaleck',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3239328,
        LOCATION_LATITUDE_DEG: 53.8725419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081700',
        LOCATION_NAME: 'Kilnamanagh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3803156,
        LOCATION_LATITUDE_DEG: 53.3374299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033400',
        LOCATION_NAME: 'Kilnamartyra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0162385,
        LOCATION_LATITUDE_DEG: 51.895563,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033500',
        LOCATION_NAME: 'Kilnamona',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0835669,
        LOCATION_LATITUDE_DEG: 52.8747514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI033600',
        LOCATION_NAME: 'Kilnarovanagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6326133,
        LOCATION_LATITUDE_DEG: 52.1163871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034500',
        LOCATION_NAME: 'Kilpatrick',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159215,
        LOCATION_LATITUDE_DEG: 51.7663561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034600',
        LOCATION_NAME: 'Kilpeacon',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491975,
        LOCATION_LATITUDE_DEG: 52.5830355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034750',
        LOCATION_NAME: 'Kilpedder',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1057505,
        LOCATION_LATITUDE_DEG: 53.1002036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034850',
        LOCATION_NAME: 'Kilphrasoga',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.859523,
        LOCATION_LATITUDE_DEG: 53.575538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI034900',
        LOCATION_NAME: 'Kilpierce',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4898307,
        LOCATION_LATITUDE_DEG: 52.4980403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035025',
        LOCATION_NAME: 'Kilpoole',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0308105,
        LOCATION_LATITUDE_DEG: 52.9390175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035050',
        LOCATION_NAME: 'Kilquade',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0881827,
        LOCATION_LATITUDE_DEG: 53.1012591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035100',
        LOCATION_NAME: 'Kilquane',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6047512,
        LOCATION_LATITUDE_DEG: 52.6906057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035300',
        LOCATION_NAME: 'Kilquiggin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.579552,
        LOCATION_LATITUDE_DEG: 52.78499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035400',
        LOCATION_NAME: 'Kilquiggin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5657073,
        LOCATION_LATITUDE_DEG: 52.7830321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035500',
        LOCATION_NAME: 'Kilrane',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489938,
        LOCATION_LATITUDE_DEG: 52.2496809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI035800',
        LOCATION_NAME: 'Kilreekil',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4554679,
        LOCATION_LATITUDE_DEG: 53.2359876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036000',
        LOCATION_NAME: 'Kilronan',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6751507,
        LOCATION_LATITUDE_DEG: 53.1128896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990602',
        LOCATION_NAME: 'Kilronan Castle',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036100',
        LOCATION_NAME: 'Kilronane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0806606,
        LOCATION_LATITUDE_DEG: 51.7082645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036200',
        LOCATION_NAME: 'Kilroosky',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1050723,
        LOCATION_LATITUDE_DEG: 53.6795059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036400',
        LOCATION_NAME: 'Kilross',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2933076,
        LOCATION_LATITUDE_DEG: 52.4389213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036500',
        LOCATION_NAME: 'Kilross',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7486038,
        LOCATION_LATITUDE_DEG: 54.8341873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI991021',
        LOCATION_NAME: 'Kilruane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1469,
        LOCATION_LATITUDE_DEG: 52.8978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036700',
        LOCATION_NAME: 'Kilrush',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4874694,
        LOCATION_LATITUDE_DEG: 52.6460441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI036600',
        LOCATION_NAME: 'Kilrush',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5764335,
        LOCATION_LATITUDE_DEG: 52.6419835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037000',
        LOCATION_NAME: 'Kilsallagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7438507,
        LOCATION_LATITUDE_DEG: 53.7747033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037100',
        LOCATION_NAME: 'Kilsallaghan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3215894,
        LOCATION_LATITUDE_DEG: 53.4734508,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037200',
        LOCATION_NAME: 'Kilsaran',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3822667,
        LOCATION_LATITUDE_DEG: 53.8831405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037300',
        LOCATION_NAME: 'Kilsarn',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3516101,
        LOCATION_LATITUDE_DEG: 53.8847256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037500',
        LOCATION_NAME: 'Kilseily',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6491973,
        LOCATION_LATITUDE_DEG: 52.7997513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037600',
        LOCATION_NAME: 'Kilshanchoe',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.88232,
        LOCATION_LATITUDE_DEG: 53.3830923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037700',
        LOCATION_NAME: 'Kilshane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1151293,
        LOCATION_LATITUDE_DEG: 52.4603883,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084200',
        LOCATION_NAME: 'Kilshane',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3182128,
        LOCATION_LATITUDE_DEG: 53.387121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037800',
        LOCATION_NAME: 'Kilshannig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.016047,
        LOCATION_LATITUDE_DEG: 52.3164148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI037900',
        LOCATION_NAME: 'Kilsheelan',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5794112,
        LOCATION_LATITUDE_DEG: 52.3671041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038000',
        LOCATION_NAME: 'Kilskeer',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823296,
        LOCATION_LATITUDE_DEG: 53.6831224,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038300',
        LOCATION_NAME: 'Kiltale',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490125,
        LOCATION_LATITUDE_DEG: 53.5165109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038400',
        LOCATION_NAME: 'Kiltamagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992245,
        LOCATION_LATITUDE_DEG: 53.8498626,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038700',
        LOCATION_NAME: 'Kiltartan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159194,
        LOCATION_LATITUDE_DEG: 53.0997798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI038800',
        LOCATION_NAME: 'Kiltealy',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490219,
        LOCATION_LATITUDE_DEG: 52.5664072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039000',
        LOCATION_NAME: 'Kilteean',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5992962,
        LOCATION_LATITUDE_DEG: 52.4664243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039100',
        LOCATION_NAME: 'Kilteel',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322973,
        LOCATION_LATITUDE_DEG: 53.2330815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039200',
        LOCATION_NAME: 'Kilteely',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991757,
        LOCATION_LATITUDE_DEG: 52.5164201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039300',
        LOCATION_NAME: 'Kilteeven',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.115832,
        LOCATION_LATITUDE_DEG: 53.6331215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039400',
        LOCATION_NAME: 'Kiltegan',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6198716,
        LOCATION_LATITUDE_DEG: 52.9091492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039500',
        LOCATION_NAME: 'Kilternan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1927457,
        LOCATION_LATITUDE_DEG: 53.2398724,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI082200',
        LOCATION_NAME: 'Kilternan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1921118,
        LOCATION_LATITUDE_DEG: 53.2350815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039600',
        LOCATION_NAME: 'Kiltiernan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325113,
        LOCATION_LATITUDE_DEG: 53.1830863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039700',
        LOCATION_NAME: 'Kiltimagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0158919,
        LOCATION_LATITUDE_DEG: 53.8498485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990851',
        LOCATION_NAME: 'Kiltivna',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI039800',
        LOCATION_NAME: 'Kiltoghert',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324253,
        LOCATION_LATITUDE_DEG: 53.9831666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040000',
        LOCATION_NAME: 'Kiltoom',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0282603,
        LOCATION_LATITUDE_DEG: 53.4814119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040100',
        LOCATION_NAME: 'Kiltormer',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658514,
        LOCATION_LATITUDE_DEG: 53.2330978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040200',
        LOCATION_NAME: 'Kiltrea Bridge',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6406841,
        LOCATION_LATITUDE_DEG: 52.5119331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040300',
        LOCATION_NAME: 'Kiltrellig',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8506421,
        LOCATION_LATITUDE_DEG: 52.5747342,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040400',
        LOCATION_NAME: 'Kiltrustan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1043135,
        LOCATION_LATITUDE_DEG: 53.7777754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040500',
        LOCATION_NAME: 'Kiltullagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6401978,
        LOCATION_LATITUDE_DEG: 53.2788931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040700',
        LOCATION_NAME: 'Kiltumper',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992761,
        LOCATION_LATITUDE_DEG: 52.7330506,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI040800',
        LOCATION_NAME: 'Kiltyclogher',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324156,
        LOCATION_LATITUDE_DEG: 54.3498926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041200',
        LOCATION_NAME: 'Kilvine',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8324972,
        LOCATION_LATITUDE_DEG: 53.6665367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041700',
        LOCATION_NAME: 'Kilworth',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324618,
        LOCATION_LATITUDE_DEG: 52.1663833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI041800',
        LOCATION_NAME: 'Kilworth Camp',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.265876,
        LOCATION_LATITUDE_DEG: 52.2163937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI084300',
        LOCATION_NAME: 'Kimmage',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2971374,
        LOCATION_LATITUDE_DEG: 53.3148274,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043300',
        LOCATION_NAME: 'Kinaff Bridge',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825025,
        LOCATION_LATITUDE_DEG: 53.8831586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043500',
        LOCATION_NAME: 'Kinard',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.199364,
        LOCATION_LATITUDE_DEG: 52.1329891,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043600',
        LOCATION_NAME: 'Kinard',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825674,
        LOCATION_LATITUDE_DEG: 52.5497349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI043400',
        LOCATION_NAME: 'Kinard',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824229,
        LOCATION_LATITUDE_DEG: 53.8498501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044500',
        LOCATION_NAME: 'Kincaslough',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824167,
        LOCATION_LATITUDE_DEG: 55.0166718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044600',
        LOCATION_NAME: 'Kincasslagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824548,
        LOCATION_LATITUDE_DEG: 55.0166158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044700',
        LOCATION_NAME: 'Kincon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159463,
        LOCATION_LATITUDE_DEG: 54.1998898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI044750',
        LOCATION_NAME: 'Kinconly',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9729138,
        LOCATION_LATITUDE_DEG: 53.5742662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI045100',
        LOCATION_NAME: 'Kindrum More',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.69906,
        LOCATION_LATITUDE_DEG: 55.2166804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI046400',
        LOCATION_NAME: 'Kingarrow',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0196906,
        LOCATION_LATITUDE_DEG: 54.9123512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI050800',
        LOCATION_NAME: 'Kingscourt',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8043428,
        LOCATION_LATITUDE_DEG: 53.9058467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI052400',
        LOCATION_NAME: 'Kingsland',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.365851,
        LOCATION_LATITUDE_DEG: 53.9165556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI990917',
        LOCATION_NAME: 'Kingsland',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI081600',
        LOCATION_NAME: 'Kingswood Height',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3748142,
        LOCATION_LATITUDE_DEG: 53.3374341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061300',
        LOCATION_NAME: 'Kinlough',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2923559,
        LOCATION_LATITUDE_DEG: 54.4535084,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061400',
        LOCATION_NAME: 'Kinlough',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2895589,
        LOCATION_LATITUDE_DEG: 54.4474857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI061800',
        LOCATION_NAME: 'Kinnadoohy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993073,
        LOCATION_LATITUDE_DEG: 53.6831455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062100',
        LOCATION_NAME: 'Kinnegad',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0930109,
        LOCATION_LATITUDE_DEG: 53.4572023,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI062200',
        LOCATION_NAME: 'Kinneigh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659495,
        LOCATION_LATITUDE_DEG: 51.766356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063300',
        LOCATION_NAME: 'Kinnitty',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7249151,
        LOCATION_LATITUDE_DEG: 53.1010798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI063900',
        LOCATION_NAME: 'Kinrovar',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9657245,
        LOCATION_LATITUDE_DEG: 54.0690855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064000',
        LOCATION_NAME: 'Kinsale',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5246886,
        LOCATION_LATITUDE_DEG: 51.7072512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064100',
        LOCATION_NAME: 'Kinsalebeg',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8116458,
        LOCATION_LATITUDE_DEG: 51.9746689,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064200',
        LOCATION_NAME: 'Kinsalebeg',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8060146,
        LOCATION_LATITUDE_DEG: 51.9745245,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064300',
        LOCATION_NAME: 'Kinsaley',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 17',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1822536,
        LOCATION_LATITUDE_DEG: 53.4164851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI064450',
        LOCATION_NAME: 'Kinsealy',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1674572,
        LOCATION_LATITUDE_DEG: 53.409941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065600',
        LOCATION_NAME: 'Kinvara Village',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9279762,
        LOCATION_LATITUDE_DEG: 53.1394398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065700',
        LOCATION_NAME: 'Kinvarra',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9414707,
        LOCATION_LATITUDE_DEG: 53.1421906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI065950',
        LOCATION_NAME: 'Kippaunagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6550905,
        LOCATION_LATITUDE_DEG: 53.5712124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI067800',
        LOCATION_NAME: 'Kirikee',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322747,
        LOCATION_LATITUDE_DEG: 52.9497509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079100',
        LOCATION_NAME: 'Kishkeam',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659638,
        LOCATION_LATITUDE_DEG: 52.1663877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KI079300',
        LOCATION_NAME: 'Kiskeam',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659421,
        LOCATION_LATITUDE_DEG: 52.1663439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KL930151',
        LOCATION_NAME: 'Klmullen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000700',
        LOCATION_NAME: 'Knappagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492796,
        LOCATION_LATITUDE_DEG: 53.7498536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN000750',
        LOCATION_NAME: 'Knappogue',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8275925,
        LOCATION_LATITUDE_DEG: 52.7962319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN003800',
        LOCATION_NAME: 'Knights Town',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.274661,
        LOCATION_LATITUDE_DEG: 51.932177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004050',
        LOCATION_NAME: 'Knightstown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2616155,
        LOCATION_LATITUDE_DEG: 53.1051692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN004900',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3326074,
        LOCATION_LATITUDE_DEG: 52.6330753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005000',
        LOCATION_NAME: 'Knock',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9158849,
        LOCATION_LATITUDE_DEG: 53.7831863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005200',
        LOCATION_NAME: 'Knockacappul',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825806,
        LOCATION_LATITUDE_DEG: 52.0663812,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005250',
        LOCATION_NAME: 'Knockachur',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3903888,
        LOCATION_LATITUDE_DEG: 52.2652847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005300',
        LOCATION_NAME: 'Knockaderry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659384,
        LOCATION_LATITUDE_DEG: 52.4664142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005400',
        LOCATION_NAME: 'Knockainy',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658849,
        LOCATION_LATITUDE_DEG: 52.4664165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005600',
        LOCATION_NAME: 'Knockalisheen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6511749,
        LOCATION_LATITUDE_DEG: 52.6930155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005800',
        LOCATION_NAME: 'Knockalough',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659524,
        LOCATION_LATITUDE_DEG: 52.699743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN005900',
        LOCATION_NAME: 'Knockananna',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4989868,
        LOCATION_LATITUDE_DEG: 52.8664417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006000',
        LOCATION_NAME: 'Knockanare',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325141,
        LOCATION_LATITUDE_DEG: 51.966373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN991099',
        LOCATION_NAME: 'Knockanemore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6689,
        LOCATION_LATITUDE_DEG: 51.8769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006200',
        LOCATION_NAME: 'Knockanillaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2382441,
        LOCATION_LATITUDE_DEG: 54.122488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006300',
        LOCATION_NAME: 'Knockanore',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8824292,
        LOCATION_LATITUDE_DEG: 52.0496692,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006400',
        LOCATION_NAME: 'Knockanure',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659705,
        LOCATION_LATITUDE_DEG: 52.4664167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006600',
        LOCATION_NAME: 'Knockarradaun East',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159539,
        LOCATION_LATITUDE_DEG: 52.9164655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006700',
        LOCATION_NAME: 'Knockarradaun West',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0992459,
        LOCATION_LATITUDE_DEG: 52.91647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990596',
        LOCATION_NAME: 'Knockatallon',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006800',
        LOCATION_NAME: 'Knockatanvally',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2492624,
        LOCATION_LATITUDE_DEG: 52.4664212,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006900',
        LOCATION_NAME: 'Knockatee',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7743222,
        LOCATION_LATITUDE_DEG: 51.782963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN006950',
        LOCATION_NAME: 'Knockatee',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7707536,
        LOCATION_LATITUDE_DEG: 53.6250374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007000',
        LOCATION_NAME: 'Knockatooan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.215974,
        LOCATION_LATITUDE_DEG: 52.2830048,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007100',
        LOCATION_NAME: 'Knockaunnaglashy',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993462,
        LOCATION_LATITUDE_DEG: 52.0996931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007150',
        LOCATION_NAME: 'Knockavanny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7764105,
        LOCATION_LATITUDE_DEG: 53.5321755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007200',
        LOCATION_NAME: 'Knockavrogeen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.316073,
        LOCATION_LATITUDE_DEG: 52.1664021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990628',
        LOCATION_NAME: 'Knockawarriga',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007400',
        LOCATION_NAME: 'Knockbrack',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823726,
        LOCATION_LATITUDE_DEG: 54.8999453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990616',
        LOCATION_NAME: 'Knockbrack',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN991024',
        LOCATION_NAME: 'Knockbrack',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.1158,
        LOCATION_LATITUDE_DEG: 53.5564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007600',
        LOCATION_NAME: 'Knockbrett',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7547637,
        LOCATION_LATITUDE_DEG: 52.5004536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007700',
        LOCATION_NAME: 'Knockbridge',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.482277,
        LOCATION_LATITUDE_DEG: 53.9665433,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN007800',
        LOCATION_NAME: 'Knockcroghery',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991199,
        LOCATION_LATITUDE_DEG: 53.5665246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008100',
        LOCATION_NAME: 'Knockdrin',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3197297,
        LOCATION_LATITUDE_DEG: 53.5697794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008200',
        LOCATION_NAME: 'Knockduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4659738,
        LOCATION_LATITUDE_DEG: 53.2817033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN008600',
        LOCATION_NAME: 'Knockferry',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.149248,
        LOCATION_LATITUDE_DEG: 53.4165068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009000',
        LOCATION_NAME: 'Knockinarshat Cross Roads',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5804041,
        LOCATION_LATITUDE_DEG: 52.4905486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009150',
        LOCATION_NAME: 'Knockkelly',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6677886,
        LOCATION_LATITUDE_DEG: 52.4950954,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009300',
        LOCATION_NAME: 'Knocklofty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7880109,
        LOCATION_LATITUDE_DEG: 52.3374668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009400',
        LOCATION_NAME: 'Knocklong',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.415888,
        LOCATION_LATITUDE_DEG: 52.4330192,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN991149',
        LOCATION_NAME: 'KNOCKLOUGHLIN',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7542,
        LOCATION_LATITUDE_DEG: 53.7617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN016700',
        LOCATION_NAME: 'Knocklyon',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3306861,
        LOCATION_LATITUDE_DEG: 53.2684464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009600',
        LOCATION_NAME: 'Knockmahon',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3658116,
        LOCATION_LATITUDE_DEG: 52.1496785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009750',
        LOCATION_NAME: 'Knockmaschill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4616509,
        LOCATION_LATITUDE_DEG: 53.5974348,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN009900',
        LOCATION_NAME: 'Knockmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1745161,
        LOCATION_LATITUDE_DEG: 54.01877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010000',
        LOCATION_NAME: 'Knockmoylan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990817,
        LOCATION_LATITUDE_DEG: 52.3997074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010300',
        LOCATION_NAME: 'Knocknagee',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.887728,
        LOCATION_LATITUDE_DEG: 52.8707427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010400',
        LOCATION_NAME: 'Knocknaghee',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2107879,
        LOCATION_LATITUDE_DEG: 52.1219647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010500',
        LOCATION_NAME: 'Knocknagoshel',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3852003,
        LOCATION_LATITUDE_DEG: 52.3277289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010600',
        LOCATION_NAME: 'Knocknagree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159708,
        LOCATION_LATITUDE_DEG: 52.1163845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990727',
        LOCATION_NAME: 'Knocknaheeny',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010700',
        LOCATION_NAME: 'Knocknahilan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159262,
        LOCATION_LATITUDE_DEG: 51.8329608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990887',
        LOCATION_NAME: 'Knocknahorgan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010800',
        LOCATION_NAME: 'Knocknalower',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8160012,
        LOCATION_LATITUDE_DEG: 54.2415928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990644',
        LOCATION_NAME: 'Knocknarea',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990615',
        LOCATION_NAME: 'Knocknasna',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN010900',
        LOCATION_NAME: 'Knockraha',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324783,
        LOCATION_LATITUDE_DEG: 51.9496657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011000',
        LOCATION_NAME: 'Knockroe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032656,
        LOCATION_LATITUDE_DEG: 51.9329709,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011100',
        LOCATION_NAME: 'Knocks',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9338306,
        LOCATION_LATITUDE_DEG: 51.6882037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011200',
        LOCATION_NAME: 'Knocks Boy',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6819267,
        LOCATION_LATITUDE_DEG: 52.196297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011300',
        LOCATION_NAME: 'Knockskagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9285869,
        LOCATION_LATITUDE_DEG: 51.6649776,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011350',
        LOCATION_NAME: 'Knocksquire',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8769044,
        LOCATION_LATITUDE_DEG: 52.6123676,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011400',
        LOCATION_NAME: 'Knocktopher',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157645,
        LOCATION_LATITUDE_DEG: 52.48301,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN990755',
        LOCATION_NAME: 'Knockumber',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011600',
        LOCATION_NAME: 'Knockvicar',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991225,
        LOCATION_LATITUDE_DEG: 53.9998656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011700',
        LOCATION_NAME: 'Knockwilliam',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990759,
        LOCATION_LATITUDE_DEG: 52.4497062,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN011800',
        LOCATION_NAME: 'Knockyhena',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159736,
        LOCATION_LATITUDE_DEG: 52.1329886,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KN015900',
        LOCATION_NAME: 'Knuttery',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5325052,
        LOCATION_LATITUDE_DEG: 52.0829775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000200',
        LOCATION_NAME: 'Kyle',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1836887,
        LOCATION_LATITUDE_DEG: 52.5089835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000400',
        LOCATION_NAME: 'Kylebrack',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658754,
        LOCATION_LATITUDE_DEG: 53.1330832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY000500',
        LOCATION_NAME: 'Kylemore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658735,
        LOCATION_LATITUDE_DEG: 53.0997781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001100',
        LOCATION_NAME: 'Kylesa',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7159987,
        LOCATION_LATITUDE_DEG: 53.3498079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'KY001350',
        LOCATION_NAME: 'Kyletalesha',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3124398,
        LOCATION_LATITUDE_DEG: 53.0725005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000100',
        LOCATION_NAME: 'Laban',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7987303,
        LOCATION_LATITUDE_DEG: 53.1379882,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000200',
        LOCATION_NAME: 'Labasheeda',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2573641,
        LOCATION_LATITUDE_DEG: 52.617244,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000300',
        LOCATION_NAME: 'Labbadish',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6157593,
        LOCATION_LATITUDE_DEG: 54.9332539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA000900',
        LOCATION_NAME: 'Lacka',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4274845,
        LOCATION_LATITUDE_DEG: 53.6379166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001000',
        LOCATION_NAME: 'Lackagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8658728,
        LOCATION_LATITUDE_DEG: 53.3664712,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001100',
        LOCATION_NAME: 'Lackan',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4949579,
        LOCATION_LATITUDE_DEG: 53.139167,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA001200',
        LOCATION_NAME: 'Lacken',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0606498,
        LOCATION_LATITUDE_DEG: 52.5291488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002050',
        LOCATION_NAME: 'Ladestown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4037798,
        LOCATION_LATITUDE_DEG: 53.4955128,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002800',
        LOCATION_NAME: 'Ladys Island',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3823132,
        LOCATION_LATITUDE_DEG: 52.2163777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990895',
        LOCATION_NAME: 'Ladys Well',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA002900',
        LOCATION_NAME: 'Ladysbridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324649,
        LOCATION_LATITUDE_DEG: 51.8996513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034600',
        LOCATION_NAME: 'Ladyswell',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.401595,
        LOCATION_LATITUDE_DEG: 53.4148501,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003300',
        LOCATION_NAME: 'Laffansbridge',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7314783,
        LOCATION_LATITUDE_DEG: 52.5779214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990884',
        LOCATION_NAME: 'Laghey',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA003900',
        LOCATION_NAME: 'Laghtgeorge',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325285,
        LOCATION_LATITUDE_DEG: 53.3498074,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004000',
        LOCATION_NAME: 'Laghy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0911108,
        LOCATION_LATITUDE_DEG: 54.6196211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990805',
        LOCATION_NAME: 'Laharandota',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004200',
        LOCATION_NAME: 'Lahard',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658686,
        LOCATION_LATITUDE_DEG: 51.7913578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA004300',
        LOCATION_NAME: 'Lahard',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4990677,
        LOCATION_LATITUDE_DEG: 53.9831554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014400',
        LOCATION_NAME: 'Lahinch',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3451638,
        LOCATION_LATITUDE_DEG: 52.9338713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA005950',
        LOCATION_NAME: 'Lamagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8270852,
        LOCATION_LATITUDE_DEG: 53.7574323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA012400',
        LOCATION_NAME: 'Lanesborough',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9848631,
        LOCATION_LATITUDE_DEG: 53.6725754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022600',
        LOCATION_NAME: 'Laracor',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823113,
        LOCATION_LATITUDE_DEG: 53.5165056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990203',
        LOCATION_NAME: 'Laragh',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022700',
        LOCATION_NAME: 'Laragh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.295276,
        LOCATION_LATITUDE_DEG: 53.0096591,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990060',
        LOCATION_NAME: 'Laragh Beg',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7767938,
        LOCATION_LATITUDE_DEG: 53.3851155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990055',
        LOCATION_NAME: 'Laragh Hill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7324074,
        LOCATION_LATITUDE_DEG: 53.3612546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990059',
        LOCATION_NAME: 'Laragh More',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.791293,
        LOCATION_LATITUDE_DEG: 53.389008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA022900',
        LOCATION_NAME: 'Larah',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157329,
        LOCATION_LATITUDE_DEG: 53.9998535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023000',
        LOCATION_NAME: 'Larass',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5824543,
        LOCATION_LATITUDE_DEG: 54.2665961,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023300',
        LOCATION_NAME: 'Larch Hill',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823024,
        LOCATION_LATITUDE_DEG: 53.1997805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023500',
        LOCATION_NAME: 'Largan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.332351,
        LOCATION_LATITUDE_DEG: 53.9165502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023800',
        LOCATION_NAME: 'Largy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5158361,
        LOCATION_LATITUDE_DEG: 54.6332322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023900',
        LOCATION_NAME: 'Largydonnell',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158344,
        LOCATION_LATITUDE_DEG: 54.4166064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024100',
        LOCATION_NAME: 'Larkfield',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658192,
        LOCATION_LATITUDE_DEG: 54.2665923,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA024500',
        LOCATION_NAME: 'Larkins Cross Roads',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6010487,
        LOCATION_LATITUDE_DEG: 52.6894528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA023875',
        LOCATION_NAME: 'Lattera',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026700',
        LOCATION_NAME: 'Latteragh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0436574,
        LOCATION_LATITUDE_DEG: 52.8437407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA026900',
        LOCATION_NAME: 'Lattin',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.265868,
        LOCATION_LATITUDE_DEG: 52.4664176,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA027000',
        LOCATION_NAME: 'Latton',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9441536,
        LOCATION_LATITUDE_DEG: 54.0690618,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990090',
        LOCATION_NAME: 'Laught',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0733398,
        LOCATION_LATITUDE_DEG: 53.2754811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028500',
        LOCATION_NAME: 'Lauragh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7774195,
        LOCATION_LATITUDE_DEG: 51.7694554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA034700',
        LOCATION_NAME: 'Laurel Lodge',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3739861,
        LOCATION_LATITUDE_DEG: 53.3787619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA028800',
        LOCATION_NAME: 'Laurencetown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.186763,
        LOCATION_LATITUDE_DEG: 53.2401896,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA029100',
        LOCATION_NAME: 'Lavagh',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6871418,
        LOCATION_LATITUDE_DEG: 54.0999371,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA991130',
        LOCATION_NAME: 'Lavally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8242,
        LOCATION_LATITUDE_DEG: 53.2431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA990694',
        LOCATION_NAME: 'Lavallyroe',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA030300',
        LOCATION_NAME: 'Lavey',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490529,
        LOCATION_LATITUDE_DEG: 53.9665556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA991053',
        LOCATION_NAME: 'Lawrencetown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1747,
        LOCATION_LATITUDE_DEG: 53.2367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LA033500',
        LOCATION_NAME: 'Laytown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2387661,
        LOCATION_LATITUDE_DEG: 53.6662154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE000550',
        LOCATION_NAME: 'Lea',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1308784,
        LOCATION_LATITUDE_DEG: 53.150834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003100',
        LOCATION_NAME: 'Leamlara',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2786297,
        LOCATION_LATITUDE_DEG: 51.9718947,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003500',
        LOCATION_NAME: 'Leanamore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4325852,
        LOCATION_LATITUDE_DEG: 52.5330341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003700',
        LOCATION_NAME: 'Leansaghane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6493043,
        LOCATION_LATITUDE_DEG: 52.5497341,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003800',
        LOCATION_NAME: 'Leap',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1483187,
        LOCATION_LATITUDE_DEG: 51.585431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE003900',
        LOCATION_NAME: 'Leap, The',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6990198,
        LOCATION_LATITUDE_DEG: 52.3996962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE004800',
        LOCATION_NAME: 'Leatbeg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7538961,
        LOCATION_LATITUDE_DEG: 55.1840828,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990918',
        LOCATION_NAME: 'Lecamey',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990718',
        LOCATION_NAME: 'Lecanvey',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006000',
        LOCATION_NAME: 'Lecarrow',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991296,
        LOCATION_LATITUDE_DEG: 54.1331716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006100',
        LOCATION_NAME: 'Lecarrow',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491267,
        LOCATION_LATITUDE_DEG: 53.5498214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006500',
        LOCATION_NAME: 'Leckanvy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.686798,
        LOCATION_LATITUDE_DEG: 53.7748543,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE006600',
        LOCATION_NAME: 'Leckemy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0822891,
        LOCATION_LATITUDE_DEG: 55.2332777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013200',
        LOCATION_NAME: 'Leenaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7056402,
        LOCATION_LATITUDE_DEG: 53.5951366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE013800',
        LOCATION_NAME: 'Legan',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6157912,
        LOCATION_LATITUDE_DEG: 53.6165204,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014100',
        LOCATION_NAME: 'Legga',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6657906,
        LOCATION_LATITUDE_DEG: 53.8998564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE990093',
        LOCATION_NAME: 'LEHANAGH',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7833175,
        LOCATION_LATITUDE_DEG: 53.4569848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE014700',
        LOCATION_NAME: 'Leifear',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823391,
        LOCATION_LATITUDE_DEG: 54.8332362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE016500',
        LOCATION_NAME: 'Leighlinbridge',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.965751,
        LOCATION_LATITUDE_DEG: 52.7330343,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018300',
        LOCATION_NAME: 'Leitrim Village',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0628435,
        LOCATION_LATITUDE_DEG: 53.9919764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE018400',
        LOCATION_NAME: 'Leixlip',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.482283,
        LOCATION_LATITUDE_DEG: 53.3664862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE019200',
        LOCATION_NAME: 'Lenamore',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6324001,
        LOCATION_LATITUDE_DEG: 53.6165206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE020000',
        LOCATION_NAME: 'Lenstown',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.01592,
        LOCATION_LATITUDE_DEG: 54.283202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE030400',
        LOCATION_NAME: 'Leopards Town',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1904504,
        LOCATION_LATITUDE_DEG: 53.2721974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021150',
        LOCATION_NAME: 'Lerhin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6295829,
        LOCATION_LATITUDE_DEG: 53.575103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE021300',
        LOCATION_NAME: 'Lerrig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7493143,
        LOCATION_LATITUDE_DEG: 52.3497089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023850',
        LOCATION_NAME: 'Lettera',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.641928,
        LOCATION_LATITUDE_DEG: 53.6052564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE991050',
        LOCATION_NAME: 'Letteragh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0872,
        LOCATION_LATITUDE_DEG: 53.2819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE023900',
        LOCATION_NAME: 'Letterbarrow',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1882876,
        LOCATION_LATITUDE_DEG: 54.6868608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024100',
        LOCATION_NAME: 'Letterdunane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5326088,
        LOCATION_LATITUDE_DEG: 51.8163611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024300',
        LOCATION_NAME: 'Letterfinish',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8160325,
        LOCATION_LATITUDE_DEG: 51.8663634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024600',
        LOCATION_NAME: 'Letterfrack',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9575623,
        LOCATION_LATITUDE_DEG: 53.5539324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024500',
        LOCATION_NAME: 'Letterfrack',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1947006,
        LOCATION_LATITUDE_DEG: 53.5522716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024700',
        LOCATION_NAME: 'Letterkenny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.735113,
        LOCATION_LATITUDE_DEG: 54.9574535,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE024800',
        LOCATION_NAME: 'Lettermacaward',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3194117,
        LOCATION_LATITUDE_DEG: 54.8543517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE991052',
        LOCATION_NAME: 'Lettermore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.655,
        LOCATION_LATITUDE_DEG: 53.2889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025000',
        LOCATION_NAME: 'Lettermullan',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7410044,
        LOCATION_LATITUDE_DEG: 53.2331024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025800',
        LOCATION_NAME: 'Leugh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824538,
        LOCATION_LATITUDE_DEG: 52.616429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025925',
        LOCATION_NAME: 'Levally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6715175,
        LOCATION_LATITUDE_DEG: 53.5130507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LE025950',
        LOCATION_NAME: 'Levally Lough',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7084556,
        LOCATION_LATITUDE_DEG: 53.5314578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI000600',
        LOCATION_NAME: 'Licketstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157789,
        LOCATION_LATITUDE_DEG: 52.2496839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001100',
        LOCATION_NAME: 'Lickowen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.232576,
        LOCATION_LATITUDE_DEG: 51.482928,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI001800',
        LOCATION_NAME: 'Lidoville',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1156535,
        LOCATION_LATITUDE_DEG: 53.4997963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI002300',
        LOCATION_NAME: 'Lifford',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4873195,
        LOCATION_LATITUDE_DEG: 54.8345407,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI004750',
        LOCATION_NAME: 'Lilliput',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4400235,
        LOCATION_LATITUDE_DEG: 53.4482269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005700',
        LOCATION_NAME: 'Limerick',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6224,
        LOCATION_LATITUDE_DEG: 52.6679374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005800',
        LOCATION_NAME: 'Limerick',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989796,
        LOCATION_LATITUDE_DEG: 52.7330291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI005900',
        LOCATION_NAME: 'Limerick Junction',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991597,
        LOCATION_LATITUDE_DEG: 52.4997155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI011100',
        LOCATION_NAME: 'Linsfort',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4961555,
        LOCATION_LATITUDE_DEG: 55.1680756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI013800',
        LOCATION_NAME: 'Lisacul',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6324734,
        LOCATION_LATITUDE_DEG: 53.8498561,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014000',
        LOCATION_NAME: 'Lisbealadea',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659572,
        LOCATION_LATITUDE_DEG: 51.6996503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014200',
        LOCATION_NAME: 'Lisboduff',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157422,
        LOCATION_LATITUDE_DEG: 54.0665631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014500',
        LOCATION_NAME: 'Liscananaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659195,
        LOCATION_LATITUDE_DEG: 53.3665113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014600',
        LOCATION_NAME: 'Liscannor',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3958069,
        LOCATION_LATITUDE_DEG: 52.9363719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014700',
        LOCATION_NAME: 'Liscarney',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492776,
        LOCATION_LATITUDE_DEG: 53.7331438,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014800',
        LOCATION_NAME: 'Liscarroll',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7992207,
        LOCATION_LATITUDE_DEG: 52.249694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990748',
        LOCATION_NAME: 'Liscarton',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI014900',
        LOCATION_NAME: 'Liscasey',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825651,
        LOCATION_LATITUDE_DEG: 52.7330512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015100',
        LOCATION_NAME: 'Lisconly',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492073,
        LOCATION_LATITUDE_DEG: 53.5831314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015200',
        LOCATION_NAME: 'Lisdargan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.199361,
        LOCATION_LATITUDE_DEG: 52.1496936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015300',
        LOCATION_NAME: 'Lisdeen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.599287,
        LOCATION_LATITUDE_DEG: 52.6664432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015400',
        LOCATION_NAME: 'Lisdoonvarna',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2920543,
        LOCATION_LATITUDE_DEG: 53.0351768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015500',
        LOCATION_NAME: 'Lisdowney',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823786,
        LOCATION_LATITUDE_DEG: 52.7830464,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015700',
        LOCATION_NAME: 'Lisduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7554259,
        LOCATION_LATITUDE_DEG: 53.650202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015750',
        LOCATION_NAME: 'Lisduff',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.795177,
        LOCATION_LATITUDE_DEG: 53.6900662,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990932',
        LOCATION_NAME: 'Lisduff',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015600',
        LOCATION_NAME: 'Lisduff',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323235,
        LOCATION_LATITUDE_DEG: 53.7998304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015800',
        LOCATION_NAME: 'Lisgould',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2172088,
        LOCATION_LATITUDE_DEG: 51.9725548,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI015900',
        LOCATION_NAME: 'Lisgrea',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823232,
        LOCATION_LATITUDE_DEG: 53.8498431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016000',
        LOCATION_NAME: 'Lisheen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825971,
        LOCATION_LATITUDE_DEG: 51.5163336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016100',
        LOCATION_NAME: 'Lisheen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2492661,
        LOCATION_LATITUDE_DEG: 52.1329901,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016200',
        LOCATION_NAME: 'Lisheen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824684,
        LOCATION_LATITUDE_DEG: 53.4165081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016300',
        LOCATION_NAME: 'Lisheenavalla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825203,
        LOCATION_LATITUDE_DEG: 53.3331041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016400',
        LOCATION_NAME: 'Lisheenkyle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8347385,
        LOCATION_LATITUDE_DEG: 53.2946778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016550',
        LOCATION_NAME: 'Liskeevy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9217172,
        LOCATION_LATITUDE_DEG: 53.5936951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016600',
        LOCATION_NAME: 'Lislary',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6158584,
        LOCATION_LATITUDE_DEG: 54.3832095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI016900',
        LOCATION_NAME: 'Lislevane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7659292,
        LOCATION_LATITUDE_DEG: 51.5996305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017100',
        LOCATION_NAME: 'Lismacaffery',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4634069,
        LOCATION_LATITUDE_DEG: 53.7124032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017200',
        LOCATION_NAME: 'Lismore',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9459078,
        LOCATION_LATITUDE_DEG: 52.1392811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017350',
        LOCATION_NAME: 'Lismortagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7608858,
        LOCATION_LATITUDE_DEG: 52.5470054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017400',
        LOCATION_NAME: 'Lismoyny',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5490975,
        LOCATION_LATITUDE_DEG: 53.3330931,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017700',
        LOCATION_NAME: 'Lisnagat',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8131937,
        LOCATION_LATITUDE_DEG: 51.8030844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017800',
        LOCATION_NAME: 'Lisnageer',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657386,
        LOCATION_LATITUDE_DEG: 54.0665666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI017900',
        LOCATION_NAME: 'Lisnagry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5167551,
        LOCATION_LATITUDE_DEG: 52.6808344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018100',
        LOCATION_NAME: 'Lisnalty',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.524299,
        LOCATION_LATITUDE_DEG: 52.6404296,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018150',
        LOCATION_NAME: 'Lisnamuck',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7743204,
        LOCATION_LATITUDE_DEG: 53.7373338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018300',
        LOCATION_NAME: 'Lispatrick',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5492127,
        LOCATION_LATITUDE_DEG: 51.6329325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018400',
        LOCATION_NAME: 'Lispole',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.166069,
        LOCATION_LATITUDE_DEG: 52.1329983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018500',
        LOCATION_NAME: 'Lisroe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825475,
        LOCATION_LATITUDE_DEG: 52.7830564,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018700',
        LOCATION_NAME: 'Lisronagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.043687,
        LOCATION_LATITUDE_DEG: 52.8437392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018600',
        LOCATION_NAME: 'Lisronagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991227,
        LOCATION_LATITUDE_DEG: 52.4164064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018800',
        LOCATION_NAME: 'Lisryan',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4990767,
        LOCATION_LATITUDE_DEG: 53.7331354,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI018950',
        LOCATION_NAME: 'Liss',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0693836,
        LOCATION_LATITUDE_DEG: 53.4624053,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019100',
        LOCATION_NAME: 'Lissacreasig',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0602596,
        LOCATION_LATITUDE_DEG: 51.91315,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019200',
        LOCATION_NAME: 'Lissadill',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5792278,
        LOCATION_LATITUDE_DEG: 54.3495145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI990814',
        LOCATION_NAME: 'Lissagriffin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI991000',
        LOCATION_NAME: 'Lissahane',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019400',
        LOCATION_NAME: 'Lissaniska',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492266,
        LOCATION_LATITUDE_DEG: 54.0165719,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019450',
        LOCATION_NAME: 'Lissaniska',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9765058,
        LOCATION_LATITUDE_DEG: 52.4516001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019500',
        LOCATION_NAME: 'Lissaphooca Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325188,
        LOCATION_LATITUDE_DEG: 51.7163513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019600',
        LOCATION_NAME: 'Lissarda',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8554128,
        LOCATION_LATITUDE_DEG: 51.8429088,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019700',
        LOCATION_NAME: 'Lissataggle',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5825939,
        LOCATION_LATITUDE_DEG: 52.1996985,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI991108',
        LOCATION_NAME: 'Lissatunny',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.88204,
        LOCATION_LATITUDE_DEG: 53.5005,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019725',
        LOCATION_NAME: 'Lissavalley',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8369151,
        LOCATION_LATITUDE_DEG: 53.5568936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019750',
        LOCATION_NAME: 'Lissavard',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9479846,
        LOCATION_LATITUDE_DEG: 51.6122031,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI019800',
        LOCATION_NAME: 'Lisselton',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5825963,
        LOCATION_LATITUDE_DEG: 52.499728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020100',
        LOCATION_NAME: 'Lissoy',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.815815,
        LOCATION_LATITUDE_DEG: 53.4998082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020150',
        LOCATION_NAME: 'Lissybroder',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7301801,
        LOCATION_LATITUDE_DEG: 53.5958716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020200',
        LOCATION_NAME: 'Lissycasey',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1677916,
        LOCATION_LATITUDE_DEG: 52.7403105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020300',
        LOCATION_NAME: 'Listellan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157297,
        LOCATION_LATITUDE_DEG: 54.1998723,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020400',
        LOCATION_NAME: 'Listellick',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993104,
        LOCATION_LATITUDE_DEG: 52.2997086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020600',
        LOCATION_NAME: 'Listerlin',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657683,
        LOCATION_LATITUDE_DEG: 52.399696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020800',
        LOCATION_NAME: 'Listowel',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4841917,
        LOCATION_LATITUDE_DEG: 52.4516194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI020900',
        LOCATION_NAME: 'Listrolin',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157898,
        LOCATION_LATITUDE_DEG: 52.3664049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021000',
        LOCATION_NAME: 'Listry',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6660038,
        LOCATION_LATITUDE_DEG: 52.1163889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI021200',
        LOCATION_NAME: 'Lisvernane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2225953,
        LOCATION_LATITUDE_DEG: 52.413295,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI032700',
        LOCATION_NAME: 'Little Furze, The',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6489897,
        LOCATION_LATITUDE_DEG: 53.6498187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI037500',
        LOCATION_NAME: 'Little Island',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3478428,
        LOCATION_LATITUDE_DEG: 51.8904632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI054800',
        LOCATION_NAME: 'Littleton',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7457088,
        LOCATION_LATITUDE_DEG: 52.6414283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LI061500',
        LOCATION_NAME: 'Lixnaw',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6160064,
        LOCATION_LATITUDE_DEG: 52.3997194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LL036050',
        LOCATION_NAME: 'Lleigh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9909466,
        LOCATION_LATITUDE_DEG: 52.7456598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO000700',
        LOCATION_NAME: 'Lobinstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6489928,
        LOCATION_LATITUDE_DEG: 53.7831334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO001100',
        LOCATION_NAME: 'Loch Garman',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4657059,
        LOCATION_LATITUDE_DEG: 52.3329847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008900',
        LOCATION_NAME: 'Loghinny',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823951,
        LOCATION_LATITUDE_DEG: 52.6997251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO010000',
        LOCATION_NAME: 'Lombardstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7825267,
        LOCATION_LATITUDE_DEG: 52.116387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031000',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8057339,
        LOCATION_LATITUDE_DEG: 53.729941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO031100',
        LOCATION_NAME: 'Longford',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7324173,
        LOCATION_LATITUDE_DEG: 53.0497622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036200',
        LOCATION_NAME: 'Longueville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7325132,
        LOCATION_LATITUDE_DEG: 52.1329841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO036800',
        LOCATION_NAME: 'Longwood',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157183,
        LOCATION_LATITUDE_DEG: 53.4497976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO037500',
        LOCATION_NAME: 'Looscaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.332461,
        LOCATION_LATITUDE_DEG: 53.0330715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038300',
        LOCATION_NAME: 'Loputo',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324336,
        LOCATION_LATITUDE_DEG: 54.4832018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO038800',
        LOCATION_NAME: 'Lorrha',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158504,
        LOCATION_LATITUDE_DEG: 53.0830783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039200',
        LOCATION_NAME: 'Loskeran',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6158281,
        LOCATION_LATITUDE_DEG: 52.0163743,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO039300',
        LOCATION_NAME: 'Losset',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1324553,
        LOCATION_LATITUDE_DEG: 52.6330306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040700',
        LOCATION_NAME: 'Lough Ennell',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4764906,
        LOCATION_LATITUDE_DEG: 53.5066952,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040800',
        LOCATION_NAME: 'Lough Gowna',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5430846,
        LOCATION_LATITUDE_DEG: 53.8584055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040850',
        LOCATION_NAME: 'Loughaderra',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0904876,
        LOCATION_LATITUDE_DEG: 51.9163168,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO040900',
        LOCATION_NAME: 'Loughanayally',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5323896,
        LOCATION_LATITUDE_DEG: 53.4831032,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041000',
        LOCATION_NAME: 'Loughane',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491554,
        LOCATION_LATITUDE_DEG: 51.8663592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990941',
        LOCATION_NAME: 'Loughane East',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990942',
        LOCATION_NAME: 'Loughane West',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041100',
        LOCATION_NAME: 'Loughawavally',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5291229,
        LOCATION_LATITUDE_DEG: 53.4872157,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041400',
        LOCATION_NAME: 'Loughduff',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4516416,
        LOCATION_LATITUDE_DEG: 53.8760009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041500',
        LOCATION_NAME: 'Lougher',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822792,
        LOCATION_LATITUDE_DEG: 53.6665177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990819',
        LOCATION_NAME: 'Loughglinn',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990818',
        LOCATION_NAME: 'Loughglynn',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO008800',
        LOCATION_NAME: 'Loughill',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992605,
        LOCATION_LATITUDE_DEG: 52.5970404,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042000',
        LOCATION_NAME: 'Loughlinstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1327239,
        LOCATION_LATITUDE_DEG: 53.2427727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO041800',
        LOCATION_NAME: 'Loughlynn',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491664,
        LOCATION_LATITUDE_DEG: 53.8165503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042100',
        LOCATION_NAME: 'Loughmoe',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324443,
        LOCATION_LATITUDE_DEG: 52.7497337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042200',
        LOCATION_NAME: 'Loughmore',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8057074,
        LOCATION_LATITUDE_DEG: 52.757631,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042400',
        LOCATION_NAME: 'Loughnavalley',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5265579,
        LOCATION_LATITUDE_DEG: 53.4859484,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042600',
        LOCATION_NAME: 'Loughrea',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5740947,
        LOCATION_LATITUDE_DEG: 53.2044914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO990603',
        LOCATION_NAME: 'Loughrynn Castle',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO042800',
        LOCATION_NAME: 'Loughshinny',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0864463,
        LOCATION_LATITUDE_DEG: 53.5465004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043200',
        LOCATION_NAME: 'Louisburgh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8032351,
        LOCATION_LATITUDE_DEG: 53.7679537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO043800',
        LOCATION_NAME: 'Louth',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322677,
        LOCATION_LATITUDE_DEG: 53.9498454,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO059250',
        LOCATION_NAME: 'Lower Dripsey',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7452642,
        LOCATION_LATITUDE_DEG: 51.9306298,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LO075700',
        LOCATION_NAME: 'Lowertown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5993036,
        LOCATION_LATITUDE_DEG: 51.5163283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU000200',
        LOCATION_NAME: 'Lucan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.445374,
        LOCATION_LATITUDE_DEG: 53.3555876,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU990975',
        LOCATION_NAME: 'Lugatober',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU003800',
        LOCATION_NAME: 'Luggacurren',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1157647,
        LOCATION_LATITUDE_DEG: 52.9497479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004000',
        LOCATION_NAME: 'Lugglass Lower',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.548989,
        LOCATION_LATITUDE_DEG: 53.0664588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004100',
        LOCATION_NAME: 'Lugnadeffa',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5824629,
        LOCATION_LATITUDE_DEG: 54.1998872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU004600',
        LOCATION_NAME: 'Lukeswell',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1823791,
        LOCATION_LATITUDE_DEG: 52.3996957,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU005200',
        LOCATION_NAME: 'Lullymore',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9442923,
        LOCATION_LATITUDE_DEG: 53.2771691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008200',
        LOCATION_NAME: 'Lurganboy',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991217,
        LOCATION_LATITUDE_DEG: 54.3165949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008300',
        LOCATION_NAME: 'Lurgangreen',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3822551,
        LOCATION_LATITUDE_DEG: 53.949853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU008800',
        LOCATION_NAME: 'Lusk',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1656529,
        LOCATION_LATITUDE_DEG: 53.516504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LU010600',
        LOCATION_NAME: 'Luttrellstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.414645,
        LOCATION_LATITUDE_DEG: 53.4046233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY002400',
        LOCATION_NAME: 'Lydican',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9401355,
        LOCATION_LATITUDE_DEG: 53.3174447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006350',
        LOCATION_NAME: 'Lynn',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3574303,
        LOCATION_LATITUDE_DEG: 53.4970021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY006400',
        LOCATION_NAME: 'Lynnbury',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490804,
        LOCATION_LATITUDE_DEG: 53.4831106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007400',
        LOCATION_NAME: 'Lyracrumpane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4993023,
        LOCATION_LATITUDE_DEG: 52.3497143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007500',
        LOCATION_NAME: 'Lyrattin',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491329,
        LOCATION_LATITUDE_DEG: 52.1829839,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007600',
        LOCATION_NAME: 'Lyre',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659768,
        LOCATION_LATITUDE_DEG: 52.2664041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007800',
        LOCATION_NAME: 'Lyre',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325484,
        LOCATION_LATITUDE_DEG: 51.6663461,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007700',
        LOCATION_NAME: 'Lyre',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0158462,
        LOCATION_LATITUDE_DEG: 52.0496717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'LY007900',
        LOCATION_NAME: 'Lyreacrompane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4991671,
        LOCATION_LATITUDE_DEG: 52.3503897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990913',
        LOCATION_NAME: 'Maam',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000100',
        LOCATION_NAME: 'Maam Cross',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5429352,
        LOCATION_LATITUDE_DEG: 53.4614164,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000200',
        LOCATION_NAME: 'Maas',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3778252,
        LOCATION_LATITUDE_DEG: 54.8339483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000300',
        LOCATION_NAME: 'Maas Lower',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658252,
        LOCATION_LATITUDE_DEG: 54.8332477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA000400',
        LOCATION_NAME: 'Maas Upper',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491301,
        LOCATION_LATITUDE_DEG: 54.8332429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA001400',
        LOCATION_NAME: 'Macetown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.502431,
        LOCATION_LATITUDE_DEG: 53.5700264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002100',
        LOCATION_NAME: 'Mackans',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6324033,
        LOCATION_LATITUDE_DEG: 53.4498078,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002400',
        LOCATION_NAME: 'Macreddin',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322885,
        LOCATION_LATITUDE_DEG: 52.8830439,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002500',
        LOCATION_NAME: 'Macroom',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9612221,
        LOCATION_LATITUDE_DEG: 51.9081695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990302',
        LOCATION_NAME: 'Maddenstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA002900',
        LOCATION_NAME: 'Maddockstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.199077,
        LOCATION_LATITUDE_DEG: 52.6330214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA006500',
        LOCATION_NAME: 'Maganey',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157393,
        LOCATION_LATITUDE_DEG: 52.9164528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007025',
        LOCATION_NAME: 'Maghera',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8337376,
        LOCATION_LATITUDE_DEG: 52.8854066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007050',
        LOCATION_NAME: 'Magheracloone',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7878788,
        LOCATION_LATITUDE_DEG: 53.9322504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA007275',
        LOCATION_NAME: 'Magheramore',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.030589,
        LOCATION_LATITUDE_DEG: 52.9326376,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008200',
        LOCATION_NAME: 'Mahonburgh Bridge',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492477,
        LOCATION_LATITUDE_DEG: 52.8164517,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA008300',
        LOCATION_NAME: 'Mahoonagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159445,
        LOCATION_LATITUDE_DEG: 52.4330132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011100',
        LOCATION_NAME: 'Mala',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6325195,
        LOCATION_LATITUDE_DEG: 52.1329834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA011200',
        LOCATION_NAME: 'Malahide',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.152533,
        LOCATION_LATITUDE_DEG: 53.4504869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012000',
        LOCATION_NAME: 'Malin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2706552,
        LOCATION_LATITUDE_DEG: 55.3042881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012100',
        LOCATION_NAME: 'Malin Beg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7824772,
        LOCATION_LATITUDE_DEG: 54.6666333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012744',
        LOCATION_NAME: 'Malin Head',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2583943,
        LOCATION_LATITUDE_DEG: 55.2562081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012200',
        LOCATION_NAME: 'Malin More',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7833855,
        LOCATION_LATITUDE_DEG: 54.6969329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012600',
        LOCATION_NAME: 'Mallaranny',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7916917,
        LOCATION_LATITUDE_DEG: 53.9112659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012725',
        LOCATION_NAME: 'Mallin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2605852,
        LOCATION_LATITUDE_DEG: 55.3041384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012738',
        LOCATION_NAME: 'Mallin Beg',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012747',
        LOCATION_NAME: 'Mallin More',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7749817,
        LOCATION_LATITUDE_DEG: 54.6976483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA012800',
        LOCATION_NAME: 'Mallow',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6406677,
        LOCATION_LATITUDE_DEG: 52.1412863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA019900',
        LOCATION_NAME: 'Manning',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324766,
        LOCATION_LATITUDE_DEG: 52.1829904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055650',
        LOCATION_NAME: 'Manor Hamilton',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1750296,
        LOCATION_LATITUDE_DEG: 54.3053091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990512',
        LOCATION_NAME: 'Manor Kilbride',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021400',
        LOCATION_NAME: 'Manorcunningham',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.615764,
        LOCATION_LATITUDE_DEG: 54.9499525,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA021000',
        LOCATION_NAME: 'Manorhamilton',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1841624,
        LOCATION_LATITUDE_DEG: 54.3089008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022100',
        LOCATION_NAME: 'Manseltown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158156,
        LOCATION_LATITUDE_DEG: 52.7164304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA022500',
        LOCATION_NAME: 'Mansfieldstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4489617,
        LOCATION_LATITUDE_DEG: 53.8998374,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA023800',
        LOCATION_NAME: 'Manulla',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825326,
        LOCATION_LATITUDE_DEG: 53.8331629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA025800',
        LOCATION_NAME: 'Marble Hill',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8990791,
        LOCATION_LATITUDE_DEG: 55.1666696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA027500',
        LOCATION_NAME: 'Maree',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9416673,
        LOCATION_LATITUDE_DEG: 53.2399783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA056500',
        LOCATION_NAME: 'Marino',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 3',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2386003,
        LOCATION_LATITUDE_DEG: 53.3727322,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033400',
        LOCATION_NAME: 'Marlefield',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7469717,
        LOCATION_LATITUDE_DEG: 52.3481734,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033650',
        LOCATION_NAME: 'Marley',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8305861,
        LOCATION_LATITUDE_DEG: 53.541249,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA033850',
        LOCATION_NAME: 'Marlinstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2892036,
        LOCATION_LATITUDE_DEG: 53.5127492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA037100',
        LOCATION_NAME: 'Marshalstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5686337,
        LOCATION_LATITUDE_DEG: 52.5564679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990438',
        LOCATION_NAME: 'Martinstown',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043300',
        LOCATION_NAME: 'Martry',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7867414,
        LOCATION_LATITUDE_DEG: 53.692647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA043900',
        LOCATION_NAME: 'Mary Ville',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324814,
        LOCATION_LATITUDE_DEG: 52.8330546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA055200',
        LOCATION_NAME: 'Maryborough',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044500',
        LOCATION_NAME: 'Maryfort',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6992072,
        LOCATION_LATITUDE_DEG: 52.8664532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA044800',
        LOCATION_NAME: 'Maryland',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6325738,
        LOCATION_LATITUDE_DEG: 53.8998685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA045900',
        LOCATION_NAME: 'Massbrook',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2834085,
        LOCATION_LATITUDE_DEG: 53.9865411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046000',
        LOCATION_NAME: 'Massytown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659598,
        LOCATION_LATITUDE_DEG: 51.8996726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA046100',
        LOCATION_NAME: 'Mastergeehy',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.099361,
        LOCATION_LATITUDE_DEG: 51.8829678,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049200',
        LOCATION_NAME: 'Maugha',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659798,
        LOCATION_LATITUDE_DEG: 51.7829617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049600',
        LOCATION_NAME: 'Maulyneill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7160201,
        LOCATION_LATITUDE_DEG: 51.9163694,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049700',
        LOCATION_NAME: 'Maum',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5796721,
        LOCATION_LATITUDE_DEG: 53.5286209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA049800',
        LOCATION_NAME: 'Maum East',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659773,
        LOCATION_LATITUDE_DEG: 53.5165239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA050000',
        LOCATION_NAME: 'Maurices Mills',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492601,
        LOCATION_LATITUDE_DEG: 52.8997609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA990723',
        LOCATION_NAME: 'Mayfield',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053200',
        LOCATION_NAME: 'Mayglass',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5157146,
        LOCATION_LATITUDE_DEG: 52.232971,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053600',
        LOCATION_NAME: 'Maynooth',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5743365,
        LOCATION_LATITUDE_DEG: 53.3936968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MA053700',
        LOCATION_NAME: 'Mayo Abbey',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159276,
        LOCATION_LATITUDE_DEG: 53.7498431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME000750',
        LOCATION_NAME: 'Meadstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4443843,
        LOCATION_LATITUDE_DEG: 51.7876637,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME001200',
        LOCATION_NAME: 'Meanus',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991997,
        LOCATION_LATITUDE_DEG: 52.5164215,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003050',
        LOCATION_NAME: 'Meedian',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3601553,
        LOCATION_LATITUDE_DEG: 53.4177785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003200',
        LOCATION_NAME: 'Meelick',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492102,
        LOCATION_LATITUDE_DEG: 53.699834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003300',
        LOCATION_NAME: 'Meelick',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6678057,
        LOCATION_LATITUDE_DEG: 52.6861234,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003100',
        LOCATION_NAME: 'Meelick',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0928866,
        LOCATION_LATITUDE_DEG: 53.1751778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003338',
        LOCATION_NAME: 'Meelick',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4074697,
        LOCATION_LATITUDE_DEG: 53.1517309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003325',
        LOCATION_NAME: 'Meelick',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2832412,
        LOCATION_LATITUDE_DEG: 53.0165049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003350',
        LOCATION_NAME: 'Meelick West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8578747,
        LOCATION_LATITUDE_DEG: 53.5617688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003400',
        LOCATION_NAME: 'Meelin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325485,
        LOCATION_LATITUDE_DEG: 52.2663983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003500',
        LOCATION_NAME: 'Meenadeeny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2491247,
        LOCATION_LATITUDE_DEG: 54.8166494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003600',
        LOCATION_NAME: 'Meenasrona',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7823903,
        LOCATION_LATITUDE_DEG: 54.7332297,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003700',
        LOCATION_NAME: 'Meenglass',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8236864,
        LOCATION_LATITUDE_DEG: 54.7695823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990629',
        LOCATION_NAME: 'Meenheala',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990627',
        LOCATION_NAME: 'Meenkilla',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME003800',
        LOCATION_NAME: 'Meenlaragh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824112,
        LOCATION_LATITUDE_DEG: 55.1332726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME991137',
        LOCATION_NAME: 'Meenoughter',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9894,
        LOCATION_LATITUDE_DEG: 52.0025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME004350',
        LOCATION_NAME: 'Meeting of the Waters',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2344047,
        LOCATION_LATITUDE_DEG: 52.8952174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME007700',
        LOCATION_NAME: 'Melkagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7490898,
        LOCATION_LATITUDE_DEG: 53.8331432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012300',
        LOCATION_NAME: 'Menlough',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659339,
        LOCATION_LATITUDE_DEG: 53.2998067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME012200',
        LOCATION_NAME: 'Menlough',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5707823,
        LOCATION_LATITUDE_DEG: 53.4175695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020600',
        LOCATION_NAME: 'Merchants Quay',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2743873,
        LOCATION_LATITUDE_DEG: 53.3455518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990443',
        LOCATION_NAME: 'Merlin Park',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME020500',
        LOCATION_NAME: 'Merrion',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2261571,
        LOCATION_LATITUDE_DEG: 53.3312854,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME015300',
        LOCATION_NAME: 'Merrion',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2055692,
        LOCATION_LATITUDE_DEG: 53.3149834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ME990441',
        LOCATION_NAME: 'Mervue',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI011800',
        LOCATION_NAME: 'Midfield',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.915905,
        LOCATION_LATITUDE_DEG: 53.8998616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI012900',
        LOCATION_NAME: 'Midleton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1734808,
        LOCATION_LATITUDE_DEG: 51.9140658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015400',
        LOCATION_NAME: 'Milemill',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7323009,
        LOCATION_LATITUDE_DEG: 53.1164628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI015600',
        LOCATION_NAME: 'Milestone',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0824397,
        LOCATION_LATITUDE_DEG: 52.6830347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016300',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492197,
        LOCATION_LATITUDE_DEG: 52.3330027,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016000',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7051885,
        LOCATION_LATITUDE_DEG: 55.089664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI016400',
        LOCATION_NAME: 'Milford',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9317668,
        LOCATION_LATITUDE_DEG: 52.7850152,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI017800',
        LOCATION_NAME: 'Mill Town',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6822859,
        LOCATION_LATITUDE_DEG: 54.1331638,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020200',
        LOCATION_NAME: 'Millroad',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5657249,
        LOCATION_LATITUDE_DEG: 52.182973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020400',
        LOCATION_NAME: 'Millstreet',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0585945,
        LOCATION_LATITUDE_DEG: 52.0607732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020300',
        LOCATION_NAME: 'Millstreet',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658729,
        LOCATION_LATITUDE_DEG: 52.1996919,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI020500',
        LOCATION_NAME: 'Millstreet',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.756654,
        LOCATION_LATITUDE_DEG: 52.1608832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026900',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7402229,
        LOCATION_LATITUDE_DEG: 52.1451983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026800',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9005741,
        LOCATION_LATITUDE_DEG: 53.6143902,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026700',
        LOCATION_NAME: 'Milltown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9777646,
        LOCATION_LATITUDE_DEG: 53.182403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021600',
        LOCATION_NAME: 'Milltownpass',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.232348,
        LOCATION_LATITUDE_DEG: 53.4331014,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI026600',
        LOCATION_NAME: 'MILTON OF CULLODEN',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.48002,
        LOCATION_LATITUDE_DEG: 54.0641774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI021400',
        LOCATION_NAME: 'Miltown Malbay',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4076011,
        LOCATION_LATITUDE_DEG: 52.862661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027500',
        LOCATION_NAME: 'Minane Bridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3658982,
        LOCATION_LATITUDE_DEG: 51.7496414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI027600',
        LOCATION_NAME: 'Minard',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.132659,
        LOCATION_LATITUDE_DEG: 52.1163925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033000',
        LOCATION_NAME: 'Mitchells Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2419562,
        LOCATION_LATITUDE_DEG: 55.0869679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MI033100',
        LOCATION_NAME: 'Mitchelstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2774105,
        LOCATION_LATITUDE_DEG: 52.272798,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000100',
        LOCATION_NAME: 'Moanflugh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9828992,
        LOCATION_LATITUDE_DEG: 51.9632246,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO000400',
        LOCATION_NAME: 'Moate',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7175657,
        LOCATION_LATITUDE_DEG: 53.3992057,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001300',
        LOCATION_NAME: 'Mocklershill',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.815843,
        LOCATION_LATITUDE_DEG: 52.5164178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001700',
        LOCATION_NAME: 'Modelligo',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491377,
        LOCATION_LATITUDE_DEG: 52.1329732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO001900',
        LOCATION_NAME: 'Modreeny',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0651554,
        LOCATION_LATITUDE_DEG: 52.9569578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002700',
        LOCATION_NAME: 'Mogeely',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491678,
        LOCATION_LATITUDE_DEG: 51.9329609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO002900',
        LOCATION_NAME: 'Mohill',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8708227,
        LOCATION_LATITUDE_DEG: 53.9209533,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO003400',
        LOCATION_NAME: 'Molahiffe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5826101,
        LOCATION_LATITUDE_DEG: 52.1829995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO901284',
        LOCATION_NAME: 'Monacow',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7447046,
        LOCATION_LATITUDE_DEG: 53.5227975,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004600',
        LOCATION_NAME: 'Monaghan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9670258,
        LOCATION_LATITUDE_DEG: 54.2492789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990732',
        LOCATION_NAME: 'Monalee',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004700',
        LOCATION_NAME: 'Monamolin',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489962,
        LOCATION_LATITUDE_DEG: 52.5497113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004800',
        LOCATION_NAME: 'Monard',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2230353,
        LOCATION_LATITUDE_DEG: 52.5110732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO004900',
        LOCATION_NAME: 'Monart',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5990073,
        LOCATION_LATITUDE_DEG: 52.4997058,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005000',
        LOCATION_NAME: 'Monaseed',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3989874,
        LOCATION_LATITUDE_DEG: 52.7164251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005100',
        LOCATION_NAME: 'Monaster',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6659038,
        LOCATION_LATITUDE_DEG: 52.5164225,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005300',
        LOCATION_NAME: 'Monasteraden',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4982585,
        LOCATION_LATITUDE_DEG: 53.9419751,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005500',
        LOCATION_NAME: 'Monasterboice',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4033767,
        LOCATION_LATITUDE_DEG: 53.7704252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005600',
        LOCATION_NAME: 'Monasterevin',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0562829,
        LOCATION_LATITUDE_DEG: 53.1428727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005700',
        LOCATION_NAME: 'Monasteroris',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0823411,
        LOCATION_LATITUDE_DEG: 53.3330903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO005900',
        LOCATION_NAME: 'Monavarnoge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0158406,
        LOCATION_LATITUDE_DEG: 51.9996646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006000',
        LOCATION_NAME: 'Monbay',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3903696,
        LOCATION_LATITUDE_DEG: 52.6823019,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006300',
        LOCATION_NAME: 'Moneen',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0491376,
        LOCATION_LATITUDE_DEG: 53.666534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006350',
        LOCATION_NAME: 'Moneenroe',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1527264,
        LOCATION_LATITUDE_DEG: 52.838793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006500',
        LOCATION_NAME: 'Money',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.915719,
        LOCATION_LATITUDE_DEG: 53.9831559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006600',
        LOCATION_NAME: 'Moneycashen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6826085,
        LOCATION_LATITUDE_DEG: 52.4830278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006650',
        LOCATION_NAME: 'Moneycusker',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0029627,
        LOCATION_LATITUDE_DEG: 51.8554068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006700',
        LOCATION_NAME: 'Moneyduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.19936,
        LOCATION_LATITUDE_DEG: 51.9496786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO006800',
        LOCATION_NAME: 'Moneygall',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.961594,
        LOCATION_LATITUDE_DEG: 52.8785263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007000',
        LOCATION_NAME: 'Moneygurney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4156402,
        LOCATION_LATITUDE_DEG: 51.8594398,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007350',
        LOCATION_NAME: 'Moneystown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2148732,
        LOCATION_LATITUDE_DEG: 52.9991086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO007800',
        LOCATION_NAME: 'Monilea',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3045003,
        LOCATION_LATITUDE_DEG: 53.5786753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO008000',
        LOCATION_NAME: 'Monivea',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6991892,
        LOCATION_LATITUDE_DEG: 53.36651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010350',
        LOCATION_NAME: 'Monksland',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9896196,
        LOCATION_LATITUDE_DEG: 53.4218199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010700',
        LOCATION_NAME: 'Monkstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3474965,
        LOCATION_LATITUDE_DEG: 51.8455101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO010800',
        LOCATION_NAME: 'Monkstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1543136,
        LOCATION_LATITUDE_DEG: 53.2878314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012950',
        LOCATION_NAME: 'Monroe',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9275499,
        LOCATION_LATITUDE_DEG: 52.7034963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO012900',
        LOCATION_NAME: 'Monroe',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323896,
        LOCATION_LATITUDE_DEG: 52.4163974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990724',
        LOCATION_NAME: 'Montenotte',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO013700',
        LOCATION_NAME: 'Montpellier',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4941332,
        LOCATION_LATITUDE_DEG: 52.7523745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014700',
        LOCATION_NAME: 'Moonbawn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7847355,
        LOCATION_LATITUDE_DEG: 53.3139675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014800',
        LOCATION_NAME: 'Mooncoin',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490812,
        LOCATION_LATITUDE_DEG: 52.2829922,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014900',
        LOCATION_NAME: 'Moone',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8179017,
        LOCATION_LATITUDE_DEG: 52.9752559,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO014950',
        LOCATION_NAME: 'Mooninroe',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1615361,
        LOCATION_LATITUDE_DEG: 52.830255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015200',
        LOCATION_NAME: 'Moor',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.482469,
        LOCATION_LATITUDE_DEG: 53.7831447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO015900',
        LOCATION_NAME: 'Moore',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0658261,
        LOCATION_LATITUDE_DEG: 53.3330942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO016200',
        LOCATION_NAME: 'Mooretown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3822544,
        LOCATION_LATITUDE_DEG: 53.9331458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO022650',
        LOCATION_NAME: 'Morett',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2145879,
        LOCATION_LATITUDE_DEG: 53.0845269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO024500',
        LOCATION_NAME: 'Mornington',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822644,
        LOCATION_LATITUDE_DEG: 53.716522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO028500',
        LOCATION_NAME: 'Mosney',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2289812,
        LOCATION_LATITUDE_DEG: 53.6574665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031050',
        LOCATION_NAME: 'Mosstrim',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6217693,
        LOCATION_LATITUDE_DEG: 53.7243462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031500',
        LOCATION_NAME: 'Mostrim',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6062798,
        LOCATION_LATITUDE_DEG: 53.694827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031750',
        LOCATION_NAME: 'Mote Park',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1751973,
        LOCATION_LATITUDE_DEG: 53.5897383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO031900',
        LOCATION_NAME: 'Mothel',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4157952,
        LOCATION_LATITUDE_DEG: 52.2996926,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034700',
        LOCATION_NAME: 'Mount Bellew',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5030792,
        LOCATION_LATITUDE_DEG: 53.4731778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034800',
        LOCATION_NAME: 'Mount Bolton',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157887,
        LOCATION_LATITUDE_DEG: 52.3164004,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO034950',
        LOCATION_NAME: 'Mount Dalton',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5320442,
        LOCATION_LATITUDE_DEG: 53.5132933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035000',
        LOCATION_NAME: 'Mount Druid',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323699,
        LOCATION_LATITUDE_DEG: 52.2329868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035300',
        LOCATION_NAME: 'Mount Falcon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492324,
        LOCATION_LATITUDE_DEG: 54.0665716,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035400',
        LOCATION_NAME: 'Mount George',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156962,
        LOCATION_LATITUDE_DEG: 52.5664121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO035800',
        LOCATION_NAME: 'Mount Keefe',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825373,
        LOCATION_LATITUDE_DEG: 52.2329965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036000',
        LOCATION_NAME: 'Mount Merrion',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.214513,
        LOCATION_LATITUDE_DEG: 53.2963049,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036100',
        LOCATION_NAME: 'Mount Neill',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6657147,
        LOCATION_LATITUDE_DEG: 52.8997411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036500',
        LOCATION_NAME: 'Mount Seskin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4221432,
        LOCATION_LATITUDE_DEG: 53.2353287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036800',
        LOCATION_NAME: 'Mount Talbot',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2917266,
        LOCATION_LATITUDE_DEG: 53.5286201,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036900',
        LOCATION_NAME: 'Mount Temple',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7734206,
        LOCATION_LATITUDE_DEG: 53.4277043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037000',
        LOCATION_NAME: 'Mount Uniacke',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991645,
        LOCATION_LATITUDE_DEG: 51.9663669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037600',
        LOCATION_NAME: 'Mountain Lodge',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990378,
        LOCATION_LATITUDE_DEG: 53.9831481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990852',
        LOCATION_NAME: 'Mountainmuck',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO037700',
        LOCATION_NAME: 'Mountbellew',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5000377,
        LOCATION_LATITUDE_DEG: 53.4697864,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038000',
        LOCATION_NAME: 'Mountbolus',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6324128,
        LOCATION_LATITUDE_DEG: 53.1830794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038100',
        LOCATION_NAME: 'Mountcharles',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1982321,
        LOCATION_LATITUDE_DEG: 54.6492309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038200',
        LOCATION_NAME: 'Mountcollins',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2325624,
        LOCATION_LATITUDE_DEG: 52.3164013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038550',
        LOCATION_NAME: 'Mountloftus',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9824444,
        LOCATION_LATITUDE_DEG: 52.601251,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038600',
        LOCATION_NAME: 'Mountlucas',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2190154,
        LOCATION_LATITUDE_DEG: 53.2995524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990617',
        LOCATION_NAME: 'Mountmahon',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO038700',
        LOCATION_NAME: 'Mountmellick',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3302475,
        LOCATION_LATITUDE_DEG: 53.1234756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO036200',
        LOCATION_NAME: 'Mountnugent',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490507,
        LOCATION_LATITUDE_DEG: 53.816536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039200',
        LOCATION_NAME: 'Mountrath',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4646121,
        LOCATION_LATITUDE_DEG: 53.0061613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039300',
        LOCATION_NAME: 'Mountshannon',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4324706,
        LOCATION_LATITUDE_DEG: 52.9330573,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044800',
        LOCATION_NAME: 'Mountview',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO044850',
        LOCATION_NAME: 'Mournabby',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.619418,
        LOCATION_LATITUDE_DEG: 52.0753337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990382',
        LOCATION_NAME: 'Mourneabbey',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039800',
        LOCATION_NAME: 'Moveen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7160079,
        LOCATION_LATITUDE_DEG: 52.6330355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO039900',
        LOCATION_NAME: 'Moville',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0411497,
        LOCATION_LATITUDE_DEG: 55.1934665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040600',
        LOCATION_NAME: 'Moy Bridge',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657074,
        LOCATION_LATITUDE_DEG: 54.3831946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040650',
        LOCATION_NAME: 'Moyanna',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1251513,
        LOCATION_LATITUDE_DEG: 53.0536455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040700',
        LOCATION_NAME: 'Moyard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.018425,
        LOCATION_LATITUDE_DEG: 53.5461357,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO040900',
        LOCATION_NAME: 'Moyascragh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1992476,
        LOCATION_LATITUDE_DEG: 53.3831135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041000',
        LOCATION_NAME: 'Moyasta',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5325831,
        LOCATION_LATITUDE_DEG: 52.6664455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041100',
        LOCATION_NAME: 'Moycullen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.179738,
        LOCATION_LATITUDE_DEG: 53.341703,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041200',
        LOCATION_NAME: 'Moydow',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.788276,
        LOCATION_LATITUDE_DEG: 53.6508239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041250',
        LOCATION_NAME: 'Moydrum',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.869759,
        LOCATION_LATITUDE_DEG: 53.4227946,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO990229',
        LOCATION_NAME: 'Moyglass',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7177242,
        LOCATION_LATITUDE_DEG: 52.5255179,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041400',
        LOCATION_NAME: 'Moyhora',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323629,
        LOCATION_LATITUDE_DEG: 52.8497465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041600',
        LOCATION_NAME: 'Moylaw',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825418,
        LOCATION_LATITUDE_DEG: 54.099879,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO041900',
        LOCATION_NAME: 'Moylough',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5772308,
        LOCATION_LATITUDE_DEG: 53.4923129,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042000',
        LOCATION_NAME: 'Moynalty',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823147,
        LOCATION_LATITUDE_DEG: 53.7831257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042100',
        LOCATION_NAME: 'Moynalvey',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6840543,
        LOCATION_LATITUDE_DEG: 53.4838621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042300',
        LOCATION_NAME: 'Moyne',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5324665,
        LOCATION_LATITUDE_DEG: 53.8498536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042200',
        LOCATION_NAME: 'Moyne',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158296,
        LOCATION_LATITUDE_DEG: 52.7330396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042400',
        LOCATION_NAME: 'Moyne',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323925,
        LOCATION_LATITUDE_DEG: 53.8998574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042500',
        LOCATION_NAME: 'Moyne Cross Roads',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323888,
        LOCATION_LATITUDE_DEG: 53.9165477,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042700',
        LOCATION_NAME: 'Moyny',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159366,
        LOCATION_LATITUDE_DEG: 54.2999044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042600',
        LOCATION_NAME: 'Moyny',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2992941,
        LOCATION_LATITUDE_DEG: 51.6663361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042800',
        LOCATION_NAME: 'Moyour Bridge',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659622,
        LOCATION_LATITUDE_DEG: 53.8165556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO042900',
        LOCATION_NAME: 'Moyra',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.065803,
        LOCATION_LATITUDE_DEG: 55.1332738,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043100',
        LOCATION_NAME: 'Moyvally',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.915731,
        LOCATION_LATITUDE_DEG: 53.4331036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043150',
        LOCATION_NAME: 'Moyvane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3673021,
        LOCATION_LATITUDE_DEG: 52.501231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043200',
        LOCATION_NAME: 'Moyvilla',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8289623,
        LOCATION_LATITUDE_DEG: 53.2595629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043300',
        LOCATION_NAME: 'Moyvore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6157906,
        LOCATION_LATITUDE_DEG: 53.5331153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043400',
        LOCATION_NAME: 'Moyvoughley',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7009529,
        LOCATION_LATITUDE_DEG: 53.4421166,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MO043500',
        LOCATION_NAME: 'Moyvoughly',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991095,
        LOCATION_LATITUDE_DEG: 53.4331033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU000200',
        LOCATION_NAME: 'Muccurragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5660183,
        LOCATION_LATITUDE_DEG: 51.7163471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001250',
        LOCATION_NAME: 'Muckalee',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2558944,
        LOCATION_LATITUDE_DEG: 52.656124,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU001450',
        LOCATION_NAME: 'Mucklagh',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5386568,
        LOCATION_LATITUDE_DEG: 53.2539763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002100',
        LOCATION_NAME: 'Muckross',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.49075,
        LOCATION_LATITUDE_DEG: 52.0305819,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU002700',
        LOCATION_NAME: 'Muff',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2697191,
        LOCATION_LATITUDE_DEG: 55.0735622,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU991154',
        LOCATION_NAME: 'Muine Bheag',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.952521,
        LOCATION_LATITUDE_DEG: 52.699098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU991128',
        LOCATION_NAME: 'Muingmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8942,
        LOCATION_LATITUDE_DEG: 54.1504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003100',
        LOCATION_NAME: 'Muingvautia',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4492813,
        LOCATION_LATITUDE_DEG: 52.2997055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU003200',
        LOCATION_NAME: 'Muingwee',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.415986,
        LOCATION_LATITUDE_DEG: 52.3497038,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU990993',
        LOCATION_NAME: 'Mulgannon',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004700',
        LOCATION_NAME: 'Mulhuddart',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4052282,
        LOCATION_LATITUDE_DEG: 53.4052867,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU013000',
        LOCATION_NAME: 'Mulhuddart',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3997024,
        LOCATION_LATITUDE_DEG: 53.388243,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004800',
        LOCATION_NAME: 'Mullabryan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657027,
        LOCATION_LATITUDE_DEG: 54.3665916,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU004900',
        LOCATION_NAME: 'Mullacrew',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5322839,
        LOCATION_LATITUDE_DEG: 53.9331455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005200',
        LOCATION_NAME: 'Mullagh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7326056,
        LOCATION_LATITUDE_DEG: 53.7498514,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005300',
        LOCATION_NAME: 'Mullagh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4159688,
        LOCATION_LATITUDE_DEG: 52.7997609,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005100',
        LOCATION_NAME: 'Mullagh',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9490281,
        LOCATION_LATITUDE_DEG: 53.8165339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005000',
        LOCATION_NAME: 'Mullagh',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.632288,
        LOCATION_LATITUDE_DEG: 53.4498017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005350',
        LOCATION_NAME: 'Mullaghanny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5388652,
        LOCATION_LATITUDE_DEG: 54.8472979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005600',
        LOCATION_NAME: 'Mullaghgarve',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324099,
        LOCATION_LATITUDE_DEG: 54.0831704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005700',
        LOCATION_NAME: 'Mullaghglass',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9160155,
        LOCATION_LATITUDE_DEG: 53.5915412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU005800',
        LOCATION_NAME: 'Mullaghmore',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658431,
        LOCATION_LATITUDE_DEG: 54.4499146,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU990099',
        LOCATION_NAME: 'mullaghmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006000',
        LOCATION_NAME: 'Mullaghoran',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4490691,
        LOCATION_LATITUDE_DEG: 53.8498431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006050',
        LOCATION_NAME: 'Mullaghvorneen',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8123155,
        LOCATION_LATITUDE_DEG: 53.6997126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006200',
        LOCATION_NAME: 'Mullanalaghta',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5157844,
        LOCATION_LATITUDE_DEG: 53.8331392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006400',
        LOCATION_NAME: 'Mullawornagh',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991138,
        LOCATION_LATITUDE_DEG: 53.5831261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006500',
        LOCATION_NAME: 'Mullinahone',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4991001,
        LOCATION_LATITUDE_DEG: 52.5164115,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006650',
        LOCATION_NAME: 'Mullinarrigle',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU990969',
        LOCATION_NAME: 'Mullinary',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006700',
        LOCATION_NAME: 'Mullinavat',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1702164,
        LOCATION_LATITUDE_DEG: 52.3670986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU006800',
        LOCATION_NAME: 'Mullingar',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.342834,
        LOCATION_LATITUDE_DEG: 53.5298087,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007000',
        LOCATION_NAME: 'Mullycagh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6323108,
        LOCATION_LATITUDE_DEG: 53.0330572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007200',
        LOCATION_NAME: 'Mulranney',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.704798,
        LOCATION_LATITUDE_DEG: 53.9027546,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU007300',
        LOCATION_NAME: 'Multyfarnham',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823739,
        LOCATION_LATITUDE_DEG: 53.6165203,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU008300',
        LOCATION_NAME: 'Mungret',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6825096,
        LOCATION_LATITUDE_DEG: 52.6330417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU990713',
        LOCATION_NAME: 'Murlog',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU009900',
        LOCATION_NAME: 'Murntown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5323107,
        LOCATION_LATITUDE_DEG: 52.2829858,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010100',
        LOCATION_NAME: 'Murragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992351,
        LOCATION_LATITUDE_DEG: 51.7329551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010200',
        LOCATION_NAME: 'Murreagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.360582,
        LOCATION_LATITUDE_DEG: 52.180598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU991135',
        LOCATION_NAME: 'Murrintown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.52,
        LOCATION_LATITUDE_DEG: 52.2811,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010300',
        LOCATION_NAME: 'Murrisk',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6492846,
        LOCATION_LATITUDE_DEG: 53.7831536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010350',
        LOCATION_NAME: 'Murroe',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4059988,
        LOCATION_LATITUDE_DEG: 52.6536837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MU010500',
        LOCATION_NAME: 'Murroogh',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825654,
        LOCATION_LATITUDE_DEG: 53.1330847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY000400',
        LOCATION_NAME: 'Mylerstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990187,
        LOCATION_LATITUDE_DEG: 53.2664877,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002400',
        LOCATION_NAME: 'Myrtleville',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2994346,
        LOCATION_LATITUDE_DEG: 51.7825479,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'MY002500',
        LOCATION_NAME: 'Myshall',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657333,
        LOCATION_LATITUDE_DEG: 52.6830272,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000100',
        LOCATION_NAME: 'Naas',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6647526,
        LOCATION_LATITUDE_DEG: 53.2117727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA000700',
        LOCATION_NAME: 'Nad',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325404,
        LOCATION_LATITUDE_DEG: 52.066386,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA001100',
        LOCATION_NAME: 'Nags Head',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2822563,
        LOCATION_LATITUDE_DEG: 53.5665018,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA006500',
        LOCATION_NAME: 'Narraghmore',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323281,
        LOCATION_LATITUDE_DEG: 53.033055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA990908',
        LOCATION_NAME: 'Naul',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008100',
        LOCATION_NAME: 'Naul',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3005032,
        LOCATION_LATITUDE_DEG: 53.5884101,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NA008500',
        LOCATION_NAME: 'Navan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6867927,
        LOCATION_LATITUDE_DEG: 53.6543165,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000200',
        LOCATION_NAME: 'Neale',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2325371,
        LOCATION_LATITUDE_DEG: 53.5665302,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE000400',
        LOCATION_NAME: 'Nealstown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991202,
        LOCATION_LATITUDE_DEG: 52.9830556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE059100',
        LOCATION_NAME: 'Neilstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 22',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4015139,
        LOCATION_LATITUDE_DEG: 53.3383309,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE003500',
        LOCATION_NAME: 'Nenagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2019199,
        LOCATION_LATITUDE_DEG: 52.8685597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE010800',
        LOCATION_NAME: 'Nethertown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3657017,
        LOCATION_LATITUDE_DEG: 52.1829732,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE014200',
        LOCATION_NAME: 'New Birmingham',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6324231,
        LOCATION_LATITUDE_DEG: 52.6164211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE015700',
        LOCATION_NAME: 'New Chapel Cross',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.174562,
        LOCATION_LATITUDE_DEG: 51.8525651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019300',
        LOCATION_NAME: 'New Inn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4991635,
        LOCATION_LATITUDE_DEG: 53.2997915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019400',
        LOCATION_NAME: 'New Inn',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1885421,
        LOCATION_LATITUDE_DEG: 53.0890704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019800',
        LOCATION_NAME: 'New Kildimo',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8091189,
        LOCATION_LATITUDE_DEG: 52.6257367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019900',
        LOCATION_NAME: 'New Kilmainham',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3202395,
        LOCATION_LATITUDE_DEG: 53.3392822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE021700',
        LOCATION_NAME: 'New Mills',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8032747,
        LOCATION_LATITUDE_DEG: 54.9339519,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022200',
        LOCATION_NAME: 'New Pallas',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3500542,
        LOCATION_LATITUDE_DEG: 52.5504156,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE022700',
        LOCATION_NAME: 'New Quay',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659307,
        LOCATION_LATITUDE_DEG: 53.1497898,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023200',
        LOCATION_NAME: 'New Ross',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9448386,
        LOCATION_LATITUDE_DEG: 52.3959009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE023300',
        LOCATION_NAME: 'New Ross Port',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9494475,
        LOCATION_LATITUDE_DEG: 52.3942316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024300',
        LOCATION_NAME: 'New Town',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0991344,
        LOCATION_LATITUDE_DEG: 53.2830992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024400',
        LOCATION_NAME: 'New Town',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5657831,
        LOCATION_LATITUDE_DEG: 53.5831169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE024700',
        LOCATION_NAME: 'New Twopothouse Village',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6825117,
        LOCATION_LATITUDE_DEG: 52.1829915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE025900',
        LOCATION_NAME: 'Newbawn',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823332,
        LOCATION_LATITUDE_DEG: 52.3329935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE026000',
        LOCATION_NAME: 'Newberry',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7157095,
        LOCATION_LATITUDE_DEG: 53.133059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE027000',
        LOCATION_NAME: 'Newbliss',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1302695,
        LOCATION_LATITUDE_DEG: 54.1594731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029800',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825435,
        LOCATION_LATITUDE_DEG: 52.5497319,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029700',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4344811,
        LOCATION_LATITUDE_DEG: 53.5110132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029600',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990279,
        LOCATION_LATITUDE_DEG: 53.183068,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE029900',
        LOCATION_NAME: 'Newbridge',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2156731,
        LOCATION_LATITUDE_DEG: 52.849739,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032600',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6775372,
        LOCATION_LATITUDE_DEG: 53.3406434,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032400',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8086529,
        LOCATION_LATITUDE_DEG: 52.2773455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE991001',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032300',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.498983,
        LOCATION_LATITUDE_DEG: 53.2997866,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE032500',
        LOCATION_NAME: 'Newcastle',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0647675,
        LOCATION_LATITUDE_DEG: 53.0680918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034000',
        LOCATION_NAME: 'Newcastle West',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0651572,
        LOCATION_LATITUDE_DEG: 52.4516177,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE034200',
        LOCATION_NAME: 'Newcestown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659414,
        LOCATION_LATITUDE_DEG: 51.7829507,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE038300',
        LOCATION_NAME: 'Newinn',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8911937,
        LOCATION_LATITUDE_DEG: 52.4365095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE019500',
        LOCATION_NAME: 'Newinns',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1823408,
        LOCATION_LATITUDE_DEG: 53.899843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039700',
        LOCATION_NAME: 'Newmarket',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0027952,
        LOCATION_LATITUDE_DEG: 52.2210976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039800',
        LOCATION_NAME: 'Newmarket',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.265776,
        LOCATION_LATITUDE_DEG: 52.4664142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE039900',
        LOCATION_NAME: 'Newmarket on Fergus',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8944665,
        LOCATION_LATITUDE_DEG: 52.763845,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990927',
        LOCATION_NAME: 'Newmarket-On-Fergus',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990078',
        LOCATION_NAME: 'Newmills',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042600',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.550264,
        LOCATION_LATITUDE_DEG: 53.8955672,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE042500',
        LOCATION_NAME: 'Newport',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.401025,
        LOCATION_LATITUDE_DEG: 52.7121396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE990309',
        LOCATION_NAME: 'Newton Sands',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE902535',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7107217,
        LOCATION_LATITUDE_DEG: 53.4312367,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055000',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2961995,
        LOCATION_LATITUDE_DEG: 52.8703419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055100',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3699161,
        LOCATION_LATITUDE_DEG: 52.2128965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE902693',
        LOCATION_NAME: 'Newtown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9610431,
        LOCATION_LATITUDE_DEG: 52.5515281,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE902772',
        LOCATION_NAME: 'Newtown Cashel',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055400',
        LOCATION_NAME: 'Newtown Cunningham',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5208851,
        LOCATION_LATITUDE_DEG: 55.0000569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055500',
        LOCATION_NAME: 'Newtown Daly',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824815,
        LOCATION_LATITUDE_DEG: 53.1830892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058200',
        LOCATION_NAME: 'Newtown Dillon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE058250',
        LOCATION_NAME: 'Newtown Farragher',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2620586,
        LOCATION_LATITUDE_DEG: 53.7049774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055600',
        LOCATION_NAME: 'Newtown Forbes',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8382782,
        LOCATION_LATITUDE_DEG: 53.7649347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055700',
        LOCATION_NAME: 'Newtown Gore',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.674552,
        LOCATION_LATITUDE_DEG: 54.0482605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056200',
        LOCATION_NAME: 'Newtown Trim',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657051,
        LOCATION_LATITUDE_DEG: 53.5498081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056650',
        LOCATION_NAME: 'Newtownbond',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6847306,
        LOCATION_LATITUDE_DEG: 53.7258945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056800',
        LOCATION_NAME: 'Newtownburke',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4722459,
        LOCATION_LATITUDE_DEG: 54.7668459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE991123',
        LOCATION_NAME: 'Newtowncunningham',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5139,
        LOCATION_LATITUDE_DEG: 54.9981,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056400',
        LOCATION_NAME: 'Newtown-Dillon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7966082,
        LOCATION_LATITUDE_DEG: 53.9638646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057100',
        LOCATION_NAME: 'Newtownlynch',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159305,
        LOCATION_LATITUDE_DEG: 53.1664906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE055900',
        LOCATION_NAME: 'Newtownmountkennedy',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1066477,
        LOCATION_LATITUDE_DEG: 53.0875145,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE056000',
        LOCATION_NAME: 'Newtownsands',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659717,
        LOCATION_LATITUDE_DEG: 52.4997284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NE057250',
        LOCATION_NAME: 'Newtownshadrum',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7672369,
        LOCATION_LATITUDE_DEG: 52.3455943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI000400',
        LOCATION_NAME: 'Nicker',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491694,
        LOCATION_LATITUDE_DEG: 52.5664299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001500',
        LOCATION_NAME: 'Ninemilehouse',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4620666,
        LOCATION_LATITUDE_DEG: 52.4679025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NI001850',
        LOCATION_NAME: 'Nira Valley',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5934369,
        LOCATION_LATITUDE_DEG: 52.2480066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO000300',
        LOCATION_NAME: 'Nobber',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7403074,
        LOCATION_LATITUDE_DEG: 53.8151389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO001100',
        LOCATION_NAME: 'Nohavel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4044875,
        LOCATION_LATITUDE_DEG: 51.7224384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO019500',
        LOCATION_NAME: 'North Ring',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8452326,
        LOCATION_LATITUDE_DEG: 51.5998392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO990499',
        LOCATION_NAME: 'Northern Cross',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO027400',
        LOCATION_NAME: 'Northgrove',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5824093,
        LOCATION_LATITUDE_DEG: 53.0164627,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO028000',
        LOCATION_NAME: 'Northlands',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8526335,
        LOCATION_LATITUDE_DEG: 53.9674494,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NO036500',
        LOCATION_NAME: 'Noughaval',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1825472,
        LOCATION_LATITUDE_DEG: 53.0164752,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002300',
        LOCATION_NAME: 'Nurney',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323396,
        LOCATION_LATITUDE_DEG: 53.0830628,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002200',
        LOCATION_NAME: 'Nurney',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157433,
        LOCATION_LATITUDE_DEG: 52.7497288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'NU002400',
        LOCATION_NAME: 'Nursetown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6992213,
        LOCATION_LATITUDE_DEG: 52.0829821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OA003700',
        LOCATION_NAME: 'Oakpark',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.920668,
        LOCATION_LATITUDE_DEG: 52.8641595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000200',
        LOCATION_NAME: 'Oberstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5360759,
        LOCATION_LATITUDE_DEG: 53.5815565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OB000701',
        LOCATION_NAME: 'OBriensbridge',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5067911,
        LOCATION_LATITUDE_DEG: 52.7540375,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000701',
        LOCATION_NAME: "O'Callaghans Mills",
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6858466,
        LOCATION_LATITUDE_DEG: 52.8438358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OC000051',
        LOCATION_NAME: 'Ocallaghansmills',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG000600',
        LOCATION_NAME: 'Oghil',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6993027,
        LOCATION_LATITUDE_DEG: 53.1330873,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OG001000',
        LOCATION_NAME: 'Ogonnelloe',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.459779,
        LOCATION_LATITUDE_DEG: 52.8878001,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OI000100',
        LOCATION_NAME: 'Oilgate',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5334661,
        LOCATION_LATITUDE_DEG: 52.4247017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL990967',
        LOCATION_NAME: 'Old Conna',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL005000',
        LOCATION_NAME: 'Old Kilcullen',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490178,
        LOCATION_LATITUDE_DEG: 53.0997599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL006700',
        LOCATION_NAME: 'Old Pallas',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491698,
        LOCATION_LATITUDE_DEG: 52.5497158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL007800',
        LOCATION_NAME: 'Old Ross',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323382,
        LOCATION_LATITUDE_DEG: 52.3829974,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL009900',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7323761,
        LOCATION_LATITUDE_DEG: 54.9332487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010000',
        LOCATION_NAME: 'Old Town',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823875,
        LOCATION_LATITUDE_DEG: 52.8997562,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL010300',
        LOCATION_NAME: 'Old Twopothouse Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6325038,
        LOCATION_LATITUDE_DEG: 52.1829978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL015800',
        LOCATION_NAME: 'Oldbawn',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3642561,
        LOCATION_LATITUDE_DEG: 53.2782778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL011500',
        LOCATION_NAME: 'Oldbridge',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.282278,
        LOCATION_LATITUDE_DEG: 53.0497611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012300',
        LOCATION_NAME: 'Oldcastle',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325228,
        LOCATION_LATITUDE_DEG: 53.9498611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL990897',
        LOCATION_NAME: 'Oldcastle',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012200',
        LOCATION_NAME: 'Oldcastle',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1643954,
        LOCATION_LATITUDE_DEG: 53.7764349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012400',
        LOCATION_NAME: 'Oldchapel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7492265,
        LOCATION_LATITUDE_DEG: 51.7329518,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012600',
        LOCATION_NAME: 'Oldcourt',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657601,
        LOCATION_LATITUDE_DEG: 52.3329951,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL012700',
        LOCATION_NAME: 'Oldcourt',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4656838,
        LOCATION_LATITUDE_DEG: 53.1664629,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL013900',
        LOCATION_NAME: 'Oldleighlin',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157443,
        LOCATION_LATITUDE_DEG: 52.7330312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014450',
        LOCATION_NAME: 'Oldtown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9353783,
        LOCATION_LATITUDE_DEG: 53.3662026,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014300',
        LOCATION_NAME: 'Oldtown',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3431235,
        LOCATION_LATITUDE_DEG: 53.9664929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OL014400',
        LOCATION_NAME: 'Oldtown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3156666,
        LOCATION_LATITUDE_DEG: 53.5164997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: "O'000702",
        LOCATION_NAME: "O'Mbre's Forest",
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3659563,
        LOCATION_LATITUDE_DEG: 53.0880587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OM000300',
        LOCATION_NAME: 'Omeath',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.250875,
        LOCATION_LATITUDE_DEG: 54.08135,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON000100',
        LOCATION_NAME: 'Onaght',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826098,
        LOCATION_LATITUDE_DEG: 53.149785,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ON990753',
        LOCATION_NAME: 'Ongenstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OO000100',
        LOCATION_NAME: 'Oola',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658584,
        LOCATION_LATITUDE_DEG: 52.5330283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000100',
        LOCATION_NAME: 'Oran',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324566,
        LOCATION_LATITUDE_DEG: 53.6665271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR000200',
        LOCATION_NAME: 'Oranmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9257274,
        LOCATION_LATITUDE_DEG: 53.2727918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR002400',
        LOCATION_NAME: 'Oristown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7823122,
        LOCATION_LATITUDE_DEG: 53.7165175,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OR003500',
        LOCATION_NAME: 'Ormond View',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991444,
        LOCATION_LATITUDE_DEG: 53.1497829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS990935',
        LOCATION_NAME: 'Osberstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OS000700',
        LOCATION_NAME: 'Osbertown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6870385,
        LOCATION_LATITUDE_DEG: 53.2368118,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000100',
        LOCATION_NAME: 'Oughter',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991059,
        LOCATION_LATITUDE_DEG: 53.2497843,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000200',
        LOCATION_NAME: 'Oughterard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3151547,
        LOCATION_LATITUDE_DEG: 53.4288169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU000700',
        LOCATION_NAME: 'Oulart',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3990003,
        LOCATION_LATITUDE_DEG: 52.4997039,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OU001700',
        LOCATION_NAME: 'Ourtnagapple',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7318624,
        LOCATION_LATITUDE_DEG: 53.1196892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OV000300',
        LOCATION_NAME: 'Ovens',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.665914,
        LOCATION_LATITUDE_DEG: 51.8663598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000100',
        LOCATION_NAME: 'Owenduff',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326004,
        LOCATION_LATITUDE_DEG: 53.9498766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW000200',
        LOCATION_NAME: 'Ower',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1720278,
        LOCATION_LATITUDE_DEG: 53.3842557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW990289',
        LOCATION_NAME: 'Ower East',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1652609,
        LOCATION_LATITUDE_DEG: 53.3867545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OW990290',
        LOCATION_NAME: 'Ower West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1652609,
        LOCATION_LATITUDE_DEG: 53.3867545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OY991057',
        LOCATION_NAME: 'Oylegate',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4667,
        LOCATION_LATITUDE_DEG: 52.4217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'OY000200',
        LOCATION_NAME: 'Oysterhaven',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4395026,
        LOCATION_LATITUDE_DEG: 51.692942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA000800',
        LOCATION_NAME: 'Paddock',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7660203,
        LOCATION_LATITUDE_DEG: 52.4497268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA003100',
        LOCATION_NAME: 'Painestown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989495,
        LOCATION_LATITUDE_DEG: 53.6831213,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004025',
        LOCATION_NAME: 'Palace',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8201544,
        LOCATION_LATITUDE_DEG: 52.4276556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004200',
        LOCATION_NAME: 'Palace East',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9781175,
        LOCATION_LATITUDE_DEG: 52.238452,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004400',
        LOCATION_NAME: 'Palatine',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657263,
        LOCATION_LATITUDE_DEG: 52.8497441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004800',
        LOCATION_NAME: 'Pallas',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6991069,
        LOCATION_LATITUDE_DEG: 53.5665123,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004850',
        LOCATION_NAME: 'Pallas Big',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3420266,
        LOCATION_LATITUDE_DEG: 53.043917,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004950',
        LOCATION_NAME: 'Pallas Little',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3675386,
        LOCATION_LATITUDE_DEG: 53.0447727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA004900',
        LOCATION_NAME: 'Pallasgreen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491711,
        LOCATION_LATITUDE_DEG: 52.5497247,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005000',
        LOCATION_NAME: 'Pallaskenry',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659255,
        LOCATION_LATITUDE_DEG: 52.633036,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005600',
        LOCATION_NAME: 'Palmerstown',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2659351,
        LOCATION_LATITUDE_DEG: 54.2331933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA005700',
        LOCATION_NAME: 'Palmerstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 20',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.376633,
        LOCATION_LATITUDE_DEG: 53.3520868,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015300',
        LOCATION_NAME: 'Parkmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9805641,
        LOCATION_LATITUDE_DEG: 53.1694256,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA015400',
        LOCATION_NAME: 'Parknasilla',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8802534,
        LOCATION_LATITUDE_DEG: 51.8237586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA023400',
        LOCATION_NAME: 'Parslickstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3950772,
        LOCATION_LATITUDE_DEG: 53.4144428,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA016900',
        LOCATION_NAME: 'Parteen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6158433,
        LOCATION_LATITUDE_DEG: 52.6956137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA990776',
        LOCATION_NAME: 'Parteen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017500',
        LOCATION_NAME: 'Partry',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825407,
        LOCATION_LATITUDE_DEG: 53.6998453,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017700',
        LOCATION_NAME: 'Passage East',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9703504,
        LOCATION_LATITUDE_DEG: 52.2310132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA017800',
        LOCATION_NAME: 'Passage West',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.343071,
        LOCATION_LATITUDE_DEG: 51.8656602,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA019600',
        LOCATION_NAME: 'Patrickswell',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7128512,
        LOCATION_LATITUDE_DEG: 52.6008293,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021250',
        LOCATION_NAME: 'Paulstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0214625,
        LOCATION_LATITUDE_DEG: 52.6798153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PA021300',
        LOCATION_NAME: 'Paulsworth',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7097899,
        LOCATION_LATITUDE_DEG: 51.9715655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE000500',
        LOCATION_NAME: 'Peamount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4792573,
        LOCATION_LATITUDE_DEG: 53.3195065,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE003200',
        LOCATION_NAME: 'Pedlars Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492386,
        LOCATION_LATITUDE_DEG: 51.6829396,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041300',
        LOCATION_NAME: 'Pembroke',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2385108,
        LOCATION_LATITUDE_DEG: 53.337639,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE032650',
        LOCATION_NAME: 'Peppardstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6433248,
        LOCATION_LATITUDE_DEG: 52.5100691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE041400',
        LOCATION_NAME: 'Perrystown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3179174,
        LOCATION_LATITUDE_DEG: 53.3074178,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037300',
        LOCATION_NAME: 'Petersville',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823138,
        LOCATION_LATITUDE_DEG: 53.8165387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE037400',
        LOCATION_NAME: 'Peterswell',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7451923,
        LOCATION_LATITUDE_DEG: 53.1162759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE900294',
        LOCATION_NAME: 'Petitswood',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3104576,
        LOCATION_LATITUDE_DEG: 53.5284648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PE038300',
        LOCATION_NAME: 'Pettigoe',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8324217,
        LOCATION_LATITUDE_DEG: 54.5499142,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH000400',
        LOCATION_NAME: 'Philipstown',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2823653,
        LOCATION_LATITUDE_DEG: 53.2830929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PH001000',
        LOCATION_NAME: 'Phoenix Park',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3293321,
        LOCATION_LATITUDE_DEG: 53.3554077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI003900',
        LOCATION_NAME: 'Piercestown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4927287,
        LOCATION_LATITUDE_DEG: 52.286202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004000',
        LOCATION_NAME: 'Pierpoint',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5492008,
        LOCATION_LATITUDE_DEG: 52.132986,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004200',
        LOCATION_NAME: 'Pike of Rushall',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5519923,
        LOCATION_LATITUDE_DEG: 52.9514387,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI004300',
        LOCATION_NAME: 'Pike, The',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991316,
        LOCATION_LATITUDE_DEG: 52.9997669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI005600',
        LOCATION_NAME: 'Pilltown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991411,
        LOCATION_LATITUDE_DEG: 51.9663655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PI006700',
        LOCATION_NAME: 'Piltown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323908,
        LOCATION_LATITUDE_DEG: 52.3497013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL001200',
        LOCATION_NAME: 'Plassey',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5988103,
        LOCATION_LATITUDE_DEG: 52.6767254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PL003800',
        LOCATION_NAME: 'Pluck',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6323618,
        LOCATION_LATITUDE_DEG: 54.9332485,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO001800',
        LOCATION_NAME: 'Polduff',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1989785,
        LOCATION_LATITUDE_DEG: 52.5664103,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002100',
        LOCATION_NAME: 'Poles',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2976289,
        LOCATION_LATITUDE_DEG: 53.9920228,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO002963',
        LOCATION_NAME: 'Pollagh',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9784704,
        LOCATION_LATITUDE_DEG: 52.5945067,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003200',
        LOCATION_NAME: 'Pollboy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1950702,
        LOCATION_LATITUDE_DEG: 53.3161992,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO991153',
        LOCATION_NAME: 'Pollerton',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9069,
        LOCATION_LATITUDE_DEG: 52.8467,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003600',
        LOCATION_NAME: 'Pollpeasty',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7804254,
        LOCATION_LATITUDE_DEG: 52.4509149,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO003700',
        LOCATION_NAME: 'Pollremon',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6307574,
        LOCATION_LATITUDE_DEG: 53.6779372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO009300',
        LOCATION_NAME: 'Pontoon',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2130458,
        LOCATION_LATITUDE_DEG: 53.9758218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO014800',
        LOCATION_NAME: 'Port',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.265833,
        LOCATION_LATITUDE_DEG: 53.8347305,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO015600',
        LOCATION_NAME: 'Port Doon',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2002886,
        LOCATION_LATITUDE_DEG: 55.2585899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO017000',
        LOCATION_NAME: 'Port Rane',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1122207,
        LOCATION_LATITUDE_DEG: 53.4925557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018000',
        LOCATION_NAME: 'Portacloy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7825756,
        LOCATION_LATITUDE_DEG: 54.3166107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018300',
        LOCATION_NAME: 'Portahack',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.153379,
        LOCATION_LATITUDE_DEG: 55.3022857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018400',
        LOCATION_NAME: 'Portaleen',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1656986,
        LOCATION_LATITUDE_DEG: 55.3166855,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018500',
        LOCATION_NAME: 'Portarlington',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1854823,
        LOCATION_LATITUDE_DEG: 53.1594072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO018950',
        LOCATION_NAME: 'Portdrine',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7431461,
        LOCATION_LATITUDE_DEG: 52.681419,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035300',
        LOCATION_NAME: 'Porterstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4077832,
        LOCATION_LATITUDE_DEG: 53.3821231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022600',
        LOCATION_NAME: 'Portlaoise',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3029109,
        LOCATION_LATITUDE_DEG: 53.0328727,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO022700',
        LOCATION_NAME: 'Portlaw',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157992,
        LOCATION_LATITUDE_DEG: 52.2829878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023200',
        LOCATION_NAME: 'Portmagee',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.36609,
        LOCATION_LATITUDE_DEG: 51.882973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO023400',
        LOCATION_NAME: 'Portmarnock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1335634,
        LOCATION_LATITUDE_DEG: 53.4224834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO900690',
        LOCATION_NAME: 'Portnablagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9318858,
        LOCATION_LATITUDE_DEG: 55.1769935,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024200',
        LOCATION_NAME: 'Portnalong',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1823014,
        LOCATION_LATITUDE_DEG: 55.3166914,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024400',
        LOCATION_NAME: 'Portnoo',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658392,
        LOCATION_LATITUDE_DEG: 54.8332456,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO035800',
        LOCATION_NAME: 'Portobello',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2696119,
        LOCATION_LATITUDE_DEG: 53.3302844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO024900',
        LOCATION_NAME: 'Portraine',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1072344,
        LOCATION_LATITUDE_DEG: 53.4930962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025200',
        LOCATION_NAME: 'Portrinard',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.315982,
        LOCATION_LATITUDE_DEG: 52.3997159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025300',
        LOCATION_NAME: 'Portroe',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3491702,
        LOCATION_LATITUDE_DEG: 52.8830539,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025350',
        LOCATION_NAME: 'Portroyal',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2682052,
        LOCATION_LATITUDE_DEG: 53.7090468,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO025500',
        LOCATION_NAME: 'Portsalon',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6201109,
        LOCATION_LATITUDE_DEG: 55.1979749,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026600',
        LOCATION_NAME: 'Portumna',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2287437,
        LOCATION_LATITUDE_DEG: 53.0968768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO026700',
        LOCATION_NAME: 'Porturlin',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7159925,
        LOCATION_LATITUDE_DEG: 54.3166044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030700',
        LOCATION_NAME: 'Poulacapple',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323895,
        LOCATION_LATITUDE_DEG: 52.4997072,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030800',
        LOCATION_NAME: 'Poulanargid',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9277876,
        LOCATION_LATITUDE_DEG: 51.8333696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO030900',
        LOCATION_NAME: 'Poulnabonny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7377851,
        LOCATION_LATITUDE_DEG: 53.2553431,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031000',
        LOCATION_NAME: 'Poulnalour',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159373,
        LOCATION_LATITUDE_DEG: 53.0164795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO031100',
        LOCATION_NAME: 'Poulnamucky',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8158429,
        LOCATION_LATITUDE_DEG: 52.3997021,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO990581',
        LOCATION_NAME: 'Poulshone',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033100',
        LOCATION_NAME: 'Powellsborough',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6824788,
        LOCATION_LATITUDE_DEG: 54.0498795,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033200',
        LOCATION_NAME: 'Powers Cross',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324601,
        LOCATION_LATITUDE_DEG: 53.066473,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033400',
        LOCATION_NAME: 'Powerstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157485,
        LOCATION_LATITUDE_DEG: 52.5997158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PO033450',
        LOCATION_NAME: 'Powerswood',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1348152,
        LOCATION_LATITUDE_DEG: 52.4853003,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR009700',
        LOCATION_NAME: 'Priorswood',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2093886,
        LOCATION_LATITUDE_DEG: 53.4055079,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR990792',
        LOCATION_NAME: 'Prospect',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PR010800',
        LOCATION_NAME: 'Prosperous',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7490184,
        LOCATION_LATITUDE_DEG: 53.2830809,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU000200',
        LOCATION_NAME: 'Puckane',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324546,
        LOCATION_LATITUDE_DEG: 52.9330605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU991129',
        LOCATION_NAME: 'Pulathomas',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8111,
        LOCATION_LATITUDE_DEG: 54.2492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU001800',
        LOCATION_NAME: 'Pulleen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5825914,
        LOCATION_LATITUDE_DEG: 52.7330534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU990907',
        LOCATION_NAME: 'Pullough',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'PU002450',
        LOCATION_NAME: 'Punchestown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6351068,
        LOCATION_LATITUDE_DEG: 53.1864411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU000500',
        LOCATION_NAME: 'Quakers Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0159505,
        LOCATION_LATITUDE_DEG: 51.5829278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU003800',
        LOCATION_NAME: 'Queensborough',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2655988,
        LOCATION_LATITUDE_DEG: 53.7331585,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004050',
        LOCATION_NAME: 'Queensfort',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8044792,
        LOCATION_LATITUDE_DEG: 53.5584006,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU004800',
        LOCATION_NAME: 'Querrin',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5947585,
        LOCATION_LATITUDE_DEG: 52.6352835,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU990609',
        LOCATION_NAME: 'Quigleys Point',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005300',
        LOCATION_NAME: 'Quilty',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4557389,
        LOCATION_LATITUDE_DEG: 52.8188551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005400',
        LOCATION_NAME: 'Quin',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659093,
        LOCATION_LATITUDE_DEG: 52.8164499,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005600',
        LOCATION_NAME: 'Quinagh',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9206892,
        LOCATION_LATITUDE_DEG: 52.8162095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'QU005700',
        LOCATION_NAME: 'Quinalahy',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0325113,
        LOCATION_LATITUDE_DEG: 54.2665983,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004350',
        LOCATION_NAME: 'Raffeen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3552738,
        LOCATION_LATITUDE_DEG: 51.8396403,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA004600',
        LOCATION_NAME: 'Rag, The',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158326,
        LOCATION_LATITUDE_DEG: 52.7164364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990177',
        LOCATION_NAME: 'Rahaelty',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005300',
        LOCATION_NAME: 'Rahan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6242204,
        LOCATION_LATITUDE_DEG: 53.2835364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005400',
        LOCATION_NAME: 'Rahara',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1499528,
        LOCATION_LATITUDE_DEG: 53.5266865,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005500',
        LOCATION_NAME: 'Raharney',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0990511,
        LOCATION_LATITUDE_DEG: 53.5165055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005700',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492684,
        LOCATION_LATITUDE_DEG: 54.2999028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990523',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6451581,
        LOCATION_LATITUDE_DEG: 52.6261269,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005600',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991777,
        LOCATION_LATITUDE_DEG: 53.5831235,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990257',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005800',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.36578,
        LOCATION_LATITUDE_DEG: 52.9664522,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA005900',
        LOCATION_NAME: 'Raheen',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.80177,
        LOCATION_LATITUDE_DEG: 52.3928043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006000',
        LOCATION_NAME: 'Raheenagh',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0414681,
        LOCATION_LATITUDE_DEG: 52.3749949,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006050',
        LOCATION_NAME: 'Raheenroche',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0630444,
        LOCATION_LATITUDE_DEG: 52.5683492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006100',
        LOCATION_NAME: 'Raheens',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492521,
        LOCATION_LATITUDE_DEG: 53.8498574,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006200',
        LOCATION_NAME: 'Raheny',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1630698,
        LOCATION_LATITUDE_DEG: 53.385093,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006300',
        LOCATION_NAME: 'Rahillakeen',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323626,
        LOCATION_LATITUDE_DEG: 52.3329943,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA006400',
        LOCATION_NAME: 'Rahugh',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4418551,
        LOCATION_LATITUDE_DEG: 53.3325741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA007900',
        LOCATION_NAME: 'Rake Street',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492533,
        LOCATION_LATITUDE_DEG: 54.0665829,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008300',
        LOCATION_NAME: 'Ramelton',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6553417,
        LOCATION_LATITUDE_DEG: 55.0385674,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008550',
        LOCATION_NAME: 'Rampark',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2614019,
        LOCATION_LATITUDE_DEG: 53.9970766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA008600',
        LOCATION_NAME: 'Rampart',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1322363,
        LOCATION_LATITUDE_DEG: 54.0165455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA011100',
        LOCATION_NAME: 'Ramsgrange',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9021637,
        LOCATION_LATITUDE_DEG: 52.2479831,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026500',
        LOCATION_NAME: 'Ranelagh',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2540117,
        LOCATION_LATITUDE_DEG: 53.3251566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990645',
        LOCATION_NAME: 'Ransboro',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990496',
        LOCATION_NAME: 'Rantogue',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013000',
        LOCATION_NAME: 'Rapemills',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158342,
        LOCATION_LATITUDE_DEG: 52.1329837,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013100',
        LOCATION_NAME: 'Raphoe',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6139171,
        LOCATION_LATITUDE_DEG: 54.8814513,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA013700',
        LOCATION_NAME: 'Rashenny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490284,
        LOCATION_LATITUDE_DEG: 55.2832844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014800',
        LOCATION_NAME: 'Rath',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7991203,
        LOCATION_LATITUDE_DEG: 53.1330827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990232',
        LOCATION_NAME: 'Rath Peak',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA014900',
        LOCATION_NAME: 'Rathangan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9964438,
        LOCATION_LATITUDE_DEG: 53.2260863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015000',
        LOCATION_NAME: 'Rathangan',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6078981,
        LOCATION_LATITUDE_DEG: 52.2277363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015100',
        LOCATION_NAME: 'Rathanna',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8157369,
        LOCATION_LATITUDE_DEG: 52.5830097,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015200',
        LOCATION_NAME: 'Rathanny',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5818094,
        LOCATION_LATITUDE_DEG: 52.2663704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015300',
        LOCATION_NAME: 'Rathbane South',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6129473,
        LOCATION_LATITUDE_DEG: 52.6503459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015400',
        LOCATION_NAME: 'Rathbride Cross Roads',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8862515,
        LOCATION_LATITUDE_DEG: 53.1808821,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015500',
        LOCATION_NAME: 'Rathcabbin',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.027745,
        LOCATION_LATITUDE_DEG: 53.1183117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015600',
        LOCATION_NAME: 'Rathclarish',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4324071,
        LOCATION_LATITUDE_DEG: 52.4164064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015700',
        LOCATION_NAME: 'Rathcoffey',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.691499,
        LOCATION_LATITUDE_DEG: 53.3353486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015800',
        LOCATION_NAME: 'Rathcolman',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823702,
        LOCATION_LATITUDE_DEG: 53.5165091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015825',
        LOCATION_NAME: 'Rathconnel',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2895704,
        LOCATION_LATITUDE_DEG: 53.5465126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015850',
        LOCATION_NAME: 'Rathconner',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2364217,
        LOCATION_LATITUDE_DEG: 53.6853287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA015900',
        LOCATION_NAME: 'Rathconrath',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5157755,
        LOCATION_LATITUDE_DEG: 53.5165137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016000',
        LOCATION_NAME: 'Rathcool',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9659309,
        LOCATION_LATITUDE_DEG: 52.0829788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016100',
        LOCATION_NAME: 'Rathcoole',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4656389,
        LOCATION_LATITUDE_DEG: 53.2664373,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA991075',
        LOCATION_NAME: 'Rathcoole',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.975,
        LOCATION_LATITUDE_DEG: 52.096,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016200',
        LOCATION_NAME: 'Rathcooney',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4241436,
        LOCATION_LATITUDE_DEG: 51.9347194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016300',
        LOCATION_NAME: 'Rathcor',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1822391,
        LOCATION_LATITUDE_DEG: 53.9831471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016400',
        LOCATION_NAME: 'Rathcor Upper',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1989376,
        LOCATION_LATITUDE_DEG: 53.9831486,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016500',
        LOCATION_NAME: 'Rathcore',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490262,
        LOCATION_LATITUDE_DEG: 53.4498028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016600',
        LOCATION_NAME: 'Rathcorick',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3350292,
        LOCATION_LATITUDE_DEG: 53.9665836,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA991125',
        LOCATION_NAME: 'Rathcormac',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5,
        LOCATION_LATITUDE_DEG: 54.3333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA991124',
        LOCATION_NAME: 'Rathcormac',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2819,
        LOCATION_LATITUDE_DEG: 52.0792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016700',
        LOCATION_NAME: 'Rathcormack',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.475841,
        LOCATION_LATITUDE_DEG: 54.3182291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016800',
        LOCATION_NAME: 'Rathcormack',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2861684,
        LOCATION_LATITUDE_DEG: 52.0862774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA016900',
        LOCATION_NAME: 'Rathcoursey',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1943973,
        LOCATION_LATITUDE_DEG: 51.8774307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017000',
        LOCATION_NAME: 'Rathdangan',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5490002,
        LOCATION_LATITUDE_DEG: 52.9164427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017100',
        LOCATION_NAME: 'Rathdowney',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5947007,
        LOCATION_LATITUDE_DEG: 52.8535481,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017200',
        LOCATION_NAME: 'Rathdrinagh',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5156839,
        LOCATION_LATITUDE_DEG: 53.6498114,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017300',
        LOCATION_NAME: 'Rathdrum',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2391331,
        LOCATION_LATITUDE_DEG: 52.9379465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017400',
        LOCATION_NAME: 'Rathduff',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.582502,
        LOCATION_LATITUDE_DEG: 52.0163745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017500',
        LOCATION_NAME: 'Rathea',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.482593,
        LOCATION_LATITUDE_DEG: 52.3830209,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017650',
        LOCATION_NAME: 'Ratheren',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2734432,
        LOCATION_LATITUDE_DEG: 53.0624578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017700',
        LOCATION_NAME: 'Rathescar Cross',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4322707,
        LOCATION_LATITUDE_DEG: 53.8165306,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017800',
        LOCATION_NAME: 'Ratheskin',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492394,
        LOCATION_LATITUDE_DEG: 54.1998892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026100',
        LOCATION_NAME: 'Rathfarnham',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2889898,
        LOCATION_LATITUDE_DEG: 53.3023634,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA017900',
        LOCATION_NAME: 'Rathfeigh',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4822778,
        LOCATION_LATITUDE_DEG: 53.5831113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026400',
        LOCATION_NAME: 'Rathgar',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2766305,
        LOCATION_LATITUDE_DEG: 53.3160334,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018200',
        LOCATION_NAME: 'Rathgaroge',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8649771,
        LOCATION_LATITUDE_DEG: 52.4226659,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018300',
        LOCATION_NAME: 'Rathgormuck',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4991064,
        LOCATION_LATITUDE_DEG: 52.2996933,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018400',
        LOCATION_NAME: 'Rathgranagher',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659326,
        LOCATION_LATITUDE_DEG: 53.5998286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018450',
        LOCATION_NAME: 'Rathguire',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1982637,
        LOCATION_LATITUDE_DEG: 51.9551429,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018600',
        LOCATION_NAME: 'Rathkea',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2386885,
        LOCATION_LATITUDE_DEG: 52.4419616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018700',
        LOCATION_NAME: 'Rathkeale',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9240024,
        LOCATION_LATITUDE_DEG: 52.5308195,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA018900',
        LOCATION_NAME: 'Rathkenny',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.632311,
        LOCATION_LATITUDE_DEG: 53.733158,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019000',
        LOCATION_NAME: 'Rathlacken',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2541151,
        LOCATION_LATITUDE_DEG: 54.288717,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019050',
        LOCATION_NAME: 'Rathleague',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2620348,
        LOCATION_LATITUDE_DEG: 53.0176276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019100',
        LOCATION_NAME: 'Rathlee',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0375563,
        LOCATION_LATITUDE_DEG: 54.2762857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019325',
        LOCATION_NAME: 'Rathmichael',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1504904,
        LOCATION_LATITUDE_DEG: 53.2348222,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019350',
        LOCATION_NAME: 'Rathmiles',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1563334,
        LOCATION_LATITUDE_DEG: 53.1315422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA026600',
        LOCATION_NAME: 'Rathmines',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2658938,
        LOCATION_LATITUDE_DEG: 53.3231572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019400',
        LOCATION_NAME: 'Rathmines',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2646496,
        LOCATION_LATITUDE_DEG: 53.322284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019500',
        LOCATION_NAME: 'Rathmolyon',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8095957,
        LOCATION_LATITUDE_DEG: 53.4958993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019700',
        LOCATION_NAME: 'Rathmore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2194257,
        LOCATION_LATITUDE_DEG: 52.0862878,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990873',
        LOCATION_NAME: 'Rathmore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019600',
        LOCATION_NAME: 'Rathmore',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5656935,
        LOCATION_LATITUDE_DEG: 53.2164718,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019750',
        LOCATION_NAME: 'Rathmoy',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9529026,
        LOCATION_LATITUDE_DEG: 52.7282872,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019800',
        LOCATION_NAME: 'Rathmullan',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5152756,
        LOCATION_LATITUDE_DEG: 55.081362,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019850',
        LOCATION_NAME: 'Rathnamanagh',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.275001,
        LOCATION_LATITUDE_DEG: 53.0741976,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA019900',
        LOCATION_NAME: 'Rathnew',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1010811,
        LOCATION_LATITUDE_DEG: 53.0040569,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020000',
        LOCATION_NAME: 'Rathnure',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7657329,
        LOCATION_LATITUDE_DEG: 52.4997082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020300',
        LOCATION_NAME: 'Rathowen',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5244138,
        LOCATION_LATITUDE_DEG: 53.661528,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA990863',
        LOCATION_NAME: 'Rathpeacon',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020400',
        LOCATION_NAME: 'Rathribbon',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4970629,
        LOCATION_LATITUDE_DEG: 54.1870154,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020450',
        LOCATION_NAME: 'Rathsallaght',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7242788,
        LOCATION_LATITUDE_DEG: 53.038098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020500',
        LOCATION_NAME: 'Rathtroane',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7990204,
        LOCATION_LATITUDE_DEG: 53.4331002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020600',
        LOCATION_NAME: 'Rathurd',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5948002,
        LOCATION_LATITUDE_DEG: 52.6311958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA020800',
        LOCATION_NAME: 'Rathvilly',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823386,
        LOCATION_LATITUDE_DEG: 52.8664117,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021000',
        LOCATION_NAME: 'Rathwire',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490428,
        LOCATION_LATITUDE_DEG: 53.4998041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA021300',
        LOCATION_NAME: 'Ratoath',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4489764,
        LOCATION_LATITUDE_DEG: 53.4997993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA022800',
        LOCATION_NAME: 'Ravensdale',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322459,
        LOCATION_LATITUDE_DEG: 54.0498509,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RA024900',
        LOCATION_NAME: 'Rawros',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7657686,
        LOCATION_LATITUDE_DEG: 55.1832771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE000800',
        LOCATION_NAME: 'Readypenny',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4611101,
        LOCATION_LATITUDE_DEG: 53.9302912,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001000',
        LOCATION_NAME: 'Reaghstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5989827,
        LOCATION_LATITUDE_DEG: 53.8998417,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001200',
        LOCATION_NAME: 'Reananerree',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659706,
        LOCATION_LATITUDE_DEG: 51.8996657,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001300',
        LOCATION_NAME: 'Reanascreena',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0492558,
        LOCATION_LATITUDE_DEG: 51.6163332,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001400',
        LOCATION_NAME: 'Rear Cross',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324622,
        LOCATION_LATITUDE_DEG: 52.6830372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE001550',
        LOCATION_NAME: 'Reary More',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4690348,
        LOCATION_LATITUDE_DEG: 53.1655372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002200',
        LOCATION_NAME: 'Recess',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7129736,
        LOCATION_LATITUDE_DEG: 53.4675231,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE002600',
        LOCATION_NAME: 'Red Castle',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1191459,
        LOCATION_LATITUDE_DEG: 55.1628691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990608',
        LOCATION_NAME: 'Redcastle',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE004600',
        LOCATION_NAME: 'Redcross',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1489609,
        LOCATION_LATITUDE_DEG: 52.883042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006000',
        LOCATION_NAME: 'Redforge Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324481,
        LOCATION_LATITUDE_DEG: 51.982967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006100',
        LOCATION_NAME: 'Redgate',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4990007,
        LOCATION_LATITUDE_DEG: 52.4164016,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE006600',
        LOCATION_NAME: 'Redhill',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658498,
        LOCATION_LATITUDE_DEG: 53.9831621,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE007100',
        LOCATION_NAME: 'Redhills',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157515,
        LOCATION_LATITUDE_DEG: 54.0998681,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE009900',
        LOCATION_NAME: 'Reenard',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.249374,
        LOCATION_LATITUDE_DEG: 51.9163765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010000',
        LOCATION_NAME: 'Reenroe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.249372,
        LOCATION_LATITUDE_DEG: 51.8496687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE010100',
        LOCATION_NAME: 'Reens',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.999245,
        LOCATION_LATITUDE_DEG: 52.499725,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011400',
        LOCATION_NAME: 'Relaghbeg',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9490207,
        LOCATION_LATITUDE_DEG: 53.8665427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011500',
        LOCATION_NAME: 'Releagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5660192,
        LOCATION_LATITUDE_DEG: 51.7829545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE011600',
        LOCATION_NAME: 'Releagh Bridge',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5493129,
        LOCATION_LATITUDE_DEG: 51.7996592,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE012100',
        LOCATION_NAME: 'Renaghmore',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5323945,
        LOCATION_LATITUDE_DEG: 52.6497304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE990440',
        LOCATION_NAME: 'Renmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0352416,
        LOCATION_LATITUDE_DEG: 53.2798813,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RE013400',
        LOCATION_NAME: 'Rerrin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8062728,
        LOCATION_LATITUDE_DEG: 51.6356418,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RH003000',
        LOCATION_NAME: 'Rhode',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990539,
        LOCATION_LATITUDE_DEG: 53.3497936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI014000',
        LOCATION_NAME: 'Rialto',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2870567,
        LOCATION_LATITUDE_DEG: 53.3428113,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI001500',
        LOCATION_NAME: 'Richmount Hill',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.699097,
        LOCATION_LATITUDE_DEG: 53.6331227,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003200',
        LOCATION_NAME: 'Ridge',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0620623,
        LOCATION_LATITUDE_DEG: 52.7521814,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI003350',
        LOCATION_NAME: 'Ridge of Capard',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5129775,
        LOCATION_LATITUDE_DEG: 53.0883138,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006500',
        LOCATION_NAME: 'Rineanna',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9469863,
        LOCATION_LATITUDE_DEG: 52.6898426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI991118',
        LOCATION_NAME: 'Ring',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5833,
        LOCATION_LATITUDE_DEG: 52.05,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI006700',
        LOCATION_NAME: 'Ringaskiddy',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2991817,
        LOCATION_LATITUDE_DEG: 51.8136466,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013650',
        LOCATION_NAME: 'Ringkippeen',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8338491,
        LOCATION_LATITUDE_DEG: 53.5057037,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013900',
        LOCATION_NAME: 'Ringsend',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2128964,
        LOCATION_LATITUDE_DEG: 53.3417415,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008000',
        LOCATION_NAME: 'Ringville',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5824169,
        LOCATION_LATITUDE_DEG: 52.0496728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008400',
        LOCATION_NAME: 'Rinn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8159092,
        LOCATION_LATITUDE_DEG: 53.2164889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008450',
        LOCATION_NAME: 'Rinn',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3895504,
        LOCATION_LATITUDE_DEG: 53.1421041,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008500',
        LOCATION_NAME: 'Rinnagonnaght',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5159914,
        LOCATION_LATITUDE_DEG: 52.7330458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008600',
        LOCATION_NAME: 'Rinneen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.382572,
        LOCATION_LATITUDE_DEG: 52.8830702,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008700',
        LOCATION_NAME: 'Rinville',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325252,
        LOCATION_LATITUDE_DEG: 53.2498009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI008800',
        LOCATION_NAME: 'Rinvyle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9826268,
        LOCATION_LATITUDE_DEG: 53.5998353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012100',
        LOCATION_NAME: 'River',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.049326,
        LOCATION_LATITUDE_DEG: 53.9831822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012400',
        LOCATION_NAME: 'Riverchapel',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2323103,
        LOCATION_LATITUDE_DEG: 52.633052,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012700',
        LOCATION_NAME: 'Rivers Town',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8158028,
        LOCATION_LATITUDE_DEG: 53.916554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012800',
        LOCATION_NAME: 'Riverstick',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.482499,
        LOCATION_LATITUDE_DEG: 51.7663504,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013200',
        LOCATION_NAME: 'Riverstown',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991486,
        LOCATION_LATITUDE_DEG: 54.1165807,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI012900',
        LOCATION_NAME: 'Riverstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824897,
        LOCATION_LATITUDE_DEG: 51.932969,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013100',
        LOCATION_NAME: 'Riverstown',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158238,
        LOCATION_LATITUDE_DEG: 53.0830695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RI013000',
        LOCATION_NAME: 'Riverstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2152569,
        LOCATION_LATITUDE_DEG: 53.9860399,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000300',
        LOCATION_NAME: 'Roachtown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657479,
        LOCATION_LATITUDE_DEG: 53.6998279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO000500',
        LOCATION_NAME: 'Roadford',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659706,
        LOCATION_LATITUDE_DEG: 53.0164775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001500',
        LOCATION_NAME: 'Robertstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8157236,
        LOCATION_LATITUDE_DEG: 53.2664786,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO001400',
        LOCATION_NAME: 'Robertstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3643657,
        LOCATION_LATITUDE_DEG: 53.500963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002200',
        LOCATION_NAME: 'Robinstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.339723,
        LOCATION_LATITUDE_DEG: 53.5407132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002100',
        LOCATION_NAME: 'Robinstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7157004,
        LOCATION_LATITUDE_DEG: 53.5831089,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO002575',
        LOCATION_NAME: 'Roches Point',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2501556,
        LOCATION_LATITUDE_DEG: 51.7938239,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004300',
        LOCATION_NAME: 'Rochestown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3358028,
        LOCATION_LATITUDE_DEG: 51.8677554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004200',
        LOCATION_NAME: 'Rochestown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990548,
        LOCATION_LATITUDE_DEG: 52.3163956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004100',
        LOCATION_NAME: 'Rochestown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8780834,
        LOCATION_LATITUDE_DEG: 52.3690726,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004000',
        LOCATION_NAME: 'Rochestown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7724295,
        LOCATION_LATITUDE_DEG: 52.2949684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO003900',
        LOCATION_NAME: 'Rochestown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6433508,
        LOCATION_LATITUDE_DEG: 52.2517385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO004600',
        LOCATION_NAME: 'Rochfortbridge',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2914104,
        LOCATION_LATITUDE_DEG: 53.424597,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037500',
        LOCATION_NAME: 'Rockbrook',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3034105,
        LOCATION_LATITUDE_DEG: 53.3062606,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005500',
        LOCATION_NAME: 'Rockbrook',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2994295,
        LOCATION_LATITUDE_DEG: 53.2605735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005600',
        LOCATION_NAME: 'Rockchapel',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1492665,
        LOCATION_LATITUDE_DEG: 52.283002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005800',
        LOCATION_NAME: 'Rockcorry',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157333,
        LOCATION_LATITUDE_DEG: 54.1165688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO005900',
        LOCATION_NAME: 'Rockfield',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824391,
        LOCATION_LATITUDE_DEG: 53.6498283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006400',
        LOCATION_NAME: 'Rockhill',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6964645,
        LOCATION_LATITUDE_DEG: 52.4247091,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006500',
        LOCATION_NAME: 'Rockhill',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1491261,
        LOCATION_LATITUDE_DEG: 54.066576,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO006700',
        LOCATION_NAME: 'Rockland',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3323634,
        LOCATION_LATITUDE_DEG: 53.7165238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO007300',
        LOCATION_NAME: 'Rockmills',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.415874,
        LOCATION_LATITUDE_DEG: 52.2163889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO008900',
        LOCATION_NAME: 'Rodena Bridge',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3322789,
        LOCATION_LATITUDE_DEG: 52.8330366,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037300',
        LOCATION_NAME: 'Roebuck',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2190309,
        LOCATION_LATITUDE_DEG: 53.3002384,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO010400',
        LOCATION_NAME: 'Roesborough',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0125098,
        LOCATION_LATITUDE_DEG: 52.421288,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013400',
        LOCATION_NAME: 'Roney Point',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2147443,
        LOCATION_LATITUDE_DEG: 52.6020361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO013500',
        LOCATION_NAME: 'Roo',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.727694,
        LOCATION_LATITUDE_DEG: 53.2141832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014500',
        LOCATION_NAME: 'Rookwood',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824429,
        LOCATION_LATITUDE_DEG: 53.5665278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014600',
        LOCATION_NAME: 'Roonah Quay',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8993007,
        LOCATION_LATITUDE_DEG: 53.749849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO014950',
        LOCATION_NAME: 'Rooskagh',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015000',
        LOCATION_NAME: 'Rooskey',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.925804,
        LOCATION_LATITUDE_DEG: 53.8320963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015200',
        LOCATION_NAME: 'Roosky',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6658677,
        LOCATION_LATITUDE_DEG: 53.9998667,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015700',
        LOCATION_NAME: 'Rosbercon',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9688872,
        LOCATION_LATITUDE_DEG: 52.3938911,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO991026',
        LOCATION_NAME: 'Roscam',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.984974,
        LOCATION_LATITUDE_DEG: 53.264423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015800',
        LOCATION_NAME: 'Roscarberry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0356967,
        LOCATION_LATITUDE_DEG: 51.5768395,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO015900',
        LOCATION_NAME: 'Roscommon',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1972537,
        LOCATION_LATITUDE_DEG: 53.6398321,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016000',
        LOCATION_NAME: 'Roscrea',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8003871,
        LOCATION_LATITUDE_DEG: 52.9562555,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016200',
        LOCATION_NAME: 'Rosdaul',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.465867,
        LOCATION_LATITUDE_DEG: 53.6165339,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016250',
        LOCATION_NAME: 'Rosdellig',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8720034,
        LOCATION_LATITUDE_DEG: 52.5952909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO016600',
        LOCATION_NAME: 'Rose Mount',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6490907,
        LOCATION_LATITUDE_DEG: 53.4331013,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017100',
        LOCATION_NAME: 'Rosecommon',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1824345,
        LOCATION_LATITUDE_DEG: 53.6331271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO017400',
        LOCATION_NAME: 'Rosegreen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8288497,
        LOCATION_LATITUDE_DEG: 52.4653132,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO037400',
        LOCATION_NAME: 'Roselawn',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3785261,
        LOCATION_LATITUDE_DEG: 53.3867736,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO018500',
        LOCATION_NAME: 'Rosenallis',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3990885,
        LOCATION_LATITUDE_DEG: 53.1330746,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019600',
        LOCATION_NAME: 'Rosgreen',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8367744,
        LOCATION_LATITUDE_DEG: 52.4683784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019700',
        LOCATION_NAME: 'Roshin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158178,
        LOCATION_LATITUDE_DEG: 54.5332218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO019900',
        LOCATION_NAME: 'Roskeeda',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6436504,
        LOCATION_LATITUDE_DEG: 53.3344102,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020500',
        LOCATION_NAME: 'Rosmadda',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5860652,
        LOCATION_LATITUDE_DEG: 52.7049616,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020600',
        LOCATION_NAME: 'Rosmore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9906068,
        LOCATION_LATITUDE_DEG: 51.6675632,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020700',
        LOCATION_NAME: 'Rosmuck',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.615991,
        LOCATION_LATITUDE_DEG: 53.3665085,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO020800',
        LOCATION_NAME: 'Rosmult',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9658224,
        LOCATION_LATITUDE_DEG: 52.6830312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021000',
        LOCATION_NAME: 'Ross',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493227,
        LOCATION_LATITUDE_DEG: 52.5830333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021100',
        LOCATION_NAME: 'Ross',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5772196,
        LOCATION_LATITUDE_DEG: 53.5678842,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021200',
        LOCATION_NAME: 'Ross Behy',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9743504,
        LOCATION_LATITUDE_DEG: 52.0496799,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO990933',
        LOCATION_NAME: 'Ross Cross',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021300',
        LOCATION_NAME: 'Ross Cross Roads',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5656892,
        LOCATION_LATITUDE_DEG: 53.5665082,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021400',
        LOCATION_NAME: 'Ross Port',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7992867,
        LOCATION_LATITUDE_DEG: 54.2831963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021500',
        LOCATION_NAME: 'Ross West',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2492393,
        LOCATION_LATITUDE_DEG: 53.9165645,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021800',
        LOCATION_NAME: 'Rossadrehid',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1167351,
        LOCATION_LATITUDE_DEG: 52.4122578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO021900',
        LOCATION_NAME: 'Rossaveel',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5492937,
        LOCATION_LATITUDE_DEG: 53.2665054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022000',
        LOCATION_NAME: 'Rossbrin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4825933,
        LOCATION_LATITUDE_DEG: 51.532938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022100',
        LOCATION_NAME: 'Rosscahill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2553105,
        LOCATION_LATITUDE_DEG: 53.4010119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022300',
        LOCATION_NAME: 'Rossduff',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.015767,
        LOCATION_LATITUDE_DEG: 52.1996841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022500',
        LOCATION_NAME: 'Rosses Point',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491627,
        LOCATION_LATITUDE_DEG: 54.3165962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO022900',
        LOCATION_NAME: 'Rossinan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1657724,
        LOCATION_LATITUDE_DEG: 52.3329925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023100',
        LOCATION_NAME: 'Rossinver',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.115825,
        LOCATION_LATITUDE_DEG: 54.383202,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023300',
        LOCATION_NAME: 'Rosslare',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3956064,
        LOCATION_LATITUDE_DEG: 52.2741805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023400',
        LOCATION_NAME: 'Rosslare Harbour',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3486229,
        LOCATION_LATITUDE_DEG: 52.2506844,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023550',
        LOCATION_NAME: 'Rossleaghan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3227384,
        LOCATION_LATITUDE_DEG: 53.063326,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023800',
        LOCATION_NAME: 'Rossmore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5826015,
        LOCATION_LATITUDE_DEG: 52.1496942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023850',
        LOCATION_NAME: 'Rossmore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9584946,
        LOCATION_LATITUDE_DEG: 51.6444378,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023700',
        LOCATION_NAME: 'Rossmore',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990425,
        LOCATION_LATITUDE_DEG: 52.8164372,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO023900',
        LOCATION_NAME: 'Rossnakill',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823665,
        LOCATION_LATITUDE_DEG: 55.1832793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024000',
        LOCATION_NAME: 'Rossnowlagh Lower',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991133,
        LOCATION_LATITUDE_DEG: 54.5666254,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024100',
        LOCATION_NAME: 'Rossnowlagh Upper',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991263,
        LOCATION_LATITUDE_DEG: 54.5499199,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO024300',
        LOCATION_NAME: 'Rostellan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1771114,
        LOCATION_LATITUDE_DEG: 51.8455756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO025000',
        LOCATION_NAME: 'Rosturk',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7318155,
        LOCATION_LATITUDE_DEG: 53.9031617,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029100',
        LOCATION_NAME: 'Roundfort',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0992215,
        LOCATION_LATITUDE_DEG: 53.6331405,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO029400',
        LOCATION_NAME: 'Roundstone',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9232281,
        LOCATION_LATITUDE_DEG: 53.3995098,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030000',
        LOCATION_NAME: 'Roundtown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2895303,
        LOCATION_LATITUDE_DEG: 53.3147777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO030200',
        LOCATION_NAME: 'Roundwood',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2333379,
        LOCATION_LATITUDE_DEG: 53.0651551,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO034600',
        LOCATION_NAME: 'Roxborough',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6054076,
        LOCATION_LATITUDE_DEG: 52.6130483,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035300',
        LOCATION_NAME: 'Roy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493188,
        LOCATION_LATITUDE_DEG: 54.0831788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035350',
        LOCATION_NAME: 'Roy',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7894998,
        LOCATION_LATITUDE_DEG: 53.5952524,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RO035600',
        LOCATION_NAME: 'Royaloak',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.982345,
        LOCATION_LATITUDE_DEG: 52.6997216,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU000300',
        LOCATION_NAME: 'Ruan',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.982542,
        LOCATION_LATITUDE_DEG: 52.9164656,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005150',
        LOCATION_NAME: 'Runnabrackan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3454322,
        LOCATION_LATITUDE_DEG: 53.6864968,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005175',
        LOCATION_NAME: 'Runnamoat',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3575089,
        LOCATION_LATITUDE_DEG: 53.698534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU005900',
        LOCATION_NAME: 'Rush',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1106307,
        LOCATION_LATITUDE_DEG: 53.5212995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006800',
        LOCATION_NAME: 'Rushbrooke',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158752,
        LOCATION_LATITUDE_DEG: 51.8496593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU006600',
        LOCATION_NAME: 'Rushbrooke',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7974419,
        LOCATION_LATITUDE_DEG: 52.954194,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU991101',
        LOCATION_NAME: 'Rusheenduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.99741,
        LOCATION_LATITUDE_DEG: 53.6034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU990954',
        LOCATION_NAME: 'Rusheens',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU991100',
        LOCATION_NAME: 'Rushneenduff',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.99741,
        LOCATION_LATITUDE_DEG: 53.6034,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU009550',
        LOCATION_NAME: 'Russellstown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491284,
        LOCATION_LATITUDE_DEG: 52.3163964,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU990827',
        LOCATION_NAME: 'Russellstown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RU010900',
        LOCATION_NAME: 'Rutland',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8631499,
        LOCATION_LATITUDE_DEG: 52.8426685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY000900',
        LOCATION_NAME: 'Ryefield',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490419,
        LOCATION_LATITUDE_DEG: 53.7831336,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY001250',
        LOCATION_NAME: 'Ryehill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7312089,
        LOCATION_LATITUDE_DEG: 53.5300292,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY990056',
        LOCATION_NAME: 'Ryehill Demesne',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6911263,
        LOCATION_LATITUDE_DEG: 53.4005263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'RY002000',
        LOCATION_NAME: 'Rylane Cross',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8325314,
        LOCATION_LATITUDE_DEG: 51.9829777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA001200',
        LOCATION_NAME: 'Saggart',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4441895,
        LOCATION_LATITUDE_DEG: 53.2799808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA990981',
        LOCATION_NAME: 'Saint Lukes',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002600',
        LOCATION_NAME: 'Saleen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4659922,
        LOCATION_LATITUDE_DEG: 52.549735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA002700',
        LOCATION_NAME: 'Saleen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1593112,
        LOCATION_LATITUDE_DEG: 51.8652687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA004600',
        LOCATION_NAME: 'Salia',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9493074,
        LOCATION_LATITUDE_DEG: 53.9498704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005000',
        LOCATION_NAME: 'Sallins',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.665714,
        LOCATION_LATITUDE_DEG: 53.24978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005200',
        LOCATION_NAME: 'Sallybank',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6236089,
        LOCATION_LATITUDE_DEG: 52.7672328,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005300',
        LOCATION_NAME: 'Sallybrook',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991991,
        LOCATION_LATITUDE_DEG: 51.9329677,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA990790',
        LOCATION_NAME: 'Sallynoggin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005400',
        LOCATION_NAME: 'Sallynogin',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1367633,
        LOCATION_LATITUDE_DEG: 53.2755775,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA005800',
        LOCATION_NAME: 'Salrock',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493145,
        LOCATION_LATITUDE_DEG: 53.5998303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA006200',
        LOCATION_NAME: 'Salt Hill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0776641,
        LOCATION_LATITUDE_DEG: 53.2596997,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA007900',
        LOCATION_NAME: 'Salterstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.298954,
        LOCATION_LATITUDE_DEG: 53.8665368,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008400',
        LOCATION_NAME: 'Salthill',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.074969,
        LOCATION_LATITUDE_DEG: 53.2623832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA008900',
        LOCATION_NAME: 'Saltmills',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8338189,
        LOCATION_LATITUDE_DEG: 52.2196789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029700',
        LOCATION_NAME: 'Sandford',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.249948,
        LOCATION_LATITUDE_DEG: 53.3235833,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018200',
        LOCATION_NAME: 'Sandy Cove',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5297757,
        LOCATION_LATITUDE_DEG: 51.6700432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA018400',
        LOCATION_NAME: 'Sandy Ford',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4656874,
        LOCATION_LATITUDE_DEG: 52.8497414,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA990925',
        LOCATION_NAME: 'Sandycove',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029300',
        LOCATION_NAME: 'Sandyford',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2242715,
        LOCATION_LATITUDE_DEG: 53.2780465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA019600',
        LOCATION_NAME: 'Sandymount',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3656532,
        LOCATION_LATITUDE_DEG: 53.9665449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029600',
        LOCATION_NAME: 'Sandymount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 4',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2123827,
        LOCATION_LATITUDE_DEG: 53.3336446,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA020600',
        LOCATION_NAME: 'Santry',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2534231,
        LOCATION_LATITUDE_DEG: 53.3962885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA029800',
        LOCATION_NAME: 'Santry',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2532763,
        LOCATION_LATITUDE_DEG: 53.3960238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA022200',
        LOCATION_NAME: 'Sarnaght',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159426,
        LOCATION_LATITUDE_DEG: 53.8998633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA023400',
        LOCATION_NAME: 'Sarsfieldcourt',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3993534,
        LOCATION_LATITUDE_DEG: 51.9530143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SA025100',
        LOCATION_NAME: 'Saundersville',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823147,
        LOCATION_LATITUDE_DEG: 52.9664498,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC001600',
        LOCATION_NAME: 'Scalp',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823054,
        LOCATION_LATITUDE_DEG: 53.0830661,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003200',
        LOCATION_NAME: 'Scardaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.999223,
        LOCATION_LATITUDE_DEG: 53.6498427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003100',
        LOCATION_NAME: 'Scardaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.999223,
        LOCATION_LATITUDE_DEG: 53.6498427,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC990646',
        LOCATION_NAME: 'Scarden',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC003800',
        LOCATION_NAME: 'Scarnagh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2193175,
        LOCATION_LATITUDE_DEG: 52.7560756,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004100',
        LOCATION_NAME: 'Scarriff',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5268619,
        LOCATION_LATITUDE_DEG: 52.9150633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC991030',
        LOCATION_NAME: 'Scart',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5481,
        LOCATION_LATITUDE_DEG: 52.6081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004400',
        LOCATION_NAME: 'Scartaglen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.412565,
        LOCATION_LATITUDE_DEG: 52.1802066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004500',
        LOCATION_NAME: 'Scartaglin',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3992825,
        LOCATION_LATITUDE_DEG: 52.1830002,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC004750',
        LOCATION_NAME: 'Scartleigh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.531826,
        LOCATION_LATITUDE_DEG: 52.4424687,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC990221',
        LOCATION_NAME: 'Schull',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC008900',
        LOCATION_NAME: 'Scotshouse',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2490443,
        LOCATION_LATITUDE_DEG: 54.116566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC009000',
        LOCATION_NAME: 'Scotstown',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657222,
        LOCATION_LATITUDE_DEG: 54.2665805,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC010700',
        LOCATION_NAME: 'Scrabby',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5323768,
        LOCATION_LATITUDE_DEG: 53.8665526,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011100',
        LOCATION_NAME: 'Scrahan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3659767,
        LOCATION_LATITUDE_DEG: 52.3997121,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011200',
        LOCATION_NAME: 'Scramoge',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0219688,
        LOCATION_LATITUDE_DEG: 53.7583459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011800',
        LOCATION_NAME: 'Screeb',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5544793,
        LOCATION_LATITUDE_DEG: 53.3907092,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007100',
        LOCATION_NAME: 'Screen',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4077255,
        LOCATION_LATITUDE_DEG: 52.4123688,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC011900',
        LOCATION_NAME: 'Scregg East',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5658769,
        LOCATION_LATITUDE_DEG: 53.5331197,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012000',
        LOCATION_NAME: 'Scregg West',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5824771,
        LOCATION_LATITUDE_DEG: 53.5331218,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC012100',
        LOCATION_NAME: 'Screggan',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5401964,
        LOCATION_LATITUDE_DEG: 53.2594857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SC014300',
        LOCATION_NAME: 'Scribblestown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3582098,
        LOCATION_LATITUDE_DEG: 53.3872214,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE000300',
        LOCATION_NAME: 'Sea Mount',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1322592,
        LOCATION_LATITUDE_DEG: 53.4330903,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE001150',
        LOCATION_NAME: 'Seafield',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4898286,
        LOCATION_LATITUDE_DEG: 52.8071356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE007000',
        LOCATION_NAME: 'Seershin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159562,
        LOCATION_LATITUDE_DEG: 53.2664956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE010600',
        LOCATION_NAME: 'Seltannaveeny',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1158266,
        LOCATION_LATITUDE_DEG: 54.0998685,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012200',
        LOCATION_NAME: 'Seskinrea',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.065752,
        LOCATION_LATITUDE_DEG: 52.7664325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE012300',
        LOCATION_NAME: 'Seskinryan',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157559,
        LOCATION_LATITUDE_DEG: 52.683033,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SE013500',
        LOCATION_NAME: 'Seven Stars, The',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8823336,
        LOCATION_LATITUDE_DEG: 53.0497537,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041250',
        LOCATION_NAME: 'Shaen',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2541057,
        LOCATION_LATITUDE_DEG: 53.0848363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH001550',
        LOCATION_NAME: 'Shalee',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2983198,
        LOCATION_LATITUDE_DEG: 52.7907304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002250',
        LOCATION_NAME: 'Shamballymore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7896826,
        LOCATION_LATITUDE_DEG: 53.6450664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002400',
        LOCATION_NAME: 'Shanagarry',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324557,
        LOCATION_LATITUDE_DEG: 51.8496532,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002500',
        LOCATION_NAME: 'Shanagolden',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1012585,
        LOCATION_LATITUDE_DEG: 52.5720317,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002550',
        LOCATION_NAME: 'Shanahill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8071702,
        LOCATION_LATITUDE_DEG: 52.1819909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002600',
        LOCATION_NAME: 'Shanahoe',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.419145,
        LOCATION_LATITUDE_DEG: 52.9232211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002650',
        LOCATION_NAME: 'Shanavougha',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1791174,
        LOCATION_LATITUDE_DEG: 51.9962412,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002900',
        LOCATION_NAME: 'Shanbally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7703078,
        LOCATION_LATITUDE_DEG: 53.2256219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002700',
        LOCATION_NAME: 'Shanbally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3966831,
        LOCATION_LATITUDE_DEG: 53.1175633,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH002800',
        LOCATION_NAME: 'Shanbally',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3566876,
        LOCATION_LATITUDE_DEG: 51.8321613,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003000',
        LOCATION_NAME: 'Shanballymore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4659013,
        LOCATION_LATITUDE_DEG: 52.216394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003025',
        LOCATION_NAME: 'Shanbeg',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3941667,
        LOCATION_LATITUDE_DEG: 53.1370248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003050',
        LOCATION_NAME: 'Shandangan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8649453,
        LOCATION_LATITUDE_DEG: 51.8751104,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003600',
        LOCATION_NAME: 'Shankill',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1268304,
        LOCATION_LATITUDE_DEG: 53.2293925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003800',
        LOCATION_NAME: 'Shanlaragh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659577,
        LOCATION_LATITUDE_DEG: 51.7829502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH003900',
        LOCATION_NAME: 'Shanlis Cross Roads',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5656758,
        LOCATION_LATITUDE_DEG: 53.8331383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004000',
        LOCATION_NAME: 'Shannaghmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991884,
        LOCATION_LATITUDE_DEG: 53.5998311,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004100',
        LOCATION_NAME: 'Shannakyle',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5906521,
        LOCATION_LATITUDE_DEG: 52.6986261,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004300',
        LOCATION_NAME: 'Shannon',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8859003,
        LOCATION_LATITUDE_DEG: 52.7081881,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004400',
        LOCATION_NAME: 'Shannon Airport',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.913368,
        LOCATION_LATITUDE_DEG: 52.6934299,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004500',
        LOCATION_NAME: 'Shannon Harbour',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9474506,
        LOCATION_LATITUDE_DEG: 53.2203426,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004600',
        LOCATION_NAME: 'Shannon Vale',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8820457,
        LOCATION_LATITUDE_DEG: 51.6447942,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004700',
        LOCATION_NAME: 'Shannonbridge',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0324207,
        LOCATION_LATITUDE_DEG: 53.2664887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990057',
        LOCATION_NAME: 'Shantallow',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8463055,
        LOCATION_LATITUDE_DEG: 53.2735534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004800',
        LOCATION_NAME: 'Shantonagh',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8490038,
        LOCATION_LATITUDE_DEG: 54.0331608,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH004900',
        LOCATION_NAME: 'Shanvally',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9158089,
        LOCATION_LATITUDE_DEG: 53.7831435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH009600',
        LOCATION_NAME: 'Sheeanamore',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3489769,
        LOCATION_LATITUDE_DEG: 52.8830447,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH041000',
        LOCATION_NAME: 'Sheepmore',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH991144',
        LOCATION_NAME: 'Sheepwalk',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1903,
        LOCATION_LATITUDE_DEG: 52.8283,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020000',
        LOCATION_NAME: 'Shercock',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8977664,
        LOCATION_LATITUDE_DEG: 53.9965521,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH020900',
        LOCATION_NAME: 'Sheriffhill',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.799028,
        LOCATION_LATITUDE_DEG: 52.9497441,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022400',
        LOCATION_NAME: 'Sheshia',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659408,
        LOCATION_LATITUDE_DEG: 53.099787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH022450',
        LOCATION_NAME: 'Sheskin',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1705634,
        LOCATION_LATITUDE_DEG: 53.146944,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH024000',
        LOCATION_NAME: 'Shillelagh',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5433065,
        LOCATION_LATITUDE_DEG: 52.748126,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH990867',
        LOCATION_NAME: 'Shinglis',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH026100',
        LOCATION_NAME: 'Shinrone',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.915844,
        LOCATION_LATITUDE_DEG: 52.9830571,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036100',
        LOCATION_NAME: 'Shrah',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3361238,
        LOCATION_LATITUDE_DEG: 53.6837349,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH036950',
        LOCATION_NAME: 'Shrod',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7468744,
        LOCATION_LATITUDE_DEG: 53.7230826,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037000',
        LOCATION_NAME: 'Shrone',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4825885,
        LOCATION_LATITUDE_DEG: 52.5164303,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037100',
        LOCATION_NAME: 'Shronell',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.232472,
        LOCATION_LATITUDE_DEG: 52.4664147,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037200',
        LOCATION_NAME: 'Shronowen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.44929,
        LOCATION_LATITUDE_DEG: 52.4997279,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SH037500',
        LOCATION_NAME: 'Shrule',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0915778,
        LOCATION_LATITUDE_DEG: 53.5304323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI001800',
        LOCATION_NAME: 'Siddan',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6489895,
        LOCATION_LATITUDE_DEG: 53.7998338,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI005300',
        LOCATION_NAME: 'Silver Stream',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157025,
        LOCATION_LATITUDE_DEG: 54.2665779,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI006000',
        LOCATION_NAME: 'Silvermines',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2324657,
        LOCATION_LATITUDE_DEG: 52.7830459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007700',
        LOCATION_NAME: 'Singland',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.594726,
        LOCATION_LATITUDE_DEG: 52.6612822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI007800',
        LOCATION_NAME: 'Single Street',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2658302,
        LOCATION_LATITUDE_DEG: 54.4832148,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SI009700',
        LOCATION_NAME: 'Sixmilebridge',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7697567,
        LOCATION_LATITUDE_DEG: 52.7455512,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000400',
        LOCATION_NAME: 'Skeagh',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492789,
        LOCATION_LATITUDE_DEG: 51.5829361,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK000500',
        LOCATION_NAME: 'Skeaghvasteen',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.995606,
        LOCATION_LATITUDE_DEG: 52.5878255,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK001200',
        LOCATION_NAME: 'Skehanagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6324935,
        LOCATION_LATITUDE_DEG: 53.4165122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003100',
        LOCATION_NAME: 'Skenakilla Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5159027,
        LOCATION_LATITUDE_DEG: 52.1829847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003700',
        LOCATION_NAME: 'Skerries',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1137613,
        LOCATION_LATITUDE_DEG: 53.5771841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK003750',
        LOCATION_NAME: 'Skerry',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4181496,
        LOCATION_LATITUDE_DEG: 53.1026458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK004300',
        LOCATION_NAME: 'Skibbereen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2686793,
        LOCATION_LATITUDE_DEG: 51.5560268,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007300',
        LOCATION_NAME: 'Skreen',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7158826,
        LOCATION_LATITUDE_DEG: 54.2331895,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007200',
        LOCATION_NAME: 'Skreen',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5618225,
        LOCATION_LATITUDE_DEG: 53.5851735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SK007400',
        LOCATION_NAME: 'Skull',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5531272,
        LOCATION_LATITUDE_DEG: 51.5318344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL000500',
        LOCATION_NAME: 'Slade',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9157645,
        LOCATION_LATITUDE_DEG: 52.1329669,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001500',
        LOCATION_NAME: 'Slane',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5408827,
        LOCATION_LATITUDE_DEG: 53.7129286,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL001550',
        LOCATION_NAME: 'Slanemore',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4359821,
        LOCATION_LATITUDE_DEG: 53.5463642,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003300',
        LOCATION_NAME: 'Sleatygraigue',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657419,
        LOCATION_LATITUDE_DEG: 52.8497421,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003800',
        LOCATION_NAME: 'Slievemore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.066025,
        LOCATION_LATITUDE_DEG: 54.0165711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL003900',
        LOCATION_NAME: 'Slievenakilla',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9324064,
        LOCATION_LATITUDE_DEG: 54.1498792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004050',
        LOCATION_NAME: 'Slieveroe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1962082,
        LOCATION_LATITUDE_DEG: 53.4672927,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004000',
        LOCATION_NAME: 'Slieveroe',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0657684,
        LOCATION_LATITUDE_DEG: 52.2829907,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL990687',
        LOCATION_NAME: 'Slieverue',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004100',
        LOCATION_NAME: 'Sligeach',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824668,
        LOCATION_LATITUDE_DEG: 54.2665962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SL004200',
        LOCATION_NAME: 'Sligo',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4741507,
        LOCATION_LATITUDE_DEG: 54.2780871,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM002400',
        LOCATION_NAME: 'Smerwick',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.41609,
        LOCATION_LATITUDE_DEG: 52.1997042,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003000',
        LOCATION_NAME: 'Smithborough',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0610104,
        LOCATION_LATITUDE_DEG: 54.2354695,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM003350',
        LOCATION_NAME: 'Smithstown',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8744216,
        LOCATION_LATITUDE_DEG: 52.7191806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SM991018',
        LOCATION_NAME: 'Smithstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2953,
        LOCATION_LATITUDE_DEG: 53.6803,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN002000',
        LOCATION_NAME: 'Sneem',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9086959,
        LOCATION_LATITUDE_DEG: 51.8414668,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SN004500',
        LOCATION_NAME: 'Snugboro',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3878556,
        LOCATION_LATITUDE_DEG: 53.3937722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO900149',
        LOCATION_NAME: 'Sonnagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5000264,
        LOCATION_LATITUDE_DEG: 53.6132077,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO990647',
        LOCATION_NAME: 'Sooey',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO003600',
        LOCATION_NAME: 'Soppog',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157185,
        LOCATION_LATITUDE_DEG: 55.0666612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031900',
        LOCATION_NAME: 'South Circular Road',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2937128,
        LOCATION_LATITUDE_DEG: 53.3362017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SO031800',
        LOCATION_NAME: 'South Quays',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 2',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2828044,
        LOCATION_LATITUDE_DEG: 53.3669411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP000100',
        LOCATION_NAME: 'Spa',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826277,
        LOCATION_LATITUDE_DEG: 52.283012,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001100',
        LOCATION_NAME: 'Spancil Hill',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992203,
        LOCATION_LATITUDE_DEG: 52.8664599,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP001200',
        LOCATION_NAME: 'Spanish Point',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4373475,
        LOCATION_LATITUDE_DEG: 52.8494822,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP003200',
        LOCATION_NAME: 'Spear Vale',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990177,
        LOCATION_LATITUDE_DEG: 53.9165449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005300',
        LOCATION_NAME: 'Spiddle',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3015053,
        LOCATION_LATITUDE_DEG: 53.2493024,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP005500',
        LOCATION_NAME: 'Spink',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2157757,
        LOCATION_LATITUDE_DEG: 52.8997475,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP006700',
        LOCATION_NAME: 'Spittle',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324741,
        LOCATION_LATITUDE_DEG: 52.3830064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SP007900',
        LOCATION_NAME: 'Sporthouse Cross Roads',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1823826,
        LOCATION_LATITUDE_DEG: 52.199675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SR000100',
        LOCATION_NAME: 'Srah',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9325993,
        LOCATION_LATITUDE_DEG: 54.1665959,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SR000200',
        LOCATION_NAME: 'Srah',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491276,
        LOCATION_LATITUDE_DEG: 53.2830887,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SR000300',
        LOCATION_NAME: 'Srahduggaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7325914,
        LOCATION_LATITUDE_DEG: 53.9998713,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SR000400',
        LOCATION_NAME: 'Srahlaghy',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659594,
        LOCATION_LATITUDE_DEG: 54.233196,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SR000500',
        LOCATION_NAME: 'Srahmore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5659782,
        LOCATION_LATITUDE_DEG: 53.9498682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118200',
        LOCATION_NAME: 'St Catherines',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST118700',
        LOCATION_NAME: 'St Clerens',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST120600',
        LOCATION_NAME: 'St Johns Port',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103600',
        LOCATION_NAME: 'St Johnston',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST103800',
        LOCATION_NAME: 'St Johnstown',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST105700',
        LOCATION_NAME: 'St Leonards',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST106400',
        LOCATION_NAME: 'St Margarets',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST098300',
        LOCATION_NAME: 'St Mullins',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST099800',
        LOCATION_NAME: 'St Patrickswell',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST000900',
        LOCATION_NAME: "St. Ann's",
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5992151,
        LOCATION_LATITUDE_DEG: 51.9329644,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST003900',
        LOCATION_NAME: 'St. Catherines',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5991881,
        LOCATION_LATITUDE_DEG: 52.866458,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST004400',
        LOCATION_NAME: 'St. Clerens',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6571997,
        LOCATION_LATITUDE_DEG: 53.2440646,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST010800',
        LOCATION_NAME: 'St. Johns Port',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6065394,
        LOCATION_LATITUDE_DEG: 54.3437015,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011000',
        LOCATION_NAME: 'St. Johnston',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.460267,
        LOCATION_LATITUDE_DEG: 54.9349491,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011250',
        LOCATION_NAME: 'St. Johnstown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6452566,
        LOCATION_LATITUDE_DEG: 52.5370287,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST011200',
        LOCATION_NAME: 'St. Johnstown',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4721842,
        LOCATION_LATITUDE_DEG: 54.9463474,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST012800',
        LOCATION_NAME: 'St. Leonards',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.807393,
        LOCATION_LATITUDE_DEG: 52.2587289,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST013900',
        LOCATION_NAME: 'St. Margarets',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3002123,
        LOCATION_LATITUDE_DEG: 53.4328556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST018100',
        LOCATION_NAME: 'St. Mullins',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990496,
        LOCATION_LATITUDE_DEG: 52.4830017,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST019600',
        LOCATION_NAME: 'St. Patrickswell',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7159068,
        LOCATION_LATITUDE_DEG: 52.5997275,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022800',
        LOCATION_NAME: 'Stabannan',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4322682,
        LOCATION_LATITUDE_DEG: 53.8665369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST022900',
        LOCATION_NAME: 'Stabannon',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4050414,
        LOCATION_LATITUDE_DEG: 53.8654359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST023300',
        LOCATION_NAME: 'Stackallen',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.624963,
        LOCATION_LATITUDE_DEG: 53.6964248,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990761',
        LOCATION_NAME: 'Stamullen',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST029500',
        LOCATION_NAME: 'Stamullin',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2656568,
        LOCATION_LATITUDE_DEG: 53.6165059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST042200',
        LOCATION_NAME: 'Staplestown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7662329,
        LOCATION_LATITUDE_DEG: 53.3314624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST123500',
        LOCATION_NAME: 'Stepaside',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2264952,
        LOCATION_LATITUDE_DEG: 53.2947735,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST050500',
        LOCATION_NAME: 'Stepaside',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2133545,
        LOCATION_LATITUDE_DEG: 53.2537733,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST054800',
        LOCATION_NAME: 'Stillorgan',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.206329,
        LOCATION_LATITUDE_DEG: 53.2886772,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST068200',
        LOCATION_NAME: 'Stone Bridge',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.165741,
        LOCATION_LATITUDE_DEG: 54.1998748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069500',
        LOCATION_NAME: 'Stonefield',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8159974,
        LOCATION_LATITUDE_DEG: 54.299904,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST069900',
        LOCATION_NAME: 'Stonehall',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659203,
        LOCATION_LATITUDE_DEG: 52.6164346,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071000',
        LOCATION_NAME: 'Stonepark',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9325117,
        LOCATION_LATITUDE_DEG: 54.0165691,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071050',
        LOCATION_NAME: 'Stonepark',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8210908,
        LOCATION_LATITUDE_DEG: 53.6938382,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST071600',
        LOCATION_NAME: 'Stonetown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5491792,
        LOCATION_LATITUDE_DEG: 53.6165331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST073200',
        LOCATION_NAME: 'Stoneyford',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2313338,
        LOCATION_LATITUDE_DEG: 52.5364151,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST074400',
        LOCATION_NAME: 'Stonybatter',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4489977,
        LOCATION_LATITUDE_DEG: 52.7664284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080150',
        LOCATION_NAME: 'Straboe',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2661193,
        LOCATION_LATITUDE_DEG: 53.0802715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080600',
        LOCATION_NAME: 'Stradbally',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.066048,
        LOCATION_LATITUDE_DEG: 52.2497094,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080800',
        LOCATION_NAME: 'Stradbally',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8992191,
        LOCATION_LATITUDE_DEG: 53.2164918,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080500',
        LOCATION_NAME: 'Stradbally',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4491058,
        LOCATION_LATITUDE_DEG: 52.1329763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST080700',
        LOCATION_NAME: 'Stradbally',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1570509,
        LOCATION_LATITUDE_DEG: 53.0237595,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081000',
        LOCATION_NAME: 'Strade',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1325311,
        LOCATION_LATITUDE_DEG: 53.9165612,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST990984',
        LOCATION_NAME: 'Stradeen',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081200',
        LOCATION_NAME: 'Stradone',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2493978,
        LOCATION_LATITUDE_DEG: 53.9868544,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081400',
        LOCATION_NAME: 'Straffan',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6157039,
        LOCATION_LATITUDE_DEG: 53.2997899,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST081550',
        LOCATION_NAME: 'Strahart',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5891292,
        LOCATION_LATITUDE_DEG: 52.6142263,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082000',
        LOCATION_NAME: 'Strand',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159554,
        LOCATION_LATITUDE_DEG: 52.3997095,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082100',
        LOCATION_NAME: 'Strandhill',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5947432,
        LOCATION_LATITUDE_DEG: 54.2770188,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST082600',
        LOCATION_NAME: 'Stranorlar',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7729908,
        LOCATION_LATITUDE_DEG: 54.8061436,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST083000',
        LOCATION_NAME: 'Stratford',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823095,
        LOCATION_LATITUDE_DEG: 52.9830523,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086900',
        LOCATION_NAME: 'Streamstown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.049328,
        LOCATION_LATITUDE_DEG: 53.5165206,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST086800',
        LOCATION_NAME: 'Streamstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5823867,
        LOCATION_LATITUDE_DEG: 53.4331054,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST087500',
        LOCATION_NAME: 'Street',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4823714,
        LOCATION_LATITUDE_DEG: 53.6665266,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091050',
        LOCATION_NAME: 'Stripe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7597574,
        LOCATION_LATITUDE_DEG: 53.5264655,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST091450',
        LOCATION_NAME: 'Strokestown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1042634,
        LOCATION_LATITUDE_DEG: 53.7826495,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST092700',
        LOCATION_NAME: 'Stroove',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9413214,
        LOCATION_LATITUDE_DEG: 55.2219748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'ST093500',
        LOCATION_NAME: 'Stuake',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7659235,
        LOCATION_LATITUDE_DEG: 51.9829679,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU002500',
        LOCATION_NAME: 'Summer Cove',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.499198,
        LOCATION_LATITUDE_DEG: 51.6996462,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003050',
        LOCATION_NAME: 'Summergrove',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3807698,
        LOCATION_LATITUDE_DEG: 53.1201794,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003300',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323566,
        LOCATION_LATITUDE_DEG: 52.7997435,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003400',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7235338,
        LOCATION_LATITUDE_DEG: 53.4885948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015800',
        LOCATION_NAME: 'Summerhill',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 1',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2531904,
        LOCATION_LATITUDE_DEG: 53.3559731,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU003900',
        LOCATION_NAME: 'Summerville',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3664908,
        LOCATION_LATITUDE_DEG: 53.8025397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU004300',
        LOCATION_NAME: 'Suncroft',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8640389,
        LOCATION_LATITUDE_DEG: 53.1079554,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SU015500',
        LOCATION_NAME: 'Sutton',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 13',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1168085,
        LOCATION_LATITUDE_DEG: 53.3940769,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW002300',
        LOCATION_NAME: 'Swan',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490591,
        LOCATION_LATITUDE_DEG: 52.8830541,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW003200',
        LOCATION_NAME: 'Swanlinbar',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.699089,
        LOCATION_LATITUDE_DEG: 54.1998787,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006100',
        LOCATION_NAME: 'Sweep, The',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2323819,
        LOCATION_LATITUDE_DEG: 52.2163823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW006500',
        LOCATION_NAME: 'Swellan',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3673426,
        LOCATION_LATITUDE_DEG: 53.9878768,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008300',
        LOCATION_NAME: 'Swineford',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492038,
        LOCATION_LATITUDE_DEG: 53.9498684,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW008900',
        LOCATION_NAME: 'Swinford',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9503197,
        LOCATION_LATITUDE_DEG: 53.9443889,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SW011100',
        LOCATION_NAME: 'Swords',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2157432,
        LOCATION_LATITUDE_DEG: 53.4577967,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'SY001050',
        LOCATION_NAME: 'Sylaun',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9287108,
        LOCATION_LATITUDE_DEG: 53.5254869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001269',
        LOCATION_NAME: 'Taghmaconnell',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1826845,
        LOCATION_LATITUDE_DEG: 53.3761232,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA001900',
        LOCATION_NAME: 'Taghmon',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490272,
        LOCATION_LATITUDE_DEG: 52.3163869,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002000',
        LOCATION_NAME: 'Taghsheenod',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158102,
        LOCATION_LATITUDE_DEG: 53.6165237,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002100',
        LOCATION_NAME: 'Taghshinny',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158032,
        LOCATION_LATITUDE_DEG: 53.5998241,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002200',
        LOCATION_NAME: 'Tagoat',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3823017,
        LOCATION_LATITUDE_DEG: 52.2496796,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA002300',
        LOCATION_NAME: 'Tahilla',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326289,
        LOCATION_LATITUDE_DEG: 51.832962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA020000',
        LOCATION_NAME: 'Tallaght',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 24',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.370699,
        LOCATION_LATITUDE_DEG: 53.2890271,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA004700',
        LOCATION_NAME: 'Tallanstown',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5489849,
        LOCATION_LATITUDE_DEG: 53.9165423,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005200',
        LOCATION_NAME: 'Tallow',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0148368,
        LOCATION_LATITUDE_DEG: 52.0940763,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005300',
        LOCATION_NAME: 'Tallowbridge',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.011568,
        LOCATION_LATITUDE_DEG: 52.1065789,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA005400',
        LOCATION_NAME: 'Tallyho',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.348988,
        LOCATION_LATITUDE_DEG: 52.7997276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA008400',
        LOCATION_NAME: 'Tang',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7983801,
        LOCATION_LATITUDE_DEG: 53.5328169,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA991062',
        LOCATION_NAME: 'Tappagh',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1275,
        LOCATION_LATITUDE_DEG: 54.2086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010500',
        LOCATION_NAME: 'Tara',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5823119,
        LOCATION_LATITUDE_DEG: 53.5664741,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010600',
        LOCATION_NAME: 'Tara Hill',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.219317,
        LOCATION_LATITUDE_DEG: 52.6993666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA010700',
        LOCATION_NAME: 'Tarbert',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3813404,
        LOCATION_LATITUDE_DEG: 52.5733284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990306',
        LOCATION_NAME: 'Tarbet',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990308',
        LOCATION_NAME: 'Tarman',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012200',
        LOCATION_NAME: 'Tarmon',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3825682,
        LOCATION_LATITUDE_DEG: 52.5330369,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA990495',
        LOCATION_NAME: 'Tarmon',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA012300',
        LOCATION_NAME: 'Tarmonbarry',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA014600',
        LOCATION_NAME: 'Tashinny',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6985533,
        LOCATION_LATITUDE_DEG: 53.591782,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017100',
        LOCATION_NAME: 'Taur',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1159513,
        LOCATION_LATITUDE_DEG: 52.2329977,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017550',
        LOCATION_NAME: 'Tawlaght',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8531514,
        LOCATION_LATITUDE_DEG: 52.2793777,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017600',
        LOCATION_NAME: 'Tawny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5995509,
        LOCATION_LATITUDE_DEG: 54.6219238,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017700',
        LOCATION_NAME: 'Tawny',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6823752,
        LOCATION_LATITUDE_DEG: 55.1999784,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA017900',
        LOCATION_NAME: 'Tawnyinah',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7640636,
        LOCATION_LATITUDE_DEG: 53.9106603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018450',
        LOCATION_NAME: 'Taylorstown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9745441,
        LOCATION_LATITUDE_DEG: 53.3793682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TA018400',
        LOCATION_NAME: 'Taylorstown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8145877,
        LOCATION_LATITUDE_DEG: 52.2771806,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE000900',
        LOCATION_NAME: 'Tedavnet',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0157163,
        LOCATION_LATITUDE_DEG: 54.2831832,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001500',
        LOCATION_NAME: 'Teelin',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6320767,
        LOCATION_LATITUDE_DEG: 54.6356324,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001600',
        LOCATION_NAME: 'Teeranearagh',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.266077,
        LOCATION_LATITUDE_DEG: 51.866364,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001800',
        LOCATION_NAME: 'Teerelton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825878,
        LOCATION_LATITUDE_DEG: 51.8329958,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001700',
        LOCATION_NAME: 'Teerelton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9825377,
        LOCATION_LATITUDE_DEG: 51.8329538,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001850',
        LOCATION_NAME: 'Teergay',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0182147,
        LOCATION_LATITUDE_DEG: 51.8745185,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE001900',
        LOCATION_NAME: 'Teeromoyle',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.082647,
        LOCATION_LATITUDE_DEG: 51.9663748,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE002250',
        LOCATION_NAME: 'Teevurcher',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9219132,
        LOCATION_LATITUDE_DEG: 53.878009,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005400',
        LOCATION_NAME: 'Templebodan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2158728,
        LOCATION_LATITUDE_DEG: 51.9996666,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005500',
        LOCATION_NAME: 'Templeboy',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8158933,
        LOCATION_LATITUDE_DEG: 54.2498909,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005800',
        LOCATION_NAME: 'Templederry',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0732368,
        LOCATION_LATITUDE_DEG: 52.7718217,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE990620',
        LOCATION_NAME: 'Templeglantine',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE991006',
        LOCATION_NAME: 'Templeludigan',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE005850',
        LOCATION_NAME: 'Templelusk',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2699342,
        LOCATION_LATITUDE_DEG: 52.8556422,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006000',
        LOCATION_NAME: 'Templemartin',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7679008,
        LOCATION_LATITUDE_DEG: 51.8165565,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE990896',
        LOCATION_NAME: 'Templemichael',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006100',
        LOCATION_NAME: 'Templemore',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8485431,
        LOCATION_LATITUDE_DEG: 52.7965383,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006300',
        LOCATION_NAME: 'Templenoe',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7019275,
        LOCATION_LATITUDE_DEG: 51.8682658,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE012000',
        LOCATION_NAME: 'Templeogue',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3221168,
        LOCATION_LATITUDE_DEG: 53.2950294,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE012200',
        LOCATION_NAME: 'Templeogue',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3007414,
        LOCATION_LATITUDE_DEG: 53.3010848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006500',
        LOCATION_NAME: 'Templeshambo',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6800183,
        LOCATION_LATITUDE_DEG: 52.5793472,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006800',
        LOCATION_NAME: 'Templetouhy',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.715823,
        LOCATION_LATITUDE_DEG: 52.7830406,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE006900',
        LOCATION_NAME: 'Templetown',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8971463,
        LOCATION_LATITUDE_DEG: 52.1797766,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE012300',
        LOCATION_NAME: 'Terenure',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 6',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2750799,
        LOCATION_LATITUDE_DEG: 53.3128502,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008000',
        LOCATION_NAME: 'Termon',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8269778,
        LOCATION_LATITUDE_DEG: 55.0452106,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008100',
        LOCATION_NAME: 'Termonbarry',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9173721,
        LOCATION_LATITUDE_DEG: 53.7511392,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008200',
        LOCATION_NAME: 'Termoncarragh',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.066008,
        LOCATION_LATITUDE_DEG: 54.2499025,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE008300',
        LOCATION_NAME: 'Termonfeckin',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2753208,
        LOCATION_LATITUDE_DEG: 53.760728,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE003300',
        LOCATION_NAME: 'Terrerath',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8934545,
        LOCATION_LATITUDE_DEG: 52.3395291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009200',
        LOCATION_NAME: 'Terryglass',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.199149,
        LOCATION_LATITUDE_DEG: 53.0497744,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009300',
        LOCATION_NAME: 'Terryland',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0539564,
        LOCATION_LATITUDE_DEG: 53.2886897,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TE009500',
        LOCATION_NAME: 'Tervoe',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7282063,
        LOCATION_LATITUDE_DEG: 52.6434863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH040400',
        LOCATION_NAME: 'The Coombe',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 8',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH040000',
        LOCATION_NAME: 'The Curragh',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8328965,
        LOCATION_LATITUDE_DEG: 53.1484715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'HA042600',
        LOCATION_NAME: 'The Harrow',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4322903,
        LOCATION_LATITUDE_DEG: 52.5497116,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH005100',
        LOCATION_NAME: 'The Heath',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2234205,
        LOCATION_LATITUDE_DEG: 53.0569208,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990910',
        LOCATION_NAME: 'The Pigeons',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH008800',
        LOCATION_NAME: 'The Rower',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.969059,
        LOCATION_LATITUDE_DEG: 52.4617604,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH009300',
        LOCATION_NAME: 'The Summit',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0568935,
        LOCATION_LATITUDE_DEG: 53.3771851,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013700',
        LOCATION_NAME: 'Thomas Street',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2192935,
        LOCATION_LATITUDE_DEG: 53.4717211,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014150',
        LOCATION_NAME: 'Thomastown',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0671476,
        LOCATION_LATITUDE_DEG: 53.3700345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013800',
        LOCATION_NAME: 'Thomastown',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0158349,
        LOCATION_LATITUDE_DEG: 52.4830112,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH013900',
        LOCATION_NAME: 'Thomastown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1220777,
        LOCATION_LATITUDE_DEG: 52.5268143,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH014000',
        LOCATION_NAME: 'Thomastown',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.882324,
        LOCATION_LATITUDE_DEG: 53.3997945,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH991143',
        LOCATION_NAME: 'Threecastles',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3308,
        LOCATION_LATITUDE_DEG: 52.71,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH990585',
        LOCATION_NAME: 'Threemilehouse',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TH035600',
        LOCATION_NAME: 'Thurles',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8255706,
        LOCATION_LATITUDE_DEG: 52.6859344,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI000100',
        LOCATION_NAME: 'Tiaquin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.63249,
        LOCATION_LATITUDE_DEG: 53.3665044,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI016400',
        LOCATION_NAME: 'Ticknock',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 18',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2525964,
        LOCATION_LATITUDE_DEG: 53.3433808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003200',
        LOCATION_NAME: 'Tiduff',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9326462,
        LOCATION_LATITUDE_DEG: 52.4094219,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003500',
        LOCATION_NAME: 'Tiershanaghan',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493219,
        LOCATION_LATITUDE_DEG: 52.4205252,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI003600',
        LOCATION_NAME: 'Tievemore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7739892,
        LOCATION_LATITUDE_DEG: 54.585119,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007500',
        LOCATION_NAME: 'Timahoe',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1991215,
        LOCATION_LATITUDE_DEG: 52.9617459,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI007400',
        LOCATION_NAME: 'Timahoe',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323207,
        LOCATION_LATITUDE_DEG: 53.3330906,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008100',
        LOCATION_NAME: 'Timoleague',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7659279,
        LOCATION_LATITUDE_DEG: 51.632938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008200',
        LOCATION_NAME: 'Timolin',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8069582,
        LOCATION_LATITUDE_DEG: 52.9949488,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008800',
        LOCATION_NAME: 'Tinahely',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4710884,
        LOCATION_LATITUDE_DEG: 52.8011291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008850',
        LOCATION_NAME: 'Tinakilly',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6393962,
        LOCATION_LATITUDE_DEG: 52.483493,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI008900',
        LOCATION_NAME: 'Tinalira',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158418,
        LOCATION_LATITUDE_DEG: 52.1829773,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI009100',
        LOCATION_NAME: 'Tincoora',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8659384,
        LOCATION_LATITUDE_DEG: 52.0996827,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010000',
        LOCATION_NAME: 'Tinkerslane',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9823267,
        LOCATION_LATITUDE_DEG: 53.4998045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010250',
        LOCATION_NAME: 'Tinnahinch',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5194153,
        LOCATION_LATITUDE_DEG: 53.110978,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010200',
        LOCATION_NAME: 'Tinnahinch',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9503487,
        LOCATION_LATITUDE_DEG: 52.5389183,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI991117',
        LOCATION_NAME: 'Tinnahinch',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2192,
        LOCATION_LATITUDE_DEG: 52.8611,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010275',
        LOCATION_NAME: 'Tinnakill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1731307,
        LOCATION_LATITUDE_DEG: 53.140172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI990983',
        LOCATION_NAME: 'Tinnock',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010300',
        LOCATION_NAME: 'Tinny Park',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824565,
        LOCATION_LATITUDE_DEG: 53.6831347,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI010400',
        LOCATION_NAME: 'Tinryland',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8944643,
        LOCATION_LATITUDE_DEG: 52.7959588,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI011400',
        LOCATION_NAME: 'Tipperary',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1669045,
        LOCATION_LATITUDE_DEG: 52.477122,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012400',
        LOCATION_NAME: 'Tiragarvan',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7656975,
        LOCATION_LATITUDE_DEG: 53.9831566,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI990979',
        LOCATION_NAME: 'Tircullen',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012650',
        LOCATION_NAME: 'Tirhogar',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1731307,
        LOCATION_LATITUDE_DEG: 53.140172,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI012800',
        LOCATION_NAME: 'Tirneevin',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825112,
        LOCATION_LATITUDE_DEG: 53.0664815,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013200',
        LOCATION_NAME: 'Tirraboy',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490173,
        LOCATION_LATITUDE_DEG: 55.2499754,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI013400',
        LOCATION_NAME: 'Tisaxon',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7028059,
        LOCATION_LATITUDE_DEG: 53.3368153,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TI015400',
        LOCATION_NAME: 'Tivoli',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4308023,
        LOCATION_LATITUDE_DEG: 51.9054915,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000200',
        LOCATION_NAME: 'Toames',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9820431,
        LOCATION_LATITUDE_DEG: 51.8655022,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000300',
        LOCATION_NAME: 'Tobberoe',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8207562,
        LOCATION_LATITUDE_DEG: 53.2850055,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000500',
        LOCATION_NAME: 'Tober',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9991323,
        LOCATION_LATITUDE_DEG: 54.2165771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000400',
        LOCATION_NAME: 'Tober',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6658047,
        LOCATION_LATITUDE_DEG: 53.3664995,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000600',
        LOCATION_NAME: 'Tobercurry',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7324741,
        LOCATION_LATITUDE_DEG: 54.0498711,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO000700',
        LOCATION_NAME: 'Toberdan',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0658254,
        LOCATION_LATITUDE_DEG: 53.5331159,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO001100',
        LOCATION_NAME: 'Toberscanavan',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4991584,
        LOCATION_LATITUDE_DEG: 54.1665824,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO002700',
        LOCATION_NAME: 'Toem',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991558,
        LOCATION_LATITUDE_DEG: 52.5830276,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003600',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1659596,
        LOCATION_LATITUDE_DEG: 51.7663531,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003500',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4824967,
        LOCATION_LATITUDE_DEG: 51.8663593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003750',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3156969,
        LOCATION_LATITUDE_DEG: 53.0129304,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003300',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5156843,
        LOCATION_LATITUDE_DEG: 53.0830624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003700',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2989483,
        LOCATION_LATITUDE_DEG: 53.8331325,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003400',
        LOCATION_NAME: 'Togher',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2322705,
        LOCATION_LATITUDE_DEG: 53.0664527,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO003800',
        LOCATION_NAME: 'Togher, The',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1990591,
        LOCATION_LATITUDE_DEG: 53.083066,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006400',
        LOCATION_NAME: 'Tomacurry',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5657158,
        LOCATION_LATITUDE_DEG: 52.5497059,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006600',
        LOCATION_NAME: 'Tombrack',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5490081,
        LOCATION_LATITUDE_DEG: 52.599715,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006650',
        LOCATION_NAME: 'Tomduff',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.849045,
        LOCATION_LATITUDE_DEG: 52.6139189,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO006800',
        LOCATION_NAME: 'Tomhaggard',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4990121,
        LOCATION_LATITUDE_DEG: 52.2163783,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO990100',
        LOCATION_NAME: 'Tommard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007250',
        LOCATION_NAME: 'Tomriland',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2144262,
        LOCATION_LATITUDE_DEG: 53.0342664,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO007800',
        LOCATION_NAME: 'Tonevane',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7326481,
        LOCATION_LATITUDE_DEG: 52.2469137,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010300',
        LOCATION_NAME: 'Toomard',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4658577,
        LOCATION_LATITUDE_DEG: 53.5331171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO990835',
        LOCATION_NAME: 'Toomevara',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010500',
        LOCATION_NAME: 'Toomyvara',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0279547,
        LOCATION_LATITUDE_DEG: 52.8607582,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010600',
        LOCATION_NAME: 'Toon Bridge',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0236731,
        LOCATION_LATITUDE_DEG: 51.881587,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO990872',
        LOCATION_NAME: 'Toor',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010700',
        LOCATION_NAME: 'Tooraneena',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158385,
        LOCATION_LATITUDE_DEG: 52.1996863,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010800',
        LOCATION_NAME: 'Tooravoola',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.632503,
        LOCATION_LATITUDE_DEG: 53.0664765,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011000',
        LOCATION_NAME: 'Tooreen',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8326348,
        LOCATION_LATITUDE_DEG: 51.5496411,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO010900',
        LOCATION_NAME: 'Tooreen',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.282547,
        LOCATION_LATITUDE_DEG: 53.6665397,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011100',
        LOCATION_NAME: 'Tooreen',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7110183,
        LOCATION_LATITUDE_DEG: 52.502107,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011200',
        LOCATION_NAME: 'Tooreenbrien',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824634,
        LOCATION_LATITUDE_DEG: 52.6997394,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011300',
        LOCATION_NAME: 'Tooreencahill',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.249269,
        LOCATION_LATITUDE_DEG: 52.1496937,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011400',
        LOCATION_NAME: 'Tooreendonnell',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2325651,
        LOCATION_LATITUDE_DEG: 52.4997307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011500',
        LOCATION_NAME: 'Tooreengarriv',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2825747,
        LOCATION_LATITUDE_DEG: 52.1663892,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011600',
        LOCATION_NAME: 'Tooreens',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032657,
        LOCATION_LATITUDE_DEG: 51.8329675,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011700',
        LOCATION_NAME: 'Tooreeny',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824714,
        LOCATION_LATITUDE_DEG: 52.9997682,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011900',
        LOCATION_NAME: 'Toormore',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.032617,
        LOCATION_LATITUDE_DEG: 53.7945503,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO011800',
        LOCATION_NAME: 'Toormore',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.6537848,
        LOCATION_LATITUDE_DEG: 51.5278316,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019300',
        LOCATION_NAME: 'Tourin',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8658333,
        LOCATION_LATITUDE_DEG: 52.1163761,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019350',
        LOCATION_NAME: 'Tourlestrane',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8489677,
        LOCATION_LATITUDE_DEG: 54.0378665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO019400',
        LOCATION_NAME: 'Tourmakeady',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3665758,
        LOCATION_LATITUDE_DEG: 53.6561363,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO990619',
        LOCATION_NAME: 'Tournafulla',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TO020300',
        LOCATION_NAME: 'Tower',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5992029,
        LOCATION_LATITUDE_DEG: 51.9163665,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000150',
        LOCATION_NAME: 'Trabolgan',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2353211,
        LOCATION_LATITUDE_DEG: 51.7952359,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000200',
        LOCATION_NAME: 'Tracarta',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.190318,
        LOCATION_LATITUDE_DEG: 51.51753,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000300',
        LOCATION_NAME: 'Tracton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3991957,
        LOCATION_LATITUDE_DEG: 51.7496449,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR000800',
        LOCATION_NAME: 'Tralee',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7095729,
        LOCATION_LATITUDE_DEG: 52.2748105,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001100',
        LOCATION_NAME: 'Tramore',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1537998,
        LOCATION_LATITUDE_DEG: 52.1628759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR001200',
        LOCATION_NAME: 'Tranagh',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5824192,
        LOCATION_LATITUDE_DEG: 52.6997333,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003325',
        LOCATION_NAME: 'Trean',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.40333,
        LOCATION_LATITUDE_DEG: 53.6229553,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003350',
        LOCATION_NAME: 'Treanlaur',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4082327,
        LOCATION_LATITUDE_DEG: 53.6619781,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR003400',
        LOCATION_NAME: 'Treantagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4990508,
        LOCATION_LATITUDE_DEG: 54.916651,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR990606',
        LOCATION_NAME: 'Trentagh',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR030200',
        LOCATION_NAME: 'Trim',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7865021,
        LOCATION_LATITUDE_DEG: 53.560008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR033150',
        LOCATION_NAME: 'Trooperstown',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2514409,
        LOCATION_LATITUDE_DEG: 52.9957802,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR034000',
        LOCATION_NAME: 'Trough',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6158951,
        LOCATION_LATITUDE_DEG: 52.733043,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TR035800',
        LOCATION_NAME: 'Trusklieve',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7660237,
        LOCATION_LATITUDE_DEG: 52.6164358,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000100',
        LOCATION_NAME: 'Tuam',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8532978,
        LOCATION_LATITUDE_DEG: 53.5207193,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000200',
        LOCATION_NAME: 'Tuamgraney',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5443638,
        LOCATION_LATITUDE_DEG: 52.9006586,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000300',
        LOCATION_NAME: 'Tubber',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8825238,
        LOCATION_LATITUDE_DEG: 52.999774,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU991012',
        LOCATION_NAME: 'Tubber',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8942,
        LOCATION_LATITUDE_DEG: 52.99,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU000400',
        LOCATION_NAME: 'Tubbercurry',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7360114,
        LOCATION_LATITUDE_DEG: 54.0482758,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002600',
        LOCATION_NAME: 'Tulach Mhor',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.482382,
        LOCATION_LATITUDE_DEG: 53.266487,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002700',
        LOCATION_NAME: 'Tulla',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7544342,
        LOCATION_LATITUDE_DEG: 52.8731648,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002800',
        LOCATION_NAME: 'Tullaghan',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3324398,
        LOCATION_LATITUDE_DEG: 54.4666173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU002900',
        LOCATION_NAME: 'Tullaghanbaun',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9202463,
        LOCATION_LATITUDE_DEG: 54.0731804,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003000',
        LOCATION_NAME: 'Tullaghanoge',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657129,
        LOCATION_LATITUDE_DEG: 53.5831086,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU990750',
        LOCATION_NAME: 'Tullaghanstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003100',
        LOCATION_NAME: 'Tullagher',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0490667,
        LOCATION_LATITUDE_DEG: 52.4163965,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003300',
        LOCATION_NAME: 'Tullaghought',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3490982,
        LOCATION_LATITUDE_DEG: 52.4164081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU990861',
        LOCATION_NAME: 'Tullagubeen',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003350',
        LOCATION_NAME: 'Tullahennel',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5461972,
        LOCATION_LATITUDE_DEG: 52.5321307,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003400',
        LOCATION_NAME: 'Tullamore',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4992926,
        LOCATION_LATITUDE_DEG: 52.4830257,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003600',
        LOCATION_NAME: 'Tullamore',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1658446,
        LOCATION_LATITUDE_DEG: 54.5166155,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003500',
        LOCATION_NAME: 'Tullamore',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4929363,
        LOCATION_LATITUDE_DEG: 53.2776929,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU003700',
        LOCATION_NAME: 'Tullaroan',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.4323845,
        LOCATION_LATITUDE_DEG: 52.6497264,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004100',
        LOCATION_NAME: 'Tullig',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.8493373,
        LOCATION_LATITUDE_DEG: 52.0996834,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004000',
        LOCATION_NAME: 'Tullig',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.7826095,
        LOCATION_LATITUDE_DEG: 52.6164402,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004300',
        LOCATION_NAME: 'Tullow',
        COUNTY_NAME: 'Carlow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7380426,
        LOCATION_LATITUDE_DEG: 52.8063351,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004550',
        LOCATION_NAME: 'Tully',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8137621,
        LOCATION_LATITUDE_DEG: 53.408572,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU990909',
        LOCATION_NAME: 'Tully East',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004700',
        LOCATION_NAME: 'Tullyallen',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4156184,
        LOCATION_LATITUDE_DEG: 53.7331578,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004800',
        LOCATION_NAME: 'Tullybrook',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0824266,
        LOCATION_LATITUDE_DEG: 54.633233,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU004900',
        LOCATION_NAME: 'Tullycanna',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6823297,
        LOCATION_LATITUDE_DEG: 52.2663847,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005000',
        LOCATION_NAME: 'Tullycreen',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3492636,
        LOCATION_LATITUDE_DEG: 52.6830465,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005100',
        LOCATION_NAME: 'Tullycreen Lower',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3325752,
        LOCATION_LATITUDE_DEG: 52.666443,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005400',
        LOCATION_NAME: 'Tullyleague',
        COUNTY_NAME: 'Limerick',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159733,
        LOCATION_LATITUDE_DEG: 52.5330314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005500',
        LOCATION_NAME: 'Tullylease',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9492452,
        LOCATION_LATITUDE_DEG: 52.2997035,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005800',
        LOCATION_NAME: 'Tullynahinera',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7989981,
        LOCATION_LATITUDE_DEG: 54.0831603,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU005900',
        LOCATION_NAME: 'Tullynascreen',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824365,
        LOCATION_LATITUDE_DEG: 54.1665841,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006050',
        LOCATION_NAME: 'Tullyroe',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3881813,
        LOCATION_LATITUDE_DEG: 52.9124636,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006100',
        LOCATION_NAME: 'Tullyrossmearan',
        COUNTY_NAME: 'Leitrim',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9824147,
        LOCATION_LATITUDE_DEG: 54.3331938,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006300',
        LOCATION_NAME: 'Tullyvin',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1490389,
        LOCATION_LATITUDE_DEG: 54.0498605,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006350',
        LOCATION_NAME: 'Tullywood',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8090807,
        LOCATION_LATITUDE_DEG: 53.4153278,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006500',
        LOCATION_NAME: 'Tulrahan',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8237863,
        LOCATION_LATITUDE_DEG: 53.7022948,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU006600',
        LOCATION_NAME: 'Tulsk',
        COUNTY_NAME: 'Roscommon',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2633664,
        LOCATION_LATITUDE_DEG: 53.7831385,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009400',
        LOCATION_NAME: 'Turkstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2980548,
        LOCATION_LATITUDE_DEG: 52.3165962,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009700',
        LOCATION_NAME: 'Turlough',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.2159287,
        LOCATION_LATITUDE_DEG: 53.8831593,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009600',
        LOCATION_NAME: 'Turlough',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.0659429,
        LOCATION_LATITUDE_DEG: 53.0830745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TU009800',
        LOCATION_NAME: 'Turloughmore',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8492006,
        LOCATION_LATITUDE_DEG: 53.3831081,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002350',
        LOCATION_NAME: 'Two Mile',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3674952,
        LOCATION_LATITUDE_DEG: 53.1535624,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW002550',
        LOCATION_NAME: 'Two Mile House',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6978881,
        LOCATION_LATITUDE_DEG: 53.1691742,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003000',
        LOCATION_NAME: 'Twomileborris',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7158278,
        LOCATION_LATITUDE_DEG: 52.6664291,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TW003100',
        LOCATION_NAME: 'Twomileditch',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9992185,
        LOCATION_LATITUDE_DEG: 53.2997956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY000900',
        LOCATION_NAME: 'Tydavnet',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0200952,
        LOCATION_LATITUDE_DEG: 54.2950056,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY001500',
        LOCATION_NAME: 'Tyholland',
        COUNTY_NAME: 'Monaghan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8990059,
        LOCATION_LATITUDE_DEG: 54.2498823,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY002400',
        LOCATION_NAME: 'Tynagh',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3824642,
        LOCATION_LATITUDE_DEG: 53.1497778,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'TY003800',
        LOCATION_NAME: 'Tyrrellspass',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3942781,
        LOCATION_LATITUDE_DEG: 53.3882979,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UA000101',
        LOCATION_NAME: 'Uamera',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.8976371,
        LOCATION_LATITUDE_DEG: 51.9026893,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UL000900',
        LOCATION_NAME: 'Ullard',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9323468,
        LOCATION_LATITUDE_DEG: 52.5664184,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UM000300',
        LOCATION_NAME: 'Ummeryroe',
        COUNTY_NAME: 'Sligo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2824445,
        LOCATION_LATITUDE_DEG: 54.1165755,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UM000400',
        LOCATION_NAME: 'Umrycam',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6990582,
        LOCATION_LATITUDE_DEG: 55.1832721,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN990833',
        LOCATION_NAME: 'Union Hall',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UN001100',
        LOCATION_NAME: 'Unionhall',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1325771,
        LOCATION_LATITUDE_DEG: 51.54963,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP017200',
        LOCATION_NAME: 'Upperchurch',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.0235902,
        LOCATION_LATITUDE_DEG: 52.7036356,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UP019100',
        LOCATION_NAME: 'Upton',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6659305,
        LOCATION_LATITUDE_DEG: 51.7829492,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR990178',
        LOCATION_NAME: 'Urlingford',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.6080296,
        LOCATION_LATITUDE_DEG: 52.8094008,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'UR000400',
        LOCATION_NAME: 'Urlingford',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5837729,
        LOCATION_LATITUDE_DEG: 52.7252353,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000400',
        LOCATION_NAME: 'Valencia',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.332723,
        LOCATION_LATITUDE_DEG: 51.9163331,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000700',
        LOCATION_NAME: 'Valley',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.9693982,
        LOCATION_LATITUDE_DEG: 54.0147171,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VA000800',
        LOCATION_NAME: 'Valleymount',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5263996,
        LOCATION_LATITUDE_DEG: 53.1060941,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VE001600',
        LOCATION_NAME: 'Ventry',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.366079,
        LOCATION_LATITUDE_DEG: 52.1329993,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI990894',
        LOCATION_NAME: 'Vicarstown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000400',
        LOCATION_NAME: 'Vicarstown',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.082346,
        LOCATION_LATITUDE_DEG: 53.0497625,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI000500',
        LOCATION_NAME: 'Vicarstown Cross Roads',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.6492044,
        LOCATION_LATITUDE_DEG: 51.9329671,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI001600',
        LOCATION_NAME: 'Villierstown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8491192,
        LOCATION_LATITUDE_DEG: 52.0829792,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'VI002000',
        LOCATION_NAME: 'Virginia',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0783007,
        LOCATION_LATITUDE_DEG: 53.8381432,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044800',
        LOCATION_NAME: 'Wadelai',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 11',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2704054,
        LOCATION_LATITUDE_DEG: 53.3868643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA005700',
        LOCATION_NAME: 'Walderstown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7581222,
        LOCATION_LATITUDE_DEG: 53.4726131,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA009100',
        LOCATION_NAME: 'Walkinstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3370427,
        LOCATION_LATITUDE_DEG: 53.3155849,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA044900',
        LOCATION_NAME: 'Walkinstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 12',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3318993,
        LOCATION_LATITUDE_DEG: 53.3179045,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA013700',
        LOCATION_NAME: 'Walsh Island',
        COUNTY_NAME: 'Offaly',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.2354662,
        LOCATION_LATITUDE_DEG: 53.2187696,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014050',
        LOCATION_NAME: 'Walshestown',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3871918,
        LOCATION_LATITUDE_DEG: 53.5396853,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014200',
        LOCATION_NAME: 'Walshtown',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.1991736,
        LOCATION_LATITUDE_DEG: 51.982973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA014900',
        LOCATION_NAME: 'Walterstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5489866,
        LOCATION_LATITUDE_DEG: 53.5998076,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA021200',
        LOCATION_NAME: 'Ward',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.3383133,
        LOCATION_LATITUDE_DEG: 53.4366936,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033400',
        LOCATION_NAME: 'Waterfall',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5492034,
        LOCATION_LATITUDE_DEG: 51.8496534,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA033700',
        LOCATION_NAME: 'Waterford',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1177034,
        LOCATION_LATITUDE_DEG: 52.2538885,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA034100',
        LOCATION_NAME: 'Watergrasshill',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3419737,
        LOCATION_LATITUDE_DEG: 52.0240759,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA035200',
        LOCATION_NAME: 'Waterloo',
        COUNTY_NAME: 'Cavan',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1323347,
        LOCATION_LATITUDE_DEG: 53.9331545,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WA037700',
        LOCATION_NAME: 'Waterville',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.173462,
        LOCATION_LATITUDE_DEG: 51.8329643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE001000',
        LOCATION_NAME: 'Weatherstown',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0323519,
        LOCATION_LATITUDE_DEG: 52.3663956,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE005200',
        LOCATION_NAME: 'Welchtown',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.8657909,
        LOCATION_LATITUDE_DEG: 54.8166425,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE008100',
        LOCATION_NAME: 'Wellington Bridge',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7413395,
        LOCATION_LATITUDE_DEG: 52.2773793,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE990445',
        LOCATION_NAME: 'Wellpark',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE990579',
        LOCATION_NAME: 'Wells',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE022100',
        LOCATION_NAME: 'West Cove',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -10.06606,
        LOCATION_LATITUDE_DEG: 51.7663557,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE040800',
        LOCATION_NAME: 'West Town',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2185635,
        LOCATION_LATITUDE_DEG: 55.2583862,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE041100',
        LOCATION_NAME: 'West Village',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5992076,
        LOCATION_LATITUDE_DEG: 51.8829619,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE065800',
        LOCATION_NAME: 'Westmanstown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 15',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4391834,
        LOCATION_LATITUDE_DEG: 53.3803365,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE058300',
        LOCATION_NAME: 'Westport',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.5282206,
        LOCATION_LATITUDE_DEG: 53.8018556,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WE062200',
        LOCATION_NAME: 'Wexford',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4754668,
        LOCATION_LATITUDE_DEG: 52.3395973,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH005700',
        LOCATION_NAME: 'Wheelam Cross Roads',
        COUNTY_NAME: 'Kildare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8657301,
        LOCATION_LATITUDE_DEG: 53.1997762,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH012400',
        LOCATION_NAME: 'White Castle',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1761638,
        LOCATION_LATITUDE_DEG: 55.138064,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH990924',
        LOCATION_NAME: 'White Linen Woods',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014400',
        LOCATION_NAME: 'Whitechurch',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5159026,
        LOCATION_LATITUDE_DEG: 51.9663722,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014500',
        LOCATION_NAME: 'Whitechurch',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.7491399,
        LOCATION_LATITUDE_DEG: 52.0996808,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014200',
        LOCATION_NAME: 'Whitechurch',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3823884,
        LOCATION_LATITUDE_DEG: 52.3664028,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH014300',
        LOCATION_NAME: 'Whitechurch',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9657472,
        LOCATION_LATITUDE_DEG: 52.316391,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029300',
        LOCATION_NAME: 'Whitechurch',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 16',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -0.071674,
        LOCATION_LATITUDE_DEG: 51.5231647,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016000',
        LOCATION_NAME: 'Whitegate',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3671168,
        LOCATION_LATITUDE_DEG: 52.9490643,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016100',
        LOCATION_NAME: 'Whitegate',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.2492146,
        LOCATION_LATITUDE_DEG: 51.8226173,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH015900',
        LOCATION_NAME: 'Whitegate',
        COUNTY_NAME: 'Westmeath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3157541,
        LOCATION_LATITUDE_DEG: 53.7331323,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016600',
        LOCATION_NAME: 'Whitehall',
        COUNTY_NAME: 'Longford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.9208689,
        LOCATION_LATITUDE_DEG: 53.7620314,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH016500',
        LOCATION_NAME: 'Whitehall',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.0050086,
        LOCATION_LATITUDE_DEG: 52.6839329,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH029700',
        LOCATION_NAME: 'Whitehall',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 9',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2419917,
        LOCATION_LATITUDE_DEG: 53.2694991,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019400',
        LOCATION_NAME: 'Whites Cross',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4525351,
        LOCATION_LATITUDE_DEG: 51.9367174,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH019500',
        LOCATION_NAME: 'Whites Town',
        COUNTY_NAME: 'Louth',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.1434034,
        LOCATION_LATITUDE_DEG: 53.9855471,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WH020200',
        LOCATION_NAME: 'Whitestown',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.4113206,
        LOCATION_LATITUDE_DEG: 53.3941925,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI003700',
        LOCATION_NAME: 'Wicklow',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.0454865,
        LOCATION_LATITUDE_DEG: 52.9824476,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI011400',
        LOCATION_NAME: 'Wilkinstown',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.7157124,
        LOCATION_LATITUDE_DEG: 53.7331284,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI012000',
        LOCATION_NAME: 'Willbrook',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.1325437,
        LOCATION_LATITUDE_DEG: 52.9330704,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI013500',
        LOCATION_NAME: 'Williamstown',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.5919259,
        LOCATION_LATITUDE_DEG: 53.6791355,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990091',
        LOCATION_NAME: 'WINDFIELD',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4675479,
        LOCATION_LATITUDE_DEG: 53.5202542,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI022100',
        LOCATION_NAME: 'Windgap',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.3991093,
        LOCATION_LATITUDE_DEG: 52.4497109,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023500',
        LOCATION_NAME: 'Windy Arbour',
        COUNTY_NAME: 'Dublin',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.246047,
        LOCATION_LATITUDE_DEG: 53.3036955,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI043300',
        LOCATION_NAME: 'Windy Arbour',
        COUNTY_NAME: 'Dublin',
        POSTCODE: 'Dublin 14',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2454207,
        LOCATION_LATITUDE_DEG: 53.3034389,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI023600',
        LOCATION_NAME: 'Windy Harbour',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.6490009,
        LOCATION_LATITUDE_DEG: 53.7331312,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WI990731',
        LOCATION_NAME: 'Wingfield',
        COUNTY_NAME: 'Wexford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO001300',
        LOCATION_NAME: 'Wolfhill',
        COUNTY_NAME: 'Laois',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.1259328,
        LOCATION_LATITUDE_DEG: 52.9045236,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO008500',
        LOCATION_NAME: 'Woodcockhill',
        COUNTY_NAME: 'Clare',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.7151923,
        LOCATION_LATITUDE_DEG: 52.7206455,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO009500',
        LOCATION_NAME: 'Woodenbridge',
        COUNTY_NAME: 'Wicklow',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.2457044,
        LOCATION_LATITUDE_DEG: 52.8378345,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011000',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Kerry',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.4492838,
        LOCATION_LATITUDE_DEG: 52.0496788,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011100',
        LOCATION_NAME: 'Woodford',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.399169,
        LOCATION_LATITUDE_DEG: 53.0497771,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO011400',
        LOCATION_NAME: 'Woodfort',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.8323161,
        LOCATION_LATITUDE_DEG: 53.8831337,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO990605',
        LOCATION_NAME: 'Woodlands Park',
        COUNTY_NAME: 'Donegal',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5564484,
        LOCATION_LATITUDE_DEG: 49.7661857,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO015000',
        LOCATION_NAME: 'Woodlawn',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.4811438,
        LOCATION_LATITUDE_DEG: 53.3307764,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO016850',
        LOCATION_NAME: 'Woodquay',
        COUNTY_NAME: 'Galway',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.9063862,
        LOCATION_LATITUDE_DEG: 53.5252442,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO018000',
        LOCATION_NAME: 'Woodsgift',
        COUNTY_NAME: 'Kilkenny',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.5404864,
        LOCATION_LATITUDE_DEG: 52.6990598,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO019400',
        LOCATION_NAME: 'Woodstown',
        COUNTY_NAME: 'Waterford',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.9990682,
        LOCATION_LATITUDE_DEG: 52.1996745,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'WO020200',
        LOCATION_NAME: 'Woodville',
        COUNTY_NAME: 'Mayo',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -9.3159395,
        LOCATION_LATITUDE_DEG: 54.1331848,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YE001700',
        LOCATION_NAME: 'Yellow Furze',
        COUNTY_NAME: 'Meath',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -6.5656828,
        LOCATION_LATITUDE_DEG: 53.6665187,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001100',
        LOCATION_NAME: 'Youghal',
        COUNTY_NAME: 'Cork',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -7.859471,
        LOCATION_LATITUDE_DEG: 51.961262,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
    {
        LOCATION_CODE: 'YO001200',
        LOCATION_NAME: 'Youghalara',
        COUNTY_NAME: 'Tipperary',
        POSTCODE: '',
        COUNTRY_CODE: 'IE',
        LOCATION_LONGITUDE_DEG: -8.3158678,
        LOCATION_LATITUDE_DEG: 52.8830536,
        LAST_UPDATED_DATE: '5/29/25 8:16',
    },
];
export default townFromIreland;
